/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-currency/currency.js":
/*!**********************************************************!*\
  !*** ./node_modules/@shopify/theme-currency/currency.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/listeners.js":
/*!***************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/listeners.js ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Listeners)
/* harmony export */ });
function Listeners() {
  this.entries = [];
}

Listeners.prototype.add = function(element, event, fn) {
  this.entries.push({ element: element, event: event, fn: fn });
  element.addEventListener(event, fn);
};

Listeners.prototype.removeAll = function() {
  this.entries = this.entries.filter(function(listener) {
    listener.element.removeEventListener(listener.event, listener.fn);
    return false;
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-product-form/theme-product-form.js":
/*!************************************************************************!*\
  !*** ./node_modules/@shopify/theme-product-form/theme-product-form.js ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ProductForm: () => (/* binding */ ProductForm),
/* harmony export */   getUrlWithVariant: () => (/* binding */ getUrlWithVariant)
/* harmony export */ });
/* harmony import */ var _listeners__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./listeners */ "./node_modules/@shopify/theme-product-form/listeners.js");
/* harmony import */ var _shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-product */ "./node_modules/@shopify/theme-product/theme-product.js");



var selectors = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]'
};

// Public Methods
// -----------------------------------------------------------------------------

/**
 * Returns a URL with a variant ID query parameter. Useful for updating window.history
 * with a new URL based on the currently select product variant.
 * @param {string} url - The URL you wish to append the variant ID to
 * @param {number} id  - The variant ID you wish to append to the URL
 * @returns {string} - The new url which includes the variant ID query parameter
 */

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}

/**
 * Constructor class that creates a new instance of a product form controller.
 *
 * @param {Element} element - DOM element which is equal to the <form> node wrapping product form inputs
 * @param {Object} product - A product object
 * @param {Object} options - Optional options object
 * @param {Function} options.onOptionChange - Callback for whenever an option input changes
 * @param {Function} options.onQuantityChange - Callback for whenever an quantity input changes
 * @param {Function} options.onPropertyChange - Callback for whenever a property input changes
 * @param {Function} options.onFormSubmit - Callback for whenever the product form is submitted
 */
function ProductForm(element, product, options) {
  this.element = element;
  this.product = _validateProductObject(product);

  options = options || {};

  this._listeners = new _listeners__WEBPACK_IMPORTED_MODULE_0__["default"]();
  this._listeners.add(
    this.element,
    'submit',
    this._onSubmit.bind(this, options)
  );

  this.optionInputs = this._initInputs(
    selectors.optionInput,
    options.onOptionChange
  );

  this.quantityInputs = this._initInputs(
    selectors.quantityInput,
    options.onQuantityChange
  );

  this.propertyInputs = this._initInputs(
    selectors.propertyInput,
    options.onPropertyChange
  );
}

/**
 * Cleans up all event handlers that were assigned when the Product Form was constructed.
 * Useful for use when a section needs to be reloaded in the theme editor.
 */
ProductForm.prototype.destroy = function() {
  this._listeners.removeAll();
};

/**
 * Getter method which returns the array of currently selected option values
 *
 * @returns {Array} An array of option values
 */
ProductForm.prototype.options = function() {
  return _serializeOptionValues(this.optionInputs, function(item) {
    var regex = /(?:^(options\[))(.*?)(?:\])/;
    item.name = regex.exec(item.name)[2]; // Use just the value between 'options[' and ']'
    return item;
  });
};

/**
 * Getter method which returns the currently selected variant, or `null` if variant
 * doesn't exist.
 *
 * @returns {Object|null} Variant object
 */
ProductForm.prototype.variant = function() {
  return (0,_shopify_theme_product__WEBPACK_IMPORTED_MODULE_1__.getVariantFromSerializedArray)(this.product, this.options());
};

/**
 * Getter method which returns a collection of objects containing name and values
 * of property inputs
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.properties = function() {
  var properties = _serializePropertyValues(this.propertyInputs, function(
    propertyName
  ) {
    var regex = /(?:^(properties\[))(.*?)(?:\])/;
    var name = regex.exec(propertyName)[2]; // Use just the value between 'properties[' and ']'
    return name;
  });

  return Object.entries(properties).length === 0 ? null : properties;
};

/**
 * Getter method which returns the current quantity or 1 if no quantity input is
 * included in the form
 *
 * @returns {Array} Collection of objects with name and value keys
 */
ProductForm.prototype.quantity = function() {
  return this.quantityInputs[0]
    ? Number.parseInt(this.quantityInputs[0].value, 10)
    : 1;
};

// Private Methods
// -----------------------------------------------------------------------------
ProductForm.prototype._setIdInputValue = function(value) {
  var idInputElement = this.element.querySelector(selectors.idInput);

  if (!idInputElement) {
    idInputElement = document.createElement('input');
    idInputElement.type = 'hidden';
    idInputElement.name = 'id';
    this.element.appendChild(idInputElement);
  }

  idInputElement.value = value.toString();
};

ProductForm.prototype._onSubmit = function(options, event) {
  event.dataset = this._getProductFormEventData();

  if (event.dataset.variant) {
    this._setIdInputValue(event.dataset.variant.id);
  }

  if (options.onFormSubmit) {
    options.onFormSubmit(event);
  }
};

ProductForm.prototype._onFormEvent = function(cb) {
  if (typeof cb === 'undefined') {
    return Function.prototype;
  }

  return function(event) {
    event.dataset = this._getProductFormEventData();
    cb(event);
  }.bind(this);
};

ProductForm.prototype._initInputs = function(selector, cb) {
  var elements = Array.prototype.slice.call(
    this.element.querySelectorAll(selector)
  );

  return elements.map(
    function(element) {
      this._listeners.add(element, 'change', this._onFormEvent(cb));
      return element;
    }.bind(this)
  );
};

ProductForm.prototype._getProductFormEventData = function() {
  return {
    options: this.options(),
    variant: this.variant(),
    properties: this.properties(),
    quantity: this.quantity()
  };
};

function _serializeOptionValues(inputs, transform) {
  return inputs.reduce(function(options, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      options.push(transform({ name: input.name, value: input.value }));
    }

    return options;
  }, []);
}

function _serializePropertyValues(inputs, transform) {
  return inputs.reduce(function(properties, input) {
    if (
      input.checked || // If input is a checked (means type radio or checkbox)
      (input.type !== 'radio' && input.type !== 'checkbox') // Or if its any other type of input
    ) {
      properties[transform(input.name)] = input.value;
    }

    return properties;
  }, {});
}

function _validateProductObject(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (typeof product.variants[0].options === 'undefined') {
    throw new TypeError(
      'Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route'
    );
  }

  return product;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-product/theme-product.js":
/*!**************************************************************!*\
  !*** ./node_modules/@shopify/theme-product/theme-product.js ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getProductJson: () => (/* binding */ getProductJson),
/* harmony export */   getVariantFromId: () => (/* binding */ getVariantFromId),
/* harmony export */   getVariantFromOptionArray: () => (/* binding */ getVariantFromOptionArray),
/* harmony export */   getVariantFromSerializedArray: () => (/* binding */ getVariantFromSerializedArray)
/* harmony export */ });
/**
 * Returns a product JSON object when passed a product URL
 * @param {*} url
 */
function getProductJson(handle) {
  return fetch('/products/' + handle + '.js').then(function(response) {
    return response.json();
  });
}

/**
 * Find a match in the project JSON (using a ID number) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Number} value Accepts Number (e.g. 6908023078973)
 * @returns {Object} The variant object once a match has been successful. Otherwise null will be return
 */
function getVariantFromId(product, value) {
  _validateProductStructure(product);

  if (typeof value !== 'number') {
    throw new TypeError(value + ' is not a Number.');
  }

  var result = product.variants.filter(function(variant) {
    return variant.id === value;
  });

  return result[0] || null;
}

/**
 * Convert the Object (with 'name' and 'value' keys) into an Array of values, then find a match & return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Object} collection Object with 'name' and 'value' keys (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromSerializedArray(product, collection) {
  _validateProductStructure(product);

  // If value is an array of options
  var optionArray = _createOptionArrayFromOptionCollection(product, collection);
  return getVariantFromOptionArray(product, optionArray);
}

/**
 * Find a match in the project JSON (using Array with option values) and return the variant (as an Object)
 * @param {Object} product Product JSON object
 * @param {Array} options List of submitted values (e.g. ['36', 'Black'])
 * @returns {Object || null} The variant object once a match has been successful. Otherwise null will be returned
 */
function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);

  var result = product.variants.filter(function(variant) {
    return options.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

/**
 * Creates an array of selected options from the object
 * Loops through the project.options and check if the "option name" exist (product.options.name) and matches the target
 * @param {Object} product Product JSON object
 * @param {Array} collection Array of object (e.g. [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }])
 * @returns {Array} The result of the matched values. (e.g. ['36', 'Black'])
 */
function _createOptionArrayFromOptionCollection(product, collection) {
  _validateProductStructure(product);
  _validateSerializedArray(collection);

  var optionArray = [];

  collection.forEach(function(option) {
    for (var i = 0; i < product.options.length; i++) {
      if (product.options[i].name.toLowerCase() === option.name.toLowerCase()) {
        optionArray[i] = option.value;
        break;
      }
    }
  });

  return optionArray;
}

/**
 * Check if the product data is a valid JS object
 * Error will be thrown if type is invalid
 * @param {object} product Product JSON object
 */
function _validateProductStructure(product) {
  if (typeof product !== 'object') {
    throw new TypeError(product + ' is not an object.');
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + ' is empty.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted like jQuery's serializeArray()
 * @param {Array} collection Array of object [{ name: "Size", value: "36" }, { name: "Color", value: "Black" }]
 */
function _validateSerializedArray(collection) {
  if (!Array.isArray(collection)) {
    throw new TypeError(collection + ' is not an array.');
  }

  if (collection.length === 0) {
    return [];
  }

  if (collection[0].hasOwnProperty('name')) {
    if (typeof collection[0].name !== 'string') {
      throw new TypeError(
        'Invalid value type passed for name of option ' +
          collection[0].name +
          '. Value should be string.'
      );
    }
  } else {
    throw new Error(collection[0] + 'does not contain name key.');
  }
}

/**
 * Validate the structure of the array
 * It must be formatted as list of values
 * @param {Array} collection Array of object (e.g. ['36', 'Black'])
 */
function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === 'object') {
    throw new Error(options + 'is not a valid array of options.');
  }
}


/***/ }),

/***/ "./src/scripts/common.js":
/*!*******************************!*\
  !*** ./src/scripts/common.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lazysizes */ "./node_modules/lazysizes/lazysizes.js");
/* harmony import */ var lazysizes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lazysizes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_quantity_selector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/quantity-selector */ "./src/scripts/modules/quantity-selector.js");
/* harmony import */ var _modules_product__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/product */ "./src/scripts/modules/product.js");
/* harmony import */ var _modules_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/navigation */ "./src/scripts/modules/navigation.js");
/* harmony import */ var _modules_product_list__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/product-list */ "./src/scripts/modules/product-list.js");
/* harmony import */ var _modules_accordion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/accordion */ "./src/scripts/modules/accordion.js");
/* harmony import */ var _modules_top_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/top-bar */ "./src/scripts/modules/top-bar.js");
/* harmony import */ var _modules_collection_promo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/collection-promo */ "./src/scripts/modules/collection-promo.js");
/* harmony import */ var _modules_cart__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/cart */ "./src/scripts/modules/cart.js");
/* harmony import */ var _modules_bike_build_updated__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/bike-build-updated */ "./src/scripts/modules/bike-build-updated.js");
/* harmony import */ var _modules_select_item_ga4__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/select-item-ga4 */ "./src/scripts/modules/select-item-ga4.js");
/* harmony import */ var _modules_pdp_preselect_ga4__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/pdp-preselect-ga4 */ "./src/scripts/modules/pdp-preselect-ga4.js");
/* harmony import */ var _modules_pdp_sticky_atc_ga4__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/pdp-sticky-atc-ga4 */ "./src/scripts/modules/pdp-sticky-atc-ga4.js");
/* harmony import */ var _modules_collection_slider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/collection-slider */ "./src/scripts/modules/collection-slider.js");
/* harmony import */ var _modules_product_media__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/product-media */ "./src/scripts/modules/product-media.js");
/* harmony import */ var _modules_product_gallery__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/product-gallery */ "./src/scripts/modules/product-gallery.js");
/* harmony import */ var _modules_review_carousel__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/review-carousel */ "./src/scripts/modules/review-carousel.js");
/* harmony import */ var _modules_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/icons */ "./src/scripts/modules/icons.js");
/* harmony import */ var _modules_product_card__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/product-card */ "./src/scripts/modules/product-card.js");
/* harmony import */ var _modules_account__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/account */ "./src/scripts/modules/account.js");
/* harmony import */ var _modules_product_lightbox__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./modules/product-lightbox */ "./src/scripts/modules/product-lightbox.js");
/* harmony import */ var _modules_product_size_guide__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/product-size-guide */ "./src/scripts/modules/product-size-guide.js");
/* harmony import */ var _modules_product_recommendations__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/product-recommendations */ "./src/scripts/modules/product-recommendations.js");
/* harmony import */ var _modules_product_bike_builder__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/product-bike-builder */ "./src/scripts/modules/product-bike-builder.js");
/* harmony import */ var _modules_product_bike_builder_simple__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./modules/product-bike-builder-simple */ "./src/scripts/modules/product-bike-builder-simple.js");
/* harmony import */ var _modules_product_bike_builder_v3__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./modules/product-bike-builder-v3 */ "./src/scripts/modules/product-bike-builder-v3.js");
/* harmony import */ var _modules_upsell_popup__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./modules/upsell-popup */ "./src/scripts/modules/upsell-popup.js");
/* harmony import */ var _modules_slideshow_slider__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./modules/slideshow-slider */ "./src/scripts/modules/slideshow-slider.js");
/* harmony import */ var _modules_product_bundle__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./modules/product-bundle */ "./src/scripts/modules/product-bundle.js");
/* harmony import */ var _modules_product_preorder__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./modules/product-preorder */ "./src/scripts/modules/product-preorder.js");
/* harmony import */ var _modules_bis_popup__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./modules/bis-popup */ "./src/scripts/modules/bis-popup.js");
/* harmony import */ var _modules_product_form__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./modules/product-form */ "./src/scripts/modules/product-form.js");
/* harmony import */ var _modules_modal_opener__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./modules/modal-opener */ "./src/scripts/modules/modal-opener.js");
/* harmony import */ var _modules_quick_add_modal__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./modules/quick-add-modal */ "./src/scripts/modules/quick-add-modal.js");
/* harmony import */ var _modules_quick_add_form__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./modules/quick-add-form */ "./src/scripts/modules/quick-add-form.js");




































/**
 * Check if document is ready cross-browser
 * @param callback
 */
var ready = function ready(callback) {
  if (document.readyState !== "loading") {
    /**
     * Document is already ready, call the callback directly
     */
    callback();
  } else if (document.addEventListener) {
    /**
     * All modern browsers to register DOMContentLoaded
     */
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    /**
     * Old IE browsers
     */
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        callback();
      }
    });
  }
};
ready(function () {
  //Top Bar
  // const topBar = new TopBar();
  // topBar.init();

  // Navigation
  // const navigation = new Navigation();
  // navigation.init();

  //Cart
  var cart = new _modules_cart__WEBPACK_IMPORTED_MODULE_8__["default"]();
  cart.init();

  // A bike just updated from the builder: mark its basket line, offer Undo.
  (0,_modules_bike_build_updated__WEBPACK_IMPORTED_MODULE_9__["default"])();

  // GA4 select_item for product cards. Records clicks, publishes on the PDP.
  (0,_modules_select_item_ga4__WEBPACK_IMPORTED_MODULE_10__["default"])();

  // PDP pre-selection A/B arm stamp. No-ops off a stamped product page.
  (0,_modules_pdp_preselect_ga4__WEBPACK_IMPORTED_MODULE_11__.emitPreselectView)();

  // PDP mobile sticky add to basket A/B arm stamp. No-ops off a stamped product page.
  (0,_modules_pdp_sticky_atc_ga4__WEBPACK_IMPORTED_MODULE_12__.emitStickyAtcView)();

  //Account Modal
  var accountModal = new _modules_account__WEBPACK_IMPORTED_MODULE_19__["default"]();
  accountModal.init();

  // Product List
  var productList = new _modules_product_list__WEBPACK_IMPORTED_MODULE_4__["default"]();
  productList.init();

  // Collection Slider
  var collectionSlider = new _modules_collection_slider__WEBPACK_IMPORTED_MODULE_13__["default"]();
  collectionSlider.init();

  // Collection Slider
  var reviewSlider = new _modules_review_carousel__WEBPACK_IMPORTED_MODULE_16__["default"]();
  reviewSlider.init();

  // Accordions
  var accordion = new _modules_accordion__WEBPACK_IMPORTED_MODULE_5__["default"]();
  accordion.init();

  // Product Card
  var productCard = new _modules_product_card__WEBPACK_IMPORTED_MODULE_18__["default"]();
  productCard.init();
  var upsellPopup = new _modules_upsell_popup__WEBPACK_IMPORTED_MODULE_26__["default"]();
  upsellPopup.init();

  // Product Bundle
  var productBundle = new _modules_product_bundle__WEBPACK_IMPORTED_MODULE_28__["default"]();
  productBundle.init();

  // Product Preorder
  var productPreorder = new _modules_product_preorder__WEBPACK_IMPORTED_MODULE_29__["default"]();
  productPreorder.init();

  // QuantitySelectors
  customElements.define("quantity-selector", _modules_quantity_selector__WEBPACK_IMPORTED_MODULE_1__["default"]);

  // Product
  customElements.define("main-product", _modules_product__WEBPACK_IMPORTED_MODULE_2__["default"]);

  // Product Media
  customElements.define("product-media", _modules_product_media__WEBPACK_IMPORTED_MODULE_14__["default"]);

  // Product Size Guide
  customElements.define("product-size-guide", _modules_product_size_guide__WEBPACK_IMPORTED_MODULE_21__["default"]);

  // Product Lightbox
  customElements.define("product-lightbox", _modules_product_lightbox__WEBPACK_IMPORTED_MODULE_20__["default"]);

  // Product Gallery
  customElements.define("product-gallery", _modules_product_gallery__WEBPACK_IMPORTED_MODULE_15__["default"]);

  // Product Recommendations
  customElements.define("product-recommendations", _modules_product_recommendations__WEBPACK_IMPORTED_MODULE_22__["default"]);

  // Product Bike Builder
  customElements.define("product-bike-builder", _modules_product_bike_builder__WEBPACK_IMPORTED_MODULE_23__["default"]);

  // Product Bike Builder Simple (Add to basket / Customise variant)
  customElements.define("product-bike-builder-simple", _modules_product_bike_builder_simple__WEBPACK_IMPORTED_MODULE_24__["default"]);

  // Product Bike Builder V3 (buy column), on the bike-builder-v3 template. Runs
  // alongside the one above so bikes can move over one at a time.
  customElements.define("product-bike-builder-v3", _modules_product_bike_builder_v3__WEBPACK_IMPORTED_MODULE_25__["default"]);

  // Back in Stock Popup
  customElements.define("bis-popup", _modules_bis_popup__WEBPACK_IMPORTED_MODULE_30__["default"]);
  var imageResizer = new _modules_collection_promo__WEBPACK_IMPORTED_MODULE_7__["default"]("product-card", "collection-promo");
  imageResizer.init();

  // Slidshow Slider
  var slideshowSlider = new _modules_slideshow_slider__WEBPACK_IMPORTED_MODULE_27__["default"]();
  slideshowSlider.init();
  if (!customElements.get("product-form")) {
    customElements.define("product-form", _modules_product_form__WEBPACK_IMPORTED_MODULE_31__["default"]);
  }

  // Quick Add modal + opener
  if (!customElements.get("modal-opener")) {
    customElements.define("modal-opener", _modules_modal_opener__WEBPACK_IMPORTED_MODULE_32__["default"]);
  }
  if (!customElements.get("quick-add-modal")) {
    customElements.define("quick-add-modal", _modules_quick_add_modal__WEBPACK_IMPORTED_MODULE_33__["default"]);
  }
  if (!customElements.get("quick-add-form")) {
    customElements.define("quick-add-form", _modules_quick_add_form__WEBPACK_IMPORTED_MODULE_34__["default"]);
  }
});

/***/ }),

/***/ "./src/scripts/modules/accordion.js":
/*!******************************************!*\
  !*** ./src/scripts/modules/accordion.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Accordion)
/* harmony export */ });
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Accordion = /*#__PURE__*/function () {
  function Accordion() {
    _classCallCheck(this, Accordion);
    this.DOM = {
      container: ".accordion",
      button: ".accordion__button",
      content: ".accordion__content"
    };
    this.container = document.querySelectorAll(this.DOM.container);
    this.button = document.querySelectorAll(this.DOM.button);
  }
  return _createClass(Accordion, [{
    key: "init",
    value: function init() {
      var _this = this;
      Array.from(this.button).forEach(function (button) {
        button.addEventListener('click', function (e) {
          return _this.toggleAccordion(button);
        });
      });
    }
  }, {
    key: "toggleAccordion",
    value: function toggleAccordion(button) {
      var content = button.parentElement.querySelector(this.DOM.content);
      button.parentElement.classList.toggle('accordion--open');
      this.toggleAria(button, 'expanded');
      this.toggleAria(content, 'hidden');
    }
  }, {
    key: "toggleAria",
    value: function toggleAria(el, attr) {
      if (el.getAttribute('aria-' + attr) === 'false') {
        el.setAttribute('aria-' + attr, 'true');
      } else {
        el.setAttribute('aria-' + attr, 'false');
      }
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/account.js":
/*!****************************************!*\
  !*** ./src/scripts/modules/account.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Account)
/* harmony export */ });
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-currency */ "./node_modules/@shopify/theme-currency/currency.js");
/* harmony import */ var whatwg_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! whatwg-fetch */ "./node_modules/whatwg-fetch/fetch.js");
/* harmony import */ var form_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! form-serialize */ "./node_modules/form-serialize/index.js");
/* harmony import */ var form_serialize__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(form_serialize__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var Account = /*#__PURE__*/function () {
  function Account() {
    _classCallCheck(this, Account);
    this.DOM = {
      openTrigger: ".account__trigger",
      closeTrigger: ".account-drawer__header-close",
      account: ".account-drawer",
      accountInner: ".account-drawer__inner",
      accountBody: ".account-drawer__body",
      accountOverlay: ".account-drawer__overlay"
    };
    this.openTrigger = document.querySelectorAll(this.DOM.openTrigger);
    this.closeTrigger = document.querySelectorAll(this.DOM.closeTrigger);
    this.account = document.querySelector(this.DOM.account);
    this.accountInner = document.querySelector(this.DOM.accountInner);
    this.accountBody = document.querySelector(this.DOM.accountBody);
    this.accountOverlay = document.querySelectorAll(this.DOM.accountOverlay);
    this.currentaccount = {};
  }
  return _createClass(Account, [{
    key: "init",
    value: function init() {
      var _this = this;
      Array.from(this.openTrigger).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this.openDraw(e);
        });
      });
      Array.from(this.closeTrigger).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this.closeDraw(e);
        });
      });
      Array.from(this.accountOverlay).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this.closeDraw(e);
        });
      });

      // this.fetchaccount();
    }
  }, {
    key: "openDraw",
    value: function openDraw() {
      this.account.classList.add('active');
      this.accountInner.classList.add('open');
    }
  }, {
    key: "closeDraw",
    value: function closeDraw() {
      this.account.classList.remove('active');
      this.accountInner.classList.remove('open');
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/bike-build-basket.js":
/*!**************************************************!*\
  !*** ./src/scripts/modules/bike-build-basket.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   forgetUpdatedBuild: () => (/* binding */ forgetUpdatedBuild),
/* harmony export */   readUpdatedBuild: () => (/* binding */ readUpdatedBuild),
/* harmony export */   rememberUpdatedBuild: () => (/* binding */ rememberUpdatedBuild),
/* harmony export */   removeBuild: () => (/* binding */ removeBuild),
/* harmony export */   restoreBuild: () => (/* binding */ restoreBuild),
/* harmony export */   saveUpdatedBuild: () => (/* binding */ saveUpdatedBuild)
/* harmony export */ });
/* harmony import */ var _bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bike-build-lines.mjs */ "./src/scripts/modules/bike-build-lines.mjs");
/* harmony import */ var _bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bike-build-changes.mjs */ "./src/scripts/modules/bike-build-changes.mjs");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



/**
 * Basket calls for a bike build: taking one out, and remembering an update so
 * the basket can mark it and offer Undo (Phase 3 brief 4.2, Kenny's V3 design).
 * Shared by the builder (product-bike-builder-v3.js) and the basket
 * (bike-build-updated.js), so both find a build's lines the same way.
 */

var UPDATED_KEY = "bb-build-updated";
// Long enough to cover a look round the basket, short enough that an old
// update is not marked on a later visit.
var UPDATED_MAX_AGE = 30 * 60 * 1000;
var root = function root() {
  return window.Shopify.routes.root;
};
function readCart() {
  return _readCart.apply(this, arguments);
}
/**
 * Zeroes every basket line of one build: its bike line and any line whose
 * `_parentLineItem` points at it, whether or not the bike line is still there.
 *
 * @returns {Promise<{parent: object|null, components: object[]}>} the lines taken out
 */
function _readCart() {
  _readCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetch("".concat(root(), "cart.js"), {
            credentials: "same-origin"
          });
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new Error("cart.js ".concat(response.status));
        case 2:
          return _context.a(2, response.json());
      }
    }, _callee);
  }));
  return _readCart.apply(this, arguments);
}
function removeBuild(_x) {
  return _removeBuild.apply(this, arguments);
}

/**
 * Puts a build's lines back, as Undo does. Lines that make it in before a
 * failure are taken out again, so a half-restored build never lingers.
 */
function _removeBuild() {
  _removeBuild = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(parentId) {
    var cart, id, items, updates, response;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return readCart();
        case 1:
          cart = _context2.v;
          id = String(parentId);
          items = cart.items || [];
          updates = {};
          items.forEach(function (item) {
            var props = item.properties || {};
            if (String(props._primaryParentLineItem) === id || (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_0__.isComponentOf)(props, id)) {
              updates[item.key] = 0;
            }
          });
          if (!Object.keys(updates).length) {
            _context2.n = 3;
            break;
          }
          _context2.n = 2;
          return fetch("".concat(root(), "cart/update.js"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({
              updates: updates
            })
          });
        case 2:
          response = _context2.v;
          if (response.ok) {
            _context2.n = 3;
            break;
          }
          throw new Error("cart/update ".concat(response.status));
        case 3:
          return _context2.a(2, (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_0__.buildLines)(items, id));
      }
    }, _callee2);
  }));
  return _removeBuild.apply(this, arguments);
}
function restoreBuild(_x2, _x3) {
  return _restoreBuild.apply(this, arguments);
}

/**
 * Records an update for the basket: the new build's id, to mark its line
 * Updated, and the old build's lines, for Undo.
 */
function _restoreBuild() {
  _restoreBuild = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(items, parentId) {
    var response, _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetch("".concat(root(), "cart/add.js"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({
              items: items
            })
          });
        case 1:
          response = _context3.v;
          if (response.ok) {
            _context3.n = 2;
            break;
          }
          throw new Error("cart/add ".concat(response.status));
        case 2:
          _context3.n = 5;
          break;
        case 3:
          _context3.p = 3;
          _t = _context3.v;
          _context3.n = 4;
          return removeBuild(parentId)["catch"](function () {});
        case 4:
          throw _t;
        case 5:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return _restoreBuild.apply(this, arguments);
}
function rememberUpdatedBuild(_ref) {
  var parentId = _ref.parentId,
    oldParentId = _ref.oldParentId,
    oldLines = _ref.oldLines;
  try {
    window.sessionStorage.setItem(UPDATED_KEY, JSON.stringify({
      parentId: String(parentId),
      oldParentId: String(oldParentId),
      undo: (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_1__.undoItems)(oldLines.parent, oldLines.components),
      toastShown: false,
      at: Date.now()
    }));
  } catch (error) {
    // Private browsing can refuse storage. The update stands; only the marker and Undo are lost.
  }
}
function readUpdatedBuild() {
  try {
    var record = JSON.parse(window.sessionStorage.getItem(UPDATED_KEY));
    if (!record || Date.now() - record.at > UPDATED_MAX_AGE) return null;
    return record;
  } catch (error) {
    return null;
  }
}
function saveUpdatedBuild(record) {
  try {
    window.sessionStorage.setItem(UPDATED_KEY, JSON.stringify(record));
  } catch (error) {
    // As above.
  }
}
function forgetUpdatedBuild() {
  try {
    window.sessionStorage.removeItem(UPDATED_KEY);
  } catch (error) {
    // As above.
  }
}

/***/ }),

/***/ "./src/scripts/modules/bike-build-drawer.js":
/*!**************************************************!*\
  !*** ./src/scripts/modules/bike-build-drawer.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SummaryDrawer)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * The Your build drawer (buy column, Kenny's "Builder direction: buy
 * column"): at $large the build summary slides in over the photo, opened by
 * the toggle on it. Not a dialog: the page stays usable, so the shopper can
 * change parts and watch the summary follow. The X, the toggle, or Escape
 * while focus is inside close it. Narrowing below $large closes it, because
 * the same summary is the mobile sheet there. Closed on every page load.
 */
var OPEN_CLASS = "bike-builder-drawer--open";
var SummaryDrawer = /*#__PURE__*/function () {
  /**
   * @param {{drawer: HTMLElement, toggle: HTMLElement, closer?: HTMLElement, isLarge: () => boolean, onChange?: (open: boolean) => void}} parts
   */
  function SummaryDrawer(_ref) {
    var _this = this;
    var drawer = _ref.drawer,
      toggle = _ref.toggle,
      _ref$closer = _ref.closer,
      closer = _ref$closer === void 0 ? null : _ref$closer,
      isLarge = _ref.isLarge,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
    _classCallCheck(this, SummaryDrawer);
    this.drawer = drawer;
    this.toggle = toggle;
    this.isLarge = isLarge;
    this.onChange = onChange;
    this.isOpen = false;
    toggle.addEventListener("click", function () {
      return _this.isOpen ? _this.close() : _this.open();
    });
    if (closer) closer.addEventListener("click", function () {
      return _this.close({
        restoreFocus: true
      });
    });
    drawer.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || !_this.isOpen) return;
      event.preventDefault();
      _this.close({
        restoreFocus: true
      });
    });
    window.addEventListener("resize", function () {
      if (_this.isOpen && !_this.isLarge()) _this.close();
    });
  }
  return _createClass(SummaryDrawer, [{
    key: "open",
    value: function open() {
      if (this.isOpen || !this.isLarge()) return;
      this.isOpen = true;
      this.drawer.classList.add(OPEN_CLASS);
      this.toggle.setAttribute("aria-expanded", "true");
      this.onChange(true);
    }
  }, {
    key: "close",
    value: function close() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$restoreFocus = _ref2.restoreFocus,
        restoreFocus = _ref2$restoreFocus === void 0 ? false : _ref2$restoreFocus;
      if (!this.isOpen) return;
      this.isOpen = false;
      this.drawer.classList.remove(OPEN_CLASS);
      this.toggle.setAttribute("aria-expanded", "false");
      this.onChange(false);
      if (restoreFocus) this.toggle.focus();
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/bike-build-summary-sheet.js":
/*!*********************************************************!*\
  !*** ./src/scripts/modules/bike-build-summary-sheet.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SummarySheet)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * The build summary as a bottom sheet below $large (Builder refinements,
 * Kenny's "Builder/Build summary v2", Breakpoint=Mobile sheet), opened from
 * the build bar's View build. A dialog while open: focus moves in and stays
 * there, the page behind does not scroll, and Escape, the dimmed page or the
 * chevron close it, returning focus to View build. Widening past $large closes
 * it, so the summary is always a plain card at desktop width.
 */

var OPEN_CLASS = "bike-builder-summary--sheet-open";
var BODY_CLASS = "bike-builder-sheet-open";
var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';
var SummarySheet = /*#__PURE__*/function () {
  /**
   * @param {{sheet: HTMLElement, opener: HTMLElement, overlay?: HTMLElement, closer?: HTMLElement, isSmall: () => boolean}} parts
   */
  function SummarySheet(_ref) {
    var _this = this;
    var sheet = _ref.sheet,
      opener = _ref.opener,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? null : _ref$overlay,
      _ref$closer = _ref.closer,
      closer = _ref$closer === void 0 ? null : _ref$closer,
      isSmall = _ref.isSmall;
    _classCallCheck(this, SummarySheet);
    this.sheet = sheet;
    this.opener = opener;
    this.overlay = overlay;
    this.closer = closer;
    this.isSmall = isSmall;
    this.isOpen = false;
    this.onKeydown = function (event) {
      return _this.keydown(event);
    };
    opener.addEventListener("click", function () {
      return _this.open();
    });
    if (closer) closer.addEventListener("click", function () {
      return _this.close();
    });
    if (overlay) overlay.addEventListener("click", function () {
      return _this.close();
    });
    window.addEventListener("resize", function () {
      if (_this.isOpen && !_this.isSmall()) _this.close({
        restoreFocus: false
      });
    });
  }
  return _createClass(SummarySheet, [{
    key: "open",
    value: function open() {
      if (this.isOpen || !this.isSmall()) return;
      this.isOpen = true;
      this.sheet.classList.add(OPEN_CLASS);
      this.sheet.setAttribute("role", "dialog");
      this.sheet.setAttribute("aria-modal", "true");
      if (this.overlay) this.overlay.hidden = false;
      document.body.classList.add(BODY_CLASS);
      this.opener.setAttribute("aria-expanded", "true");
      document.addEventListener("keydown", this.onKeydown);
      var first = this.closer || this.sheet.querySelector(FOCUSABLE);
      if (first) first.focus();
    }
  }, {
    key: "close",
    value: function close() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$restoreFocus = _ref2.restoreFocus,
        restoreFocus = _ref2$restoreFocus === void 0 ? true : _ref2$restoreFocus;
      if (!this.isOpen) return;
      this.isOpen = false;
      this.sheet.classList.remove(OPEN_CLASS);
      this.sheet.removeAttribute("role");
      this.sheet.removeAttribute("aria-modal");
      if (this.overlay) this.overlay.hidden = true;
      document.body.classList.remove(BODY_CLASS);
      this.opener.setAttribute("aria-expanded", "false");
      document.removeEventListener("keydown", this.onKeydown);
      if (restoreFocus) this.opener.focus();
    }
  }, {
    key: "keydown",
    value: function keydown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== "Tab") return;

      // Keep Tab inside the sheet while it is open.
      var items = _toConsumableArray(this.sheet.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/bike-build-toast.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/bike-build-toast.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   hideToast: () => (/* binding */ hideToast),
/* harmony export */   showToast: () => (/* binding */ showToast)
/* harmony export */ });
/**
 * The dark toast, at the foot of the screen on mobile (above the builder's
 * build bar when it shows) and top right on desktop: Kenny's V3 "Toast". A
 * message, a tick unless it reports a failure, and at most one action, a
 * button or a link. Shared by the basket's Undo (bike-build-updated.js) and
 * the builder's Reset build.
 *
 * Screen readers hear the message through one status region that stays in the
 * page: text written into a region that is already present is announced
 * reliably, a region that arrives already filled often is not. The toast waits
 * while it is hovered or has focus, so its action can always be reached.
 */

var TOAST_MS = 10000;
var PLAIN_CLASS = "bike-build-toast--plain";
var toast = null;
var toastTimer = null;
var toastOnHide = null;
var liveRegion = null;
function announce(message) {
  if (!liveRegion) {
    liveRegion = document.createElement("div");
    liveRegion.className = "visually-hidden";
    liveRegion.setAttribute("role", "status");
    document.body.append(liveRegion);
  }
  liveRegion.textContent = "";
  // Written a moment later, so even a region created just now announces it.
  window.setTimeout(function () {
    liveRegion.textContent = message;
  }, 100);
}
function startTimer() {
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(function () {
    return hideToast();
  }, TOAST_MS);
}

/**
 * Closes the toast. Given an element, closes it only if it is still the one
 * showing, so a stale caller never closes a newer toast.
 * @param {HTMLElement} [target]
 */
function hideToast(target) {
  if (target && target !== toast) return;
  window.clearTimeout(toastTimer);
  var onHide = toastOnHide;
  if (toast) toast.remove();
  toast = null;
  toastOnHide = null;
  if (onHide) onHide();
}

/**
 * @param {string} message
 * @param {{tick?: boolean, action?: {label: string, run?: () => void, href?: string}, focusAction?: boolean, onHide?: () => void}} [options]
 *   focusAction: move focus to the action (for a keyboard user who just triggered the toast)
 *   onHide: called once the toast is gone, however it went
 * @returns {HTMLElement} the toast
 */
function showToast(message) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$tick = _ref.tick,
    tick = _ref$tick === void 0 ? true : _ref$tick,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? null : _ref$action,
    _ref$focusAction = _ref.focusAction,
    focusAction = _ref$focusAction === void 0 ? false : _ref$focusAction,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? null : _ref$onHide;
  hideToast();
  toast = document.createElement("div");
  toast.className = tick ? "bike-build-toast" : "bike-build-toast ".concat(PLAIN_CLASS);
  var text = document.createElement("span");
  text.className = "bike-build-toast__text";
  text.textContent = message;
  toast.append(text);
  var control = null;
  if (action) {
    control = document.createElement(action.href ? "a" : "button");
    control.className = "bike-build-toast__action reset-styles";
    control.textContent = action.label;
    if (action.href) {
      control.href = action.href;
    } else {
      control.type = "button";
      control.addEventListener("click", action.run);
    }
    toast.append(control);
  }

  // Wait while hovered or focused; carry on once neither.
  var shown = toast;
  var resume = function resume() {
    if (shown !== toast) return;
    if (shown.matches(":hover") || shown.contains(document.activeElement)) return;
    startTimer();
  };
  shown.addEventListener("mouseenter", function () {
    return window.clearTimeout(toastTimer);
  });
  shown.addEventListener("focusin", function () {
    return window.clearTimeout(toastTimer);
  });
  shown.addEventListener("mouseleave", resume);
  shown.addEventListener("focusout", function () {
    return window.setTimeout(resume, 0);
  });
  document.body.append(shown);
  toastOnHide = onHide;
  announce(message);
  startTimer();
  if (focusAction && control) control.focus({
    preventScroll: true
  });
  return shown;
}

/***/ }),

/***/ "./src/scripts/modules/bike-build-updated.js":
/*!***************************************************!*\
  !*** ./src/scripts/modules/bike-build-updated.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initUpdatedBuild)
/* harmony export */ });
/* harmony import */ var _bike_build_basket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bike-build-basket */ "./src/scripts/modules/bike-build-basket.js");
/* harmony import */ var _bike_build_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bike-build-toast */ "./src/scripts/modules/bike-build-toast.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



/**
 * After a bike is updated from the builder: its basket line reads Updated, and
 * a toast offers Undo, which puts the old build back and takes the new one out
 * (Phase 3 brief 4.2, Kenny's V3 "Basket drawer after update"). The toast
 * itself is bike-build-toast.js, shared with the builder.
 *
 * The update is remembered in sessionStorage by the builder, so this works
 * wherever the basket is drawn: the drawer the builder opens, and the basket
 * page. The drawer is re-rendered whole on every change, so the marking is
 * re-applied on each "cart:rendered" (cart.js renderCart).
 */

function linesFor(record) {
  return Array.from(document.querySelectorAll(".cart-item--bike")).filter(function (line) {
    return line.dataset.bikeParentId === record.parentId;
  });
}
function markUpdated(line) {
  if (line.querySelector(".cart-item__updated")) return;
  var pill = document.createElement("span");
  pill.className = "cart-item__updated";
  pill.textContent = line.dataset.bikeUpdated || "Updated";
  var details = line.querySelector(".cart-item__details");
  if (details) details.prepend(pill);
}
function undo(_x, _x2) {
  return _undo.apply(this, arguments);
}
function _undo() {
  _undo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(record, strings) {
    var _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          (0,_bike_build_toast__WEBPACK_IMPORTED_MODULE_1__.hideToast)();
          _context.p = 1;
          _context.n = 2;
          return (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_0__.restoreBuild)(record.undo, record.oldParentId);
        case 2:
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          (0,_bike_build_toast__WEBPACK_IMPORTED_MODULE_1__.showToast)(strings.failed, {
            tick: false
          });
          return _context.a(2);
        case 4:
          _context.p = 4;
          _context.n = 5;
          return (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_0__.removeBuild)(record.parentId);
        case 5:
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t2 = _context.v;
        case 7:
          (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_0__.forgetUpdatedBuild)();
          if (/\/cart\/?$/.test(window.location.pathname)) {
            window.location.reload();
          } else {
            document.dispatchEvent(new Event("renderCart"));
          }
        case 8:
          return _context.a(2);
      }
    }, _callee, null, [[4, 6], [1, 3]]);
  }));
  return _undo.apply(this, arguments);
}
function decorate() {
  var record = (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_0__.readUpdatedBuild)();
  if (!record) return;
  var lines = linesFor(record);
  if (!lines.length) return;
  lines.forEach(markUpdated);
  if (record.toastShown) return;
  record.toastShown = true;
  (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_0__.saveUpdatedBuild)(record);
  var line = lines[0];
  var strings = {
    failed: line.dataset.bikeUndoFailed || ""
  };
  (0,_bike_build_toast__WEBPACK_IMPORTED_MODULE_1__.showToast)(line.dataset.bikeUpdatedToast || "", {
    action: {
      label: line.dataset.bikeUndo || "Undo",
      run: function run() {
        return undo(record, strings);
      }
    }
  });
}
function initUpdatedBuild() {
  decorate();
  document.addEventListener("cart:rendered", decorate);
}

/***/ }),

/***/ "./src/scripts/modules/bike-builder-ga4.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/bike-builder-ga4.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildBikeAddedToCartPayload: () => (/* binding */ buildBikeAddedToCartPayload),
/* harmony export */   emitBikeAddedToCart: () => (/* binding */ emitBikeAddedToCart),
/* harmony export */   getBuildTotalCents: () => (/* binding */ getBuildTotalCents),
/* harmony export */   getSelectedFrameVariant: () => (/* binding */ getSelectedFrameVariant)
/* harmony export */ });
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Shared GA4 `add_to_cart` emitter for the bike builders.
 *
 * The builders add to cart via a native full-page form POST (not the AJAX
 * `/cart/add.js` path), so Shopify never fires its native `product_added_to_cart`
 * customer event and GA4 records nothing for bikes. We bridge that gap by
 * publishing one custom customer event per build; a custom pixel forwards it to
 * GA4 as a single bike-level `add_to_cart` at the full configured price.
 *
 * The build total is recomputed from the DOM at call time (frame base +
 * selected extras) so this module stays independent of each builder's internal
 * running state.
 */

var EVENT_NAME = "alpkit:bike_added_to_cart";
var FRAME_TOTAL_SELECTOR = ".js-bike-builder-total";
var EXTRA_SELECTOR = ".js-bike-builder-extra";
var CHECKED_OPTION_SELECTOR = '[data-bike-builder-step="1"] input[data-product-option]:checked';

/**
 * Resolve the selected frame variant from the step-1 option inputs.
 * Mirrors the option-matching the builders already use.
 *
 * @param {Object} product - parsed frame product JSON (has `.variants`)
 * @returns {Object|null}
 */
function getSelectedFrameVariant(product) {
  var checkedOptions = document.querySelectorAll(CHECKED_OPTION_SELECTOR);
  if (!checkedOptions.length || !product || !product.variants) return null;
  return product.variants.find(function (variant) {
    return _toConsumableArray(checkedOptions).every(function (option) {
      return variant["option".concat(option.dataset.productOption)] === option.value;
    });
  }) || null;
}

/**
 * Full build total in cents: frame base price + every selected extra.
 * Reads the same data attributes the builders read when rendering the total.
 *
 * @returns {number} integer cents, or NaN if the frame base can't be resolved
 */
function getBuildTotalCents() {
  var totalEl = document.querySelector(FRAME_TOTAL_SELECTOR);
  if (!totalEl) return NaN;
  var frameCents = parseInt(totalEl.dataset.attrPrice, 10);
  if (Number.isNaN(frameCents)) return NaN;
  var extrasCents = 0;
  document.querySelectorAll(EXTRA_SELECTOR).forEach(function (extra) {
    var price = parseInt(extra.dataset.attrPrice, 10);
    if (!Number.isNaN(price)) extrasCents += price;
  });
  return frameCents + extrasCents;
}

/**
 * Build the GA4 payload for the current build, or null if it can't be valued.
 *
 * The identity is the PAGE product (the bike the customer is on), NOT the frame
 * product loaded into the builder — so GA4 measures bikes, not frames. The frame
 * only contributes the selected variant (size/colour) and the build total.
 *
 * @param {Object} identity
 * @param {(string|number)} identity.itemId   - bike (page) product id
 * @param {string}          identity.itemName - bike (page) product title
 * @param {string}         [identity.itemVariant] - selected frame variant title (e.g. "Small / Jet Black")
 * @returns {Object|null}
 */
function buildBikeAddedToCartPayload() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    itemId = _ref.itemId,
    itemName = _ref.itemName,
    itemVariant = _ref.itemVariant;
  if (!itemName) return null;
  var totalCents = getBuildTotalCents();
  if (Number.isNaN(totalCents) || totalCents <= 0) return null;
  var value = totalCents / 100;
  var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "GBP";
  var bike = {
    item_id: String(itemId || ""),
    item_name: itemName,
    item_brand: "Sonder",
    price: value,
    quantity: 1
  };
  if (itemVariant) bike.item_variant = itemVariant;
  return {
    bike: bike,
    currency: currency,
    value: value
  };
}

/**
 * Publish the bike-level add_to_cart custom event. Never throws.
 *
 * @param {Object} identity - { itemId, itemName, itemVariant } for the bike (page) product
 * @returns {boolean} true if the event was published
 */
function emitBikeAddedToCart(identity) {
  try {
    var payload = buildBikeAddedToCartPayload(identity);
    if (!payload) return false;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(EVENT_NAME, payload);
      return true;
    }
  } catch (err) {
    console.error("bike GA4 add_to_cart publish failed:", err);
  }
  return false;
}

/***/ }),

/***/ "./src/scripts/modules/bis-popup.js":
/*!******************************************!*\
  !*** ./src/scripts/modules/bis-popup.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ BISPopup)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BISPopup = /*#__PURE__*/function (_HTMLElement) {
  function BISPopup() {
    var _this;
    _classCallCheck(this, BISPopup);
    _this = _callSuper(this, BISPopup);

    /** @type {string} */
    _this.productId = _this.dataset.productId;
    /** @type {HTMLDialogElement} */
    _this.dialogEl = _this.querySelector("dialog");
    /** @type {HTMLButtonElement} */
    _this.dialogHeaderCloseButtonEL = _this.querySelector(".bis-popup__close");
    /** @type {HTMLDivElement} */
    _this.dialogMessageWrapperEl = _this.querySelector(".bis-popup__completed-message");
    /** @type {HTMLSpanElement} */
    _this.dialogMessageEl = _this.dialogMessageWrapperEl.querySelector("span");
    /** @type {HTMLButtonElement} */
    _this.dialogMessageCloseButtonEl = _this.querySelector(".bis-popup__completed-message-close");
    /** @type {HTMLFormElement} */
    _this.formEl = _this.querySelector("form");
    /** @type {HTMLSelectElement} */
    _this.variantSelectorEl = _this.querySelector('select[name="variants"]');
    /** @type {HTMLInputElement} */
    _this.emailAddressFieldEl = _this.querySelector('input[name="email"]');
    /** @type {HTMLInputElement} */
    _this.acceptsMarketingCheckboxEl = _this.querySelector('input[name="accepts_marketing"]');

    /** @type {HTMLElement} */
    _this.mainProductEl = _this.closest("main-product");
    return _this;
  }
  _inherits(BISPopup, _HTMLElement);
  return _createClass(BISPopup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      // Set up event listeners
      this.dialogHeaderCloseButtonEL.addEventListener("click", function () {
        _this2.closeDialog();
      });
      this.dialogMessageCloseButtonEl.addEventListener("click", function () {
        _this2.closeDialog();
      });
      this.formEl.querySelector('button[type="submit"').addEventListener("click", function (e) {
        e.preventDefault();
        _this2.handleFormSubmit();
      });
      this.formEl.addEventListener("submit", function (e) {
        e.preventDefault();
        _this2.handleFormSubmit();
      });
      if (this.mainProductEl !== undefined) {
        this.mainProductEl.addEventListener("click", function (e) {
          if (!e.target.id == "BIS_trigger") return;
          if (!e.target.parentNode.classList.contains("is-sold-out")) return;
          _this2.openDialog();
        });
      }
    }
  }, {
    key: "openDialog",
    value: function openDialog() {
      this.dialogEl.showModal();
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.dialogEl.close();
    }
  }, {
    key: "handleFormSubmit",
    value: function () {
      var _handleFormSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return BIS.create(this.emailAddressFieldEl.value, this.variantSelectorEl.value, this.productId, {
                accepts_marketing: this.acceptsMarketingCheckboxEl.checked
              });
            case 1:
              res = _context.v;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              console.log(res);
              if (!(res.status != "OK")) {
                _context.n = 4;
                break;
              }
              this.dialogMessageWrapperEl.classList.remove("bis-popup__completed-message--success");
              this.dialogMessageWrapperEl.classList.add("bis-popup__completed-message--error");
              this.dialogMessageEl.innerText = res.errors.base[0];
              return _context.a(2);
            case 4:
              this.dialogMessageWrapperEl.classList.remove("bis-popup__completed-message--error");
              this.dialogMessageWrapperEl.classList.add("bis-popup__completed-message--success");
              this.dialogMessageEl.innerText = res.message;
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleFormSubmit(_x) {
        return _handleFormSubmit.apply(this, arguments);
      }
      return handleFormSubmit;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/cart.js":
/*!*************************************!*\
  !*** ./src/scripts/modules/cart.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Cart)
/* harmony export */ });
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-currency */ "./node_modules/@shopify/theme-currency/currency.js");
/* harmony import */ var whatwg_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! whatwg-fetch */ "./node_modules/whatwg-fetch/fetch.js");
/* harmony import */ var form_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! form-serialize */ "./node_modules/form-serialize/index.js");
/* harmony import */ var form_serialize__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(form_serialize__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _pdp_preselect_ga4__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./pdp-preselect-ga4 */ "./src/scripts/modules/pdp-preselect-ga4.js");
/* harmony import */ var _pdp_sticky_atc_ga4__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pdp-sticky-atc-ga4 */ "./src/scripts/modules/pdp-sticky-atc-ga4.js");
/* harmony import */ var _bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./bike-build-lines.mjs */ "./src/scripts/modules/bike-build-lines.mjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var Cart = /*#__PURE__*/function () {
  function Cart() {
    _classCallCheck(this, Cart);
    this.DOM = {
      openTrigger: ".cart__trigger",
      closeTrigger: ".cart-drawer__header-close",
      cart: ".cart-drawer",
      cartInner: ".cart-drawer__inner",
      cartBody: ".cart-drawer__body",
      cartOverlay: ".cart-drawer__overlay",
      removeItem: "",
      addItem: ".select-options-button",
      addItemAlt: "#AddToCart",
      addUpsell: ".js-upsell-add",
      quantityPlus: "",
      quantityMinus: "",
      cartItem: ".cart-item",
      productFormError: ".js-product-form-error"
    };
    this.openTrigger = document.querySelectorAll(this.DOM.openTrigger);
    this.closeTrigger = document.querySelectorAll(this.DOM.closeTrigger);
    this.cart = document.querySelector(this.DOM.cart);
    this.cartInner = document.querySelector(this.DOM.cartInner);
    this.cartBody = document.querySelector(this.DOM.cartBody);
    this.cartOverlay = document.querySelectorAll(this.DOM.cartOverlay);
    this.addUpsell = document.querySelectorAll(this.DOM.addUpsell);
    this.$cartItems = document.querySelectorAll(this.DOM.cartItem);
    this.addButton = document.querySelectorAll(this.DOM.addItem);
    this.addButtonAlt = document.querySelectorAll(this.DOM.addItemAlt);
    this.currentCart = {};
  }
  return _createClass(Cart, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.bindCheckoutFallback();
      Array.from(this.openTrigger).forEach(function (el) {
        el.addEventListener("click", function (e) {
          return _this.openDraw(e);
        });
      });
      Array.from(this.closeTrigger).forEach(function (el) {
        el.addEventListener("click", function (e) {
          return _this.closeDraw(e);
        });
      });
      Array.from(this.cartOverlay).forEach(function (el) {
        el.addEventListener("click", function (e) {
          return _this.closeDraw(e);
        });
      });
      Array.from(this.addButton).forEach(function (el) {
        el.addEventListener("click", function (e) {
          return _this.addItem(e);
        });
      });
      Array.from(this.addButtonAlt).forEach(function (el) {
        el.addEventListener("click", function (e) {
          return _this.addItem(e);
        });
      });
      document.addEventListener("click", function (e) {
        if (e.target.classList.contains("cart-drawer__overlay") || e.target.closest(".cart-drawer__header-close")) {
          _this.closeDraw();
        }
        if (e.target.classList.contains("delete-item")) {
          _this.deleteItem(e);
        }
        if (e.target.classList.contains("plus-item")) {
          _this.updateQty(e);
        }
        if (e.target.classList.contains("minus-item")) {
          _this.updateQty(e);
        }
      });
      document.addEventListener("renderCart", function (e) {
        _this.renderCart();
      });

      // this.fetchCart();
    }
  }, {
    key: "bindCheckoutFallback",
    value: function bindCheckoutFallback() {
      if (window.__cartDrawerCheckoutFallbackBound) {
        return;
      }
      document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !target.closest) {
          return;
        }
        var checkoutTrigger = target.closest('.cart-drawer a[href="/checkout"], .cart-drawer a.button.primary_green.big, .cart-drawer [name="checkout"]');
        if (!checkoutTrigger) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }
        window.location.assign("/checkout");
      }, true);
      window.__cartDrawerCheckoutFallbackBound = true;
    }
  }, {
    key: "openDraw",
    value: function openDraw() {
      document.querySelector(this.DOM.cart).classList.add("active");
      document.querySelector(this.DOM.cartInner).classList.add("open");
      document.querySelector("body").classList.add("showingScroll");
    }
  }, {
    key: "closeDraw",
    value: function closeDraw() {
      document.querySelector(this.DOM.cart).classList.remove("active");
      document.querySelector(this.DOM.cartInner).classList.remove("open");
      document.querySelector("body").classList.remove("showingScroll");
    }
  }, {
    key: "getFilteredCartCount",
    value: function getFilteredCartCount(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        return 0;
      }
      return cart.items.reduce(function (total, item) {
        var isValidItem = true;
        var properties = item.properties || {};
        Object.keys(properties).forEach(function (key) {
          if (key.indexOf("parentLineItem") !== -1) {
            isValidItem = false;
          }
          if (key.indexOf("OPTIONS_HIDDEN_PRODUCT") !== -1) {
            isValidItem = false;
          }
          if (key.indexOf("_bundle_free") !== -1 && String(properties[key]) === "true") {
            isValidItem = false;
          }
        });
        if (!isValidItem) {
          return total;
        }
        return total + (item.quantity || 0);
      }, 0);
    }
  }, {
    key: "updateCartCount",
    value: function updateCartCount() {
      var cartCount = this.getFilteredCartCount(this.currentCart);
      var isEmpty = cartCount === 0;
      var countEl = document.getElementById("CartCount");
      if (countEl) {
        countEl.textContent = cartCount;
        countEl.classList.toggle("hidden-count", isEmpty);
      }
      Array.from(this.openTrigger).forEach(function (el) {
        isEmpty ? el.classList.remove("cart__trigger--has-items") : el.classList.add("cart__trigger--has-items");
      });
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(e) {
      var _this2 = this;
      e.preventDefault();
      var cartItem = e.target.closest(".cart-item");
      var deletedItemKey = cartItem.getAttribute("data-attr-key");

      // Always fetch the live cart first so we can reliably cascade deletion to
      // all related items. Handles both property systems:
      //   - Regular bundles: _bundle_instance_id shared across parent + children
      //   - Bike builder: _primaryParentLineItem on parent, _parentLineItem_TYPE on children
      // We cannot rely on DOM attributes (data-attr-bundle-parent) because the Liquid
      // 'contains parentLineItem' check also matches '_primaryParentLineItem', causing
      // bike parents to be incorrectly excluded from bundle-parent detection.
      window.fetch(window.Shopify.routes.root + "cart.js", {
        credentials: "same-origin"
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        var updates = {};

        // Always zero the deleted item itself
        updates[deletedItemKey] = 0;
        var deletedItem = cart.items.find(function (item) {
          return item.key === deletedItemKey;
        });
        var deletedProps = deletedItem && deletedItem.properties || {};

        // Regular bundle: match by shared _bundle_instance_id
        var bundleInstanceId = deletedProps["_bundle_instance_id"] || deletedProps["bundle_instance_id"] || deletedProps["_bundle_id"];

        // Bike builder: match children where _parentLineItem_X value ends with ___bikeParentId
        var bikeParentId = deletedProps["_primaryParentLineItem"];
        if (bundleInstanceId || bikeParentId) {
          cart.items.forEach(function (item) {
            if (item.key === deletedItemKey) return;
            var props = item.properties || {};
            if (bundleInstanceId) {
              var itemInstanceId = props["_bundle_instance_id"] || props["bundle_instance_id"] || props["_bundle_id"];
              if (itemInstanceId === bundleInstanceId) {
                updates[item.key] = 0;
                return;
              }
            }

            // Shared with the bike builder's edit mode, see bike-build-lines.mjs.
            if (bikeParentId && (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__.isComponentOf)(props, bikeParentId)) {
              updates[item.key] = 0;
            }
          });
        }
        return window.fetch(window.Shopify.routes.root + "cart/update.js", {
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: updates,
            sections: ["mini-cart"]
          })
        });
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (window.location.pathname === "/cart") {
          window.location.reload();
          return;
        }
        var sectionHTML = result.sections && result.sections["mini-cart"];
        if (sectionHTML) {
          document.querySelector("#shopify-section-mini-cart").innerHTML = sectionHTML;
          _this2.openDraw();
          _this2.fetchCart();
          _this2.checkBikeBuilder();
        } else {
          _this2.deletedItem = true;
          _this2.renderCart();
        }
        // Safety net: remove any bike components whose parent is no longer in the cart.
        // Runs after the primary deletion in case the pre-deletion property matching missed
        // any components (e.g. unexpected property key format).
        _this2.cleanupOrphanedBikeComponents();
      })["catch"](function (err) {
        return console.error(err.message, err);
      });
    }

    // Scans the cart for bike builder components (items with parentLineItem_* properties)
    // whose referenced parent (primaryParentLineItem value) no longer exists in the cart.
    // Called after any deletion as a safety net for orphaned components.
  }, {
    key: "cleanupOrphanedBikeComponents",
    value: function cleanupOrphanedBikeComponents() {
      var _this3 = this;
      window.fetch(window.Shopify.routes.root + "cart.js", {
        credentials: "same-origin"
      }).then(function (r) {
        return r.json();
      }).then(function (cart) {
        // Collect all active bike parent IDs from primaryParentLineItem properties
        var activeBikeParentIds = new Set();
        cart.items.forEach(function (item) {
          var parentId = (item.properties || {})["_primaryParentLineItem"];
          if (parentId != null) activeBikeParentIds.add(String(parentId));
        });

        // Find components referencing a parent ID that is no longer present
        var updates = {};
        cart.items.forEach(function (item) {
          var props = item.properties || {};
          var isOrphaned = Object.keys(props).some(function (key) {
            if (!key.startsWith("_parentLineItem")) return false;
            var ref = String(props[key]).split("___").pop();
            return !activeBikeParentIds.has(ref);
          });
          if (isOrphaned) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return null;
        return window.fetch(window.Shopify.routes.root + "cart/update.js", {
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: updates,
            sections: ["mini-cart"]
          })
        });
      }).then(function (response) {
        return response && response.json();
      }).then(function (result) {
        if (!result) return;
        var sectionHTML = result.sections && result.sections["mini-cart"];
        if (sectionHTML) {
          var cartWasOpen = document.body.classList.contains("showingScroll");
          document.querySelector("#shopify-section-mini-cart").innerHTML = sectionHTML;
          if (cartWasOpen) _this3.openDraw();
          _this3.fetchCart();
        }
      })["catch"](function (err) {
        return console.error(err.message, err);
      });
    }
  }, {
    key: "updateQty",
    value: function updateQty(e) {
      var _this4 = this;
      e.preventDefault();
      var data = "";
      if (e.target.closest(".cart-item").getAttribute("data-attr-bundle-parent") == "true") {
        var parentCartItem = e.target.closest(".cart-item");
        var key = parentCartItem.getAttribute("data-attr-key");
        var qty = parseInt(e.target.getAttribute("data-attr-qty"));
        var bundleInstanceId = parentCartItem.getAttribute("data-attr-bundle-instance-id");
        data = {
          updates: _defineProperty({}, key, qty)
        };
        var cartDrawerBody = e.target.closest(".cart-drawer__body");
        var cartForm = e.target.closest("#cart-form");
        var cartItems;
        if (cartDrawerBody) {
          cartItems = cartDrawerBody.getElementsByClassName("cart-item");
        } else {
          cartItems = cartForm.getElementsByClassName("cart-item");
        }
        var index = 1;
        Array.from(cartItems).forEach(function (cartItem) {
          if (cartItem.hasAttribute("data-attr-bundle-id") && cartItem.getAttribute("data-attr-bundle-id") === bundleInstanceId) {
            var cartItemKey = cartItem.dataset.attrKey;
            data.updates[cartItemKey] = qty;
          }
          index += 1;
        });
      } else {
        var _key = e.target.closest(".cart-item").getAttribute("data-attr-key");
        var _qty = parseInt(e.target.getAttribute("data-attr-qty"));
        data = {
          updates: _defineProperty({}, _key, _qty)
        };
      }
      data.sections = ["mini-cart"];
      window.fetch(window.Shopify.routes.root + "cart/update.js", {
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (window.location.pathname === "/cart") {
          window.location.reload();
          return;
        }
        var sectionHTML = result.sections && result.sections["mini-cart"];
        if (sectionHTML) {
          document.querySelector("#shopify-section-mini-cart").innerHTML = sectionHTML;
          _this4.openDraw();
          _this4.fetchCart();
          _this4.checkBikeBuilder();
        } else {
          _this4.renderCart();
        }
      })["catch"](function (err) {
        return console.error(err.message, err);
      });
    }
  }, {
    key: "fetchCart",
    value: function fetchCart() {
      var _this5 = this;
      return window.fetch("/cart.js", {
        credentials: "same-origin",
        method: "GET"
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        // this.renderCart(cart);
        _this5.currentCart = cart;
        _this5.updateCartCount();
      })["catch"](function (error) {
        _this5.ajaxRequestFail();
        throw new Error(error);
      });
    }
  }, {
    key: "addItem",
    value: function addItem(cart) {
      var _this6 = this;
      cart.preventDefault();
      var form = cart.target.closest("form");
      var formData = new FormData(form);
      var errorsJson = form.dataset.errors;
      var formHasErrors = errorsJson ? JSON.parse(errorsJson).length > 0 : false;
      this.hasUpsell = cart.target.classList.contains("js-upsell");
      if (formHasErrors) {
        form.dispatchEvent(new CustomEvent("error"));
        return;
      }

      // If the hidden select has no value (e.g. all variants were filtered from the select),
      // fall back to data-current-variant set by product.js on the form element.
      if (!formData.get("id") && form.dataset.currentVariant) {
        formData.set("id", form.dataset.currentVariant);
      }
      var stickyAtcStuck = (0,_pdp_sticky_atc_ga4__WEBPACK_IMPORTED_MODULE_4__.isStickyAtcStuck)(form);
      window.fetch(window.Shopify.routes.root + "cart/add.js", {
        credentials: "same-origin",
        method: "POST",
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        (0,_pdp_preselect_ga4__WEBPACK_IMPORTED_MODULE_3__.emitPreselectAdd)(form, cart && cart.variant_id);
        (0,_pdp_sticky_atc_ga4__WEBPACK_IMPORTED_MODULE_4__.emitStickyAtcAdd)(form, cart && cart.variant_id, stickyAtcStuck);
        _this6.renderCart();
      })["catch"](function (err) {
        return console.error(err.message, err);
      });
    }
  }, {
    key: "renderCart",
    value: function renderCart(cart) {
      var _this7 = this;
      fetch(window.Shopify.routes.root + "?sections=mini-cart").then(function (response) {
        return response.json();
      }).then(function (cart) {
        document.querySelector("#shopify-section-mini-cart").innerHTML = cart["mini-cart"];
        // Lets anything that marks basket lines (bike-build-updated.js) redo it.
        document.dispatchEvent(new CustomEvent("cart:rendered"));
        if (!_this7.hasUpsell || _this7.deletedItem) {
          _this7.openDraw();
          if (_this7.deletedItem) {
            _this7.deletedItem = false;
          }
        }
        _this7.fetchCart();
        _this7.checkBikeBuilder();
      });
    }

    // IF THERE IS A BIKE BUILDER
    // WE NEED TO CHANGE THE UNIQUE ID
  }, {
    key: "checkBikeBuilder",
    value: function checkBikeBuilder() {
      if (document.querySelector("#primaryParentLineItem")) {
        var primaryParentLineItem = document.querySelector("#primaryParentLineItem");
        var primaryParentLineItemValue = primaryParentLineItem.value;
        // ADD 1 TO THE CURRENT VALUE AND MAKE SURE IT'S AN INT
        var newPrimaryParentLineItemValue = parseInt(primaryParentLineItem.value) + 1;
        primaryParentLineItem.value = newPrimaryParentLineItemValue;

        // GET ALL ACCESSORIES AND CUSTOMIZE
        var accessories = document.querySelectorAll('input[name*="parentLineItem"]');
        accessories.forEach(function (accessory) {
          // GET THE CURRENT VALUE
          var accessoryValue = accessory.value;
          // REPLACE THE END VALUE WITH THE NEW VALUE
          var newAccessoryValue = accessoryValue.replace(primaryParentLineItemValue, newPrimaryParentLineItemValue);
          // SET THE NEW VALUE
          accessory.value = newAccessoryValue;
        });
      }
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/collection-promo.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/collection-promo.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageResizer)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ImageResizer = /*#__PURE__*/function () {
  function ImageResizer(promoCardClassName, collectionPromoClassName) {
    _classCallCheck(this, ImageResizer);
    this.promoCardClassName = promoCardClassName;
    this.collectionPromoClassName = collectionPromoClassName;
  }
  return _createClass(ImageResizer, [{
    key: "setPromoHeight",
    value: function setPromoHeight() {
      var promoCard = document.querySelector(".".concat(this.promoCardClassName));
      var promoCardHeight = promoCard ? promoCard.clientHeight : 0;
      var collectionPromo = document.querySelector(".".concat(this.collectionPromoClassName));

      // Check if .collection-promo has the classes .collection-promo__uno or .collection-promo__half
      if (collectionPromo && !collectionPromo.classList.contains('collection-promo__uno')) {
        var collectionPromoElements = document.querySelectorAll(".".concat(this.collectionPromoClassName));
        collectionPromoElements.forEach(function (element) {
          element.style.height = "".concat(promoCardHeight, "px");
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      this.setPromoHeight();
      window.addEventListener('resize', function () {
        return _this.setPromoHeight();
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/collection-slider.js":
/*!**************************************************!*\
  !*** ./src/scripts/modules/collection-slider.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CollectionSlider)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var CollectionSlider = /*#__PURE__*/function () {
  function CollectionSlider() {
    _classCallCheck(this, CollectionSlider);
    this.DOM = {
      container: ".collection-slider"
    };
    this.container = document.querySelector(this.DOM.container);
    console.log('collection slider');
  }
  return _createClass(CollectionSlider, [{
    key: "init",
    value: function init() {
      console.log('collection slider init');
      var slider = $('.collection-slider .slick-slider').slick({
        infinite: false,
        slidesToShow: 4,
        lazyLoad: 'anticipated',
        prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
        responsive: [{
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].mega,
          settings: {
            slidesToShow: 4,
            outerEdgeLimit: true
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].huge,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].medium,
          settings: {
            slidesToShow: 2.3,
            dots: true,
            arrows: false
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].small,
          settings: {
            slidesToShow: 1.2,
            dots: true,
            arrows: false,
            variableWidth: false,
            outerEdgeLimit: true
          }
        }]
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/globals/breakpoints.js":
/*!****************************************************!*\
  !*** ./src/scripts/modules/globals/breakpoints.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  tiny: 420,
  small: 568,
  medium: 768,
  large: 980,
  huge: 1200,
  mega: 1600
});

/***/ }),

/***/ "./src/scripts/modules/globals/formatPrice.js":
/*!****************************************************!*\
  !*** ./src/scripts/modules/globals/formatPrice.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatPrice: () => (/* binding */ formatPrice)
/* harmony export */ });
function formatPrice(price) {
  var total = Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active,
    useGrouping: true,
    minimumFractionDigits: 2
  }).format(price / 100);
  return total;
}

/***/ }),

/***/ "./src/scripts/modules/globals/onResize.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/globals/onResize.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ onResize)
/* harmony export */ });
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function onResize() {
  $(window).resize(function (callback) {
    clearTimeout(200);
    window.requestAnimationFrame(function () {
      setTimeout(callback, 200);
    });
  });
}

/***/ }),

/***/ "./src/scripts/modules/icons.js":
/*!**************************************!*\
  !*** ./src/scripts/modules/icons.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _icons_sprite_icon_arrow_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../icons/sprite-icon-arrow.svg */ "./src/icons/sprite-icon-arrow.svg");
/* harmony import */ var _icons_sprite_icon_arrow_right_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../icons/sprite-icon-arrow-right.svg */ "./src/icons/sprite-icon-arrow-right.svg");
/* harmony import */ var _icons_sprite_icon_arrow_left_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../icons/sprite-icon-arrow-left.svg */ "./src/icons/sprite-icon-arrow-left.svg");
/* harmony import */ var _icons_sprite_icon_search_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../icons/sprite-icon-search.svg */ "./src/icons/sprite-icon-search.svg");
/* harmony import */ var _icons_sprite_icon_cart_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../icons/sprite-icon-cart.svg */ "./src/icons/sprite-icon-cart.svg");
/* harmony import */ var _icons_sprite_icon_profile_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../icons/sprite-icon-profile.svg */ "./src/icons/sprite-icon-profile.svg");
/* harmony import */ var _icons_sprite_icon_facebook_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../icons/sprite-icon-facebook.svg */ "./src/icons/sprite-icon-facebook.svg");
/* harmony import */ var _icons_sprite_icon_twitter_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../icons/sprite-icon-twitter.svg */ "./src/icons/sprite-icon-twitter.svg");
/* harmony import */ var _icons_sprite_icon_instagram_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../icons/sprite-icon-instagram.svg */ "./src/icons/sprite-icon-instagram.svg");
/* harmony import */ var _icons_sprite_icon_vimeo_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../icons/sprite-icon-vimeo.svg */ "./src/icons/sprite-icon-vimeo.svg");
/* harmony import */ var _icons_sprite_icon_strava_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../icons/sprite-icon-strava.svg */ "./src/icons/sprite-icon-strava.svg");
/* harmony import */ var _icons_sprite_icon_youtube_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../icons/sprite-icon-youtube.svg */ "./src/icons/sprite-icon-youtube.svg");
/* harmony import */ var _icons_sprite_icon_hamburger_svg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../icons/sprite-icon-hamburger.svg */ "./src/icons/sprite-icon-hamburger.svg");
/* harmony import */ var _icons_sprite_icon_cross_svg__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../icons/sprite-icon-cross.svg */ "./src/icons/sprite-icon-cross.svg");
/* harmony import */ var _icons_sprite_icon_chevron_svg__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../icons/sprite-icon-chevron.svg */ "./src/icons/sprite-icon-chevron.svg");
/* harmony import */ var _icons_sprite_icon_filter_svg__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../icons/sprite-icon-filter.svg */ "./src/icons/sprite-icon-filter.svg");
/* harmony import */ var _icons_sprite_icon_filter_hide_svg__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../icons/sprite-icon-filter-hide.svg */ "./src/icons/sprite-icon-filter-hide.svg");
/* harmony import */ var _icons_sprite_icon_check_svg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../icons/sprite-icon-check.svg */ "./src/icons/sprite-icon-check.svg");
/* harmony import */ var _icons_sprite_icon_4_season_svg__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../icons/sprite-icon-4-season.svg */ "./src/icons/sprite-icon-4-season.svg");
/* harmony import */ var _icons_sprite_icon_non_polluting_svg__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../icons/sprite-icon-non-polluting.svg */ "./src/icons/sprite-icon-non-polluting.svg");
/* harmony import */ var _icons_sprite_icon_aircool_back_system_svg__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../icons/sprite-icon-aircool-back-system.svg */ "./src/icons/sprite-icon-aircool-back-system.svg");
/* harmony import */ var _icons_sprite_icon_odour_resistant_svg__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../icons/sprite-icon-odour-resistant.svg */ "./src/icons/sprite-icon-odour-resistant.svg");
/* harmony import */ var _icons_sprite_icon_anti_microbrial_svg__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../icons/sprite-icon-anti-microbrial.svg */ "./src/icons/sprite-icon-anti-microbrial.svg");
/* harmony import */ var _icons_sprite_icon_odourless_svg__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../icons/sprite-icon-odourless.svg */ "./src/icons/sprite-icon-odourless.svg");
/* harmony import */ var _icons_sprite_icon_apline_bond_svg__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../icons/sprite-icon-apline-bond.svg */ "./src/icons/sprite-icon-apline-bond.svg");
/* harmony import */ var _icons_sprite_icon_organic_svg__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../icons/sprite-icon-organic.svg */ "./src/icons/sprite-icon-organic.svg");
/* harmony import */ var _icons_sprite_icon_backpacking_svg__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../icons/sprite-icon-backpacking.svg */ "./src/icons/sprite-icon-backpacking.svg");
/* harmony import */ var _icons_sprite_icon_outdoor_specific_svg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../icons/sprite-icon-outdoor-specific.svg */ "./src/icons/sprite-icon-outdoor-specific.svg");
/* harmony import */ var _icons_sprite_icon_battery_life_svg__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../icons/sprite-icon-battery-life.svg */ "./src/icons/sprite-icon-battery-life.svg");
/* harmony import */ var _icons_sprite_icon_packable_svg__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../icons/sprite-icon-packable.svg */ "./src/icons/sprite-icon-packable.svg");
/* harmony import */ var _icons_sprite_icon_big_pockets_svg__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../icons/sprite-icon-big-pockets.svg */ "./src/icons/sprite-icon-big-pockets.svg");
/* harmony import */ var _icons_sprite_icon_performance_swimwear_svg__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../icons/sprite-icon-performance-swimwear.svg */ "./src/icons/sprite-icon-performance-swimwear.svg");
/* harmony import */ var _icons_sprite_icon_bike_svg__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../icons/sprite-icon-bike.svg */ "./src/icons/sprite-icon-bike.svg");
/* harmony import */ var _icons_sprite_icon_pfc_free_svg__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../icons/sprite-icon-pfc-free.svg */ "./src/icons/sprite-icon-pfc-free.svg");
/* harmony import */ var _icons_sprite_icon_bikepacking_svg__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../icons/sprite-icon-bikepacking.svg */ "./src/icons/sprite-icon-bikepacking.svg");
/* harmony import */ var _icons_sprite_icon_pitch_time_svg__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../icons/sprite-icon-pitch-time.svg */ "./src/icons/sprite-icon-pitch-time.svg");
/* harmony import */ var _icons_sprite_icon_biodegradable_svg__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../icons/sprite-icon-biodegradable.svg */ "./src/icons/sprite-icon-biodegradable.svg");
/* harmony import */ var _icons_sprite_icon_purposeful_svg__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../icons/sprite-icon-purposeful.svg */ "./src/icons/sprite-icon-purposeful.svg");
/* harmony import */ var _icons_sprite_icon_bouldering_svg__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../icons/sprite-icon-bouldering.svg */ "./src/icons/sprite-icon-bouldering.svg");
/* harmony import */ var _icons_sprite_icon_quick_drying_svg__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../icons/sprite-icon-quick-drying.svg */ "./src/icons/sprite-icon-quick-drying.svg");
/* harmony import */ var _icons_sprite_icon_breathable_svg__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../icons/sprite-icon-breathable.svg */ "./src/icons/sprite-icon-breathable.svg");
/* harmony import */ var _icons_sprite_icon_rds_svg__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../icons/sprite-icon-rds.svg */ "./src/icons/sprite-icon-rds.svg");
/* harmony import */ var _icons_sprite_icon_camp_svg__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../icons/sprite-icon-camp.svg */ "./src/icons/sprite-icon-camp.svg");
/* harmony import */ var _icons_sprite_icon_rechargeable_svg__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../icons/sprite-icon-rechargeable.svg */ "./src/icons/sprite-icon-rechargeable.svg");
/* harmony import */ var _icons_sprite_icon_climb_svg__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../icons/sprite-icon-climb.svg */ "./src/icons/sprite-icon-climb.svg");
/* harmony import */ var _icons_sprite_icon_recycled_svg__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../icons/sprite-icon-recycled.svg */ "./src/icons/sprite-icon-recycled.svg");
/* harmony import */ var _icons_sprite_icon_cold_protection_svg__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../icons/sprite-icon-cold-protection.svg */ "./src/icons/sprite-icon-cold-protection.svg");
/* harmony import */ var _icons_sprite_icon_reduce_fatigue_svg__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../icons/sprite-icon-reduce-fatigue.svg */ "./src/icons/sprite-icon-reduce-fatigue.svg");
/* harmony import */ var _icons_sprite_icon_down_svg__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../icons/sprite-icon-down.svg */ "./src/icons/sprite-icon-down.svg");
/* harmony import */ var _icons_sprite_icon_repairable_svg__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../icons/sprite-icon-repairable.svg */ "./src/icons/sprite-icon-repairable.svg");
/* harmony import */ var _icons_sprite_icon_durable_svg__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../../icons/sprite-icon-durable.svg */ "./src/icons/sprite-icon-durable.svg");
/* harmony import */ var _icons_sprite_icon_rugged_robust_svg__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../icons/sprite-icon-rugged-robust.svg */ "./src/icons/sprite-icon-rugged-robust.svg");
/* harmony import */ var _icons_sprite_icon_ethically_sourced_svg__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../icons/sprite-icon-ethically-sourced.svg */ "./src/icons/sprite-icon-ethically-sourced.svg");
/* harmony import */ var _icons_sprite_icon_run_svg__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../../icons/sprite-icon-run.svg */ "./src/icons/sprite-icon-run.svg");
/* harmony import */ var _icons_sprite_icon_go_further_svg__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../../icons/sprite-icon-go-further.svg */ "./src/icons/sprite-icon-go-further.svg");
/* harmony import */ var _icons_sprite_icon_rws_svg__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../../icons/sprite-icon-rws.svg */ "./src/icons/sprite-icon-rws.svg");
/* harmony import */ var _icons_sprite_icon_heat_protection_svg__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../../icons/sprite-icon-heat-protection.svg */ "./src/icons/sprite-icon-heat-protection.svg");
/* harmony import */ var _icons_sprite_icon_softshell_svg__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../../icons/sprite-icon-softshell.svg */ "./src/icons/sprite-icon-softshell.svg");
/* harmony import */ var _icons_sprite_icon_high_wicking_svg__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../icons/sprite-icon-high-wicking.svg */ "./src/icons/sprite-icon-high-wicking.svg");
/* harmony import */ var _icons_sprite_icon_stretch_svg__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../icons/sprite-icon-stretch.svg */ "./src/icons/sprite-icon-stretch.svg");
/* harmony import */ var _icons_sprite_icon_hike_svg__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../../icons/sprite-icon-hike.svg */ "./src/icons/sprite-icon-hike.svg");
/* harmony import */ var _icons_sprite_icon_strong_svg__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../../icons/sprite-icon-strong.svg */ "./src/icons/sprite-icon-strong.svg");
/* harmony import */ var _icons_sprite_icon_hydrophobic_down_svg__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../../icons/sprite-icon-hydrophobic-down.svg */ "./src/icons/sprite-icon-hydrophobic-down.svg");
/* harmony import */ var _icons_sprite_icon_sub_zero_cold_tested_svg__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../../icons/sprite-icon-sub-zero-cold-tested.svg */ "./src/icons/sprite-icon-sub-zero-cold-tested.svg");
/* harmony import */ var _icons_sprite_icon_improved_balance_svg__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../../icons/sprite-icon-improved-balance.svg */ "./src/icons/sprite-icon-improved-balance.svg");
/* harmony import */ var _icons_sprite_icon_sun_protection_svg__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../../icons/sprite-icon-sun-protection.svg */ "./src/icons/sprite-icon-sun-protection.svg");
/* harmony import */ var _icons_sprite_icon_kayak_svg__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../../icons/sprite-icon-kayak.svg */ "./src/icons/sprite-icon-kayak.svg");
/* harmony import */ var _icons_sprite_icon_swim_svg__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../../icons/sprite-icon-swim.svg */ "./src/icons/sprite-icon-swim.svg");
/* harmony import */ var _icons_sprite_icon_leg_lengths_svg__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../../icons/sprite-icon-leg-lengths.svg */ "./src/icons/sprite-icon-leg-lengths.svg");
/* harmony import */ var _icons_sprite_icon_synthetic_insulation_svg__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../../icons/sprite-icon-synthetic-insulation.svg */ "./src/icons/sprite-icon-synthetic-insulation.svg");
/* harmony import */ var _icons_sprite_icon_lightweight_svg__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../../icons/sprite-icon-lightweight.svg */ "./src/icons/sprite-icon-lightweight.svg");
/* harmony import */ var _icons_sprite_icon_tasteless_svg__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../../icons/sprite-icon-tasteless.svg */ "./src/icons/sprite-icon-tasteless.svg");
/* harmony import */ var _icons_sprite_icon_long_lasting_svg__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../../icons/sprite-icon-long-lasting.svg */ "./src/icons/sprite-icon-long-lasting.svg");
/* harmony import */ var _icons_sprite_icon_thermo_regulating_svg__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../../icons/sprite-icon-thermo-regulating.svg */ "./src/icons/sprite-icon-thermo-regulating.svg");
/* harmony import */ var _icons_sprite_icon_lower_impact_svg__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../../icons/sprite-icon-lower-impact.svg */ "./src/icons/sprite-icon-lower-impact.svg");
/* harmony import */ var _icons_sprite_icon_ultra_fine_comfort_svg__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../../icons/sprite-icon-ultra-fine-comfort.svg */ "./src/icons/sprite-icon-ultra-fine-comfort.svg");
/* harmony import */ var _icons_sprite_icon_lumens_svg__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../../icons/sprite-icon-lumens.svg */ "./src/icons/sprite-icon-lumens.svg");
/* harmony import */ var _icons_sprite_icon_warm_svg__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../../icons/sprite-icon-warm.svg */ "./src/icons/sprite-icon-warm.svg");
/* harmony import */ var _icons_sprite_icon_membrane_svg__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../../icons/sprite-icon-membrane.svg */ "./src/icons/sprite-icon-membrane.svg");
/* harmony import */ var _icons_sprite_icon_water_resistant_svg__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../../icons/sprite-icon-water-resistant.svg */ "./src/icons/sprite-icon-water-resistant.svg");
/* harmony import */ var _icons_sprite_icon_mens_and_womens_svg__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../../icons/sprite-icon-mens-and-womens.svg */ "./src/icons/sprite-icon-mens-and-womens.svg");
/* harmony import */ var _icons_sprite_icon_waterproof_svg__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../../icons/sprite-icon-waterproof.svg */ "./src/icons/sprite-icon-waterproof.svg");
/* harmony import */ var _icons_sprite_icon_mens_svg__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../../icons/sprite-icon-mens.svg */ "./src/icons/sprite-icon-mens.svg");
/* harmony import */ var _icons_sprite_icon_weight_svg__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../../icons/sprite-icon-weight.svg */ "./src/icons/sprite-icon-weight.svg");
/* harmony import */ var _icons_sprite_icon_merino_wool_svg__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../../icons/sprite-icon-merino-wool.svg */ "./src/icons/sprite-icon-merino-wool.svg");
/* harmony import */ var _icons_sprite_icon_wind_resistant_svg__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../../icons/sprite-icon-wind-resistant.svg */ "./src/icons/sprite-icon-wind-resistant.svg");
/* harmony import */ var _icons_sprite_icon_mountaineering_svg__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../../icons/sprite-icon-mountaineering.svg */ "./src/icons/sprite-icon-mountaineering.svg");
/* harmony import */ var _icons_sprite_icon_windproof_svg__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../../icons/sprite-icon-windproof.svg */ "./src/icons/sprite-icon-windproof.svg");
/* harmony import */ var _icons_sprite_icon_multi_activity_svg__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../../icons/sprite-icon-multi-activity.svg */ "./src/icons/sprite-icon-multi-activity.svg");
/* harmony import */ var _icons_sprite_icon_womens_svg__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../../icons/sprite-icon-womens.svg */ "./src/icons/sprite-icon-womens.svg");
/* harmony import */ var _icons_sprite_icon_natural_fibres_svg__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../../icons/sprite-icon-natural-fibres.svg */ "./src/icons/sprite-icon-natural-fibres.svg");
/* harmony import */ var _icons_sprite_icon_delete_svg__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../../icons/sprite-icon-delete.svg */ "./src/icons/sprite-icon-delete.svg");
/* harmony import */ var _icons_sprite_icon_add_svg__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../../icons/sprite-icon-add.svg */ "./src/icons/sprite-icon-add.svg");
/* harmony import */ var _icons_sprite_icon_minus_svg__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../../icons/sprite-icon-minus.svg */ "./src/icons/sprite-icon-minus.svg");
/* harmony import */ var _icons_sprite_icon_fivestars_svg__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../../icons/sprite-icon-fivestars.svg */ "./src/icons/sprite-icon-fivestars.svg");
/* harmony import */ var _icons_sprite_icon_calendar_svg__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(/*! ../../icons/sprite-icon-calendar.svg */ "./src/icons/sprite-icon-calendar.svg");
/* harmony import */ var _icons_sprite_icon_time_svg__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(/*! ../../icons/sprite-icon-time.svg */ "./src/icons/sprite-icon-time.svg");
/* harmony import */ var _icons_sprite_icon_location_svg__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(/*! ../../icons/sprite-icon-location.svg */ "./src/icons/sprite-icon-location.svg");
/* harmony import */ var _icons_sprite_icon_age_svg__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(/*! ../../icons/sprite-icon-age.svg */ "./src/icons/sprite-icon-age.svg");
/* harmony import */ var _icons_sprite_icon_disabled_svg__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(/*! ../../icons/sprite-icon-disabled.svg */ "./src/icons/sprite-icon-disabled.svg");
/* harmony import */ var _icons_sprite_icon_beginner_svg__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(/*! ../../icons/sprite-icon-beginner.svg */ "./src/icons/sprite-icon-beginner.svg");
/* harmony import */ var _icons_sprite_icon_delivery_svg__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(/*! ../../icons/sprite-icon-delivery.svg */ "./src/icons/sprite-icon-delivery.svg");
/* harmony import */ var _icons_sprite_icon_tiktok_svg__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(/*! ../../icons/sprite-icon-tiktok.svg */ "./src/icons/sprite-icon-tiktok.svg");








































































































/***/ }),

/***/ "./src/scripts/modules/modal-opener.js":
/*!*********************************************!*\
  !*** ./src/scripts/modules/modal-opener.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ModalOpener)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// Document-level click capture so the opener fires before any
// bubble-phase delegated handler (e.g. wiro.js's product-card
// navigation) gets a chance to swallow or redirect the click.
// Registered once globally on first instance connect.
var documentClickBound = false;
function documentClickHandler(event) {
  var target = event.target;
  if (!target || !target.closest) return;
  var trigger = target.closest("modal-opener > button, modal-opener button");
  if (!trigger) return;
  var opener = trigger.closest("modal-opener");
  if (!opener) return;
  event.preventDefault();
  event.stopPropagation();
  var modalSelector = opener.getAttribute("data-modal");
  if (!modalSelector) return;
  var modal = document.querySelector(modalSelector);
  if (!modal || typeof modal.show !== "function") {
    console.warn("[modal-opener] no <quick-add-modal> matches", modalSelector);
    return;
  }
  trigger.setAttribute("aria-expanded", "true");
  modal.show(trigger);
}
var ModalOpener = /*#__PURE__*/function (_HTMLElement) {
  function ModalOpener() {
    _classCallCheck(this, ModalOpener);
    return _callSuper(this, ModalOpener, arguments);
  }
  _inherits(ModalOpener, _HTMLElement);
  return _createClass(ModalOpener, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var button = this.querySelector("button");
      if (button) {
        button.setAttribute("aria-haspopup", "dialog");
        button.setAttribute("aria-expanded", "false");
      }
      if (!documentClickBound) {
        document.addEventListener("click", documentClickHandler, true);
        documentClickBound = true;
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/navigation.js":
/*!*******************************************!*\
  !*** ./src/scripts/modules/navigation.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Navigation)
/* harmony export */ });
/* harmony import */ var _globals_onResize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./globals/onResize */ "./src/scripts/modules/globals/onResize.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Navigation = /*#__PURE__*/function () {
  function Navigation() {
    var _this = this;
    _classCallCheck(this, Navigation);
    this.DOM = {
      shopifySectionHeader: "#shopify-section-header",
      fullHeader: ".site-header",
      nav: ".navigation",
      hamburger: ".hamburger-menu",
      megaMenuGoBack: ".mega--menu--go--back",
      parentArrow: ".parent--arrow",
      searchForm: "#search-field",
      searchMobile: ".search.mobile",
      closeSearch: ".close_search",
      closeSearchMobile: ".close_search.mobile",
      sonderBar: "#shopify-section-sonder-bar"
    };
    this.body = document.querySelector("body");
    this.shopifySectionHeader = document.querySelector(this.DOM.shopifySectionHeader);
    this.fullHeader = document.querySelector(this.DOM.fullHeader);
    this.nav = document.querySelector(this.DOM.nav);
    this.hamburger = document.querySelector(this.DOM.hamburger);
    this.megaMenuGoBack = document.querySelectorAll(this.DOM.megaMenuGoBack);
    this.parentArrow = document.querySelectorAll(this.DOM.parentArrow);
    this.searchForm = document.querySelector(this.DOM.searchForm);
    this.searchMobile = document.querySelectorAll(this.DOM.searchMobile);
    this.closeSearch = document.querySelectorAll(this.DOM.closeSearch);
    this.closeSearchMobile = document.querySelectorAll(this.DOM.closeSearchMobile);
    this.sonderBar = document.querySelector(this.DOM.sonderBar);
    this.lastKnownScrollPosition = 0;
    this.ticking = false;
    this.scrollingDirection = 'down';
    this.window_height = 0;
    this.double_header_bars = 0;
    window.addEventListener('resize', function (e) {
      _this.setCoreVariables();
    });
    window.addEventListener('scroll', function (e) {
      _this.stickyHeader(e);
    });
    this.keyboardOpened = false;
  }
  return _createClass(Navigation, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.setCoreVariables();
      this.initIOSViewportFix();

      // PREP THE HAMBURGER CLICK
      this.hamburger.addEventListener('click', function (e) {
        return _this2.toggleMegaMenu(e);
      });
      Array.from(this.megaMenuGoBack).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.megaMenuBack(e);
        });
      });
      Array.from(this.parentArrow).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.showSubMenu(e);
        });
      });

      // ADDING SEARCH BOX EVENT LISTENER
      this.searchForm.addEventListener('focus', function (e) {
        return _this2.searchFocus(e);
      });
      if (!this.closeSearchMobile && this.closeSearchMobile.style.display !== "none") {
        this.searchForm.addEventListener('focusout', function (e) {
          return _this2.searchFocusOut(e);
        });
      }
      Array.from(this.searchMobile).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.searchFocus(e);
        });
      });
      Array.from(this.closeSearch).forEach(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.searchFocusOut(e);
        });
      });
      if (this.isTouchDevice()) {
        var menuItems = document.querySelectorAll('.navigation > nav > ul > li > a');
        menuItems.forEach(function (item) {
          item.addEventListener('click', function (event) {
            event.preventDefault();
            this.toggleMenu();
          }.bind(this));
        }.bind(this));
      }
    }
  }, {
    key: "setCoreVariables",
    value: function setCoreVariables() {
      // UNDERSTANDING THE 100VH IN CSS
      document.documentElement.style.setProperty('--window-height', "".concat(window.innerHeight, "px"));
      this.double_header_bars = this.sonderBar.clientHeight;
      document.documentElement.style.setProperty('--double-header-bars', "".concat(this.double_header_bars, "px"));
    }
  }, {
    key: "stickyHeader",
    value: function stickyHeader(e) {
      var _this3 = this;
      if (this.lastKnownScrollPosition < window.scrollY) {
        this.scrollingDirection = 'down';
      } else {
        this.scrollingDirection = 'up';
      }
      this.lastKnownScrollPosition = window.scrollY;
      if (!this.ticking) {
        window.requestAnimationFrame(function () {
          if (_this3.lastKnownScrollPosition > _this3.double_header_bars) {
            _this3.shopifySectionHeader.classList.add('sticky_header');
            if (_this3.scrollingDirection === 'up') {
              _this3.shopifySectionHeader.classList.add('mobile_sticky_header');
            } else {
              _this3.shopifySectionHeader.classList.remove('mobile_sticky_header');
            }
          } else {
            _this3.shopifySectionHeader.classList.remove('sticky_header');
            _this3.shopifySectionHeader.classList.remove('mobile_sticky_header');
          }
          _this3.ticking = false;
        });
        this.ticking = true;
      }
    }
  }, {
    key: "toggleMegaMenu",
    value: function toggleMegaMenu() {
      if (!this.fullHeader.classList.contains('open') && window.scrollY > 0) {
        this.sonderBar.scrollIntoView();
      }
      this.fullHeader.classList.toggle('open');
      // REMOVE LEVEL TWO SO IT'S RESET BACK
      this.fullHeader.classList.remove('levelTwo');
      this.nav.querySelectorAll('li').forEach(function (e) {
        e.classList.remove('showChild');
      });
      this.body.classList.toggle('mobileMenu');
      if (document.body.classList.contains('storeSonder')) {
        var navLogoElement = document.querySelector('#logo .nav_logo');
        navLogoElement.classList.toggle('alternate');
      }

      // SET CURRENT HEIGHT
      document.documentElement.style.setProperty('--window-height', "".concat(window.innerHeight, "px"));
    }
  }, {
    key: "megaMenuBack",
    value: function megaMenuBack(e) {
      e.target.closest('li').classList.remove('showChild');
      this.fullHeader.classList.remove('levelTwo');
    }
  }, {
    key: "showSubMenu",
    value: function showSubMenu(e) {
      e.target.parentElement.classList.add('showChild');
      this.fullHeader.classList.add('levelTwo');
    }
  }, {
    key: "searchFocus",
    value: function searchFocus() {
      // SET CURRENT HEIGHT
      document.documentElement.style.setProperty('--window-height', "".concat(window.innerHeight, "px"));
      this.body.classList.add('showingScroll');
      this.body.classList.add('showing__search');
      this.focusAndOpenKeyboard(document.querySelector('#search-field'), 500);
      this.searchForm.focus();
      var form = this.searchForm.closest('form');
      var form_left = form.offsetLeft;
      var container = this.searchForm.closest('.container');

      // SET THE PARENT TO THE DIMENSIONS
      form.style.left = form_left + "px";

      // MAKE THE INPUT ABSOLUTE AND POSITIONED WHERE IT SHOULD BE

      // ADD A CLASS TO THE AREA TO ANIMATE
      window.setTimeout(function () {
        container.classList.add('show__search');
      }, 40);
      this.keyboardOpened = true;
    }
  }, {
    key: "searchFocusOut",
    value: function searchFocusOut(e) {
      this.body.classList.remove('showingScroll');
      var container = this.searchForm.closest('.container');
      container.classList.remove('show__search');
      this.body.classList.remove('showing__search');
      var selection = document.querySelector('#klevuSearchingArea');
      if (selection !== null) {
        selection.setAttribute('style', 'display:none !important');
      }
      this.keyboardOpened = false;
    }
  }, {
    key: "focusAndOpenKeyboard",
    value: function focusAndOpenKeyboard(el, timeout) {
      if (!this.keyboardOpened && el) {
        // Align temp input element approximately where the input element is
        // so the cursor doesn't jump around
        var __tempEl__ = document.createElement('input');
        __tempEl__.style.position = 'absolute';
        __tempEl__.style.top = el.offsetTop + 7 + 'px';
        __tempEl__.style.left = el.offsetLeft + 'px';
        __tempEl__.style.height = 0;
        __tempEl__.style.opacity = 0;
        // Put this temp element as a child of the page <body> and focus on it
        document.body.appendChild(__tempEl__);
        __tempEl__.focus();

        // The keyboard is open. Now do a delayed focus on the target element
        setTimeout(function () {
          el.focus();
          el.click();
          // Remove the temp element
          document.body.removeChild(__tempEl__);
        }, timeout);

        // Set the flag to true
        this.keyboardOpened = true;
      }
    }

    // Add the isTouchDevice method
  }, {
    key: "isTouchDevice",
    value: function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    // Add the toggleMenu method
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var megaMenu = document.querySelector('.mega-menu-background');
      if (megaMenu.style.display === 'grid') {
        megaMenu.style.display = 'none';
      } else {
        megaMenu.style.display = 'grid';
      }
    }

    // Fix for iOS 26 Liquid Glass: after keyboard dismissal,
    // visualViewport.offsetTop may not reset to 0, leaving fixed
    // elements (cart drawer, modals) misaligned.
  }, {
    key: "initIOSViewportFix",
    value: function initIOSViewportFix() {
      var _this4 = this;
      if (!window.visualViewport) return;
      document.addEventListener('focusout', function (e) {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
          setTimeout(function () {
            if (window.visualViewport && window.visualViewport.offsetTop > 0) {
              window.scrollBy(0, -1);
              window.scrollBy(0, 1);
            }
            _this4.setCoreVariables();
          }, 100);
        }
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/pdp-preselect-ga4.js":
/*!**************************************************!*\
  !*** ./src/scripts/modules/pdp-preselect-ga4.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   emitPreselectAdd: () => (/* binding */ emitPreselectAdd),
/* harmony export */   emitPreselectView: () => (/* binding */ emitPreselectView)
/* harmony export */ });
/**
 * Arm stamp for the PDP variant pre-selection A/B test.
 *
 * Shopify Rollouts reports nothing we can read: the GA4 property has no
 * experiment dimension, and a full month of the previous Rollouts test emitted
 * no experiment event of any kind. So the page records its own arm rather than
 * depending on the delivery mechanism, the same bridge PR #132 uses for the
 * bike builders.
 *
 * Two events, one per PDP view and one per successful add, both carrying the
 * arm and the available-variant bucket. Carrying the bucket here rather than
 * reconstructing it afterwards matters: only products with two or more
 * available variants can respond to pre-selection at all, because at exactly
 * one available variant product.js already selects it in both arms. A blended
 * read would dilute the effect with products that cannot move.
 *
 * A custom pixel forwards both events to GA4. Nothing here throws.
 */

var VIEW_EVENT = "alpkit:pdp_preselect_view";
var ADD_EVENT = "alpkit:pdp_preselect_add";
var FORM_SELECTOR = "[data-product-form]";

/**
 * Read the arm stamp rendered onto the product form by product-form.liquid.
 *
 * @param {HTMLElement} [form] - the product form, looked up if not supplied
 * @returns {Object|null} null when the page is not a stamped PDP
 */
function readStamp(form) {
  var el = form || document.querySelector(FORM_SELECTOR);
  if (!el || !el.dataset || !el.dataset.preselectArm) return null;
  return {
    arm: el.dataset.preselectArm,
    bucket: el.dataset.preselectBucket || "unknown",
    available_variants: Number(el.dataset.preselectAvailable || 0),
    product_id: el.dataset.productid || null,
    product_handle: el.dataset.productHandle || null
  };
}

/**
 * Publish a customer event, guarding every way the sandbox can be absent.
 *
 * @returns {boolean} true if the event was published
 */
function publish(name, payload) {
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(name, payload);
      return true;
    }
  } catch (err) {
    console.error("pdp pre-select stamp failed:", err);
  }
  return false;
}

/**
 * One event per PDP view. This is the denominator for the add-to-cart rate, so
 * it has to fire on every stamped product page, including sold-out ones.
 *
 * @returns {boolean}
 */
function emitPreselectView() {
  var stamp = readStamp();
  if (!stamp) return false;
  return publish(VIEW_EVENT, stamp);
}

/**
 * One event per successful add from a stamped PDP.
 *
 * @param {HTMLElement} form - the form that was submitted
 * @param {number|string} [variantId] - variant id from the cart/add.js response
 * @returns {boolean}
 */
function emitPreselectAdd(form, variantId) {
  var stamp = readStamp(form);
  if (!stamp) return false;
  return publish(ADD_EVENT, Object.assign({}, stamp, {
    variant_id: variantId || null
  }));
}

/***/ }),

/***/ "./src/scripts/modules/pdp-sticky-atc-ga4.js":
/*!***************************************************!*\
  !*** ./src/scripts/modules/pdp-sticky-atc-ga4.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   emitStickyAtcAdd: () => (/* binding */ emitStickyAtcAdd),
/* harmony export */   emitStickyAtcView: () => (/* binding */ emitStickyAtcView),
/* harmony export */   isStickyAtcStuck: () => (/* binding */ isStickyAtcStuck)
/* harmony export */ });
/**
 * Arm stamp for the mobile sticky add to basket A/B test.
 *
 * Same approach as pdp-preselect-ga4.js: Shopify Rollouts reports nothing we
 * can read, so the page records its own arm. Kept as a separate module so
 * either test can be removed without touching the other.
 *
 * Two events, one per PDP view and one per successful add, both carrying the
 * arm and a viewport bucket. Only mobile can respond to the test, because
 * product.js only pins the button at 980px and below, so desktop is the
 * negative control and should show no difference between arms.
 *
 * The add also records whether the button was pinned when it was clicked.
 * product.js toggles the stuck class in both arms and only the CSS differs, so
 * in the off arm this is the counterfactual: an add the bar would have carried.
 *
 * A custom pixel forwards both events to GA4. Nothing here throws.
 */

var VIEW_EVENT = "alpkit:pdp_sticky_view";
var ADD_EVENT = "alpkit:pdp_sticky_add";
var FORM_SELECTOR = "[data-product-form]";
var STUCK_SELECTOR = ".product-form__actions--stickied";

// Matches the isMobile test in product.js handleStickyAddToCart.
var MOBILE_MAX_WIDTH = 980;

/**
 * Read the arm stamp rendered onto the product form by product-form.liquid.
 *
 * @param {HTMLElement} [form] - the product form, looked up if not supplied
 * @returns {Object|null} null when the page is not a stamped PDP
 */
function readStamp(form) {
  var el = form || document.querySelector(FORM_SELECTOR);
  if (!el || !el.dataset || !el.dataset.stickyAtcArm) return null;
  return {
    arm: el.dataset.stickyAtcArm,
    bucket: window.innerWidth <= MOBILE_MAX_WIDTH ? "mobile" : "desktop",
    product_id: el.dataset.productid || null,
    product_handle: el.dataset.productHandle || null
  };
}

/**
 * Publish a customer event, guarding every way the sandbox can be absent.
 *
 * @returns {boolean} true if the event was published
 */
function publish(name, payload) {
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(name, payload);
      return true;
    }
  } catch (err) {
    console.error("pdp sticky add to basket stamp failed:", err);
  }
  return false;
}

/**
 * Whether the form's add to basket button is pinned right now. Read at click
 * time, before the add request, so a scroll during the request cannot change it.
 *
 * @param {HTMLElement} form - the form being submitted
 * @returns {boolean}
 */
function isStickyAtcStuck(form) {
  return !!(form && form.querySelector(STUCK_SELECTOR));
}

/**
 * One event per PDP view. This is the denominator for the add-to-cart rate, so
 * it has to fire on every stamped product page, including sold-out ones.
 *
 * @returns {boolean}
 */
function emitStickyAtcView() {
  var stamp = readStamp();
  if (!stamp) return false;
  return publish(VIEW_EVENT, stamp);
}

/**
 * One event per successful add from a stamped PDP.
 *
 * @param {HTMLElement} form - the form that was submitted
 * @param {number|string} [variantId] - variant id from the cart/add.js response
 * @param {boolean} [stuck] - from isStickyAtcStuck at click time
 * @returns {boolean}
 */
function emitStickyAtcAdd(form, variantId, stuck) {
  var stamp = readStamp(form);
  if (!stamp) return false;
  return publish(ADD_EVENT, Object.assign({}, stamp, {
    variant_id: variantId || null,
    button_state: stuck ? "stuck" : "inline"
  }));
}

/***/ }),

/***/ "./src/scripts/modules/product-bike-builder-simple.js":
/*!************************************************************!*\
  !*** ./src/scripts/modules/product-bike-builder-simple.js ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductBikeBuilderSimple)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bike-builder-ga4 */ "./src/scripts/modules/bike-builder-ga4.js");
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }



var ProductBikeBuilderSimple = /*#__PURE__*/function (_HTMLElement) {
  function ProductBikeBuilderSimple() {
    var _this;
    _classCallCheck(this, ProductBikeBuilderSimple);
    _this = _callSuper(this, ProductBikeBuilderSimple);

    // General
    _this.product = JSON.parse(document.querySelector("[data-frame-product-json]").textContent);
    _this.observeConfig = {
      attributes: true,
      subtree: true
    };

    // Selectors
    _this.selectors = {
      bikeBuilderForm: ".js-bike-builder-form",
      bikeBuilderGroups: ".bike-builder-group",
      bikeBuilderBlocks: ".bike-builder-block",
      bikeBuilderRow: ".bike-builder-row",
      frameOptions: "[data-product-option]",
      frameDefaults: ".default",
      availModal: ".js-bike-builder-product-avail-modal",
      availTriggers: ".js-bike-builder-product-avail-trigger",
      infoModal: ".js-bike-builder-product-info-modal",
      infoModalContent: ".js-bike-builder-product-info-modal-content",
      infoTriggers: ".js-bike-builder-product-info-trigger",
      propVariantId: "[data-bike-builder-variant-id]",
      propVariantTitle: "[data-bike-builder-variant-title]",
      sizeGuide: "product-size-guide",
      stepsStates: ".js-bike-builder-state",
      steps: ".js-bike-builder-step",
      stepsContents: ".js-bike-builder-step-content",
      stepsSelections: ".js-bike-builder-step-selection",
      edits: ".js-bike-builder-edit",
      resets: ".js-bike-builder-reset",
      extra: ".js-bike-builder-extra",
      extrasArea: ".js-bike-builder-extras-area",
      extrasTotal: ".js-bike-builder-extras-total",
      priceFrameTitle: ".js-bike-builder-frame-title",
      total: ".js-bike-builder-total",
      finance: ".js-bike-builder-finance",
      financeMonthly: ".js-bike-builder-monthly",
      financeModal: "[data-bb-finance-modal]",
      financeModalOpen: "[data-bb-finance-modal-open]",
      financeModalClose: "[data-bb-finance-modal-close]",
      additionalTotals: ".js-bike-builder-additional-total",
      productCount: ".js-bike-builder-product-count",
      submit: ".js-bike-builder-submit",
      preorderVariant: "[data-preorder-variant]",
      // Simple builder specific selectors
      actionsArea: ".js-bike-builder-actions",
      customiseWrapper: ".js-bike-builder-customise-wrapper",
      customiseTrigger: ".js-bike-builder-customise-trigger",
      addToBasketBtn: ".js-bike-builder-add-to-basket",
      submitWrapper: ".js-bike-builder-submit-wrapper",
      summary: ".js-bike-builder-summary",
      summaryImage: ".bike-builder-summary__image",
      summaryDispatch: ".js-bb-summary-dispatch",
      preorderDispatch: ".js-preorder-dispatch",
      builderGallery: ".bike-builder__column .product-media",
      step3Slot: ".js-bike-builder-step3-slot",
      step3Loading: ".js-bike-builder-step3-loading",
      upsellModal: ".js-upsell-modal[data-upsell-deferred]"
    };
    _this.preorderVariant = document.querySelector(_this.selectors.preorderVariant);

    // Elements
    _this.bikeBuilderForm = document.querySelector(_this.selectors.bikeBuilderForm);
    _this.bikeBuilderGroups = document.querySelectorAll(_this.selectors.bikeBuilderGroups);
    _this.bikeBuilderBlocks = document.querySelectorAll(_this.selectors.bikeBuilderBlocks);
    _this.bikeBuilderRow = document.querySelectorAll(_this.selectors.bikeBuilderRow);
    _this.frameOptions = document.querySelectorAll(_this.selectors.frameOptions);
    _this.availModal = document.querySelector(_this.selectors.availModal);
    _this.infoModal = document.querySelector(_this.selectors.infoModal);
    _this.infoModalContent = document.querySelector(_this.selectors.infoModalContent);
    _this.availTriggers = document.querySelectorAll(_this.selectors.availTriggers);
    _this.infoTriggers = document.querySelectorAll(_this.selectors.infoTriggers);
    _this.edits = document.querySelectorAll(_this.selectors.edits);
    _this.resets = document.querySelectorAll(_this.selectors.resets);
    _this.extrasArea = document.querySelector(_this.selectors.extrasArea);
    _this.extrasTotal = document.querySelector(_this.selectors.extrasTotal);
    _this.priceFrameTitle = document.querySelector(_this.selectors.priceFrameTitle);
    _this.total = document.querySelector(_this.selectors.total);
    // There can be more than one finance line (header price + sticky summary),
    // so track them all and update each on price change.
    _this.financeBlocks = document.querySelectorAll(_this.selectors.finance);
    // Monthly figures appear in the finance line(s) AND the info modal; the
    // modal's isn't inside a finance block, so cache them all to update together.
    _this.financeMonthlyEls = document.querySelectorAll(_this.selectors.financeMonthly);
    _this.financeModal = document.querySelector(_this.selectors.financeModal);
    _this.financeModalOpenEls = document.querySelectorAll(_this.selectors.financeModalOpen);
    _this.financeModalCloseEls = document.querySelectorAll(_this.selectors.financeModalClose);
    _this.additionalTotals = document.querySelectorAll(_this.selectors.additionalTotals);
    _this.productCount = document.querySelector(_this.selectors.productCount);
    _this.submit = document.querySelector(_this.selectors.submit);
    _this.properties = {
      variantId: document.querySelector("[data-bike-builder-variant-id]"),
      variantTitle: document.querySelector("[data-bike-builder-variant-title]")
    };

    // Simple builder specific elements
    _this.actionsArea = document.querySelector(_this.selectors.actionsArea);
    _this.customiseWrapper = document.querySelector(_this.selectors.customiseWrapper);
    _this.customiseTrigger = document.querySelector(_this.selectors.customiseTrigger);
    _this.addToBasketBtn = document.querySelector(_this.selectors.addToBasketBtn);
    _this.addToBasketDefaultText = _this.addToBasketBtn ? _this.addToBasketBtn.textContent.trim() : "";
    _this.submitWrapper = document.querySelector(_this.selectors.submitWrapper);
    _this.summary = document.querySelector(_this.selectors.summary);
    _this.summaryImage = document.querySelector(_this.selectors.summaryImage);
    _this.summaryMedia = _this.summary ? _this.summary.querySelector(".bike-builder-summary__media") : null;
    // Mobile relocation target: the Initial Price row (holds the product title).
    _this.summaryInitial = _this.summary ? _this.summary.querySelector(".bike-builder-price-wrapper__wrapper.initial") : null;
    _this.summaryDispatch = document.querySelector(_this.selectors.summaryDispatch);
    _this.preorderDispatch = document.querySelector(_this.selectors.preorderDispatch);
    _this.summaryNote = _this.summary ? _this.summary.querySelector(".bike-builder-content__emboldened-text-note:not(.js-bb-summary-dispatch)") : null;
    _this.builderGallery = document.querySelector(_this.selectors.builderGallery);
    _this.step3Slot = document.querySelector(_this.selectors.step3Slot);
    _this.step3Loaded = false;
    _this.step3Ready = false;
    _this.upsellModal = document.querySelector(_this.selectors.upsellModal);
    _this.awaitingUpsell = false;
    _this.upsellResolved = false;
    _this.wheelbaseInputFront = document.querySelector("#wheelbase-id-front");
    _this.wheelbaseInputBack = document.querySelector("#wheelbase-id-back");

    // General
    _this.mouseIsDragging = false;
    _this.step2DefaultsSet = false;
    _this.step3DefaultsSet = false;
    _this.stepIsBeingEdited = false;
    _this.isCustomiseMode = false;
    _this.isSelectingDefaults = false; // Flag to prevent observer firing during default selection
    _this.step1Complete = false; // Track if step 1 has been completed

    // Steps
    _this.steps = document.querySelectorAll(_this.selectors.steps);
    _this.stepsStates = document.querySelectorAll(_this.selectors.stepsStates);
    _this.stepsContents = document.querySelectorAll(_this.selectors.stepsContents);
    _this.stepsSelections = document.querySelectorAll(_this.selectors.stepsSelections);
    _this.step = {
      1: {
        step: _this.steps[0],
        state: _this.stepsStates ? _this.stepsStates[0] : null,
        content: _this.stepsContents[0],
        selection: _this.stepsSelections[0]
      },
      2: {
        step: _this.steps[1],
        state: _this.stepsStates ? _this.stepsStates[1] : null,
        content: _this.stepsContents[1],
        selection: _this.stepsSelections[1]
      },
      3: {
        step: _this.steps[2],
        state: _this.stepsStates ? _this.stepsStates[2] : null,
        content: _this.stepsContents[2],
        selection: _this.stepsSelections[2]
      }
    };
    _this.state = {
      active: {
        1: true,
        2: false,
        3: false
      },
      observers: {}
    };

    // Classes
    _this.classes = {
      stepsStates: {
        active: "bike-builder-content__state--active",
        complete: "bike-builder-content__state--complete"
      },
      steps: {
        active: "bike-builder-content__step--active",
        complete: "bike-builder-content__step--complete"
      },
      submit: {
        disabled: "bike-builder-button--disabled"
      }
    };
    _this.currencySymbol = window.Shopify.currency.symbol;
    _this.init();
    return _this;
  }
  _inherits(ProductBikeBuilderSimple, _HTMLElement);
  return _createClass(ProductBikeBuilderSimple, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.initSliders();
      this.initialiseStep1();
      this.handleStep1Changes();
      this.handleCustomiseTrigger();
      this.handleAddToBasketClick();
      this.handleAvailTriggers();
      this.handleInfoTriggers();
      this.handleFinanceModal();
      this.initUpsellOffer();
      this.initFormSubmission();
      this.hideEmptyStepItems();
      this.checkURLForVariant();

      // Reconcile the standard availability note against the initial preorder state.
      this.syncAvailabilityNote();

      // Place the summary media block for the current viewport (below the product
      // title on mobile, photo at the top on desktop) and keep it right on resize.
      this.placeSummaryMedia();
      window.addEventListener("resize", function () {
        return _this2.placeSummaryMedia();
      });

      // Show action buttons on initial load
      this.showActionButtons();
      this.updateActionButtonState();
      this.bikeBuilderBlocks.forEach(function (el) {
        el.addEventListener("click", function () {
          if (!_this2.isSelectingDefaults) {
            _this2.changeBikeBuilderProduct(el);
          }
        });
      });
      this.frameOptions.forEach(function (el) {
        el.addEventListener("click", function () {
          _this2.updateVariantAvailability(el);
          _this2.changeFrameOption(el);
        });
      });
      this.handleContentScroll();
      this.handleNinjaDiscount();
      if (this.wheelbaseInputFront && this.wheelbaseInputBack) {
        this.populateWheelbaseInput();
      }
      this.setPurchaseEnabled(false);
      this.fetchAccessories();
      if (this.total) {
        this.updateFinance(parseInt(this.total.dataset.attrPrice, 10));
      }

      // Match the summary photo (and gallery, once slick is ready) to any
      // pre-selected colour on load.
      var initialFrameVariant = this.resolveFrameVariant();
      if (initialFrameVariant) {
        this.updateSummaryImage(initialFrameVariant);
        this.updateGalleryImage(initialFrameVariant);
        if (this.priceFrameTitle) this.priceFrameTitle.textContent = initialFrameVariant.title;
      }

      // Reflect the initial preorder dispatch state in the summary overlay.
      this.syncSummaryDispatch();
    }
  }, {
    key: "checkURLForVariant",
    value: function checkURLForVariant() {
      if (window.location.search.includes("variant=")) {
        var allDefaults = document.querySelectorAll(".default");
        allDefaults.forEach(function (block) {
          block.classList.add("active");
        });
      } else {
        var step2Element = document.querySelector('.bike-builder-content__step[data-bike-builder-step="2"]');
        if (step2Element) {
          var stepItems = step2Element.querySelectorAll(".bike-builder-content__step-item");
          var emptyCount = 0;
          stepItems.forEach(function (stepItem) {
            if (stepItem.innerHTML.trim() === "") {
              emptyCount++;
            }
          });
          if (emptyCount === stepItems.length) {
            var _allDefaults = document.querySelectorAll(".default");
            _allDefaults.forEach(function (block) {
              block.classList.add("active");
            });
          }
        }
      }
    }

    /**
     * Handles changes in Step 1 using event listeners instead of MutationObserver
     * This is more efficient and avoids infinite loop issues
     */
  }, {
    key: "handleStep1Changes",
    value: function handleStep1Changes() {
      var _this3 = this;
      // Listen for changes on the frame options (radio buttons in step 1)
      this.frameOptions.forEach(function (el) {
        el.addEventListener("change", function () {
          // changeFrameOption is bound to `click`, but keyboard selection, a
          // programmatic .checked, and browser form-state restoration on
          // back-navigation all fire `change` without `click`. Every purchase gate
          // reads the checked radios directly, so without this the radios can say
          // Large/Blue while the posted frame id is still the rendered default.
          // writeFrameBundle is idempotent, so double-firing alongside click is safe.
          _this3.writeFrameBundle(_this3.resolveFrameVariant());
          _this3.checkStep1Completion();
        });
      });
    }

    /**
     * Checks if Step 1 (Select Options) is complete
     * If complete, auto-selects defaults for steps 2 & 3
     * Note: Buttons remain visible at all times until customise mode is entered
     */
  }, {
    key: "checkStep1Completion",
    value: function checkStep1Completion() {
      // Prevent re-entry
      if (this.isSelectingDefaults) return;
      var allOptionsSelected = this.hasSelectedAllStep1Options();
      var selectedVariantAvailable = this.isSelectedFrameVariantAvailable();
      if (allOptionsSelected && selectedVariantAvailable && !this.step1Complete) {
        this.step1Complete = true;

        // Mark step 1 as complete
        this.step[1].step.classList.add(this.classes.steps.complete);

        // Auto-select defaults for steps 2 & 3 (hidden but selected)
        this.selectDefaultsForStep(2);
        this.maybeApplyStep3Defaults();
      } else if (!allOptionsSelected || !selectedVariantAvailable) {
        this.step1Complete = false;
        this.step[1].step.classList.remove(this.classes.steps.complete);
      }
      // Note: We no longer hide/show action buttons here - they stay visible until customise mode
      this.updateActionButtonState();
    }

    /**
     * Select all default options for a given step
     */
  }, {
    key: "selectDefaultsForStep",
    value: function selectDefaultsForStep(stepNumber) {
      var _this4 = this;
      if (stepNumber === 2 && this.step2DefaultsSet) return;
      if (stepNumber === 3 && this.step3DefaultsSet) return;
      var stepDefaults = document.querySelectorAll("[data-bike-builder-step=\"".concat(stepNumber, "\"] ").concat(this.selectors.frameDefaults));
      var stepGroups = document.querySelectorAll("[data-bike-builder-step=\"".concat(stepNumber, "\"] [data-product-option-list]"));
      if (stepDefaults.length === stepGroups.length) {
        // Set flag to prevent observer/click handler issues
        this.isSelectingDefaults = true;
        stepDefaults.forEach(function (stepDefault) {
          // Directly add active class and call the product change logic
          // instead of simulating a click which could trigger observers
          var productRow = stepDefault.closest("[data-product-option-list]");
          var productBlocks = productRow.querySelectorAll(_this4.selectors.bikeBuilderBlocks);
          productBlocks.forEach(function (block) {
            block.classList.toggle("active", block === stepDefault);
          });

          // Call the product change logic directly
          _this4.changeBikeBuilderProductDirect(stepDefault);
        });
        if (stepNumber === 2) this.step2DefaultsSet = true;
        if (stepNumber === 3) this.step3DefaultsSet = true;

        // Clear the flag
        this.isSelectingDefaults = false;
      }
    }

    /**
     * Direct product change without triggering click events
     * Used for auto-selecting defaults
     */
  }, {
    key: "changeBikeBuilderProductDirect",
    value: function changeBikeBuilderProductDirect(el) {
      var productRow = el.closest("[data-product-option-list]");
      var productProperties = productRow.querySelector(".product-properties");
      var productId = el.dataset.attrId;
      var productTitle = el.dataset.attrTitle;
      // See changeBikeBuilderProduct: frame option blocks have no component group,
      // so guard closest() instead of throwing null.dataset.
      var productGroupEl = el.closest(".bike-builder-group");
      if (!productGroupEl) return;
      var productGroup = productGroupEl.dataset.attrGroup;
      var isDefault = el.classList.contains("default");
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");

      // Generate properties HTML for defaults only
      var inputs = [];
      if (isDefault) {
        var defaultInputs = this.defaultComponentInputs(productGroup, productId, productTitle);
        inputs.push.apply(inputs, _toConsumableArray(defaultInputs));

        // Special handling for Wheelsets
        var isWheelset = productGroup === "Wheels";
        if (isWheelset) {
          var wheelbaseSkus = el.getAttribute("data-wheelbase-skus");
          if (wheelbaseSkus) {
            var wheelSplit = wheelbaseSkus.split(", ");
            var _wheelSplit = _slicedToArray(wheelSplit, 2),
              frontSku = _wheelSplit[0],
              backSku = _wheelSplit[1];
            inputs.length = 0;
            inputs.push("<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />");
          }
        }
      }
      if (productProperties) {
        productProperties.innerHTML = inputs.join("\n");
      }
    }

    /**
     * Shows the "Add to basket" and "Customise" action buttons
     */
  }, {
    key: "showActionButtons",
    value: function showActionButtons() {
      if (this.actionsArea && !this.isCustomiseMode) {
        this.actionsArea.style.display = "flex";
      }
    }

    /**
     * Hides the action buttons
     */
  }, {
    key: "hideActionButtons",
    value: function hideActionButtons() {
      if (this.actionsArea) {
        this.actionsArea.style.display = "none";
      }
    }

    /**
     * Checks if Step 1 is complete (all options selected)
     */
  }, {
    key: "hasSelectedAllStep1Options",
    value: function hasSelectedAllStep1Options() {
      var productOptions = document.querySelectorAll("[data-bike-builder-step=\"1\"] [data-product-option-list]");
      var checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"1\"] input[data-product-option]:checked");
      return checkedOptions.length === productOptions.length;
    }

    /**
     * The single source of truth for the chosen frame variant.
     *
     * Delegates to the shared per-option matcher in bike-builder-ga4.js — the same
     * one the availability gate, the summary and GA4 already use. This replaces a
     * second, divergent lookup that matched on a concatenated variant title; when
     * that lookup missed, the frame id was silently left at the rendered default
     * while every other gate still passed.
     */
  }, {
    key: "resolveFrameVariant",
    value: function resolveFrameVariant() {
      return (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.getSelectedFrameVariant)(this.product);
    }

    /**
     * The three `items[0]` property inputs that bundle a default component into the
     * bike: its variant id (carried in the property *key*, as /cart/add requires),
     * its display label, and the bike-component marker.
     *
     * Single definition shared by every writer of a default component —
     * changeBikeBuilderProductDirect, changeBikeBuilderProduct and writeForkBundle.
     */
  }, {
    key: "defaultComponentInputs",
    value: function defaultComponentInputs(group, id, title) {
      return ["<input id=\"bundleProduct_".concat(id, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(id, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(group, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(group, "]\" value=\"").concat(title, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
    }

    /**
     * The frame variant id currently encoded in the bundle input's name, or null
     * when the input has no name yet. The Liquid deliberately renders it nameless
     * (see snippets/product-variants-bike-builder.liquid) so an unwritten frame is
     * detectable instead of silently defaulting.
     */
  }, {
    key: "currentFrameBundleId",
    value: function currentFrameBundleId() {
      var input = this.properties.variantId;
      if (!input || !input.name) return null;
      var match = input.name.match(/_bundleProduct_(\d+)\]$/);
      return match ? match[1] : null;
    }

    /**
     * Point the bike's frame — and the colour-matched hidden fork — at `variant`.
     *
     * The frame id has to live in the input's *name* because /cart/add keys
     * bundled components as `_bundleProduct_<id>`. That makes this the only build
     * fact carried by an attribute rather than a value, so it gets one owner and
     * is re-applied defensively: on click, on change, and again at submit.
     * Must stay idempotent.
     */
  }, {
    key: "writeFrameBundle",
    value: function writeFrameBundle(variant) {
      if (!variant) return;
      if (this.properties.variantId) {
        this.properties.variantId.name = "items[0]properties[_bundleProduct_".concat(variant.id, "]");
      }
      if (this.properties.variantTitle) {
        this.properties.variantTitle.value = variant.title;
      }
      this.writeForkBundle(variant);
    }

    /**
     * Colour-match the hidden fork to the frame colour by writing its property
     * container directly.
     *
     * This previously dispatched a synthetic click, then a second one 300ms later.
     * writeFrameBundle now runs on click, change and submit, so synthetic clicks
     * would re-enter changeBikeBuilderProduct repeatedly and race that timer —
     * hence writing the inputs ourselves.
     *
     * Having no colour match is a legitimate state: plenty of bikes ship a single
     * fork colour, and availability filtering can drop a colour block entirely.
     * When that happens, explicitly reset to the group's rendered default block
     * rather than leaving whatever fork colour was written last — otherwise a
     * stale colour from a previous selection (e.g. Blue, picked before switching
     * to a frame colour with no matching fork) would silently ship bundled to
     * the new frame. The default block is guaranteed to exist per group
     * (rendered with a `default` class by
     * snippets/bike-builder-product-block.liquid), so this fallback should
     * always resolve; the final null check is just a safety net for a
     * malformed DOM, never a reason to block the sale.
     */
  }, {
    key: "writeForkBundle",
    value: function writeForkBundle(variant) {
      var forkGroup = document.querySelector('.bike-builder-group[data-attr-group="Fork"]');
      if (!forkGroup) return;
      var forkColour = this.frameColour(variant);
      var forkBlock = forkColour && forkGroup.querySelector(".bike-builder-block[data-variant-title=\"".concat(forkColour, "\"]")) || forkGroup.querySelector(".bike-builder-block.default");
      if (!forkBlock) return;
      forkGroup.querySelectorAll(this.selectors.bikeBuilderBlocks).forEach(function (block) {
        block.classList.toggle("active", block === forkBlock);
      });
      var productRow = forkBlock.closest("[data-product-option-list]");
      var productProperties = productRow ? productRow.querySelector(".product-properties") : null;
      if (!productProperties) return;
      var forkGroupName = forkGroup.dataset.attrGroup;
      var forkId = forkBlock.dataset.attrId;
      var forkTitle = forkBlock.dataset.attrTitle;
      if (!forkId) return;
      productProperties.innerHTML = this.defaultComponentInputs(forkGroupName, forkId, forkTitle).join("\n");
    }

    /**
     * Compare the frame id that would actually be posted against the customer's
     * current selection. Reports; does not act.
     *
     * @returns {{ok: boolean, expected: Object|null, posted: string|null}}
     */
  }, {
    key: "assertFrameBundle",
    value: function assertFrameBundle() {
      var expected = this.resolveFrameVariant();
      var posted = this.currentFrameBundleId();
      return {
        ok: Boolean(expected) && posted === String(expected.id),
        expected: expected,
        posted: posted
      };
    }

    /**
     * Record that the submitted frame id had to be corrected, as a hidden
     * line-item property on the bike.
     *
     * Underscore-prefixed properties are hidden from the customer but visible in
     * the admin and API, so affected orders are self-flagging and the order sweep
     * finds them with no extra infrastructure.
     *
     *   'none>ID'     the id was never written (e.g. restored form state)
     *   'OLDID>NEWID' a stale id was replaced
     *
     * The two shapes matter: they distinguish "the write never ran" from "the
     * write ran and was later reverted", which is the evidence needed to finally
     * identify the trigger. An absent property means no correction was needed.
     */
  }, {
    key: "stampFrameCorrected",
    value: function stampFrameCorrected(before, expectedId) {
      if (!this.bikeBuilderForm) return;
      var input = this.bikeBuilderForm.querySelector("[data-bb-frame-corrected]");
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "items[0]properties[_frameCorrected]";
        input.setAttribute("data-bb-frame-corrected", "");
        this.bikeBuilderForm.appendChild(input);
      }
      input.value = "".concat(before || "none", ">").concat(expectedId);
    }
  }, {
    key: "isSelectedFrameVariantAvailable",
    value: function isSelectedFrameVariantAvailable() {
      var selectedVariant = this.resolveFrameVariant();
      return Boolean(selectedVariant && selectedVariant.available);
    }
  }, {
    key: "isStep1Complete",
    value: function isStep1Complete() {
      return this.hasSelectedAllStep1Options() && this.isSelectedFrameVariantAvailable();
    }
  }, {
    key: "updateActionButtonState",
    value: function updateActionButtonState() {
      if (!this.step3Ready) {
        if (this.addToBasketBtn) {
          this.addToBasketBtn.disabled = true;
          this.addToBasketBtn.textContent = "Loading…";
        }
        if (this.customiseTrigger) this.customiseTrigger.disabled = true;
        return;
      }
      var allOptionsSelected = this.hasSelectedAllStep1Options();
      var selectedVariantAvailable = this.isSelectedFrameVariantAvailable();
      var selectedVariantUnavailable = allOptionsSelected && !selectedVariantAvailable;
      if (this.addToBasketBtn) {
        this.addToBasketBtn.textContent = selectedVariantUnavailable ? "Out of stock" : this.addToBasketDefaultText;
        this.addToBasketBtn.disabled = selectedVariantUnavailable;
        this.addToBasketBtn.classList.toggle("bike-builder-simple__action-btn--disabled", selectedVariantUnavailable);
      }
      if (this.customiseTrigger) {
        this.customiseTrigger.disabled = selectedVariantUnavailable;
        this.customiseTrigger.classList.toggle("bike-builder-simple__action-btn--disabled", selectedVariantUnavailable);
      }
    }

    /**
     * Prompts the user to select options by highlighting Step 1 and showing a toast
     */
  }, {
    key: "promptSelectOptions",
    value: function promptSelectOptions() {
      var _this5 = this,
        _window$bikeBuilderSt;
      // Add a visual highlight to indicate they need to select options (no scroll)
      if (this.step[1].step) {
        this.step[1].step.classList.add("bike-builder-content__step--highlight");

        // Remove the highlight after animation
        setTimeout(function () {
          _this5.step[1].step.classList.remove("bike-builder-content__step--highlight");
        }, 2000);
      }

      // Show an alert or message
      var message = ((_window$bikeBuilderSt = window.bikeBuilderStrings) === null || _window$bikeBuilderSt === void 0 ? void 0 : _window$bikeBuilderSt.selectOptionsPrompt) || "Please select your size and colour options first.";

      // Create a temporary toast notification
      this.showToast(message);
    }

    /**
     * Shows a toast notification message
     */
  }, {
    key: "showToast",
    value: function showToast(message) {
      // Check if toast already exists
      var toast = document.querySelector(".bike-builder-toast");
      if (!toast) {
        toast = document.createElement("div");
        toast.className = "bike-builder-toast";
        document.body.appendChild(toast);
      }
      toast.textContent = message;

      // Force a reflow to ensure the transition works
      toast.offsetHeight;
      toast.classList.add("bike-builder-toast--visible");

      // Hide after 3 seconds
      setTimeout(function () {
        toast.classList.remove("bike-builder-toast--visible");
      }, 3000);
    }
  }, {
    key: "promptUnavailableVariant",
    value: function promptUnavailableVariant() {
      this.showToast("Sorry, this option is out of stock.");
    }

    /**
     * Handles the Add to Basket button click
     */
  }, {
    key: "handleAddToBasketClick",
    value: function handleAddToBasketClick() {
      var _this6 = this;
      if (this.addToBasketBtn) {
        this.addToBasketBtn.addEventListener("click", function (e) {
          if (!_this6.hasSelectedAllStep1Options()) {
            e.preventDefault();
            _this6.promptSelectOptions();
            return;
          }
          if (!_this6.isSelectedFrameVariantAvailable()) {
            e.preventDefault();
            _this6.promptUnavailableVariant();
          }
          // If step 1 is complete, the form will submit normally
        });
      }
    }

    /**
     * Handles the Customise button click - reveals steps 2 & 3
     */
  }, {
    key: "handleCustomiseTrigger",
    value: function handleCustomiseTrigger() {
      var _this7 = this;
      if (this.customiseTrigger) {
        this.customiseTrigger.addEventListener("click", function (e) {
          if (!_this7.hasSelectedAllStep1Options()) {
            e.preventDefault();
            _this7.promptSelectOptions();
            return;
          }
          if (!_this7.isSelectedFrameVariantAvailable()) {
            e.preventDefault();
            _this7.promptUnavailableVariant();
            return;
          }
          _this7.enterCustomiseMode();
        });
      }
    }

    /**
     * Enters customise mode - reveals steps 2 & 3 and shows the submit button
     */
  }, {
    key: "enterCustomiseMode",
    value: function enterCustomiseMode() {
      var _this8 = this;
      this.isCustomiseMode = true;

      // The immersive treatment (hidden header + faded gallery + full-width sticky
      // summary) is desktop-only. On mobile we keep the legacy-style layout: the
      // steps reveal, the gallery stays, and the summary shows stacked below the
      // steps (reordered in CSS). Everything below that isDesktop guards is shared.
      var isDesktop = window.innerWidth >= _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large;

      // Enable the immersive customise view: the (sticky) site header is hidden
      // while scrolled so the build summary uses the full height. It returns at
      // the top of the page (its sticky class drops off there). See the
      // body.bike-builder-immersive rule in _bike-builder.scss.
      if (isDesktop) {
        document.body.classList.add("bike-builder-immersive");
      }

      // Hide the action buttons
      if (this.actionsArea) {
        this.actionsArea.style.display = "none";
      }

      // Show the customise wrapper (steps 2 & 3)
      if (this.customiseWrapper) {
        this.customiseWrapper.style.display = "block";

        // Re-initialise scrollbars now that the elements are visible
        this.initScrollBar();

        // Animate the reveal
        this.customiseWrapper.style.opacity = "0";
        this.customiseWrapper.style.transform = "translateY(20px)";
        requestAnimationFrame(function () {
          _this8.customiseWrapper.style.transition = "opacity 0.3s ease, transform 0.3s ease";
          _this8.customiseWrapper.style.opacity = "1";
          _this8.customiseWrapper.style.transform = "translateY(0)";
        });
      }

      // Show the submit button wrapper
      if (this.submitWrapper) {
        this.submitWrapper.style.display = "block";
      }

      // Fade out the full gallery (desktop only) — the sticky summary's own
      // colour-matched photo represents the bike there. On mobile the gallery
      // stays as the main product image (legacy-style layout).
      if (isDesktop && this.builderGallery) {
        this.builderGallery.style.transition = "opacity 0.3s ease";
        this.builderGallery.style.opacity = "0";
        setTimeout(function () {
          _this8.builderGallery.style.display = "none";
        }, 300);
      }

      // Reveal the sticky build summary in the left column (running total,
      // finance line and Add to Basket) now the customer is configuring.
      // Use flex (not block) so the panel's column layout / gap apply, and
      // fade/slide it in to match the customise-mode transition.
      if (this.summary) {
        this.summary.style.display = "flex";
        this.summary.style.opacity = "0";
        this.summary.style.transform = "translateY(12px)";
        requestAnimationFrame(function () {
          _this8.summary.style.transition = "opacity 0.3s ease, transform 0.3s ease";
          _this8.summary.style.opacity = "1";
          _this8.summary.style.transform = "translateY(0)";
        });
      }

      // Activate step 2
      this.step[2].step.classList.add(this.classes.steps.active);
      if (this.step[2].content) {
        this.step[2].content.style.maxHeight = "".concat(this.getHiddenHeight(this.step[2].content), "px");
      }

      // Activate step 3
      this.step[3].step.classList.add(this.classes.steps.active);
      if (this.step[3].content) {
        this.step[3].content.style.maxHeight = "".concat(this.getHiddenHeight(this.step[3].content), "px");
      }

      // Scroll to the customise section with header offset
      if (this.customiseWrapper) {
        // The header is hidden in the immersive customise view, so don't allow
        // for its height — scroll the customise section close to the top.
        var elementPosition = this.customiseWrapper.getBoundingClientRect().top + window.pageYOffset;
        var offsetPosition = elementPosition - 20; // small top margin

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }

    /**
     * Fetches the Step 3 (accessories) fragment from its own page render so the
     * accessory all_products lookups get a fresh 20-unique-handle budget.
     * Retries once on failure, then surfaces an error and leaves purchase disabled.
     */
  }, {
    key: "fetchAccessories",
    value: function fetchAccessories() {
      var _this9 = this;
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (!this.step3Slot) {
        // No slot (e.g. a variant of the template without accessories): don't block purchase.
        this.step3Loaded = true;
        this.step3Ready = true;
        this.setPurchaseEnabled(true);
        return;
      }
      var url = this.step3Slot.dataset.accessoriesUrl;
      fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("HTTP ".concat(response.status));
        return response.text();
      }).then(function (html) {
        return _this9.injectAccessories(html);
      })["catch"](function () {
        if (attempt < 2) {
          _this9.fetchAccessories(attempt + 1);
        } else {
          _this9.showAccessoriesError();
        }
      });
    }

    /**
     * Injects the fetched Step 3 markup, rebuilds the step references that were
     * cached at construct time (Step 3 didn't exist then), binds events for the
     * new blocks, applies the accessory defaults, and re-enables purchase.
     */
  }, {
    key: "injectAccessories",
    value: function injectAccessories(html) {
      var loading = this.step3Slot.querySelector(this.selectors.step3Loading);
      if (loading) loading.remove();
      this.step3Slot.insertAdjacentHTML("beforeend", html);

      // Rebuild step references — the constructor cached these before Step 3 existed.
      this.steps = document.querySelectorAll(this.selectors.steps);
      this.stepsContents = document.querySelectorAll(this.selectors.stepsContents);
      this.stepsSelections = document.querySelectorAll(this.selectors.stepsSelections);
      this.edits = document.querySelectorAll(this.selectors.edits);
      this.step[3] = {
        step: this.steps[2],
        state: this.stepsStates ? this.stepsStates[2] : null,
        content: this.stepsContents[2],
        selection: this.stepsSelections[2]
      };

      // Re-query the group/block collections so they include Step 3.
      this.bikeBuilderGroups = document.querySelectorAll(this.selectors.bikeBuilderGroups);
      this.bikeBuilderBlocks = document.querySelectorAll(this.selectors.bikeBuilderBlocks);

      // Bind click handlers and triggers for the newly injected blocks only.
      this.bindBlockEvents(this.step3Slot);
      this.bindStepTriggers(this.step3Slot);

      // Initialise sliders/scrollbars now the Step 3 groups are in the DOM.
      this.initScrollBar();
      this.hideEmptyStepItems();
      this.step3Loaded = true;
      this.maybeApplyStep3Defaults();
      this.step3Ready = true;
      this.setPurchaseEnabled(true);
      this.updateActionButtonState();
    }

    /**
     * Binds the product-choice click handler to bike-builder blocks within a scope.
     */
  }, {
    key: "bindBlockEvents",
    value: function bindBlockEvents(scope) {
      var _this0 = this;
      var blocks = scope.querySelectorAll(this.selectors.bikeBuilderBlocks);
      blocks.forEach(function (el) {
        el.addEventListener("click", function () {
          if (!_this0.isSelectingDefaults) {
            _this0.changeBikeBuilderProduct(el);
          }
        });
      });
    }

    /**
     * Binds info/availability modal triggers within a scope.
     */
  }, {
    key: "bindStepTriggers",
    value: function bindStepTriggers(scope) {
      var _this1 = this;
      scope.querySelectorAll(this.selectors.infoTriggers).forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var _this1$infoModalConte, _this1$infoModalConte2, _this1$infoModalConte3;
          var img = (_this1$infoModalConte = _this1.infoModalContent) === null || _this1$infoModalConte === void 0 ? void 0 : _this1$infoModalConte.querySelector(".js-bike-builder-product-info-modal__image");
          var title = (_this1$infoModalConte2 = _this1.infoModalContent) === null || _this1$infoModalConte2 === void 0 ? void 0 : _this1$infoModalConte2.querySelector(".js-bike-builder-product-info-modal__title");
          var text = (_this1$infoModalConte3 = _this1.infoModalContent) === null || _this1$infoModalConte3 === void 0 ? void 0 : _this1$infoModalConte3.querySelector(".js-bike-builder-product-info-modal__text");
          if (img) img.src = "";
          if (_this1.infoModal) {
            _this1.infoModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
          if (!trigger.hasAttribute("data-product-info-featured-image")) return;
          if (img) img.src = trigger.dataset.productInfoFeaturedImage;
          if (title) title.innerHTML = trigger.dataset.productInfoTitle.replace("[OEM]", "").replace("[BB]", "");
          if (text) text.innerHTML = trigger.dataset.productInfoText;
        });
      });
    }

    /**
     * Applies the Step 3 defaults to items[0] once both Step 1 is complete and the
     * accessory fragment has loaded (either order — whichever happens last triggers it).
     */
  }, {
    key: "maybeApplyStep3Defaults",
    value: function maybeApplyStep3Defaults() {
      if (this.step1Complete && this.step3Loaded) {
        this.selectDefaultsForStep(3);
      }
    }

    /**
     * Enables/disables the purchase controls. While disabled for loading, shows a
     * loading label; when enabled, defers to updateActionButtonState() for the
     * normal in-stock/out-of-stock state.
     */
  }, {
    key: "setPurchaseEnabled",
    value: function setPurchaseEnabled(enabled) {
      var controls = [this.addToBasketBtn, this.customiseTrigger, this.submit].filter(Boolean);
      controls.forEach(function (el) {
        el.disabled = !enabled;
        el.classList.toggle("bike-builder-simple__action-btn--loading", !enabled);
      });
      if (enabled) {
        this.updateActionButtonState();
      } else if (this.addToBasketBtn) {
        this.addToBasketBtn.textContent = "Loading…";
      }
    }

    /**
     * Leaves purchase disabled and tells the customer to refresh. We never submit
     * an incomplete bundle (missing accessory defaults).
     */
  }, {
    key: "showAccessoriesError",
    value: function showAccessoriesError() {
      if (this.step3Slot) {
        this.step3Slot.innerHTML = '<p class="bike-builder-content__step3-error">Couldn’t load build options — please refresh the page.</p>';
      }
      this.setPurchaseEnabled(false);
      if (this.addToBasketBtn) this.addToBasketBtn.textContent = "Unavailable — refresh";
    }
  }, {
    key: "getHiddenHeight",
    value: function getHiddenHeight(el) {
      if (!(el !== null && el !== void 0 && el.cloneNode)) {
        return null;
      }
      var clone = el.cloneNode(true);
      Object.assign(clone.style, {
        overflow: "visible",
        height: "auto",
        maxHeight: "none",
        opacity: "0",
        visibility: "hidden",
        display: "block"
      });
      var inputs = clone.querySelectorAll("input");
      inputs.forEach(function (input) {
        input.name = "null";
        input.id = "null";
      });
      el.after(clone);
      var height = clone.offsetHeight + 10;
      clone.remove();
      return height;
    }
  }, {
    key: "initialiseStep1",
    value: function initialiseStep1() {
      var content = this.step[1].content;
      if (content) {
        content.style.maxHeight = "".concat(this.getHiddenHeight(content), "px");
      }
      for (var i = 0; i < this.frameOptions.length; i++) {
        var input = this.frameOptions[i];
        var optionPosition = input.dataset.productOption;
        if (optionPosition === "1") continue;
        if (input.hasAttribute("data-product-option-colour")) {
          var colour = input.value;
          var colourIsAvailable = false;
          for (var _i = 0; _i < this.product.variants.length; _i++) {
            var variant = this.product.variants[_i];
            if (variant["option".concat(optionPosition)] === colour) {
              if (variant.available) {
                colourIsAvailable = true;
              }
            }
          }
          if (!colourIsAvailable) {
            var item = input.closest("li");
            item.style.display = "none";
          }
        }
      }
    }
  }, {
    key: "updateVariantAvailability",
    value: function updateVariantAvailability(chosenSwatch) {
      var chosenPosition = chosenSwatch.dataset.productOption;
      var relevantVariants = [];
      for (var i = 0; i < this.product.variants.length; i++) {
        var variant = this.product.variants[i];
        var variantMatchedOptions = variant["option".concat(chosenPosition)];
        if (variantMatchedOptions == chosenSwatch.value) {
          relevantVariants.push(variant);
        }
      }
      for (var _i2 = 0; _i2 < relevantVariants.length; _i2++) {
        var _variant = relevantVariants[_i2];
        for (var _i3 = 1; _i3 < 4; _i3++) {
          var optionName = _variant["option".concat(_i3)];
          if (optionName === null || optionName == chosenSwatch.value) continue;
          var optionPosition = _i3;
          var handleizedName = optionName.toLowerCase().replace(/ /g, "-");
          var input = document.querySelector("#Option-".concat(handleizedName, "-").concat(optionPosition));
          if (input !== null) {
            var swatch = input.parentElement;
            if (_variant.available) {
              swatch.classList.remove("is-sold-out");
            } else {
              swatch.classList.add("is-sold-out");
            }
          }
        }
      }
    }

    // Point the sticky summary image at the selected frame variant's photo so it
    // reflects the chosen colour. Falls back to the current image if the variant
    // has no dedicated image.
    // The selected frame colour, e.g. "Ruby" (the option named colour/color, else
    // option2 by convention in these builds).
  }, {
    key: "frameColour",
    value: function frameColour(variant) {
      if (!variant) return null;
      var optionNames = this.product.options || [];
      var colourIndex = optionNames.findIndex(function (n) {
        return /colou?r/i.test(n);
      });
      if (colourIndex < 0) colourIndex = 1;
      return variant["option".concat(colourIndex + 1)] || null;
    }

    // Tokens to look for in an image filename/alt: the slug ("jet-black") plus the
    // individual words ("jet", "black"), so "Jet Black" still matches "...-black-".
  }, {
    key: "colourTokens",
    value: function colourTokens(colour) {
      var handle = colour.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      var words = colour.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) {
        return w.length > 2;
      });
      return [handle].concat(_toConsumableArray(words));
    }

    // Pick the image for a colour: prefer a filename match (e.g. ...-ruby-...jpg),
    // then fall back to a whole-word match in the image's alt text (some builds
    // don't put the colour in the filename). candidates: [{ src, alt, ... }].
  }, {
    key: "matchColourImage",
    value: function matchColourImage(candidates, colour) {
      if (!colour) return null;
      var tokens = this.colourTokens(colour);
      var byName = candidates.find(function (c) {
        var name = (c.src || "").toLowerCase();
        return tokens.some(function (t) {
          return name.includes("-".concat(t, "-")) || name.includes("-".concat(t, "."));
        });
      });
      if (byName) return byName;
      return candidates.find(function (c) {
        var alt = (c.alt || "").toLowerCase();
        return tokens.some(function (t) {
          return new RegExp("(?:^|[^a-z0-9])".concat(t, "(?:[^a-z0-9]|$)")).test(alt);
        });
      }) || null;
    }

    // Full-bike photos for each colour live in the main product's images. Match
    // the selected frame colour to one and show it in the sticky summary photo.
  }, {
    key: "updateSummaryImage",
    value: function updateSummaryImage(variant) {
      if (!this.summaryImage || !variant) return;
      var images = [];
      try {
        images = JSON.parse(this.summaryImage.dataset.bikeImages || "[]");
      } catch (e) {
        images = [];
      }
      if (!images.length) return;

      // Accept both the legacy src-string array and the { src, alt } form.
      var candidates = images.map(function (im) {
        return typeof im === "string" ? {
          src: im,
          alt: ""
        } : im;
      });
      var match = this.matchColourImage(candidates, this.frameColour(variant));
      if (match && match.src) this.summaryImage.src = match.src;
    }

    // Mirror the colour match into the default (non-customise) gallery by moving
    // the product-media carousel to the matching slide.
  }, {
    key: "updateGalleryImage",
    value: function updateGalleryImage(variant) {
      if (!this.builderGallery || !variant || typeof $ === "undefined") return;
      var carousel = this.builderGallery.querySelector("[data-product-media-carousel]");
      if (!carousel || !$(carousel).hasClass("slick-initialized")) return;
      var candidates = _toConsumableArray(this.builderGallery.querySelectorAll(".product-media__media")).map(function (m) {
        var img = m.querySelector("img");
        var src = img ? [img.currentSrc, img.getAttribute("src"), img.getAttribute("srcset"), img.getAttribute("data-src")].filter(Boolean).join(" ") : "";
        return {
          src: src,
          alt: img ? img.alt || "" : "",
          index: parseInt(m.dataset.productLightboxTrigger, 10)
        };
      }).filter(function (c) {
        return !isNaN(c.index);
      });
      var match = this.matchColourImage(candidates, this.frameColour(variant));
      if (match) $(carousel).slick("slickGoTo", match.index);
    }

    // The summary media block holds the size/colour spec + availability/date note
    // (plus the bike photo on desktop). On mobile the photo is hidden and this
    // reads best just below the product title, so relocate it after the Initial
    // Price row; on desktop it's the photo at the top of the card. Called on load
    // and resize (no-op when already in the right place).
  }, {
    key: "placeSummaryMedia",
    value: function placeSummaryMedia() {
      if (!this.summaryMedia || !this.summary) return;
      var mobile = window.innerWidth < _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large;
      if (mobile) {
        if (this.summaryInitial && this.summaryMedia.previousElementSibling !== this.summaryInitial) {
          this.summaryInitial.insertAdjacentElement("afterend", this.summaryMedia);
        }
      } else if (this.summary.firstElementChild !== this.summaryMedia) {
        this.summary.insertBefore(this.summaryMedia, this.summary.firstElementChild);
      }
    }

    // Mirror the Step 1 preorder dispatch into the summary overlay. When a
    // preorder variant is selected, product-preorder.js reveals
    // .js-preorder-dispatch with the dispatch date; show that in place of the
    // standard availability note (else show the standard note).
  }, {
    key: "syncSummaryDispatch",
    value: function syncSummaryDispatch() {
      if (!this.summaryDispatch) return;
      var active = this.preorderDispatch && !this.preorderDispatch.classList.contains("is-hidden");
      if (active) {
        this.summaryDispatch.innerHTML = this.preorderDispatch.innerHTML;
        this.summaryDispatch.hidden = false;
        if (this.summaryNote) this.summaryNote.hidden = true;
      } else {
        this.summaryDispatch.hidden = true;
        if (this.summaryNote) this.summaryNote.hidden = false;
      }
    }
  }, {
    key: "changeFrameOption",
    value: function changeFrameOption(el) {
      var step = el.closest("[data-bike-builder-step]");
      if (!step) return;
      var option1 = step.querySelector('input[data-product-option="1"]:checked');
      var option2 = step.querySelector('input[data-product-option="2"]:checked');
      var option3 = step.querySelector('input[data-product-option="3"]:checked');

      // Update Step Selection Area
      if (option1 && this.step[1].selection) {
        var sel1 = this.step[1].selection.querySelector('[data-attr-option-position="1"] .js-bike-builder-step-selection-choice');
        if (sel1) sel1.textContent = option1.value;
      }
      if (option2 && this.step[1].selection) {
        var sel2 = this.step[1].selection.querySelector('[data-attr-option-position="2"] .js-bike-builder-step-selection-choice');
        if (sel2) sel2.textContent = option2.value;
      }
      if (option3 && this.step[1].selection) {
        var sel3 = this.step[1].selection.querySelector('[data-attr-option-position="3"] .js-bike-builder-step-selection-choice');
        if (sel3) sel3.textContent = option3.value;
      }
      var variant = this.resolveFrameVariant();
      if (variant) {
        this.writeFrameBundle(variant);
        this.updatePreorderStatus(variant);
        // updatePreorderStatus fires the change event product-preorder.js listens
        // to, so the Step 1 dispatch is up to date here. Reconcile the standard
        // availability note first (it may hide the dispatch when nothing is
        // selected), then mirror the dispatch into the sticky summary.
        this.syncAvailabilityNote();
        this.syncSummaryDispatch();
        if (this.priceFrameTitle) {
          this.priceFrameTitle.textContent = variant.title;
        }

        // Match both the sticky summary photo and the default gallery to the
        // selected colour.
        this.updateSummaryImage(variant);
        this.updateGalleryImage(variant);
      }
      var stepIndex = step.dataset.bikeBuilderStep;
      var content = this.step[stepIndex].content;
      if (content) {
        content.style.maxHeight = "6000px";
      }

      // Check if step 1 is now complete
      this.checkStep1Completion();
    }
  }, {
    key: "updatePreorderStatus",
    value: function updatePreorderStatus(variant) {
      if (this.preorderVariant) {
        this.preorderVariant.value = variant.id;
        this.preorderVariant.setAttribute("data-selected-variant", JSON.stringify(variant));
        var event = new Event("change");
        this.preorderVariant.dispatchEvent(event);
      }
    }

    // Keep exactly one availability message visible:
    //  - before a variant is chosen (initial load): show the general "Built to
    //    Order…" note, and suppress the dispatch's default (first-available)
    //    message so it doesn't pre-empt a real selection.
    //  - once a preorder variant is chosen: product-preorder.js reveals the Step 1
    //    dispatch ("Deliveries from …"), so hide the general note.
    //  - once a non-preorder variant is chosen: keep the general note.
  }, {
    key: "syncAvailabilityNote",
    value: function syncAvailabilityNote() {
      var dispatch = document.querySelector(".js-preorder-dispatch");
      var notes = document.querySelectorAll(".bike-builder-content__emboldened-text-note");
      var selected = document.querySelector('[data-bike-builder-step="1"] input[data-product-option]:checked');

      // No selection yet: the general note is the initial-load message.
      if (!selected) {
        if (dispatch) dispatch.classList.add("is-hidden");
        notes.forEach(function (note) {
          note.hidden = false;
        });
        return;
      }
      var preorderActive = !!dispatch && !dispatch.classList.contains("is-hidden");
      notes.forEach(function (note) {
        note.hidden = preorderActive;
      });
    }

    // Live monthly-finance figure for the PayItMonthly line.
    // PLACEHOLDER MATHS: the representative-example formula below is a stand-in
    // so the line updates live in dev. Replace it with PayItMonthly's approved
    // calculation before enabling the line in production. Reads APR / term /
    // deposit from the finance element's data- attributes (section settings).
  }, {
    key: "updateFinance",
    value: function updateFinance(totalCents) {
      var _this10 = this;
      if (!this.financeBlocks || !this.financeBlocks.length) return;
      var formatted = null;
      this.financeBlocks.forEach(function (block) {
        var amountEl = block.querySelector(_this10.selectors.financeMonthly);
        if (!amountEl) return;
        var apr = parseFloat(block.dataset.financeApr);
        var term = parseInt(block.dataset.financeTerm, 10);
        var depositPct = parseFloat(block.dataset.financeDeposit) || 0;

        // Without a valid term / APR we cannot show a figure — hide the line.
        if (!term || term <= 0 || isNaN(apr)) {
          block.hidden = true;
          return;
        }
        var financed = totalCents * (1 - depositPct / 100);
        var totalRepayable = financed * (1 + apr / 100 * (term / 12));
        var monthly = totalRepayable / term;
        var monthlyRounded = Math.round(monthly / 100) * 100; // nearest whole £

        formatted = Shopify.formatMoney(monthlyRounded, "".concat(_this10.currencySymbol, "{{ amount_no_decimals }}"));
        amountEl.textContent = formatted;
        block.hidden = false;
      });

      // The info modal's monthly figure lives outside the finance blocks, so give
      // any monthly figures not inside a block (the modal's) the same value.
      if (formatted) {
        this.financeMonthlyEls.forEach(function (el) {
          if (!el.closest(_this10.selectors.finance)) el.textContent = formatted;
        });
      }
    }

    // "Learn more" opens the finance info modal (mirrors the Klarna/PayPal
    // pattern); closes via the close buttons, overlay, or Escape.
  }, {
    key: "handleFinanceModal",
    value: function handleFinanceModal() {
      var _this11 = this;
      if (!this.financeModal) return;
      this.financeModalOpenEls.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          _this11.openFinanceModal();
        });
      });
      this.financeModalCloseEls.forEach(function (btn) {
        btn.addEventListener("click", function () {
          return _this11.closeFinanceModal();
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !_this11.financeModal.hidden) _this11.closeFinanceModal();
      });
    }
  }, {
    key: "openFinanceModal",
    value: function openFinanceModal() {
      if (!this.financeModal) return;
      this.financeModal.hidden = false;
      document.body.classList.add("bb-finance-modal-open");
    }
  }, {
    key: "closeFinanceModal",
    value: function closeFinanceModal() {
      if (!this.financeModal) return;
      this.financeModal.hidden = true;
      document.body.classList.remove("bb-finance-modal-open");
    }
  }, {
    key: "changeBikeBuilderProduct",
    value: function changeBikeBuilderProduct(el) {
      var _this12 = this;
      var productRow = el.closest("[data-product-option-list]");
      var productProperties = productRow.querySelector(".product-properties");
      var productBlocks = productRow.querySelectorAll(this.selectors.bikeBuilderBlocks);
      productBlocks.forEach(function (block) {
        block.classList.toggle("active", block === el);
      });
      var productId = el.dataset.attrId;
      var productTitle = el.dataset.attrTitle;
      var productPrice = el.getAttribute("data-attr-price");
      // Step 1 frame option blocks (size/colour) live outside any component group,
      // so closest() is null — they're handled by changeFrameOption, nothing to
      // bundle here. Components and the hidden fork DO have a group. (Previously
      // this threw "null (reading 'dataset')" on every frame-option click.)
      var productGroupEl = el.closest(".bike-builder-group");
      if (!productGroupEl) return;
      var productGroup = productGroupEl.dataset.attrGroup;
      // The hidden fork is rendered outside the numbered steps, so closest() can be
      // null here — guard it instead of throwing (the throw left the colour visually
      // selected but never updated the form, so the default fork stayed bundled).
      var stepEl = el.closest(".js-bike-builder-step");
      var associatedStep = stepEl ? parseInt(stepEl.dataset.bikeBuilderStep) : null;
      // The hidden fork is colour-matched to the frame and must stay bundled on
      // items[0] (replacing the default), not become a separate line item.
      var isHiddenFork = el.closest(".bike-builder-content__hidden-fork") !== null;
      var isDefault = el.classList.contains("default") || isHiddenFork;
      var rowIndex = isDefault ? 0 : el.closest(".bike-builder-content__step-item").dataset.rowIndex;
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");

      // Remove pre-existing extras if a extra inside a active group is changed.
      if (this.extrasArea) {
        var currentExtra = this.extrasArea.querySelector("div[data-attr-group=\"".concat(productGroup, "\"]"));
        if (currentExtra) currentExtra.remove();
      }

      // Add Selections
      if (this.step[associatedStep] && this.step[associatedStep].selection) {
        var currentSelectionPrexists = this.step[associatedStep].selection.querySelector("[data-selection-attr-group=\"".concat(productGroup, "\"]"));
        if (currentSelectionPrexists) {
          currentSelectionPrexists.innerHTML = "\n          <p class=\"bike-builder-content__step-selection-group\">\n            ".concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n          </p>\n        ");
        } else {
          this.step[associatedStep].selection.insertAdjacentHTML("beforeend", "\n            <li\n              class=\"bike-builder-content__step-selection-item\"\n              data-selection-attr-group=\"".concat(productGroup, "\"\n            >\n              <p class=\"bike-builder-content__step-selection-group\">\n                ").concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n              </p>\n            </li>\n          "));
        }
      }

      // Add Extras (only in customise mode and for non-default items)
      if (!isDefault && this.extrasArea) {
        this.extrasArea.insertAdjacentHTML("beforeend", "\n        <div\n          class=\"price-row js-bike-builder-extra\"\n          data-attr-row=\"".concat(rowIndex, "\"\n          data-attr-price=\"").concat(productPrice, "\"\n          data-attr-group=\"").concat(productGroup, "\"\n          data-attr-step=\"").concat(associatedStep, "\"\n          style=\"order: ").concat(rowIndex, "\"\n        >\n          <div class=\"desc\">\n            ").concat(productTitle, "\n          </div>\n          <div class=\"price\">\n            +").concat(Shopify.formatMoney(productPrice, "".concat(this.currencySymbol, "{{ amount}}")), "\n          </div>\n        </div>\n      "));
      }

      // Update the total price of the extras area
      var extrasTotal = 0;
      var extraProducts = document.querySelectorAll(this.selectors.extra);
      extraProducts.forEach(function (product) {
        extrasTotal = extrasTotal + parseInt(product.dataset.attrPrice);
      });
      if (this.extrasTotal) {
        this.extrasTotal.textContent = Shopify.formatMoney(extrasTotal, "".concat(this.currencySymbol, "{{ amount}}"));
      }

      // Calculate total
      if (this.total) {
        var originalTotal = this.total.dataset.attrPrice;
        var newTotal = parseInt(extrasTotal) + parseInt(originalTotal);
        this.total.textContent = Shopify.formatMoney(newTotal, "".concat(this.currencySymbol, "{{ amount}}"));
        this.additionalTotals.forEach(function (additionalTotal) {
          additionalTotal.textContent = Shopify.formatMoney(newTotal, "".concat(_this12.currencySymbol, "{{ amount}}"));
        });
        this.updateFinance(newTotal);
      }

      // Generate properties HTML
      var inputs = [];
      var defaultInputs = this.defaultComponentInputs(productGroup, productId, productTitle);
      var extraInputs = ["<input type=\"hidden\" name=\"items[".concat(rowIndex, "]id\" value=\"").concat(productId, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_parentLineItem]\" value=\"").concat(productGroup, "___").concat(primaryParentLineItem.value, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_bikeComponent]\" value=\"true\" />")];
      if (isDefault) {
        inputs.push.apply(inputs, _toConsumableArray(defaultInputs));
      } else {
        inputs.push.apply(inputs, extraInputs);
        this.productCount = document.querySelector(this.selectors.productCount);
        var newProductCountValue = 0;
        this.bikeBuilderGroups.forEach(function (group) {
          var activeChoice = group.querySelector(".active");
          if (activeChoice) ++newProductCountValue;
        });
        if (this.productCount) {
          this.productCount.value = newProductCountValue;
        }
      }

      // Special handling for Wheelsets
      var isWheelset = productGroup === "Wheels";
      if (isWheelset) {
        var wheelbaseSkus = el.getAttribute("data-wheelbase-skus");
        if (wheelbaseSkus) {
          var wheelSplit = wheelbaseSkus.split(", ");
          var _wheelSplit2 = _slicedToArray(wheelSplit, 2),
            frontSku = _wheelSplit2[0],
            backSku = _wheelSplit2[1];
          var baseWheelInputs = ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
          inputs.length = 0;
          if (isDefault) {
            inputs.push.apply(inputs, baseWheelInputs);
          }
          if (!isDefault) {
            var wheelExtras = [].concat(extraInputs, ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />")]);
            inputs.push.apply(inputs, _toConsumableArray(wheelExtras));
          }
        }
      }
      if (productProperties) {
        productProperties.innerHTML = inputs.join("\n");
      }
    }
  }, {
    key: "initFormSubmission",
    value: function initFormSubmission() {
      var _this13 = this;
      if (this.bikeBuilderForm) {
        this.bikeBuilderForm.addEventListener("submit", function (e) {
          // Prevent the native submit unconditionally, up front. If this were
          // deferred until after the reconcile block below, any throw in that
          // block would abort the listener with the default not yet prevented,
          // so the browser would fall through to a native submit — skipping
          // refreshBikeBuildId() (which guards against a known multi-bike
          // parent-id collision) and the GA4 emit.
          e.preventDefault();
          if (!_this13.step3Ready) {
            return;
          }
          if (!_this13.hasSelectedAllStep1Options()) {
            _this13.promptSelectOptions();
            return;
          }
          if (!_this13.isSelectedFrameVariantAvailable()) {
            _this13.promptUnavailableVariant();
            return;
          }

          // Last-chance reconcile. The frame id is carried in an input's name
          // attribute, so any path that set the radios without running
          // writeFrameBundle would otherwise post a plausible wrong frame. Rewrite
          // from the selection, then refuse the add if it still disagrees.
          var frameBefore = _this13.assertFrameBundle();
          _this13.writeFrameBundle(frameBefore.expected);
          var frameAfter = _this13.assertFrameBundle();
          if (!frameAfter.ok) {
            _this13.showToast("Sorry — please reselect your size to continue.");
            return;
          }
          if (!frameBefore.ok) {
            _this13.stampFrameCorrected(frameBefore.posted, frameAfter.expected.id);
          }
          if (_this13.submitting) return;

          // Offer the upsell popup before the bike posts. Closing it re-submits
          // through here with upsellResolved set, so the checks above run again.
          if (_this13.upsellResolved) {
            _this13.upsellResolved = false;
          } else if (_this13.hasUpsellOffer()) {
            _this13.upsellModal.dispatchEvent(new CustomEvent("upsell:open"));
            // dispatchEvent is synchronous, so a popup that failed to open shows
            // here, and the bike carries on to the basket rather than stalling.
            if (_this13.upsellModal.classList.contains("is-active")) {
              _this13.awaitingUpsell = true;
              return;
            }
          }
          _this13.submitting = true;
          _this13.refreshBikeBuildId();
          var bikeVariant = frameAfter.expected;
          (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.emitBikeAddedToCart)({
            itemId: _this13.dataset.bikeProductId || (bikeVariant ? bikeVariant.id : _this13.product && _this13.product.id),
            itemName: _this13.dataset.bikeProductTitle || _this13.product && _this13.product.title,
            itemVariant: bikeVariant && bikeVariant.title
          });
          var form = _this13.bikeBuilderForm;
          window.setTimeout(function () {
            return form.submit();
          }, 200);
        });
      }
    }

    /**
     * True when the bike has an upsell popup with at least one product that can
     * be added. product_upsell renders its wrapper for any `upsell_` tag, even
     * when every tagged product is sold out or hidden on this store.
     */
  }, {
    key: "hasUpsellOffer",
    value: function hasUpsellOffer() {
      return Boolean(this.upsellModal && this.upsellModal.querySelector(".js-upsell-form"));
    }

    /**
     * The upsell popup (snippets/product_upsell.liquid, rendered deferred) adds
     * its own items by AJAX and fires `upsell:closed` however it is dismissed.
     * The bike has not been added yet at that point, so every close carries on
     * to the native bike submit, which lands on /cart.
     */
  }, {
    key: "initUpsellOffer",
    value: function initUpsellOffer() {
      var _this14 = this;
      if (!this.upsellModal || !this.bikeBuilderForm) return;
      this.upsellModal.addEventListener("upsell:closed", function () {
        if (!_this14.awaitingUpsell) return;
        _this14.awaitingUpsell = false;
        _this14.upsellResolved = true;
        var form = _this14.bikeBuilderForm;
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event("submit", {
            bubbles: true,
            cancelable: true
          }));
        }
      });
    }

    /**
     * Stamps the build with a fresh, unique parent line-item id on every submit.
     *
     * Each build groups its component line items to its frame via a parent id:
     * the frame carries `_primaryParentLineItem` and every component carries
     * `_parentLineItem` = `<GROUP>___<id>`. That id is seeded server-side from
     * `{{ "now" | date: "%s" }}` (#primaryParentLineItem).
     *
     * The builder adds via a native form submit (no AJAX), so the customer
     * usually returns to it via the browser back/forward cache or a CDN-cached
     * render. In that case the seed is frozen and a second bike submits with the
     * SAME id as the first — the two builds then share a parent id, their
     * components become indistinguishable, and the cart's bundle grouping /
     * removal logic cross-links them, stripping the first bike's options.
     *
     * Re-minting the id here, client-side at submit time, guarantees each added
     * bike gets a distinct parent id regardless of how the page was cached. (The
     * legacy `checkBikeBuilder()` increment in cart.js only runs on the AJAX add
     * path, which the bike builder never uses.)
     */
  }, {
    key: "refreshBikeBuildId",
    value: function refreshBikeBuildId() {
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");
      if (!primaryParentLineItem) return;
      var uniqueId = "".concat(Date.now()).concat(Math.floor(Math.random() * 1000));

      // Re-point every component line at the new id (value is "<GROUP>___<id>").
      document.querySelectorAll('input[name$="[_parentLineItem]"]').forEach(function (input) {
        var group = input.value.split("___")[0];
        input.value = "".concat(group, "___").concat(uniqueId);
      });
      primaryParentLineItem.value = uniqueId;
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      var _this15 = this;
      // Check for duplicates
      var all_defaults = document.querySelectorAll(".bike-builder-block.default");
      all_defaults.forEach(function (default_item) {
        var get_id = default_item.dataset.attrId;
        var find_duplicates = document.querySelectorAll(".bike-builder-block[data-attr-id=\"".concat(get_id, "\"]:not(.default)"));
        if (find_duplicates.length > 0) {
          find_duplicates.forEach(function (duplicate) {
            duplicate.closest(".bike-builder-block-wrapper").remove();
          });
        }
      });
      this.initScrollBar();
      var delta = 6;
      var startX;
      var startY;
      document.body.addEventListener("mousedown", function (event) {
        startX = event.pageX;
        startY = event.pageY;
      });
      document.body.addEventListener("mouseup", function (event) {
        var diffX = Math.abs(event.pageX - startX);
        var diffY = Math.abs(event.pageY - startY);
        if (diffX < delta && diffY < delta) {
          _this15.mouseIsDragging = false;
        } else {
          _this15.mouseIsDragging = true;
        }
      });
    }
  }, {
    key: "initScrollBar",
    value: function initScrollBar() {
      this.bikeBuilderGroups.forEach(function (group) {
        var uniqueId = group.dataset.attrGroup;
        var $content = $(group).parents(".bike-builder-row");
        var $slides = $(group).children();
        var $scrollbar = $("[data-attr-scrollbar-group=\"".concat(uniqueId, "\"]"));
        var $thumb = $("[data-attr-scrollbar-thumb-group=\"".concat(uniqueId, "\"]"));
        var $prevBtn = $("[data-attr-prev-btn=\"".concat(uniqueId, "\"]"));
        var $nextBtn = $("[data-attr-next-btn=\"".concat(uniqueId, "\"]"));
        var slideWidth = $($slides[0]).outerWidth(true);
        var slidesToShow = 3;
        var totalSlides = $slides.length;
        var isDragging = false;
        var currentSlide = 0;
        var isGoToSlide = false;
        function checkOverflow() {
          $content[0].scrollWidth > $content[0].clientWidth ? $scrollbar.show() : $scrollbar.hide();
        }
        function updateButtons() {
          if ($(window).width() >= 768) {
            currentSlide <= 0 ? $prevBtn.hide() : $prevBtn.show();
            currentSlide >= totalSlides - slidesToShow ? $nextBtn.hide() : $nextBtn.show();
          }
        }
        function updateSlideVisibility() {
          $slides.each(function (index, slide) {
            var slideLeft = $(slide).position().left;
            var visibleWidth = Math.min(slideWidth, $content.width() - slideLeft, slideLeft + slideWidth);
            $(slide).css("opacity", visibleWidth >= 0.7 * slideWidth ? 1 : 0.5);
          });
        }
        function updateThumbPosition() {
          var scrollRatio = $content.scrollLeft() / ($content[0].scrollWidth - $content[0].clientWidth);
          $thumb.css("left", scrollRatio * ($scrollbar.width() - $thumb.width()));
        }
        function updateCurrentSlide() {
          var viewportCenter = $content.scrollLeft() + $content.width() / 2;
          var closestDistance = Infinity;
          var mostCenterLeftSlideIndex = 0;
          for (var i = 0; i < totalSlides; i++) {
            var slideCenter = i * slideWidth + slideWidth / 2;
            if (slideCenter <= viewportCenter && viewportCenter - slideCenter < closestDistance) {
              closestDistance = viewportCenter - slideCenter;
              mostCenterLeftSlideIndex = i;
            }
          }
          currentSlide = mostCenterLeftSlideIndex === 1 && $content.scrollLeft() <= slideWidth ? 0 : Math.min(mostCenterLeftSlideIndex, totalSlides - slidesToShow);
        }
        function goToSlide(slideIndex) {
          slideIndex = Math.max(0, Math.min(slideIndex, totalSlides - slidesToShow));
          $content.scrollLeft(slideIndex * slideWidth);
          currentSlide = slideIndex;
          isGoToSlide = true;
        }
        function startDrag(e) {
          isDragging = true;
          var startX = e.type === "touchstart" ? e.originalEvent.touches[0].pageX : e.pageX;
          var thumbStartX = $thumb.position().left;
          var moveFn = function moveFn(moveEvent) {
            var currentPageX = moveEvent.type === "touchmove" ? moveEvent.originalEvent.touches[0].pageX : moveEvent.pageX;
            var dragAmount = currentPageX - startX;
            var thumbNewX = thumbStartX + dragAmount;
            var maxThumbX = $scrollbar.width() - $thumb.width();
            thumbNewX = Math.max(0, Math.min(thumbNewX, maxThumbX));
            var scrollRatio = thumbNewX / maxThumbX;
            $content.scrollLeft(scrollRatio * ($content[0].scrollWidth - $content[0].clientWidth));
            $thumb.css("left", thumbNewX);
          };
          $(document).on("mousemove touchmove", moveFn).one("mouseup touchend", function () {
            $(document).off("mousemove touchmove", moveFn);
            isDragging = false;
          });
        }
        $thumb.off("mousedown touchstart").on("mousedown touchstart", startDrag);
        $content.off("scroll").on("scroll", function () {
          if (!isDragging) updateThumbPosition();
          if (!isGoToSlide) updateCurrentSlide();else isGoToSlide = false;
          updateButtons();
          updateSlideVisibility();
        });
        $prevBtn.off("click").on("click", function () {
          return goToSlide(currentSlide - 1);
        });
        $nextBtn.off("click").on("click", function () {
          return goToSlide(currentSlide + 1);
        });
        checkOverflow();
        updateThumbPosition();
        updateButtons();
        updateSlideVisibility();
      });
    }
  }, {
    key: "handleAvailTriggers",
    value: function handleAvailTriggers() {
      var _this16 = this;
      this.availTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          if (_this16.availModal) {
            _this16.availModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
        });
      });
    }
  }, {
    key: "handleInfoTriggers",
    value: function handleInfoTriggers() {
      var _this17 = this;
      this.infoTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var _this17$infoModalCont, _this17$infoModalCont2, _this17$infoModalCont3;
          var img = (_this17$infoModalCont = _this17.infoModalContent) === null || _this17$infoModalCont === void 0 ? void 0 : _this17$infoModalCont.querySelector(".js-bike-builder-product-info-modal__image");
          var title = (_this17$infoModalCont2 = _this17.infoModalContent) === null || _this17$infoModalCont2 === void 0 ? void 0 : _this17$infoModalCont2.querySelector(".js-bike-builder-product-info-modal__title");
          var text = (_this17$infoModalCont3 = _this17.infoModalContent) === null || _this17$infoModalCont3 === void 0 ? void 0 : _this17$infoModalCont3.querySelector(".js-bike-builder-product-info-modal__text");
          if (img) img.src = "";
          if (_this17.infoModal) {
            _this17.infoModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
          if (!trigger.hasAttribute("data-product-info-featured-image")) return;
          if (img) img.src = trigger.dataset.productInfoFeaturedImage;
          if (title) title.innerHTML = trigger.dataset.productInfoTitle.replace("[OEM]", "").replace("[BB]", "");
          if (text) text.innerHTML = trigger.dataset.productInfoText;
        });
      });
    }
  }, {
    key: "populateWheelbaseInput",
    value: function populateWheelbaseInput() {
      var wheelGroup = document.querySelector('.bike-builder-group[data-attr-group="Wheels"]');
      if (wheelGroup) {
        var activeBlock = wheelGroup.querySelector(".bike-builder-block.active");
        if (activeBlock) {
          var wheelbaseSkus = activeBlock.getAttribute("data-wheelbase-skus");
          if (wheelbaseSkus) {
            var _wheelGroup$closest;
            var wheelSplit = wheelbaseSkus.split(", ");
            var productProperties = (_wheelGroup$closest = wheelGroup.closest("[data-product-option-list]")) === null || _wheelGroup$closest === void 0 ? void 0 : _wheelGroup$closest.querySelector(".product-properties");
            if (productProperties) {
              var productIdToBundleFront = "\n            <input\n              id=\"bundleProduct_".concat(wheelSplit[0], "\"\n              type=\"text\"\n              name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[0], "]\"\n              value=\"1\"\n            />\n            ");
              var productIdToBundleBack = "\n            <input\n              id=\"bundleProduct_".concat(wheelSplit[1], "\"\n              type=\"text\"\n              name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[1], "]\"\n              value=\"1\"\n            />\n            ");
              productProperties.innerHTML = productIdToBundleFront + productIdToBundleBack;
            }
          }
        }
      }
    }
  }, {
    key: "hideEmptyStepItems",
    value: function hideEmptyStepItems() {
      var emptyStepItems = document.querySelectorAll("[data-product-option-list-empty]");
      emptyStepItems.forEach(function (item) {
        return item.parentElement.style.display = "none";
      });
    }
  }, {
    key: "handleContentScroll",
    value: function handleContentScroll() {
      if (this.submit) {
        var stickyElement = this.submit.parentElement;
        var sentinel = stickyElement === null || stickyElement === void 0 ? void 0 : stickyElement.previousElementSibling;
        if (sentinel) {
          var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
              stickyElement.classList.remove("sticky");
            } else {
              stickyElement.classList.add("sticky");
            }
          }, {
            threshold: [1]
          });
          observer.observe(sentinel);
        }
      }
    }
  }, {
    key: "handleNinjaDiscount",
    value: function handleNinjaDiscount() {
      var _this18 = this;
      document.addEventListener("limoniapps:discountninja:product:discountapplied", function (event) {
        var discountedProductInfo = event.detail.data[0];
        _this18.bikeBuilderBlocks = document.querySelectorAll(_this18.selectors.bikeBuilderBlocks);
        var discountedBlocks = document.querySelectorAll("".concat(_this18.selectors.bikeBuilderBlocks, "[data-product-handle=\"").concat(discountedProductInfo.ProductHandle, "\"]"));
        discountedBlocks.forEach(function (discountedBlock) {
          var variantPrice = parseInt(discountedBlock.getAttribute("data-attr-price"));
          var variantCompareAtPrice = parseInt(discountedBlock.getAttribute("data-attr-compare-at-price"));
          var discountPercentage = discountedProductInfo.Percentage / 100;
          var discountedVariantPrice = Math.round(variantPrice * (1 - discountPercentage));
          var formattedVariantCompareAtPrice = window.Shopify.formatMoney(variantCompareAtPrice, "".concat(window.Shopify.currency.symbol, "{{amount}}"));
          var formattedDiscountedVariantPrice = window.Shopify.formatMoney(discountedVariantPrice, "".concat(window.Shopify.currency.symbol, "{{amount}}"));
          var $price = discountedBlock.querySelector(".bike-builder-product_price");
          var updatedHTML;
          if (variantPrice == variantCompareAtPrice || variantPrice == 0) {
            updatedHTML = "<span class=\"bike-builder-product_price__current\">+".concat(formattedVariantCompareAtPrice, "</span>");
          } else {
            discountedBlock.setAttribute("data-attr-price", discountedVariantPrice);
            updatedHTML = "<span class=\"bike-builder-product_price__current\"><s>+".concat(formattedVariantCompareAtPrice, "</s> +").concat(formattedDiscountedVariantPrice, "</span>");
          }
          var $newPrice = document.createElement("p");
          $newPrice.className = "bike-builder-product_price";
          $newPrice.innerHTML = updatedHTML;
          if ($price) {
            $price.replaceWith($newPrice);
          }
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-bike-builder-v3.js":
/*!********************************************************!*\
  !*** ./src/scripts/modules/product-bike-builder-v3.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductBikeBuilderV3)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bike-builder-ga4 */ "./src/scripts/modules/bike-builder-ga4.js");
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* harmony import */ var _bike_builder_option_card_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./bike-builder-option-card.mjs */ "./src/scripts/modules/bike-builder-option-card.mjs");
/* harmony import */ var _bike_builder_finance_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./bike-builder-finance.mjs */ "./src/scripts/modules/bike-builder-finance.mjs");
/* harmony import */ var _bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./bike-build-lines.mjs */ "./src/scripts/modules/bike-build-lines.mjs");
/* harmony import */ var _bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./bike-build-changes.mjs */ "./src/scripts/modules/bike-build-changes.mjs");
/* harmony import */ var _bike_build_basket__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./bike-build-basket */ "./src/scripts/modules/bike-build-basket.js");
/* harmony import */ var _bike_build_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./bike-build-toast */ "./src/scripts/modules/bike-build-toast.js");
/* harmony import */ var _bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./bike-build-summary.mjs */ "./src/scripts/modules/bike-build-summary.mjs");
/* harmony import */ var _bike_build_c2w_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./bike-build-c2w.mjs */ "./src/scripts/modules/bike-build-c2w.mjs");
/* harmony import */ var _bike_build_summary_sheet__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./bike-build-summary-sheet */ "./src/scripts/modules/bike-build-summary-sheet.js");
/* harmony import */ var _bike_build_drawer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./bike-build-drawer */ "./src/scripts/modules/bike-build-drawer.js");
/* harmony import */ var _bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./bike-buy-column.mjs */ "./src/scripts/modules/bike-buy-column.mjs");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }














var ProductBikeBuilderV3 = /*#__PURE__*/function (_HTMLElement) {
  function ProductBikeBuilderV3() {
    var _this;
    _classCallCheck(this, ProductBikeBuilderV3);
    _this = _callSuper(this, ProductBikeBuilderV3);

    // General
    _this.product = JSON.parse(document.querySelector("[data-frame-product-json]").textContent);
    _this.observeConfig = {
      attributes: true,
      subtree: true
    };

    // Selectors
    _this.selectors = {
      bikeBuilderForm: ".js-bike-builder-form",
      bikeBuilderGroups: ".bike-builder-group",
      bikeBuilderBlocks: ".bike-builder-block",
      // One card per component product, holding a block per variant (Package C).
      optionCards: ".bike-builder-block-wrapper",
      variantSizes: ".js-bike-builder-variant-size",
      sizeLists: ".bike-builder-product_sizes",
      bikeBuilderRow: ".bike-builder-row",
      frameOptions: "[data-product-option]",
      frameDefaults: ".default",
      availModal: ".js-bike-builder-product-avail-modal",
      availTriggers: ".js-bike-builder-product-avail-trigger",
      infoModal: ".js-bike-builder-product-info-modal",
      infoModalContent: ".js-bike-builder-product-info-modal-content",
      infoTriggers: ".js-bike-builder-product-info-trigger",
      propVariantId: "[data-bike-builder-variant-id]",
      propVariantTitle: "[data-bike-builder-variant-title]",
      sizeGuide: "product-size-guide",
      stepsStates: ".js-bike-builder-state",
      steps: ".js-bike-builder-step",
      stepsContents: ".js-bike-builder-step-content",
      stepsSelections: ".js-bike-builder-step-selection",
      edits: ".js-bike-builder-edit",
      resets: ".js-bike-builder-reset",
      // Reset to standard build (Step 2 heading) and its undo affordance.
      resetBuild: ".js-bb-reset-build",
      extra: ".js-bike-builder-extra",
      extrasArea: ".js-bike-builder-extras-area",
      extrasTotal: ".js-bike-builder-extras-total",
      savings: ".js-bike-builder-savings",
      priceFrameTitle: ".js-bike-builder-frame-title",
      total: ".js-bike-builder-total",
      finance: ".js-bike-builder-finance",
      financeMonthly: ".js-bike-builder-monthly",
      financeModal: "[data-bb-finance-modal]",
      financeModalOpen: "[data-bb-finance-modal-open]",
      financeModalClose: "[data-bb-finance-modal-close]",
      c2wModal: "[data-bb-c2w-modal]",
      c2wModalOpen: "[data-bb-c2w-modal-open]",
      c2wModalClose: "[data-bb-c2w-modal-close]",
      c2wCalc: ".js-bb-c2w-calc",
      c2wCost: ".js-bb-c2w-cost",
      c2wDetail: ".js-bb-c2w-detail",
      additionalTotals: ".js-bike-builder-additional-total",
      productCount: ".js-bike-builder-product-count",
      submit: ".js-bike-builder-submit",
      preorderVariant: "[data-preorder-variant]",
      // Simple builder specific selectors
      // The desktop buy bar's Add to basket (Task 5). The bike basket sweep
      // (shopify-storefront-qa src/sweep.js) clicks this class: keep it.
      addToBasketBtn: ".js-bike-builder-add-to-basket",
      summary: ".js-bike-builder-summary",
      // Summary v2 (Builder refinements).
      summarySize: ".js-bb-summary-size",
      summaryColour: ".js-bb-summary-colour",
      summaryExtrasHeading: ".js-bb-summary-extras-heading",
      summaryEmpty: ".js-bb-summary-empty",
      summarySaving: ".js-bb-summary-saving",
      deliveryDate: ".js-bb-delivery-date",
      deliveryBlock: ".bike-builder-delivery",
      // The Step 2 heading with its padlock (Kenny's progression, 22 Oct 2026).
      unlock: ".js-bb-unlock",
      preorderDispatch: ".js-preorder-dispatch",
      builderGallery: ".bike-builder__column .product-media",
      step3Slot: ".js-bike-builder-step3-slot",
      step3Loading: ".js-bike-builder-step3-loading",
      // Mobile running-total bar (below $large, where the summary can't stick).
      mobileBar: ".js-bb-mobile-bar",
      viewBuild: ".js-bb-view-build",
      viewBuildLabel: ".js-bb-view-build-label",
      sheetOverlay: ".js-bb-sheet-overlay",
      summaryClose: ".js-bb-summary-close",
      mobileSubmit: ".js-bb-mobile-submit"
    };
    _this.preorderVariant = document.querySelector(_this.selectors.preorderVariant);

    // Elements
    _this.bikeBuilderForm = document.querySelector(_this.selectors.bikeBuilderForm);
    _this.bikeBuilderGroups = document.querySelectorAll(_this.selectors.bikeBuilderGroups);
    _this.bikeBuilderBlocks = document.querySelectorAll(_this.selectors.bikeBuilderBlocks);
    _this.bikeBuilderRow = document.querySelectorAll(_this.selectors.bikeBuilderRow);
    _this.frameOptions = document.querySelectorAll(_this.selectors.frameOptions);
    _this.availModal = document.querySelector(_this.selectors.availModal);
    _this.infoModal = document.querySelector(_this.selectors.infoModal);
    _this.infoModalContent = document.querySelector(_this.selectors.infoModalContent);
    _this.availTriggers = document.querySelectorAll(_this.selectors.availTriggers);
    _this.infoTriggers = document.querySelectorAll(_this.selectors.infoTriggers);
    _this.edits = document.querySelectorAll(_this.selectors.edits);
    _this.resets = document.querySelectorAll(_this.selectors.resets);
    _this.extrasArea = document.querySelector(_this.selectors.extrasArea);
    _this.extrasTotal = document.querySelector(_this.selectors.extrasTotal);
    _this.savings = document.querySelector(_this.selectors.savings);
    _this.priceFrameTitle = document.querySelector(_this.selectors.priceFrameTitle);
    _this.total = document.querySelector(_this.selectors.total);
    // There can be more than one finance line (header price + sticky summary),
    // so track them all and update each on price change.
    _this.financeBlocks = document.querySelectorAll(_this.selectors.finance);
    // Monthly figures appear in the finance line(s) AND the info modal; the
    // modal's isn't inside a finance block, so cache them all to update together.
    _this.financeMonthlyEls = document.querySelectorAll(_this.selectors.financeMonthly);
    _this.additionalTotals = document.querySelectorAll(_this.selectors.additionalTotals);
    _this.productCount = document.querySelector(_this.selectors.productCount);
    _this.submit = document.querySelector(_this.selectors.submit);
    _this.properties = {
      variantId: document.querySelector("[data-bike-builder-variant-id]"),
      variantTitle: document.querySelector("[data-bike-builder-variant-title]")
    };

    // Simple builder specific elements
    _this.addToBasketBtn = document.querySelector(_this.selectors.addToBasketBtn);
    _this.addToBasketDefaultText = _this.addToBasketBtn ? _this.addToBasketBtn.textContent.trim() : "";
    _this.summary = document.querySelector(_this.selectors.summary);
    _this.preorderDispatch = document.querySelector(_this.selectors.preorderDispatch);
    _this.summarySize = _this.querySelector(_this.selectors.summarySize);
    _this.summaryColour = _this.querySelector(_this.selectors.summaryColour);
    _this.summaryExtrasHeading = _this.querySelector(_this.selectors.summaryExtrasHeading);
    _this.summaryEmpty = _this.querySelector(_this.selectors.summaryEmpty);
    _this.summarySaving = _this.querySelector(_this.selectors.summarySaving);
    // The summary's delivery block and, on the closed page, the one above the buttons.
    _this.deliveryDates = _this.querySelectorAll(_this.selectors.deliveryDate);
    // The Cycle to Work calculator inside its modal (UK only, so it may be absent).
    _this.c2wCalc = document.querySelector(_this.selectors.c2wCalc);
    _this.c2wCost = _this.c2wCalc ? _this.c2wCalc.querySelector(_this.selectors.c2wCost) : null;
    _this.c2wDetail = _this.c2wCalc ? _this.c2wCalc.querySelector(_this.selectors.c2wDetail) : null;
    _this.c2wTotalCents = 0;
    // The summary as a bottom sheet below $large; set by initMobileBar().
    _this.summarySheet = null;
    // The summary as the Your build drawer at $large; set by initDrawer().
    _this.summaryDrawer = null;
    _this.stage = _this.querySelector(".js-bb-stage");
    _this.drawerToggle = _this.querySelector(".js-bb-drawer-toggle");
    _this.drawerToggleLabel = _this.querySelector(".js-bb-drawer-toggle-label");
    _this.extrasCount = 0;
    _this.resetBuildBtn = document.querySelector(_this.selectors.resetBuild);
    _this.mobileBar = document.querySelector(_this.selectors.mobileBar);
    _this.viewBuild = _this.querySelector(_this.selectors.viewBuild);
    _this.viewBuildLabel = _this.querySelector(_this.selectors.viewBuildLabel);
    _this.sheetOverlay = _this.querySelector(_this.selectors.sheetOverlay);
    _this.summaryClose = _this.querySelector(_this.selectors.summaryClose);
    _this.mobileSubmit = document.querySelector(_this.selectors.mobileSubmit);
    _this.builderGallery = document.querySelector(_this.selectors.builderGallery);
    _this.step3Slot = document.querySelector(_this.selectors.step3Slot);
    _this.step3Loaded = false;
    _this.step3Ready = false;
    _this.accessoriesFailed = false;
    _this.wheelbaseInputFront = document.querySelector("#wheelbase-id-front");
    _this.wheelbaseInputBack = document.querySelector("#wheelbase-id-back");

    // General
    _this.mouseIsDragging = false;
    _this.step2DefaultsSet = false;
    _this.step3DefaultsSet = false;
    _this.stepIsBeingEdited = false;
    _this.isSelectingDefaults = false; // Flag to prevent observer firing during default selection
    _this.step1Complete = false; // Track if step 1 has been completed
    // Reset to standard build: the pre-reset choices (undo payload) and the
    // dismissal timer for the status line. A flag distinguishes the changes the
    // reset itself makes from a customer's own change, which invalidates the undo.
    _this.resetSnapshot = null;
    // The reset toast while it shows; its Undo lasts as long as it does.
    _this.resetToast = null;
    _this.isRestoringBuild = false;

    // Edit from basket (Phase 3 brief 4.2). editParentId is set only once
    // restoreFromBasket() has found the build in the basket; the submit handler
    // reads it to replace the build instead of adding a second bike.
    _this.editParentId = null;
    _this.editStrings = {
      submit: _this.dataset.editSubmit || "Update basket",
      notFound: _this.dataset.editNotFound || "",
      unrestored: _this.dataset.editUnrestored || "",
      updateFailed: _this.dataset.editUpdateFailed || "",
      removedOne: _this.dataset.editRemovedOne || "",
      removedOther: _this.dataset.editRemovedOther || "",
      removedPart: _this.dataset.editRemovedPart || "",
      removedPick: _this.dataset.editRemovedPick || "",
      removedChange: _this.dataset.editRemovedChange || "",
      delta: _this.dataset.editDelta || "[amount]",
      deltaNone: _this.dataset.editDeltaNone || ""
    };
    _this.editNotice = _this.querySelector(".js-bike-builder-edit-notice");
    _this.submitDefaultValue = _this.submit ? _this.submit.value : "";

    // Edit mode, Kenny's V3 design: the banner naming the bike, the summary of
    // changes against the basket, and the basket's build to compare with
    // (editBaseline, set once the build is restored).
    _this.editBanner = _this.querySelector(".js-bb-editing-banner");
    _this.editSummary = _this.querySelector(".js-bb-edit-summary");
    _this.editBaseline = null;
    _this.addAsNewBike = false;

    // Resolves once Step 3 is in the page with its defaults applied, or at once
    // when the template has no Step 3. restoreFromBasket() waits on it.
    _this.step3ReadyPromise = new Promise(function (resolve) {
      _this.resolveStep3Ready = resolve;
    });

    // Steps
    _this.steps = document.querySelectorAll(_this.selectors.steps);
    _this.stepsStates = document.querySelectorAll(_this.selectors.stepsStates);
    _this.stepsContents = document.querySelectorAll(_this.selectors.stepsContents);
    _this.stepsSelections = document.querySelectorAll(_this.selectors.stepsSelections);
    _this.step = {
      1: {
        step: _this.steps[0],
        state: _this.stepsStates ? _this.stepsStates[0] : null,
        content: _this.stepsContents[0],
        selection: _this.stepsSelections[0]
      },
      2: {
        step: _this.steps[1],
        state: _this.stepsStates ? _this.stepsStates[1] : null,
        content: _this.stepsContents[1],
        selection: _this.stepsSelections[1]
      },
      3: {
        step: _this.steps[2],
        state: _this.stepsStates ? _this.stepsStates[2] : null,
        content: _this.stepsContents[2],
        selection: _this.stepsSelections[2]
      }
    };
    _this.state = {
      active: {
        1: true,
        2: false,
        3: false
      },
      observers: {}
    };

    // Classes
    _this.classes = {
      stepsStates: {
        active: "bike-builder-content__state--active",
        complete: "bike-builder-content__state--complete"
      },
      steps: {
        active: "bike-builder-content__step--active",
        complete: "bike-builder-content__step--complete"
      },
      submit: {
        disabled: "bike-builder-button--disabled"
      }
    };
    _this.currencySymbol = window.Shopify.currency.symbol;
    _this.init();
    return _this;
  }
  _inherits(ProductBikeBuilderV3, _HTMLElement);
  return _createClass(ProductBikeBuilderV3, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.initSliders();
      this.initialiseStep1();
      this.handleStep1Changes();
      this.handleResetBuild();
      this.initSections();
      this.initMobileBar();
      this.initDrawer();
      this.initImmersiveHeader();
      this.handleAddToBasketClick();
      this.handleAvailTriggers();
      this.handleInfoTriggers();
      this.bindInfoModal("financeModal");
      this.bindInfoModal("c2wModal");
      this.bindC2wCalculator();
      this.initFormSubmission();
      this.hideEmptyStepItems();
      this.checkURLForVariant();

      // Reconcile the standard availability note against the initial preorder state.
      this.syncAvailabilityNote();
      this.updateActionButtonState();
      this.bikeBuilderBlocks.forEach(function (el) {
        el.addEventListener("click", function () {
          if (!_this2.isSelectingDefaults) {
            _this2.changeBikeBuilderProduct(el);
          }
        });
      });
      this.bindOptionCards(this);
      this.observeOptionCards();
      // checkURLForVariant, above, marks every standard part active on a
      // ?variant= URL (any edit link, and collection and feed links) before the
      // observer exists, and re-selecting an active block changes no class, so
      // the observer would never catch up. Sync every card once now, or those
      // cards show no selection, which is all the green border has to say.
      this.syncOptionCards(this);
      this.frameOptions.forEach(function (el) {
        el.addEventListener("click", function () {
          _this2.updateVariantAvailability(el);
          _this2.changeFrameOption(el);
        });
      });
      this.handleContentScroll();
      this.handleNinjaDiscount();
      if (this.wheelbaseInputFront && this.wheelbaseInputBack) {
        this.populateWheelbaseInput();
      }
      this.fetchAccessories();
      this.restoreFromBasket();

      // Back after "Update basket" can restore this page from the back/forward
      // cache with edit mode still pointing at the build it just replaced. Reload
      // instead, so the restore reads the basket as it is now.
      window.addEventListener("pageshow", function (event) {
        if (event.persisted && _this2.editParentId) window.location.reload();
      });
      if (this.total) {
        this.updateFinance(parseInt(this.total.dataset.attrPrice, 10));
      }

      // Match the gallery (once slick is ready) to any pre-selected colour on load.
      var initialFrameVariant = this.resolveFrameVariant();
      if (initialFrameVariant) {
        this.updateGalleryImage(initialFrameVariant);
      }

      // Reflect the initial preorder dispatch state in the summary overlay.
      this.syncDeliveryDate();
      this.updateSummarySize();
      this.updateSummaryColour();
      this.renderSummary();
      this.updateUnlock();
    }
  }, {
    key: "checkURLForVariant",
    value: function checkURLForVariant() {
      if (window.location.search.includes("variant=")) {
        var allDefaults = document.querySelectorAll(".default");
        allDefaults.forEach(function (block) {
          block.classList.add("active");
        });
      } else {
        var step2Element = document.querySelector('.bike-builder-content__step[data-bike-builder-step="2"]');
        if (step2Element) {
          var stepItems = step2Element.querySelectorAll(".bike-builder-content__step-item");
          var emptyCount = 0;
          stepItems.forEach(function (stepItem) {
            if (stepItem.innerHTML.trim() === "") {
              emptyCount++;
            }
          });
          if (emptyCount === stepItems.length) {
            var _allDefaults = document.querySelectorAll(".default");
            _allDefaults.forEach(function (block) {
              block.classList.add("active");
            });
          }
        }
      }
    }

    /**
     * Handles changes in Step 1 using event listeners instead of MutationObserver
     * This is more efficient and avoids infinite loop issues
     */
  }, {
    key: "handleStep1Changes",
    value: function handleStep1Changes() {
      var _this3 = this;
      // Listen for changes on the frame options (radio buttons in step 1)
      this.frameOptions.forEach(function (el) {
        el.addEventListener("change", function () {
          // changeFrameOption is bound to `click`, but keyboard selection, a
          // programmatic .checked, and browser form-state restoration on
          // back-navigation all fire `change` without `click`. Every purchase gate
          // reads the checked radios directly, so without this the radios can say
          // Large/Blue while the posted frame id is still the rendered default.
          // writeFrameBundle is idempotent, so double-firing alongside click is safe.
          _this3.writeFrameBundle(_this3.resolveFrameVariant());
          _this3.checkStep1Completion();
        });
      });
    }

    /**
     * Checks if Step 1 (Select Options) is complete
     * If complete, auto-selects defaults for steps 2 & 3
     * Add to basket and the sections follow from updateActionButtonState().
     */
  }, {
    key: "checkStep1Completion",
    value: function checkStep1Completion() {
      // Prevent re-entry
      if (this.isSelectingDefaults) return;
      var allOptionsSelected = this.hasSelectedAllStep1Options();
      var selectedVariantAvailable = this.isSelectedFrameVariantAvailable();
      if (allOptionsSelected && selectedVariantAvailable && !this.step1Complete) {
        this.step1Complete = true;

        // Mark step 1 as complete
        this.step[1].step.classList.add(this.classes.steps.complete);

        // Auto-select defaults for steps 2 & 3 (hidden but selected)
        this.selectDefaultsForStep(2);
        this.maybeApplyStep3Defaults();
      } else if (!allOptionsSelected || !selectedVariantAvailable) {
        this.step1Complete = false;
        this.step[1].step.classList.remove(this.classes.steps.complete);
      }
      this.updateActionButtonState();
      this.updateSectionsLock();
      this.updateUnlock();
    }

    /**
     * Select all default options for a given step
     */
  }, {
    key: "selectDefaultsForStep",
    value: function selectDefaultsForStep(stepNumber) {
      var _this4 = this;
      if (stepNumber === 2 && this.step2DefaultsSet) return;
      if (stepNumber === 3 && this.step3DefaultsSet) return;
      var stepDefaults = document.querySelectorAll("[data-bike-builder-step=\"".concat(stepNumber, "\"] ").concat(this.selectors.frameDefaults));
      var stepGroups = document.querySelectorAll("[data-bike-builder-step=\"".concat(stepNumber, "\"] [data-product-option-list]"));
      if (stepDefaults.length === stepGroups.length) {
        // Set flag to prevent observer/click handler issues
        this.isSelectingDefaults = true;
        stepDefaults.forEach(function (stepDefault) {
          // Directly add active class and call the product change logic
          // instead of simulating a click which could trigger observers
          var productRow = stepDefault.closest("[data-product-option-list]");
          var productBlocks = productRow.querySelectorAll(_this4.selectors.bikeBuilderBlocks);
          productBlocks.forEach(function (block) {
            block.classList.toggle("active", block === stepDefault);
          });

          // Call the product change logic directly
          _this4.changeBikeBuilderProductDirect(stepDefault);
        });
        if (stepNumber === 2) this.step2DefaultsSet = true;
        if (stepNumber === 3) this.step3DefaultsSet = true;

        // Clear the flag
        this.isSelectingDefaults = false;
      }
    }

    /**
     * Direct product change without triggering click events
     * Used for auto-selecting defaults
     */
  }, {
    key: "changeBikeBuilderProductDirect",
    value: function changeBikeBuilderProductDirect(el) {
      var productRow = el.closest("[data-product-option-list]");
      var productProperties = productRow.querySelector(".product-properties");
      var productId = el.dataset.attrId;
      var productTitle = el.dataset.attrTitle;
      // See changeBikeBuilderProduct: frame option blocks have no component group,
      // so guard closest() instead of throwing null.dataset.
      var productGroupEl = el.closest(".bike-builder-group");
      if (!productGroupEl) return;
      var productGroup = productGroupEl.dataset.attrGroup;
      var isDefault = el.classList.contains("default");
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");

      // Generate properties HTML for defaults only
      var inputs = [];
      if (isDefault) {
        var defaultInputs = this.defaultComponentInputs(productGroup, productId, productTitle);
        inputs.push.apply(inputs, _toConsumableArray(defaultInputs));

        // Special handling for Wheelsets
        var isWheelset = productGroup === "Wheels";
        if (isWheelset) {
          var wheelbaseSkus = el.getAttribute("data-wheelbase-skus");
          if (wheelbaseSkus) {
            var wheelSplit = wheelbaseSkus.split(", ");
            var _wheelSplit = _slicedToArray(wheelSplit, 2),
              frontSku = _wheelSplit[0],
              backSku = _wheelSplit[1];
            inputs.length = 0;
            inputs.push("<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />");
          }
        }
      }
      if (productProperties) {
        productProperties.innerHTML = inputs.join("\n");
      }
      this.updateEditState();
    }

    /**
     * Checks if Step 1 is complete (all options selected)
     */
  }, {
    key: "hasSelectedAllStep1Options",
    value: function hasSelectedAllStep1Options() {
      var productOptions = document.querySelectorAll("[data-bike-builder-step=\"1\"] [data-product-option-list]");
      var checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"1\"] input[data-product-option]:checked");
      return checkedOptions.length === productOptions.length;
    }

    /**
     * The single source of truth for the chosen frame variant.
     *
     * Delegates to the shared per-option matcher in bike-builder-ga4.js — the same
     * one the availability gate, the summary and GA4 already use. This replaces a
     * second, divergent lookup that matched on a concatenated variant title; when
     * that lookup missed, the frame id was silently left at the rendered default
     * while every other gate still passed.
     */
  }, {
    key: "resolveFrameVariant",
    value: function resolveFrameVariant() {
      return (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.getSelectedFrameVariant)(this.product);
    }

    /**
     * The three `items[0]` property inputs that bundle a default component into the
     * bike: its variant id (carried in the property *key*, as /cart/add requires),
     * its display label, and the bike-component marker.
     *
     * Single definition shared by every writer of a default component —
     * changeBikeBuilderProductDirect, changeBikeBuilderProduct and writeForkBundle.
     */
  }, {
    key: "defaultComponentInputs",
    value: function defaultComponentInputs(group, id, title) {
      return ["<input id=\"bundleProduct_".concat(id, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(id, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(group, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(group, "]\" value=\"").concat(title, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
    }

    /**
     * The frame variant id currently encoded in the bundle input's name, or null
     * when the input has no name yet. The Liquid deliberately renders it nameless
     * (see snippets/product-variants-bike-builder.liquid) so an unwritten frame is
     * detectable instead of silently defaulting.
     */
  }, {
    key: "currentFrameBundleId",
    value: function currentFrameBundleId() {
      var input = this.properties.variantId;
      if (!input || !input.name) return null;
      var match = input.name.match(/_bundleProduct_(\d+)\]$/);
      return match ? match[1] : null;
    }

    /**
     * Point the bike's frame — and the colour-matched hidden fork — at `variant`.
     *
     * The frame id has to live in the input's *name* because /cart/add keys
     * bundled components as `_bundleProduct_<id>`. That makes this the only build
     * fact carried by an attribute rather than a value, so it gets one owner and
     * is re-applied defensively: on click, on change, and again at submit.
     * Must stay idempotent.
     */
  }, {
    key: "writeFrameBundle",
    value: function writeFrameBundle(variant) {
      if (!variant) return;
      if (this.properties.variantId) {
        this.properties.variantId.name = "items[0]properties[_bundleProduct_".concat(variant.id, "]");
      }
      if (this.properties.variantTitle) {
        this.properties.variantTitle.value = variant.title;
      }
      this.writeForkBundle(variant);
    }

    /**
     * Colour-match the hidden fork to the frame colour by writing its property
     * container directly.
     *
     * This previously dispatched a synthetic click, then a second one 300ms later.
     * writeFrameBundle now runs on click, change and submit, so synthetic clicks
     * would re-enter changeBikeBuilderProduct repeatedly and race that timer —
     * hence writing the inputs ourselves.
     *
     * Having no colour match is a legitimate state: plenty of bikes ship a single
     * fork colour, and availability filtering can drop a colour block entirely.
     * When that happens, explicitly reset to the group's rendered default block
     * rather than leaving whatever fork colour was written last — otherwise a
     * stale colour from a previous selection (e.g. Blue, picked before switching
     * to a frame colour with no matching fork) would silently ship bundled to
     * the new frame. The default block is guaranteed to exist per group
     * (rendered with a `default` class by
     * snippets/bike-builder-product-block.liquid), so this fallback should
     * always resolve; the final null check is just a safety net for a
     * malformed DOM, never a reason to block the sale.
     */
  }, {
    key: "writeForkBundle",
    value: function writeForkBundle(variant) {
      var forkGroup = document.querySelector('.bike-builder-group[data-attr-group="Fork"]');
      if (!forkGroup) return;
      var forkColour = this.frameColour(variant);
      var forkBlock = forkColour && forkGroup.querySelector(".bike-builder-block[data-variant-title=\"".concat(forkColour, "\"]")) || forkGroup.querySelector(".bike-builder-block.default");
      if (!forkBlock) return;
      forkGroup.querySelectorAll(this.selectors.bikeBuilderBlocks).forEach(function (block) {
        block.classList.toggle("active", block === forkBlock);
      });
      var productRow = forkBlock.closest("[data-product-option-list]");
      var productProperties = productRow ? productRow.querySelector(".product-properties") : null;
      if (!productProperties) return;
      var forkGroupName = forkGroup.dataset.attrGroup;
      var forkId = forkBlock.dataset.attrId;
      var forkTitle = forkBlock.dataset.attrTitle;
      if (!forkId) return;
      productProperties.innerHTML = this.defaultComponentInputs(forkGroupName, forkId, forkTitle).join("\n");
    }

    /**
     * Compare the frame id that would actually be posted against the customer's
     * current selection. Reports; does not act.
     *
     * @returns {{ok: boolean, expected: Object|null, posted: string|null}}
     */
  }, {
    key: "assertFrameBundle",
    value: function assertFrameBundle() {
      var expected = this.resolveFrameVariant();
      var posted = this.currentFrameBundleId();
      return {
        ok: Boolean(expected) && posted === String(expected.id),
        expected: expected,
        posted: posted
      };
    }

    /**
     * Record that the submitted frame id had to be corrected, as a hidden
     * line-item property on the bike.
     *
     * Underscore-prefixed properties are hidden from the customer but visible in
     * the admin and API, so affected orders are self-flagging and the order sweep
     * finds them with no extra infrastructure.
     *
     *   'none>ID'     the id was never written (e.g. restored form state)
     *   'OLDID>NEWID' a stale id was replaced
     *
     * The two shapes matter: they distinguish "the write never ran" from "the
     * write ran and was later reverted", which is the evidence needed to finally
     * identify the trigger. An absent property means no correction was needed.
     */
  }, {
    key: "stampFrameCorrected",
    value: function stampFrameCorrected(before, expectedId) {
      if (!this.bikeBuilderForm) return;
      var input = this.bikeBuilderForm.querySelector("[data-bb-frame-corrected]");
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "items[0]properties[_frameCorrected]";
        input.setAttribute("data-bb-frame-corrected", "");
        this.bikeBuilderForm.appendChild(input);
      }
      input.value = "".concat(before || "none", ">").concat(expectedId);
    }
  }, {
    key: "isSelectedFrameVariantAvailable",
    value: function isSelectedFrameVariantAvailable() {
      var selectedVariant = this.resolveFrameVariant();
      return Boolean(selectedVariant && selectedVariant.available);
    }
  }, {
    key: "isStep1Complete",
    value: function isStep1Complete() {
      return this.hasSelectedAllStep1Options() && this.isSelectedFrameVariantAvailable();
    }

    /**
     * Every Add to basket (the desktop bar's, the mobile bar's and the sheet's)
     * from one state: loading until Step 3 is in, Out of stock for a size and
     * colour that cannot be bought, Update basket while editing. With no size or
     * colour yet the buttons stay live: the submit handler prompts instead.
     */
  }, {
    key: "updateActionButtonState",
    value: function updateActionButtonState() {
      var _buyButtonState = (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.buyButtonState)({
          ready: this.step3Ready,
          failed: this.accessoriesFailed,
          chosen: this.hasSelectedAllStep1Options(),
          available: this.isSelectedFrameVariantAvailable(),
          editing: !!this.editParentId
        }, {
          add: this.addToBasketDefaultText || this.submitDefaultValue || "Add to basket",
          select: this.addToBasketBtn ? this.addToBasketBtn.dataset.selectLabel : "",
          update: this.editStrings.submit,
          loading: "Loading…",
          outOfStock: "Out of stock",
          failed: "Unavailable, refresh the page"
        }),
        label = _buyButtonState.label,
        disabled = _buyButtonState.disabled;
      [this.addToBasketBtn, this.mobileSubmit, this.submit].filter(Boolean).forEach(function (control) {
        control.disabled = disabled;
        if (control.tagName === "INPUT") control.value = label;else control.textContent = label;
      });
    }

    /**
     * Prompts the user to select options by highlighting Step 1 and showing a toast
     */
  }, {
    key: "promptSelectOptions",
    value: function promptSelectOptions() {
      var _this5 = this,
        _window$bikeBuilderSt;
      // Add a visual highlight to indicate they need to select options
      if (this.step[1].step) {
        this.step[1].step.classList.add("bike-builder-content__step--highlight");

        // Add to basket no longer sits beside Step 1 (buy column: it is in the
        // bar at the foot of the screen), so bring Step 1 into view when it is
        // off screen or low down. Where it is already in view nothing moves.
        var _this$step$1$step$get = this.step[1].step.getBoundingClientRect(),
          top = _this$step$1$step$get.top;
        if (top < 0 || top > window.innerHeight * 0.6) {
          this.step[1].step.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }

        // Remove the highlight after animation
        setTimeout(function () {
          _this5.step[1].step.classList.remove("bike-builder-content__step--highlight");
        }, 2000);
      }

      // Show an alert or message
      var message = ((_window$bikeBuilderSt = window.bikeBuilderStrings) === null || _window$bikeBuilderSt === void 0 ? void 0 : _window$bikeBuilderSt.selectOptionsPrompt) || "Please select your size and colour options first.";

      // Create a temporary toast notification
      this.showToast(message);
    }

    /**
     * Shows a toast notification message
     */
  }, {
    key: "showToast",
    value: function showToast(message) {
      // Check if toast already exists
      var toast = document.querySelector(".bike-builder-toast");
      if (!toast) {
        toast = document.createElement("div");
        toast.className = "bike-builder-toast";
        document.body.appendChild(toast);
      }
      toast.textContent = message;

      // Force a reflow to ensure the transition works
      toast.offsetHeight;
      toast.classList.add("bike-builder-toast--visible");

      // Hide after 3 seconds
      setTimeout(function () {
        toast.classList.remove("bike-builder-toast--visible");
      }, 3000);
    }
  }, {
    key: "promptUnavailableVariant",
    value: function promptUnavailableVariant() {
      this.showToast("Sorry, this option is out of stock.");
    }

    /**
     * Handles the Add to Basket button click
     */
  }, {
    key: "handleAddToBasketClick",
    value: function handleAddToBasketClick() {
      var _this6 = this;
      if (this.addToBasketBtn) {
        this.addToBasketBtn.addEventListener("click", function (e) {
          if (!_this6.hasSelectedAllStep1Options()) {
            e.preventDefault();
            _this6.promptSelectOptions();
            return;
          }
          if (!_this6.isSelectedFrameVariantAvailable()) {
            e.preventDefault();
            _this6.promptUnavailableVariant();
          }
          // If step 1 is complete, the form will submit normally
        });
      }
    }

    /** The page never scrolls for the shopper, so on desktop a notice that appears off screen is brought into view. */
  }, {
    key: "bringNoticeIntoView",
    value: function bringNoticeIntoView() {
      if (!this.editNotice || window.innerWidth < _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large) return;
      var rect = this.editNotice.getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        this.editNotice.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        });
      }
    }

    /**
     * Reset to standard build: every group in Steps 2 and 3 back to its `default`
     * block, with an Undo in a toast. Step 1 (frame size/colour) is deliberately untouched —
     * it is the bike the customer chose, not an upgrade, and clearing it would
     * invalidate both the fork colour match and the dispatch date.
     */
  }, {
    key: "handleResetBuild",
    value: function handleResetBuild() {
      var _this7 = this;
      if (this.resetBuildBtn) {
        // A click with detail 0 came from the keyboard: that customer is taken to Undo.
        this.resetBuildBtn.addEventListener("click", function (event) {
          return _this7.resetToStandardBuild({
            keyboard: event.detail === 0
          });
        });
      }
    }

    /**
     * The groups a reset may touch: Steps 2 and 3 only, and only those that have a
     * standard block to go back to. The hidden fork is rendered outside the
     * numbered steps and is slaved to the frame colour by changeFrameOption(), so
     * the step scoping already excludes it — the filter documents that it must.
     */
  }, {
    key: "customisableGroups",
    value: function customisableGroups() {
      var _this8 = this;
      var groups = document.querySelectorAll('[data-bike-builder-step="2"] .bike-builder-group, [data-bike-builder-step="3"] .bike-builder-group');
      return Array.from(groups).filter(function (group) {
        return group.closest(".bike-builder-content__hidden-fork") === null && group.querySelector("".concat(_this8.selectors.bikeBuilderBlocks, ".default"));
      });
    }

    /**
     * True once any group is on something other than its standard choice.
     */
  }, {
    key: "isBuildModified",
    value: function isBuildModified() {
      var _this9 = this;
      return this.customisableGroups().some(function (group) {
        var active = group.querySelector("".concat(_this9.selectors.bikeBuilderBlocks, ".active"));
        return Boolean(active) && !active.classList.contains("default");
      });
    }
  }, {
    key: "resetToStandardBuild",
    value: function resetToStandardBuild() {
      var _this0 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$keyboard = _ref.keyboard,
        keyboard = _ref$keyboard === void 0 ? false : _ref$keyboard;
      var changed = this.customisableGroups().map(function (group) {
        return {
          active: group.querySelector("".concat(_this0.selectors.bikeBuilderBlocks, ".active")),
          standard: group.querySelector("".concat(_this0.selectors.bikeBuilderBlocks, ".default"))
        };
      }).filter(function (_ref2) {
        var active = _ref2.active,
          standard = _ref2.standard;
        return active && standard && active !== standard;
      });
      if (!changed.length) return;
      this.resetSnapshot = changed.map(function (_ref3) {
        var active = _ref3.active;
        return active;
      });
      this.applyBlocks(changed.map(function (_ref4) {
        var standard = _ref4.standard;
        return standard;
      }));
      this.showResetStatus({
        focusUndo: keyboard
      });
    }
  }, {
    key: "undoResetToStandardBuild",
    value: function undoResetToStandardBuild() {
      if (!this.resetSnapshot || !this.resetSnapshot.length) return;

      // Undo from the keyboard: focus goes back to Reset build, not to the page.
      var fromToast = !!(this.resetToast && this.resetToast.contains(document.activeElement));
      this.applyBlocks(this.resetSnapshot);
      this.hideResetStatus();
      if (fromToast && this.resetBuildBtn && !this.resetBuildBtn.disabled) this.resetBuildBtn.focus();
    }

    /**
     * Selects each given block through the normal change path, so the ledger,
     * savings line, step selections and cart properties all follow rather than
     * being recomputed by hand. The flag stops each of those changes being read as
     * a customer edit, which would discard the undo mid-reset.
     */
  }, {
    key: "applyBlocks",
    value: function applyBlocks(blocks) {
      var _this1 = this;
      this.isRestoringBuild = true;
      blocks.forEach(function (block) {
        _this1.changeBikeBuilderProduct(block);
        _this1.scrollRowToBlock(block);
      });
      this.isRestoringBuild = false;
      this.updateResetState();
    }

    /**
     * Brings a newly-selected block into view within its horizontal row. Setting
     * scrollLeft fires the row's own scroll handler (initScrollBar), which re-runs
     * the arrow, thumb and dimming updates.
     */
  }, {
    key: "scrollRowToBlock",
    value: function scrollRowToBlock(block) {
      var row = block.closest(this.selectors.bikeBuilderRow);
      if (!row) return;

      // Measure the card, not the block: the card only swaps in the block it
      // should show once the class-change observer runs, so at this point the
      // block itself can still be hidden, and a hidden block has no box.
      var target = block.closest(this.selectors.optionCards) || block;

      // Rect-based rather than offsetLeft: the block's offsetParent isn't the row.
      // While the row is hidden every rect is zero, which correctly leaves it be.
      row.scrollLeft += target.getBoundingClientRect().left - row.getBoundingClientRect().left;
    }
  }, {
    key: "updateResetState",
    value: function updateResetState() {
      if (!this.resetBuildBtn) return;
      this.resetBuildBtn.disabled = !this.isBuildModified();
    }

    /**
     * Kenny's reset toast: "Back to the build we'd ride ourselves." with Undo,
     * which lasts as long as the toast (10 seconds, longer while it is hovered or
     * has focus). A keyboard reset moves focus to Undo, since Reset build is
     * disabled once the build is standard again.
     */
  }, {
    key: "showResetStatus",
    value: function showResetStatus() {
      var _this10 = this;
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$focusUndo = _ref5.focusUndo,
        focusUndo = _ref5$focusUndo === void 0 ? false : _ref5$focusUndo;
      if (!this.resetBuildBtn) return;
      this.resetToast = (0,_bike_build_toast__WEBPACK_IMPORTED_MODULE_8__.showToast)(this.resetBuildBtn.dataset.resetDone || "", {
        action: {
          label: this.resetBuildBtn.dataset.undo || "Undo",
          run: function run() {
            return _this10.undoResetToStandardBuild();
          }
        },
        focusAction: focusUndo,
        onHide: function onHide() {
          _this10.resetToast = null;
          _this10.resetSnapshot = null;
        }
      });
    }

    /**
     * Drops the undo, and the reset toast with it if it is still the one showing.
     * Once it is gone there is no way to trigger an undo, and a stale snapshot
     * would restore choices the customer has since changed. Another toast (the
     * basket's) is left alone.
     */
  }, {
    key: "hideResetStatus",
    value: function hideResetStatus() {
      this.resetSnapshot = null;
      if (this.resetToast) (0,_bike_build_toast__WEBPACK_IMPORTED_MODULE_8__.hideToast)(this.resetToast);
      this.resetToast = null;
    }

    /**
     * Mobile build bar (Kenny's "Builder/Mobile build bar", buy column): below
     * $large it is fixed to the foot of the screen from page load, with the
     * total, Your build (which opens the summary as a sheet) and Add to basket.
     */
  }, {
    key: "initMobileBar",
    value: function initMobileBar() {
      var _this11 = this;
      if (!this.mobileBar) return;
      if (this.summary && this.viewBuild) {
        this.summarySheet = new _bike_build_summary_sheet__WEBPACK_IMPORTED_MODULE_11__["default"]({
          sheet: this.summary,
          opener: this.viewBuild,
          overlay: this.sheetOverlay,
          closer: this.summaryClose,
          isSmall: function isSmall() {
            return window.innerWidth < _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large;
          }
        });
      }
      this.updateMobileBarVisibility();
      window.addEventListener("resize", function () {
        return _this11.updateMobileBarVisibility();
      });
      // The delivery lines change after load and on every frame change, so
      // follow the bar's own size as well as the window's.
      if ("ResizeObserver" in window) {
        new ResizeObserver(function () {
          return _this11.updateMobileBarVisibility();
        }).observe(this.mobileBar);
      }
    }
  }, {
    key: "updateMobileBarVisibility",
    value: function updateMobileBarVisibility() {
      if (!this.mobileBar) return;
      var show = window.innerWidth < _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large;
      this.mobileBar.hidden = !show;
      // Reserves room at the foot of the page so the bar can't cover the last row.
      document.body.classList.toggle("bike-builder-mobile-bar-active", show);
      // The foot padding and the chat button's lift follow the bar, which is
      // taller now it carries the delivery lines.
      document.body.style.setProperty("--bb-mobile-bar-height", show ? "".concat(this.mobileBar.offsetHeight, "px") : "0px");
    }

    /**
     * At $large the sticky site header slides away once the page scrolls and
     * comes back at the top (body.bike-builder-immersive in _bike-builder.scss),
     * from page load: customise mode used to switch this on.
     */
  }, {
    key: "initImmersiveHeader",
    value: function initImmersiveHeader() {
      var sync = function sync() {
        return document.body.classList.toggle("bike-builder-immersive", window.innerWidth >= _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large);
      };
      sync();
      window.addEventListener("resize", sync);
    }

    /** The desktop drawer and its toggle on the photo (buy column). */
  }, {
    key: "initDrawer",
    value: function initDrawer() {
      var _this12 = this;
      var drawer = this.querySelector(".js-bb-drawer");
      if (!drawer || !this.drawerToggle) return;
      this.summaryDrawer = new _bike_build_drawer__WEBPACK_IMPORTED_MODULE_12__["default"]({
        drawer: drawer,
        toggle: this.drawerToggle,
        closer: this.querySelector(".js-bb-drawer-close"),
        isLarge: function isLarge() {
          return window.innerWidth >= _globals_breakpoints__WEBPACK_IMPORTED_MODULE_2__["default"].large;
        },
        onChange: function onChange(open) {
          if (_this12.stage) _this12.stage.classList.toggle("bike-builder-stage--drawer-open", open);
          _this12.updateBuildToggles();
        }
      });
    }

    /**
     * "Your build: 4 extras" on the mobile bar and on the photo's toggle, and
     * "Hide your build" on the toggle while the drawer is open.
     */
  }, {
    key: "updateBuildToggles",
    value: function updateBuildToggles() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.extrasCount;
      this.extrasCount = count;
      if (this.viewBuild && this.viewBuildLabel) {
        this.viewBuildLabel.textContent = (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__.extrasLabel)(count, {
          none: this.viewBuild.dataset.none || "",
          one: this.viewBuild.dataset.one || "",
          other: this.viewBuild.dataset.other || ""
        });
      }
      if (this.drawerToggle && this.drawerToggleLabel) {
        var labels = this.drawerToggle.dataset;
        this.drawerToggleLabel.textContent = (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.buildToggleLabel)({
          count: count,
          open: !!(this.summaryDrawer && this.summaryDrawer.isOpen)
        }, {
          none: labels.none || "",
          one: labels.one || "",
          other: labels.other || "",
          hide: labels.hide || ""
        });
      }
    }

    /**
     * Fetches the Step 3 (accessories) fragment from its own page render so the
     * accessory all_products lookups get a fresh 20-unique-handle budget.
     * Retries once on failure, then surfaces an error and leaves purchase disabled.
     */
  }, {
    key: "fetchAccessories",
    value: function fetchAccessories() {
      var _this13 = this;
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      if (!this.step3Slot) {
        // No slot (e.g. a variant of the template without accessories): don't block purchase.
        this.step3Loaded = true;
        this.step3Ready = true;
        this.resolveStep3Ready();
        this.updateActionButtonState();
        return;
      }
      var url = this.step3Slot.dataset.accessoriesUrl;
      fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("HTTP ".concat(response.status));
        return response.text();
      }).then(function (html) {
        return _this13.injectAccessories(html);
      })["catch"](function () {
        if (attempt < 2) {
          _this13.fetchAccessories(attempt + 1);
        } else {
          _this13.showAccessoriesError();
        }
      });
    }

    /**
     * Injects the fetched Step 3 markup, rebuilds the step references that were
     * cached at construct time (Step 3 didn't exist then), binds events for the
     * new blocks, applies the accessory defaults, and re-enables purchase.
     */
  }, {
    key: "injectAccessories",
    value: function injectAccessories(html) {
      var loading = this.step3Slot.querySelector(this.selectors.step3Loading);
      if (loading) loading.remove();
      this.step3Slot.insertAdjacentHTML("beforeend", html);

      // Rebuild step references — the constructor cached these before Step 3 existed.
      this.steps = document.querySelectorAll(this.selectors.steps);
      this.stepsContents = document.querySelectorAll(this.selectors.stepsContents);
      this.stepsSelections = document.querySelectorAll(this.selectors.stepsSelections);
      this.edits = document.querySelectorAll(this.selectors.edits);
      this.step[3] = {
        step: this.steps[2],
        state: this.stepsStates ? this.stepsStates[2] : null,
        content: this.stepsContents[2],
        selection: this.stepsSelections[2]
      };

      // Re-query the group/block collections so they include Step 3.
      this.bikeBuilderGroups = document.querySelectorAll(this.selectors.bikeBuilderGroups);
      this.bikeBuilderBlocks = document.querySelectorAll(this.selectors.bikeBuilderBlocks);

      // The fetched markup has never been through initSliders, so give it the
      // same one-card-per-product pass before anything binds to it.
      this.dedupeOptionCards(this.step3Slot);
      this.syncOptionCards(this.step3Slot);

      // Bind click handlers and triggers for the newly injected blocks only.
      this.bindBlockEvents(this.step3Slot);
      this.bindOptionCards(this.step3Slot);
      this.bindStepTriggers(this.step3Slot);

      // Initialise sliders/scrollbars now the Step 3 groups are in the DOM.
      this.initScrollBar();
      this.hideEmptyStepItems();
      this.step3Loaded = true;
      this.maybeApplyStep3Defaults();
      this.step3Ready = true;
      this.resolveStep3Ready();
      this.updateActionButtonState();
      this.hideEmptySections();
      this.updateUnlock();
      // Round 2's rule, kept: a build that already has an accessory opens them.
      if (!this.isSectionsLocked() && this.changedCount(3) > 0) this.setSectionOpen("accessories", true);
      this.renderSummary();
    }

    /**
     * The two expanding sections (buy column): Customise your bike and Select
     * Accessories. Locked until an available size and colour are chosen, closed
     * on landing, each opened and closed on its own. Bound once on load; the
     * accessories arrive later inside their panel.
     */
  }, {
    key: "initSections",
    value: function initSections() {
      var _this14 = this;
      this.sections = {};
      this.querySelectorAll(".js-bb-section").forEach(function (el) {
        var name = el.dataset.bbSection;
        var toggle = el.querySelector(".js-bb-section-toggle");
        var panel = toggle ? document.getElementById(toggle.getAttribute("aria-controls")) : null;
        if (!name || !toggle || !panel) return;
        _this14.sections[name] = {
          el: el,
          toggle: toggle,
          panel: panel
        };
        toggle.addEventListener("click", function () {
          if (_this14.isSectionsLocked()) {
            _this14.promptSectionsLocked();
            return;
          }
          _this14.setSectionOpen(name, toggle.getAttribute("aria-expanded") !== "true");
        });
      });
      this.updateSectionsLock();
      this.hideEmptySections();
    }
  }, {
    key: "isSectionsLocked",
    value: function isSectionsLocked() {
      return (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.sectionsLocked)({
        chosen: this.hasSelectedAllStep1Options(),
        available: this.isSelectedFrameVariantAvailable()
      });
    }

    /** A click on a locked section gets the prompt Add to basket would give. */
  }, {
    key: "promptSectionsLocked",
    value: function promptSectionsLocked() {
      if (!this.hasSelectedAllStep1Options()) this.promptSelectOptions();else this.promptUnavailableVariant();
    }

    /** Greys and locks both sections (closing them) until the frame can be bought. */
  }, {
    key: "updateSectionsLock",
    value: function updateSectionsLock() {
      var _this15 = this;
      if (!this.sections) return;
      var locked = this.isSectionsLocked();
      Object.keys(this.sections).forEach(function (name) {
        var _this15$sections$name = _this15.sections[name],
          el = _this15$sections$name.el,
          toggle = _this15$sections$name.toggle;
        el.classList.toggle("bike-builder-section--locked", locked);
        toggle.setAttribute("aria-disabled", locked ? "true" : "false");
        if (locked) _this15.setSectionOpen(name, false);
      });
    }
  }, {
    key: "setSectionOpen",
    value: function setSectionOpen(name, open) {
      var section = this.sections && this.sections[name];
      if (!section) return;
      section.toggle.setAttribute("aria-expanded", open ? "true" : "false");
      section.panel.hidden = !open;
      section.el.classList.toggle("bike-builder-section--open", open);
      // Rows measure nothing while hidden, so re-measure on opening.
      if (open) this.initScrollBar();
      this.updateSectionCounts();
    }

    /** Opens the section that holds a group's row (Step 2 Customise, Step 3 Accessories). */
  }, {
    key: "openSectionFor",
    value: function openSectionFor(name) {
      if (this.isSectionsLocked()) return;
      var group = this.editableGroups().find(function (entry) {
        return entry.name === name;
      });
      if (!group) return;
      if (group.el.closest('[data-bike-builder-step="2"]')) this.setSectionOpen("customise", true);
      if (group.el.closest('[data-bike-builder-step="3"]')) this.setSectionOpen("accessories", true);
    }

    /** Step 2 or Step 3 groups whose chosen part is not the standard one. */
  }, {
    key: "changedCount",
    value: function changedCount(step) {
      var _this16 = this;
      return this.editableGroups().filter(function (_ref6) {
        var el = _ref6.el;
        if (!el.closest("[data-bike-builder-step=\"".concat(step, "\"]"))) return false;
        var active = el.querySelector("".concat(_this16.selectors.bikeBuilderBlocks, ".active"));
        return !!active && !active.classList.contains("default");
      }).length;
    }

    /** "2 changed" and "2 added" on the closed headings. */
  }, {
    key: "updateSectionCounts",
    value: function updateSectionCounts() {
      var _this17 = this;
      if (!this.sections) return;
      [["customise", 2], ["accessories", 3]].forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          name = _ref8[0],
          step = _ref8[1];
        var section = _this17.sections[name];
        var count = section ? section.el.querySelector(".js-bb-section-count") : null;
        if (!count) return;
        count.textContent = (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.closedCount)({
          count: _this17.changedCount(step),
          open: section.toggle.getAttribute("aria-expanded") === "true",
          template: section.toggle.dataset.count
        });
        count.hidden = !count.textContent;
      });
    }

    /** A section with nothing in it (a frameset with nothing to customise) is not shown. */
  }, {
    key: "hideEmptySections",
    value: function hideEmptySections() {
      var _this18 = this;
      if (!this.sections) return;
      [["customise", 2], ["accessories", 3]].forEach(function (_ref9) {
        var _ref0 = _slicedToArray(_ref9, 2),
          name = _ref0[0],
          step = _ref0[1];
        var section = _this18.sections[name];
        if (!section || step === 3 && !_this18.step3Loaded) return;
        section.el.hidden = !section.el.querySelector("[data-bike-builder-step=\"".concat(step, "\"] .bike-builder-group .bike-builder-block"));
      });
    }

    /**
     * Binds the product-choice click handler to bike-builder blocks within a scope.
     */
  }, {
    key: "bindBlockEvents",
    value: function bindBlockEvents(scope) {
      var _this19 = this;
      var blocks = scope.querySelectorAll(this.selectors.bikeBuilderBlocks);
      blocks.forEach(function (el) {
        el.addEventListener("click", function () {
          if (!_this19.isSelectingDefaults) {
            _this19.changeBikeBuilderProduct(el);
          }
        });
      });
    }

    /**
     * Binds info/availability modal triggers within a scope.
     */
  }, {
    key: "bindStepTriggers",
    value: function bindStepTriggers(scope) {
      var _this20 = this;
      scope.querySelectorAll(this.selectors.infoTriggers).forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var _this20$infoModalCont, _this20$infoModalCont2, _this20$infoModalCont3;
          var img = (_this20$infoModalCont = _this20.infoModalContent) === null || _this20$infoModalCont === void 0 ? void 0 : _this20$infoModalCont.querySelector(".js-bike-builder-product-info-modal__image");
          var title = (_this20$infoModalCont2 = _this20.infoModalContent) === null || _this20$infoModalCont2 === void 0 ? void 0 : _this20$infoModalCont2.querySelector(".js-bike-builder-product-info-modal__title");
          var text = (_this20$infoModalCont3 = _this20.infoModalContent) === null || _this20$infoModalCont3 === void 0 ? void 0 : _this20$infoModalCont3.querySelector(".js-bike-builder-product-info-modal__text");
          if (img) img.src = "";
          if (_this20.infoModal) {
            _this20.infoModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
          if (!trigger.hasAttribute("data-product-info-featured-image")) return;
          if (img) img.src = trigger.dataset.productInfoFeaturedImage;
          if (title) title.innerHTML = trigger.dataset.productInfoTitle.replace("[OEM]", "").replace("[BB]", "");
          if (text) text.innerHTML = trigger.dataset.productInfoText;
        });
      });
    }

    /**
     * Applies the Step 3 defaults to items[0] once both Step 1 is complete and the
     * accessory fragment has loaded (either order — whichever happens last triggers it).
     */
  }, {
    key: "maybeApplyStep3Defaults",
    value: function maybeApplyStep3Defaults() {
      if (this.step1Complete && this.step3Loaded) {
        this.selectDefaultsForStep(3);
      }
    }

    /**
     * Leaves purchase disabled and tells the customer to refresh. We never submit
     * an incomplete bundle (missing accessory defaults).
     */
  }, {
    key: "showAccessoriesError",
    value: function showAccessoriesError() {
      if (this.step3Slot) {
        this.step3Slot.innerHTML = '<p class="bike-builder-content__step3-error">Couldn’t load build options — please refresh the page.</p>';
      }
      this.accessoriesFailed = true;
      this.updateActionButtonState();
    }
  }, {
    key: "getHiddenHeight",
    value: function getHiddenHeight(el) {
      if (!(el !== null && el !== void 0 && el.cloneNode)) {
        return null;
      }
      var clone = el.cloneNode(true);
      Object.assign(clone.style, {
        overflow: "visible",
        height: "auto",
        maxHeight: "none",
        opacity: "0",
        visibility: "hidden",
        display: "block"
      });
      var inputs = clone.querySelectorAll("input");
      inputs.forEach(function (input) {
        input.name = "null";
        input.id = "null";
      });
      el.after(clone);
      var height = clone.offsetHeight + 10;
      clone.remove();
      return height;
    }
  }, {
    key: "initialiseStep1",
    value: function initialiseStep1() {
      var content = this.step[1].content;
      if (content) {
        content.style.maxHeight = "".concat(this.getHiddenHeight(content), "px");
      }
      for (var i = 0; i < this.frameOptions.length; i++) {
        var input = this.frameOptions[i];
        var optionPosition = input.dataset.productOption;
        if (optionPosition === "1") continue;
        if (input.hasAttribute("data-product-option-colour")) {
          var colour = input.value;
          var colourIsAvailable = false;
          for (var _i = 0; _i < this.product.variants.length; _i++) {
            var variant = this.product.variants[_i];
            if (variant["option".concat(optionPosition)] === colour) {
              if (variant.available) {
                colourIsAvailable = true;
              }
            }
          }
          if (!colourIsAvailable) {
            var item = input.closest("li");
            item.style.display = "none";
          }
        }
      }
    }
  }, {
    key: "updateVariantAvailability",
    value: function updateVariantAvailability(chosenSwatch) {
      var chosenPosition = chosenSwatch.dataset.productOption;
      var relevantVariants = [];
      for (var i = 0; i < this.product.variants.length; i++) {
        var variant = this.product.variants[i];
        var variantMatchedOptions = variant["option".concat(chosenPosition)];
        if (variantMatchedOptions == chosenSwatch.value) {
          relevantVariants.push(variant);
        }
      }
      for (var _i2 = 0; _i2 < relevantVariants.length; _i2++) {
        var _variant = relevantVariants[_i2];
        for (var _i3 = 1; _i3 < 4; _i3++) {
          var optionName = _variant["option".concat(_i3)];
          if (optionName === null || optionName == chosenSwatch.value) continue;
          var optionPosition = _i3;
          var handleizedName = optionName.toLowerCase().replace(/ /g, "-");
          var input = document.querySelector("#Option-".concat(handleizedName, "-").concat(optionPosition));
          if (input !== null) {
            var swatch = input.parentElement;
            if (_variant.available) {
              swatch.classList.remove("is-sold-out");
            } else {
              swatch.classList.add("is-sold-out");
            }
          }
        }
      }
    }

    // The selected frame colour, e.g. "Ruby" (the option named colour/color, else
    // option2 by convention in these builds).
  }, {
    key: "frameColour",
    value: function frameColour(variant) {
      if (!variant) return null;
      var optionNames = this.product.options || [];
      var colourIndex = optionNames.findIndex(function (n) {
        return /colou?r/i.test(n);
      });
      if (colourIndex < 0) colourIndex = 1;
      return variant["option".concat(colourIndex + 1)] || null;
    }

    // Tokens to look for in an image filename/alt: the slug ("jet-black") plus the
    // individual words ("jet", "black"), so "Jet Black" still matches "...-black-".
  }, {
    key: "colourTokens",
    value: function colourTokens(colour) {
      var handle = colour.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
      var words = colour.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) {
        return w.length > 2;
      });
      return [handle].concat(_toConsumableArray(words));
    }

    // Pick the image for a colour: prefer a filename match (e.g. ...-ruby-...jpg),
    // then fall back to a whole-word match in the image's alt text (some builds
    // don't put the colour in the filename). candidates: [{ src, alt, ... }].
  }, {
    key: "matchColourImage",
    value: function matchColourImage(candidates, colour) {
      if (!colour) return null;
      var tokens = this.colourTokens(colour);
      var byName = candidates.find(function (c) {
        var name = (c.src || "").toLowerCase();
        return tokens.some(function (t) {
          return name.includes("-".concat(t, "-")) || name.includes("-".concat(t, "."));
        });
      });
      if (byName) return byName;
      return candidates.find(function (c) {
        var alt = (c.alt || "").toLowerCase();
        return tokens.some(function (t) {
          return new RegExp("(?:^|[^a-z0-9])".concat(t, "(?:[^a-z0-9]|$)")).test(alt);
        });
      }) || null;
    }

    // Mirror the colour match into the default (non-customise) gallery by moving
    // the product-media carousel to the matching slide.
  }, {
    key: "updateGalleryImage",
    value: function updateGalleryImage(variant) {
      if (!this.builderGallery || !variant || typeof $ === "undefined") return;
      var carousel = this.builderGallery.querySelector("[data-product-media-carousel]");
      if (!carousel || !$(carousel).hasClass("slick-initialized")) return;
      var candidates = _toConsumableArray(this.builderGallery.querySelectorAll(".product-media__media")).map(function (m) {
        var img = m.querySelector("img");
        var src = img ? [img.currentSrc, img.getAttribute("src"), img.getAttribute("srcset"), img.getAttribute("data-src")].filter(Boolean).join(" ") : "";
        return {
          src: src,
          alt: img ? img.alt || "" : "",
          index: parseInt(m.dataset.productLightboxTrigger, 10)
        };
      }).filter(function (c) {
        return !isNaN(c.index);
      });
      var match = this.matchColourImage(candidates, this.frameColour(variant));
      if (match) $(carousel).slick("slickGoTo", match.index);
    }

    /**
     * The chosen value of the frame's Size option, or "" when the frame has no
     * size option or none is chosen yet.
     */
  }, {
    key: "selectedFrameSize",
    value: function selectedFrameSize() {
      var options = this.product && this.product.options || [];
      var position = options.findIndex(function (name) {
        return /size/i.test(name);
      }) + 1;
      if (!position) return "";
      var checked = this.querySelector("[data-bike-builder-step=\"1\"] input[data-product-option=\"".concat(position, "\"]:checked"));
      return checked ? checked.value : "";
    }

    /**
     * Every delivery block's date row (the summary's and the closed page's): the
     * frame's dispatch date when it has one, otherwise the bike's availability
     * note. A block left with no row to show hides, so there is never an empty
     * box. Display only: the order's dispatch values come from product-preorder.js.
     */
  }, {
    key: "syncDeliveryDate",
    value: function syncDeliveryDate() {
      var _this21 = this;
      if (!this.deliveryDates.length) return;
      var dispatch = this.preorderDispatch;
      var active = dispatch && !dispatch.classList.contains("is-hidden");
      var dateEl = active ? dispatch.querySelector("[data-preorder-earliest-date]") : null;
      this.deliveryDates.forEach(function (row) {
        var text = (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__.deliveryDateText)({
          dispatchDate: dateEl ? dateEl.textContent : "",
          note: row.dataset.note,
          template: row.dataset.template || "[date]"
        });
        var textEl = row.querySelector(".js-bb-delivery-date-text");
        if (textEl) textEl.textContent = text;
        row.hidden = !text;
        var block = row.closest(_this21.selectors.deliveryBlock);
        if (block) block.hidden = !block.querySelector(".bike-builder-delivery__row:not([hidden])");
      });
    }

    /**
     * The Step 2 heading (Kenny's progression, 22 Oct 2026): a closed padlock
     * and "Customise and unlock savings" until an available size and colour are
     * chosen, then an open one, "Make it your own" and the Step 2 option that
     * saves most against buying it separately. Step 2 is rendered with the page,
     * so the saving is worked out once. Hidden with both sections (a frameset
     * with nothing to customise or add).
     */
  }, {
    key: "updateUnlock",
    value: function updateUnlock() {
      var _this22 = this;
      var box = this.querySelector(this.selectors.unlock);
      if (!box) return;
      if (this.unlockSaving === undefined) {
        var options = [];
        this.querySelectorAll('[data-bike-builder-step="2"] .bike-builder-group').forEach(function (group) {
          group.querySelectorAll(_this22.selectors.bikeBuilderBlocks).forEach(function (block) {
            options.push({
              group: group.dataset.attrGroup,
              price: parseInt(block.dataset.attrPrice, 10),
              compareAt: parseInt(block.getAttribute("data-attr-compare-at-price"), 10),
              isDefault: block.classList.contains("default")
            });
          });
        });
        this.unlockSaving = (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__.largestUpgradeSaving)(options);
      }
      var locked = this.isSectionsLocked();
      var best = this.unlockSaving;
      var _unlockCopy = (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.unlockCopy)({
          locked: locked,
          group: best ? best.group : "",
          amount: best ? this.formatCents(best.saving) : ""
        }, {
          titleLocked: box.dataset.titleLocked,
          bodyLocked: box.dataset.bodyLocked,
          title: box.dataset.title,
          body: box.dataset.body,
          example: box.dataset.example
        }),
        title = _unlockCopy.title,
        body = _unlockCopy.body;
      var titleEl = box.querySelector(".js-bb-unlock-title");
      var bodyEl = box.querySelector(".js-bb-unlock-body");
      if (titleEl && titleEl.textContent !== title) titleEl.textContent = title;
      if (bodyEl && bodyEl.textContent !== body) bodyEl.textContent = body;
      box.classList.toggle("bike-builder-unlock--locked", locked);
      var sections = this.sections ? Object.values(this.sections) : [];
      box.hidden = sections.length > 0 && sections.every(function (_ref1) {
        var el = _ref1.el;
        return el.hidden;
      });
    }

    /** "Size: Medium" in the summary header, or nothing without a size option. */
  }, {
    key: "updateSummarySize",
    value: function updateSummarySize() {
      if (!this.summarySize || !this.summary) return;
      this.summarySize.textContent = (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__.sizeLabel)(this.selectedFrameSize(), this.summary.dataset.sizeTemplate || "");
    }

    /** "Colour: Raw Titanium" beside the size in the summary, or nothing before a colour is chosen. */
  }, {
    key: "updateSummaryColour",
    value: function updateSummaryColour() {
      if (!this.summaryColour || !this.summary) return;
      this.summaryColour.textContent = (0,_bike_buy_column_mjs__WEBPACK_IMPORTED_MODULE_13__.optionLabel)(this.frameColour(this.resolveFrameVariant()), this.summary.dataset.colourTemplate || "", "[colour]");
    }
  }, {
    key: "changeFrameOption",
    value: function changeFrameOption(el) {
      var step = el.closest("[data-bike-builder-step]");
      if (!step) return;
      var option1 = step.querySelector('input[data-product-option="1"]:checked');
      var option2 = step.querySelector('input[data-product-option="2"]:checked');
      var option3 = step.querySelector('input[data-product-option="3"]:checked');

      // Update Step Selection Area
      if (option1 && this.step[1].selection) {
        var sel1 = this.step[1].selection.querySelector('[data-attr-option-position="1"] .js-bike-builder-step-selection-choice');
        if (sel1) sel1.textContent = option1.value;
      }
      if (option2 && this.step[1].selection) {
        var sel2 = this.step[1].selection.querySelector('[data-attr-option-position="2"] .js-bike-builder-step-selection-choice');
        if (sel2) sel2.textContent = option2.value;
      }
      if (option3 && this.step[1].selection) {
        var sel3 = this.step[1].selection.querySelector('[data-attr-option-position="3"] .js-bike-builder-step-selection-choice');
        if (sel3) sel3.textContent = option3.value;
      }
      var variant = this.resolveFrameVariant();
      if (variant) {
        this.writeFrameBundle(variant);
        this.updatePreorderStatus(variant);
        // updatePreorderStatus fires the change event product-preorder.js listens
        // to, so the Step 1 dispatch is up to date here. Reconcile the standard
        // availability note first (it may hide the dispatch when nothing is
        // selected), then mirror the dispatch into the sticky summary.
        this.syncAvailabilityNote();
        this.syncDeliveryDate();
        this.updateSummarySize();
        this.updateSummaryColour();

        // Match the gallery to the selected colour.
        this.updateGalleryImage(variant);
      }
      var stepIndex = step.dataset.bikeBuilderStep;
      var content = this.step[stepIndex].content;
      if (content) {
        content.style.maxHeight = "6000px";
      }
      this.updateEditState();

      // Check if step 1 is now complete
      this.checkStep1Completion();
    }
  }, {
    key: "updatePreorderStatus",
    value: function updatePreorderStatus(variant) {
      if (this.preorderVariant) {
        this.preorderVariant.value = variant.id;
        this.preorderVariant.setAttribute("data-selected-variant", JSON.stringify(variant));
        var event = new Event("change");
        this.preorderVariant.dispatchEvent(event);
      }
    }

    // Keep exactly one availability message visible:
    //  - before a variant is chosen (initial load): show the general "Built to
    //    Order…" note, and suppress the dispatch's default (first-available)
    //    message so it doesn't pre-empt a real selection.
    //  - once a preorder variant is chosen: product-preorder.js reveals the Step 1
    //    dispatch ("Deliveries from …"), so hide the general note.
    //  - once a non-preorder variant is chosen: keep the general note.
  }, {
    key: "syncAvailabilityNote",
    value: function syncAvailabilityNote() {
      var dispatch = document.querySelector(".js-preorder-dispatch");
      var notes = document.querySelectorAll(".bike-builder-content__emboldened-text-note");
      var selected = document.querySelector('[data-bike-builder-step="1"] input[data-product-option]:checked');

      // No selection yet: the general note is the initial-load message.
      if (!selected) {
        if (dispatch) dispatch.classList.add("is-hidden");
        notes.forEach(function (note) {
          note.hidden = false;
        });
        return;
      }
      var preorderActive = !!dispatch && !dispatch.classList.contains("is-hidden");
      notes.forEach(function (note) {
        note.hidden = preorderActive;
      });
    }

    // Live monthly-finance figure for the PayItMonthly line.
    // PLACEHOLDER MATHS: the representative-example formula below is a stand-in
    // so the line updates live in dev. Replace it with PayItMonthly's approved
    // calculation before enabling the line in production. Reads APR / term /
    // deposit from the finance element's data- attributes (section settings).
  }, {
    key: "updateFinance",
    value: function updateFinance(totalCents) {
      var _this23 = this;
      if (!this.financeBlocks || !this.financeBlocks.length) return;
      var formatted = null;
      this.financeBlocks.forEach(function (block) {
        var amountEl = block.querySelector(_this23.selectors.financeMonthly);
        if (!amountEl) return;

        // Shared with the collection cards' Liquid, see bike-builder-finance.mjs.
        var monthlyRounded = (0,_bike_builder_finance_mjs__WEBPACK_IMPORTED_MODULE_4__.monthlyPaymentCents)(totalCents, {
          apr: parseFloat(block.dataset.financeApr),
          term: parseInt(block.dataset.financeTerm, 10),
          depositPct: parseFloat(block.dataset.financeDeposit)
        });

        // Without a valid term / APR we cannot show a figure — hide the line.
        if (monthlyRounded === null) {
          block.hidden = true;
          return;
        }
        formatted = Shopify.formatMoney(monthlyRounded, "".concat(_this23.currencySymbol, "{{ amount_no_decimals }}"));
        amountEl.textContent = formatted;
        block.hidden = false;
      });

      // The info modal's monthly figure lives outside the finance blocks, so give
      // any monthly figures not inside a block (the modal's) the same value.
      if (formatted) {
        this.financeMonthlyEls.forEach(function (el) {
          if (!el.closest(_this23.selectors.finance)) el.textContent = formatted;
        });
      }
    }

    // The info modals (mirroring the Klarna/PayPal pattern): finance "Learn
    // more" opens the PayItMonthly one and Cycle to Work's Learn more its own.
    // Each closes via its close buttons, the overlay, or Escape. `name` is the
    // modal's key in this.selectors, with "Open" and "Close" for its triggers.
  }, {
    key: "bindInfoModal",
    value: function bindInfoModal(name) {
      var _this24 = this;
      var modal = document.querySelector(this.selectors[name]);
      if (!modal) return;
      document.querySelectorAll(this.selectors["".concat(name, "Open")]).forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          _this24.openInfoModal(modal, btn);
        });
      });
      document.querySelectorAll(this.selectors["".concat(name, "Close")]).forEach(function (btn) {
        btn.addEventListener("click", function () {
          return _this24.closeInfoModal(modal);
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) _this24.closeInfoModal(modal);
      });
    }
  }, {
    key: "openInfoModal",
    value: function openInfoModal(modal, opener) {
      // As for the availability modal: never open underneath the summary sheet.
      if (this.summarySheet) this.summarySheet.close({
        restoreFocus: false
      });
      this.infoModalOpener = opener;
      modal.hidden = false;
      document.body.classList.add("bb-finance-modal-open");
      var panel = modal.querySelector('[role="dialog"]');
      if (!panel) return;
      panel.scrollTop = 0;
      if (panel.hasAttribute("tabindex")) panel.focus();
    }
  }, {
    key: "closeInfoModal",
    value: function closeInfoModal(modal) {
      modal.hidden = true;
      document.body.classList.remove("bb-finance-modal-open");
      // Back to the link that opened it, unless that sat in the sheet, now closed.
      var opener = this.infoModalOpener;
      this.infoModalOpener = null;
      if (opener && opener.offsetParent && getComputedStyle(opener).visibility !== "hidden") opener.focus();
    }

    /** The calculator re-runs when the shopper picks a band. */
  }, {
    key: "bindC2wCalculator",
    value: function bindC2wCalculator() {
      var _this25 = this;
      if (!this.c2wCalc) return;
      this.c2wCalc.addEventListener("change", function () {
        return _this25.updateC2wCalculator();
      });
    }

    /**
     * Cycle to Work calculator (Builder refinements package 2): the build total
     * times the chosen band's rate, from c2wFigures. renderSummary passes every
     * new total (on load and on every pick), so the figures are already current
     * whenever the modal opens; a band change re-runs it with the last total.
     */
  }, {
    key: "updateC2wCalculator",
    value: function updateC2wCalculator(totalCents) {
      if (!this.c2wCalc) return;
      if (Number.isFinite(totalCents)) this.c2wTotalCents = totalCents;
      var band = this.c2wCalc.querySelector('input[name="bb-c2w-band"]:checked');
      var _c2wFigures = (0,_bike_build_c2w_mjs__WEBPACK_IMPORTED_MODULE_10__.c2wFigures)(this.c2wTotalCents, band ? parseFloat(band.dataset.rate) : 0),
        savingCents = _c2wFigures.savingCents,
        costCents = _c2wFigures.costCents,
        monthlyCents = _c2wFigures.monthlyCents;
      if (this.c2wCost) this.c2wCost.textContent = this.formatCents(costCents);
      if (this.c2wDetail) {
        this.c2wDetail.textContent = (this.c2wDetail.dataset.template || "").replace("[saving]", this.formatCents(savingCents)).replace("[monthly]", this.formatCents(monthlyCents));
      }
    }
  }, {
    key: "changeBikeBuilderProduct",
    value: function changeBikeBuilderProduct(el) {
      var productRow = el.closest("[data-product-option-list]");
      var productProperties = productRow.querySelector(".product-properties");
      var productBlocks = productRow.querySelectorAll(this.selectors.bikeBuilderBlocks);
      productBlocks.forEach(function (block) {
        block.classList.toggle("active", block === el);
      });
      var productId = el.dataset.attrId;
      var productTitle = el.dataset.attrTitle;
      var productPrice = el.getAttribute("data-attr-price");
      // Step 1 frame option blocks (size/colour) live outside any component group,
      // so closest() is null — they're handled by changeFrameOption, nothing to
      // bundle here. Components and the hidden fork DO have a group. (Previously
      // this threw "null (reading 'dataset')" on every frame-option click.)
      var productGroupEl = el.closest(".bike-builder-group");
      if (!productGroupEl) return;
      var productGroup = productGroupEl.dataset.attrGroup;
      // The hidden fork is rendered outside the numbered steps, so closest() can be
      // null here — guard it instead of throwing (the throw left the colour visually
      // selected but never updated the form, so the default fork stayed bundled).
      var stepEl = el.closest(".js-bike-builder-step");
      var associatedStep = stepEl ? parseInt(stepEl.dataset.bikeBuilderStep) : null;
      // The hidden fork is colour-matched to the frame and must stay bundled on
      // items[0] (replacing the default), not become a separate line item.
      var isHiddenFork = el.closest(".bike-builder-content__hidden-fork") !== null;
      var isDefault = el.classList.contains("default") || isHiddenFork;
      var rowIndex = isDefault ? 0 : el.closest(".bike-builder-content__step-item").dataset.rowIndex;
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");

      // Add Selections
      if (this.step[associatedStep] && this.step[associatedStep].selection) {
        var currentSelectionPrexists = this.step[associatedStep].selection.querySelector("[data-selection-attr-group=\"".concat(productGroup, "\"]"));
        if (currentSelectionPrexists) {
          currentSelectionPrexists.innerHTML = "\n          <p class=\"bike-builder-content__step-selection-group\">\n            ".concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n          </p>\n        ");
        } else {
          this.step[associatedStep].selection.insertAdjacentHTML("beforeend", "\n            <li\n              class=\"bike-builder-content__step-selection-item\"\n              data-selection-attr-group=\"".concat(productGroup, "\"\n            >\n              <p class=\"bike-builder-content__step-selection-group\">\n                ").concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n              </p>\n            </li>\n          "));
        }
      }
      this.renderSummary();

      // A change the customer made themselves retires any pending undo (the
      // snapshot would restore a build they've since moved on from) and
      // re-evaluates whether there is anything left to reset.
      if (!this.isRestoringBuild && !this.isSelectingDefaults) {
        this.hideResetStatus();
        this.updateResetState();
      }

      // Generate properties HTML
      var inputs = [];
      var defaultInputs = this.defaultComponentInputs(productGroup, productId, productTitle);
      var extraInputs = ["<input type=\"hidden\" name=\"items[".concat(rowIndex, "]id\" value=\"").concat(productId, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_parentLineItem]\" value=\"").concat(productGroup, "___").concat(primaryParentLineItem.value, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_bikeComponent]\" value=\"true\" />")];
      if (isDefault) {
        inputs.push.apply(inputs, _toConsumableArray(defaultInputs));
      } else {
        inputs.push.apply(inputs, extraInputs);
        this.productCount = document.querySelector(this.selectors.productCount);
        var newProductCountValue = 0;
        this.bikeBuilderGroups.forEach(function (group) {
          var activeChoice = group.querySelector(".active");
          if (activeChoice) ++newProductCountValue;
        });
        if (this.productCount) {
          this.productCount.value = newProductCountValue;
        }
      }

      // Special handling for Wheelsets
      var isWheelset = productGroup === "Wheels";
      if (isWheelset) {
        var wheelbaseSkus = el.getAttribute("data-wheelbase-skus");
        if (wheelbaseSkus) {
          var wheelSplit = wheelbaseSkus.split(", ");
          var _wheelSplit2 = _slicedToArray(wheelSplit, 2),
            frontSku = _wheelSplit2[0],
            backSku = _wheelSplit2[1];
          var baseWheelInputs = ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
          inputs.length = 0;
          if (isDefault) {
            inputs.push.apply(inputs, baseWheelInputs);
          }
          if (!isDefault) {
            var wheelExtras = [].concat(extraInputs, ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />")]);
            inputs.push.apply(inputs, _toConsumableArray(wheelExtras));
          }
        }
      }
      if (productProperties) {
        productProperties.innerHTML = inputs.join("\n");
      }
      this.updateEditState();
    }

    /**
     * Edit from basket: when the page opens with ?edit=<parent id>, rebuild that
     * build from the basket. Step 1 comes from the frame bundle key on the bike
     * line; each upgrade goes through changeBikeBuilderProduct, the path a click
     * takes. See docs/superpowers/specs/2026-09-30-bike-builder-edit-from-basket-design.md
     */
  }, {
    key: "restoreFromBasket",
    value: (function () {
      var _restoreFromBasket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this26 = this;
        var params, parentId, cart, response, _buildLines, parent, components, query, upgrades, frameId, frameVariant, restored, missing, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              params = new URLSearchParams(window.location.search);
              parentId = params.get("edit");
              if (parentId) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return fetch("".concat(window.Shopify.routes.root, "cart.js"), {
                credentials: "same-origin"
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _context.n = 4;
              return response.json();
            case 4:
              cart = _context.v;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              return _context.a(2);
            case 6:
              _buildLines = (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__.buildLines)(cart.items || [], parentId), parent = _buildLines.parent, components = _buildLines.components;
              if (parent) {
                _context.n = 7;
                break;
              }
              params["delete"]("edit");
              query = params.toString();
              window.history.replaceState(null, "", "".concat(window.location.pathname).concat(query ? "?".concat(query) : "").concat(window.location.hash));
              this.showEditNotice(this.editStrings.notFound);
              return _context.a(2);
            case 7:
              _context.n = 8;
              return this.step3ReadyPromise;
            case 8:
              this.editParentId = String(parentId);
              this.updateActionButtonState();
              upgrades = (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__.upgradeSelections)(components);
              frameId = (0,_bike_build_lines_mjs__WEBPACK_IMPORTED_MODULE_5__.frameVariantId)(parent, this.product.variants.map(function (variant) {
                return variant.id;
              }));
              frameVariant = frameId ? this.product.variants.find(function (variant) {
                return String(variant.id) === frameId;
              }) : null;
              if (!(!frameVariant || !this.selectFrameVariant(frameVariant))) {
                _context.n = 9;
                break;
              }
              this.promptUnavailableVariant();
              this.showUnrestored(upgrades.map(function (upgrade) {
                return upgrade.title;
              }));
              return _context.a(2);
            case 9:
              // upgradeSelections maps component lines one for one, so each upgrade
              // keeps its basket line: its price as charged, and its photo should it
              // turn out to be no longer offered.
              restored = [];
              missing = [];
              upgrades.forEach(function (upgrade, index) {
                var entry = _objectSpread(_objectSpread({}, upgrade), {}, {
                  line: components[index]
                });
                var block = _this26.findUpgradeBlock(upgrade);
                if (block) {
                  _this26.changeBikeBuilderProduct(block);
                  restored.push(entry);
                } else {
                  missing.push(entry);
                }
              });

              // Open the sections the edit touches, removed parts included, so "Pick
              // another below" points at a row the customer can see.
              [].concat(restored, missing).forEach(function (_ref10) {
                var group = _ref10.group;
                return _this26.openSectionFor(group);
              });
              this.startEditMode({
                parent: parent,
                components: components,
                restored: restored,
                missing: missing,
                frameVariant: frameVariant
              });
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[1, 5]]);
      }));
      function restoreFromBasket() {
        return _restoreFromBasket.apply(this, arguments);
      }
      return restoreFromBasket;
    }()
    /**
     * Edit mode, once the build is back: record the basket's choice in every
     * group to compare against, then show the banner, the removed parts and the
     * edit summary (Kenny's V3 design).
     */
    )
  }, {
    key: "startEditMode",
    value: function startEditMode(_ref11) {
      var _this27 = this;
      var parent = _ref11.parent,
        components = _ref11.components,
        restored = _ref11.restored,
        missing = _ref11.missing,
        frameVariant = _ref11.frameVariant;
      var baseline = {};
      this.editableGroups().forEach(function (_ref12) {
        var name = _ref12.name,
          el = _ref12.el;
        var active = el.querySelector("".concat(_this27.selectors.bikeBuilderBlocks, ".active"));
        if (!active) return;
        var isDefault = active.classList.contains("default");
        baseline[name] = {
          variantId: active.dataset.attrId,
          title: active.dataset.attrTitle,
          price: isDefault ? 0 : parseInt(active.dataset.attrPrice, 10) || 0,
          compareAt: parseInt(active.dataset.attrCompareAtPrice, 10),
          isDefault: isDefault
        };
      });

      // An upgrade costs what the basket charges for it, which can differ from
      // today's price.
      restored.forEach(function (_ref13) {
        var group = _ref13.group,
          variantId = _ref13.variantId,
          line = _ref13.line;
        if (baseline[group] && baseline[group].variantId === variantId && line) {
          baseline[group].price = line.final_price;
        }
      });
      missing.forEach(function (_ref14) {
        var group = _ref14.group,
          variantId = _ref14.variantId,
          title = _ref14.title,
          line = _ref14.line;
        baseline[group] = {
          variantId: variantId,
          title: title,
          price: line ? line.final_price : 0,
          compareAt: NaN,
          isDefault: false,
          removed: true,
          image: line ? line.image : "",
          handle: line ? line.handle : ""
        };
      });
      this.editBaseline = {
        groups: baseline,
        removed: missing.map(function (_ref15) {
          var group = _ref15.group;
          return group;
        }),
        frameTitle: frameVariant ? frameVariant.title : "",
        basketTotal: (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_6__.basketTotalCents)(parent, components)
      };
      this.showEditingBanner(frameVariant);
      this.showRemovedNotice(missing);
      this.insertUnavailableCards();
      this.fetchRemovedCompareAt();
      if (this.summary) this.summary.classList.add("bike-builder-summary--editing");
      if (this.editSummary) this.editSummary.hidden = false;
      var addNew = this.querySelector(".js-bb-edit-add-new");
      if (addNew && !addNew.dataset.bound) {
        addNew.dataset.bound = "true";
        addNew.addEventListener("click", function () {
          _this27.addAsNewBike = true;
          _this27.bikeBuilderForm.requestSubmit();
        });
      }
      this.updateEditState();
    }

    /**
     * Every component group in Steps 2 and 3, in page order. The hidden fork
     * follows the frame colour, so it is not one the customer edits.
     */
  }, {
    key: "editableGroups",
    value: function editableGroups() {
      return Array.from(this.querySelectorAll('[data-bike-builder-step="2"] .bike-builder-group, [data-bike-builder-step="3"] .bike-builder-group')).map(function (el) {
        return {
          name: el.dataset.attrGroup,
          el: el
        };
      });
    }
  }, {
    key: "currentSelections",
    value: function currentSelections() {
      var _this28 = this;
      var current = {};
      this.editableGroups().forEach(function (_ref16) {
        var name = _ref16.name,
          el = _ref16.el;
        var active = el.querySelector("".concat(_this28.selectors.bikeBuilderBlocks, ".active"));
        if (!active) return;
        var isDefault = active.classList.contains("default");
        current[name] = {
          variantId: active.dataset.attrId,
          title: active.dataset.attrTitle,
          price: isDefault ? 0 : parseInt(active.dataset.attrPrice, 10) || 0,
          compareAt: parseInt(active.dataset.attrCompareAtPrice, 10),
          isDefault: isDefault
        };
      });
      return current;
    }
  }, {
    key: "currentTotalCents",
    value: function currentTotalCents() {
      var extras = 0;
      document.querySelectorAll(this.selectors.extra).forEach(function (row) {
        extras += parseInt(row.dataset.attrPrice, 10) || 0;
      });
      return (parseInt(this.total ? this.total.dataset.attrPrice : 0, 10) || 0) + extras;
    }

    /**
     * The build summary (Builder refinements, Kenny's "Builder/Build summary
     * v2"), redrawn from the selections on the page so it can never drift from
     * them. Each extras row keeps the .js-bike-builder-extra class and data-attr-*
     * values that currentTotalCents(), bike-builder-ga4.js and edit from basket read.
     */
  }, {
    key: "renderSummary",
    value: function renderSummary() {
      var _this29 = this;
      var basePrice = parseInt(this.total ? this.total.dataset.attrPrice : 0, 10) || 0;
      var _summaryFigures = (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_9__.summaryFigures)({
          basePrice: basePrice,
          upgrades: this.summaryUpgrades()
        }),
        extras = _summaryFigures.extras,
        count = _summaryFigures.count,
        extrasTotal = _summaryFigures.extrasTotal,
        saving = _summaryFigures.saving,
        total = _summaryFigures.total;
      if (this.extrasArea) {
        var _this$extrasArea;
        (_this$extrasArea = this.extrasArea).replaceChildren.apply(_this$extrasArea, _toConsumableArray(extras.map(function (extra) {
          return _this29.summaryExtraRow(extra);
        })));
      }
      if (this.summaryExtrasHeading && this.summary) {
        this.summaryExtrasHeading.textContent = (this.summary.dataset.extrasHeading || "").replace("[count]", String(count));
      }
      if (this.extrasTotal) this.extrasTotal.textContent = this.formatCents(extrasTotal);
      if (this.summaryEmpty) this.summaryEmpty.hidden = count > 0;
      if (this.savings) this.savings.hidden = saving <= 0;
      if (this.summarySaving) this.summarySaving.textContent = saving > 0 ? this.formatCents(saving) : "";
      if (this.total) this.total.textContent = this.formatCents(total);
      this.additionalTotals.forEach(function (el) {
        el.textContent = _this29.formatCents(total);
      });
      this.updateC2wCalculator(total);
      this.updateSectionCounts();
      this.updateFinance(total);
      this.updateBuildToggles(count);
    }

    /** Each group's chosen part that is not its standard one, in page order. */
  }, {
    key: "summaryUpgrades",
    value: function summaryUpgrades() {
      var _this30 = this;
      var upgrades = [];
      this.editableGroups().forEach(function (_ref17) {
        var name = _ref17.name,
          el = _ref17.el;
        var active = el.querySelector("".concat(_this30.selectors.bikeBuilderBlocks, ".active"));
        if (!active || active.classList.contains("default")) return;
        var step = active.closest(".js-bike-builder-step");
        var item = active.closest(".bike-builder-content__step-item");
        upgrades.push({
          group: name,
          label: el.dataset.attrLabel || name,
          variantId: active.dataset.attrId,
          title: active.dataset.attrTitle,
          price: parseInt(active.dataset.attrPrice, 10),
          compareAt: parseInt(active.getAttribute("data-attr-compare-at-price"), 10),
          row: item ? item.dataset.rowIndex || "" : "",
          step: step ? step.dataset.bikeBuilderStep || "" : ""
        });
      });
      return upgrades;
    }

    /** One line of Kenny's "Builder/Extras line": category, part, price. Selecting it shows the category. */
  }, {
    key: "summaryExtraRow",
    value: function summaryExtraRow(extra) {
      var _this31 = this;
      var item = document.createElement("li");
      item.className = "bike-builder-summary__extra js-bike-builder-extra";
      item.dataset.attrRow = extra.row;
      item.dataset.attrPrice = String(extra.price);
      item.dataset.attrCompareAtPrice = String(Number.isFinite(extra.compareAt) ? extra.compareAt : extra.price);
      item.dataset.attrGroup = extra.group;
      item.dataset.attrStep = extra.step;
      var button = document.createElement("button");
      button.type = "button";
      button.className = "bike-builder-summary__extra-button reset-styles";
      var group = document.createElement("span");
      group.className = "bike-builder-summary__extra-group";
      group.textContent = extra.label || extra.group;
      var title = document.createElement("span");
      title.className = "bike-builder-summary__extra-title";
      title.textContent = extra.title;
      var price = document.createElement("span");
      price.className = "bike-builder-summary__extra-price";
      price.textContent = this.formatCents(extra.price);
      button.append(group, title, price);
      button.addEventListener("click", function () {
        return _this31.showGroup(extra.group);
      });
      item.append(button);
      return item;
    }

    /** Scrolls the page to a category's row; on mobile the summary sheet closes first. */
  }, {
    key: "showGroup",
    value: function showGroup(name) {
      var group = this.editableGroups().find(function (entry) {
        return entry.name === name;
      });
      if (!group) return;
      // A locked section stays shut; say why instead of scrolling to a hidden row.
      if (this.isSectionsLocked()) {
        this.promptSectionsLocked();
        return;
      }
      this.openSectionFor(name);
      if (this.summarySheet) this.summarySheet.close({
        restoreFocus: false
      });
      var row = group.el.closest(".bike-builder-content__step-item") || group.el;
      row.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }

    /** A group's on-screen label (Kenny round 2), or the name itself when it has none. */
  }, {
    key: "groupLabel",
    value: function groupLabel(name) {
      var group = this.querySelector(".bike-builder-group[data-attr-group=\"".concat(CSS.escape(name), "\"]"));
      return group && group.dataset.attrLabel || name;
    }
  }, {
    key: "formatCents",
    value: function formatCents(cents) {
      return Shopify.formatMoney(cents, "".concat(this.currencySymbol, "{{ amount}}"));
    }
  }, {
    key: "signedCents",
    value: function signedCents(cents) {
      return "".concat(cents < 0 ? "-" : "+").concat(this.formatCents(Math.abs(cents)));
    }

    /**
     * Re-runs the edit summary on every change while editing. A no-op outside
     * edit mode. The cards carry no tags: the selected card's green border shows
     * the choice (James and Kenny, 6 Oct 2026), and the summary lists what changed.
     */
  }, {
    key: "updateEditState",
    value: function updateEditState() {
      if (!this.editBaseline) return;
      this.updateEditSummary(this.currentSelections());
    }
  }, {
    key: "updateEditSummary",
    value: function updateEditSummary(current) {
      var _this32 = this;
      if (!this.editSummary) return;
      var _this$editBaseline = this.editBaseline,
        baseline = _this$editBaseline.groups,
        removed = _this$editBaseline.removed,
        frameTitle = _this$editBaseline.frameTitle,
        basketTotal = _this$editBaseline.basketTotal;
      var frame = this.resolveFrameVariant();
      var newTotal = this.currentTotalCents();
      var changes = (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_6__.buildChanges)({
        groups: this.editableGroups().map(function (_ref18) {
          var name = _ref18.name;
          return name;
        }),
        baseline: baseline,
        current: current,
        removed: removed,
        frame: {
          from: frameTitle,
          to: frame ? frame.title : frameTitle
        }
      });
      var list = this.editSummary.querySelector(".js-bb-edit-changes");
      list.replaceChildren.apply(list, _toConsumableArray(changes.map(function (change) {
        var item = document.createElement("li");
        item.className = "bike-builder-edit-summary__change".concat(change.removed ? " bike-builder-edit-summary__change--removed" : "");
        var text = document.createElement("span");
        var part = document.createElement("strong");
        part.textContent = change.removed ? "".concat(change.from, " ").concat(_this32.editStrings.removedChange) : "".concat(change.from, " \u2192 ").concat(change.to);
        text.append("".concat(_this32.groupLabel(change.group), ": "), part);
        item.append(text);
        if (change.delta !== null) {
          var price = document.createElement("span");
          price.className = "bike-builder-edit-summary__change-price";
          price.textContent = _this32.signedCents(change.delta);
          item.append(price);
        }
        return item;
      })));
      this.editSummary.querySelector(".js-bb-edit-no-changes").hidden = changes.length > 0;
      this.editSummary.querySelector(".js-bb-edit-basket-price").textContent = this.formatCents(basketTotal);

      // Savings: the basket's, from what it charges for its upgrades, against
      // the current build's, by the same rule as the summary's build saving.
      var savingsOf = function savingsOf(selection) {
        return (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_6__.savingsCents)(Object.values(selection).filter(function (choice) {
          return !choice.isDefault;
        }).map(function (_ref19) {
          var price = _ref19.price,
            compareAt = _ref19.compareAt;
          return {
            price: price,
            compareAt: compareAt
          };
        }));
      };
      this.setEditFigure(".js-bb-edit-savings", savingsOf(baseline), savingsOf(current), function (cents) {
        return _this32.formatCents(cents);
      });

      // Finance, only where the builder's finance line is switched on.
      var finance = Array.from(this.financeBlocks || []).find(function (block) {
        return !block.hidden;
      });
      var financeRow = this.editSummary.querySelector(".js-bb-edit-finance");
      if (finance && financeRow) {
        var settings = {
          apr: parseFloat(finance.dataset.financeApr),
          term: parseInt(finance.dataset.financeTerm, 10),
          depositPct: parseFloat(finance.dataset.financeDeposit)
        };
        var was = (0,_bike_builder_finance_mjs__WEBPACK_IMPORTED_MODULE_4__.monthlyPaymentCents)(basketTotal, settings);
        var now = (0,_bike_builder_finance_mjs__WEBPACK_IMPORTED_MODULE_4__.monthlyPaymentCents)(newTotal, settings);
        var label = financeRow.querySelector(".js-bb-edit-finance-label");
        label.textContent = label.dataset.template.replace("[apr]", finance.dataset.financeApr).replace("[term]", finance.dataset.financeTerm);
        if (was !== null && now !== null) {
          this.setEditFigure(".js-bb-edit-finance", was, now, function (cents) {
            return "".concat(_this32.formatCents(cents), "/month");
          }, true);
        } else {
          financeRow.hidden = true;
        }
      } else if (financeRow) {
        financeRow.hidden = true;
      }
      var diff = newTotal - basketTotal;
      this.editSummary.querySelector(".js-bb-edit-delta").textContent = diff === 0 ? this.editStrings.deltaNone : this.editStrings.delta.replace("[amount]", this.signedCents(diff));
      this.editSummary.querySelector(".js-bb-edit-total").textContent = this.formatCents(newTotal);
    }

    /**
     * A figure row: today's value, with the basket's struck through beside it
     * when they differ. Hidden when both are nothing, unless always shown.
     */
  }, {
    key: "setEditFigure",
    value: function setEditFigure(selector, was, now, format) {
      var alwaysShow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var row = this.editSummary.querySelector(selector);
      if (!row) return;
      row.hidden = !alwaysShow && was === 0 && now === 0;
      var wasEl = row.querySelector(".js-bb-edit-was");
      wasEl.hidden = was === now;
      wasEl.textContent = format(was);
      row.querySelector(".js-bb-edit-now").textContent = format(now);
    }
  }, {
    key: "showEditingBanner",
    value: function showEditingBanner(frameVariant) {
      if (!this.editBanner) return;
      var text = this.editBanner.querySelector(".js-bb-editing-text");
      if (text) {
        text.textContent = text.dataset.template.replace("[bike]", this.dataset.bikeProductTitle || "").replace("[frame]", frameVariant ? frameVariant.title : "");
      }
      this.editBanner.hidden = false;
    }

    /**
     * "We've removed 1 part": each upgrade no longer offered, with what it took
     * off the build. Replaces the plain list of titles #189 showed.
     */
  }, {
    key: "showRemovedNotice",
    value: function showRemovedNotice(missing) {
      var _this33 = this;
      if (!this.editNotice || !missing.length) return;
      var title = this.editNotice.querySelector(".js-bb-notice-title");
      var body = this.editNotice.querySelector(".js-bb-notice-body");
      var s = this.editStrings;
      title.textContent = missing.length === 1 ? s.removedOne : s.removedOther.replace("[count]", String(missing.length));
      title.hidden = false;
      var lines = missing.map(function (_ref20) {
        var part = _ref20.title,
          line = _ref20.line;
        var p = document.createElement("p");
        p.textContent = s.removedPart.replace("[part]", part).replace("[amount]", _this33.signedCents(-(line ? line.final_price : 0)));
        return p;
      });
      var pick = document.createElement("p");
      pick.textContent = s.removedPick;
      body.replaceChildren.apply(body, _toConsumableArray(lines).concat([pick]));
      this.editNotice.classList.add("bike-builder-notice--removed");
      this.editNotice.hidden = false;
      this.bringNoticeIntoView();
    }

    /**
     * A removed part stays in its row, greyed, after the standard choice, so the
     * customer can see what went; the notice above says why. It is not a block,
     * so nothing can select it.
     */
  }, {
    key: "insertUnavailableCards",
    value: function insertUnavailableCards() {
      var _this34 = this;
      var _this$editBaseline2 = this.editBaseline,
        baseline = _this$editBaseline2.groups,
        removed = _this$editBaseline2.removed;
      removed.forEach(function (name) {
        var part = baseline[name];
        var group = _this34.editableGroups().find(function (entry) {
          return entry.name === name;
        });
        if (!part || !group) return;
        var card = document.createElement("div");
        card.className = "bike-builder-block-wrapper bike-builder-block-wrapper--unavailable js-bb-unavailable-card";
        card.setAttribute("aria-disabled", "true");
        var image = document.createElement("div");
        image.className = "bike-builder-product_image product_image";
        if (part.image) {
          var img = document.createElement("img");
          img.src = part.image;
          img.alt = "";
          img.loading = "lazy";
          image.append(img);
        }
        var titleEl = document.createElement("div");
        titleEl.className = "bike-builder-product_title product_title";
        titleEl.textContent = part.title;
        var price = document.createElement("p");
        price.className = "bike-builder-product_price product_price";
        price.textContent = "+".concat(_this34.formatCents(part.price));
        card.append(image, titleEl, price);
        var first = group.el.firstElementChild;
        if (first) first.after(card);else group.el.append(card);
      });
      if (removed.length) this.initScrollBar();
    }

    /**
     * A removed part's saving counts in the basket's figure. The basket line
     * carries no compare-at price, so ask the product.
     */
  }, {
    key: "fetchRemovedCompareAt",
    value: (function () {
      var _fetchRemovedCompareAt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$editBaseline3, baseline, removed;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this$editBaseline3 = this.editBaseline, baseline = _this$editBaseline3.groups, removed = _this$editBaseline3.removed;
              _context3.n = 1;
              return Promise.all(removed.map(/*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(name) {
                  var part, response, product, variant, _t2;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.p = _context2.n) {
                      case 0:
                        part = baseline[name];
                        if (!(!part || !part.handle)) {
                          _context2.n = 1;
                          break;
                        }
                        return _context2.a(2);
                      case 1:
                        _context2.p = 1;
                        _context2.n = 2;
                        return fetch("".concat(window.Shopify.routes.root, "products/").concat(part.handle, ".js"));
                      case 2:
                        response = _context2.v;
                        if (response.ok) {
                          _context2.n = 3;
                          break;
                        }
                        return _context2.a(2);
                      case 3:
                        _context2.n = 4;
                        return response.json();
                      case 4:
                        product = _context2.v;
                        variant = (product.variants || []).find(function (v) {
                          return String(v.id) === part.variantId;
                        });
                        if (variant && variant.compare_at_price) part.compareAt = variant.compare_at_price;
                        _context2.n = 6;
                        break;
                      case 5:
                        _context2.p = 5;
                        _t2 = _context2.v;
                      case 6:
                        return _context2.a(2);
                    }
                  }, _callee2, null, [[1, 5]]);
                }));
                return function (_x) {
                  return _ref21.apply(this, arguments);
                };
              }()));
            case 1:
              this.updateEditState();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function fetchRemovedCompareAt() {
        return _fetchRemovedCompareAt.apply(this, arguments);
      }
      return fetchRemovedCompareAt;
    }()
    /**
     * Leaves edit mode after the update: the page is a builder again, holding
     * the build the customer just put in the basket.
     */
    )
  }, {
    key: "finishEditMode",
    value: function finishEditMode() {
      this.editParentId = null;
      this.editBaseline = null;
      if (this.editBanner) this.editBanner.hidden = true;
      if (this.editSummary) this.editSummary.hidden = true;
      if (this.summary) this.summary.classList.remove("bike-builder-summary--editing");
      if (this.editNotice) this.editNotice.hidden = true;
      this.querySelectorAll(".js-bb-unavailable-card").forEach(function (el) {
        return el.remove();
      });
      this.updateActionButtonState();
      this.initScrollBar();
      var params = new URLSearchParams(window.location.search);
      params["delete"]("edit");
      var query = params.toString();
      window.history.replaceState(null, "", "".concat(window.location.pathname).concat(query ? "?".concat(query) : "").concat(window.location.hash));
    }

    /**
     * Clicks the frame variant's option radio in each Step 1 option list, the
     * same click a customer makes, so availability, the fork colour match, the
     * frame bundle and checkStep1Completion() all run.
     *
     * @returns {boolean} whether Step 1 is complete and available afterwards
     */
  }, {
    key: "selectFrameVariant",
    value: function selectFrameVariant(variant) {
      var step1 = this.querySelector('[data-bike-builder-step="1"]');
      if (!step1) return false;
      var _loop = function _loop() {
          var value = variant["option".concat(position)];
          if (value == null) return 0; // continue
          var input = Array.from(step1.querySelectorAll("input[data-product-option=\"".concat(position, "\"]"))).find(function (candidate) {
            return candidate.value === value;
          });
          if (!input || input.disabled) return {
            v: false
          };
          input.click();
        },
        _ret;
      for (var position = 1; position <= 3; position++) {
        _ret = _loop();
        if (_ret === 0) continue;
        if (_ret) return _ret.v;
      }
      return this.isStep1Complete();
    }

    /**
     * The upgrade's block in its group, looked for only in the numbered Steps 2
     * and 3. The hidden fork sits outside them and follows the frame colour.
     */
  }, {
    key: "findUpgradeBlock",
    value: function findUpgradeBlock(_ref22) {
      var group = _ref22.group,
        variantId = _ref22.variantId;
      var selector = ".bike-builder-group[data-attr-group=\"".concat(CSS.escape(group), "\"] ") + ".bike-builder-block[data-attr-id=\"".concat(CSS.escape(variantId), "\"]");
      var steps = this.querySelectorAll('[data-bike-builder-step="2"], [data-bike-builder-step="3"]');
      var _iterator = _createForOfIteratorHelper(steps),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var step = _step.value;
          var block = step.querySelector(selector);
          if (block) return block;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
  }, {
    key: "showUnrestored",
    value: function showUnrestored(titles) {
      if (!titles.length || !this.editStrings.unrestored) return;
      this.showEditNotice(this.editStrings.unrestored.replace("[items]", titles.join(", ")));
    }

    /**
     * The plain grey notice, e.g. a link to a bike no longer in the basket.
     */
  }, {
    key: "showEditNotice",
    value: function showEditNotice(message) {
      if (!this.editNotice || !message) return;
      var title = this.editNotice.querySelector(".js-bb-notice-title");
      var body = this.editNotice.querySelector(".js-bb-notice-body");
      if (title) title.hidden = true;
      if (body) body.textContent = message;else this.editNotice.textContent = message;
      this.editNotice.classList.remove("bike-builder-notice--removed");
      this.editNotice.hidden = false;
      this.bringNoticeIntoView();
    }
  }, {
    key: "initFormSubmission",
    value: function initFormSubmission() {
      var _this35 = this;
      if (this.bikeBuilderForm) {
        this.bikeBuilderForm.addEventListener("submit", function (e) {
          // Prevent the native submit unconditionally, up front. If this were
          // deferred until after the reconcile block below, any throw in that
          // block would abort the listener with the default not yet prevented,
          // so the browser would fall through to a native submit — skipping
          // refreshBikeBuildId() (which guards against a known multi-bike
          // parent-id collision) and the GA4 emit.
          e.preventDefault();

          // "Add as another bike" in edit mode: a normal add, leaving the bike
          // being edited in the basket. Read once, so a refused submit cannot
          // carry it over to the next.
          var addAsNewBike = _this35.addAsNewBike;
          _this35.addAsNewBike = false;
          if (!_this35.step3Ready) {
            return;
          }
          if (!_this35.hasSelectedAllStep1Options()) {
            _this35.promptSelectOptions();
            return;
          }
          if (!_this35.isSelectedFrameVariantAvailable()) {
            _this35.promptUnavailableVariant();
            return;
          }

          // Last-chance reconcile. The frame id is carried in an input's name
          // attribute, so any path that set the radios without running
          // writeFrameBundle would otherwise post a plausible wrong frame. Rewrite
          // from the selection, then refuse the add if it still disagrees.
          var frameBefore = _this35.assertFrameBundle();
          _this35.writeFrameBundle(frameBefore.expected);
          var frameAfter = _this35.assertFrameBundle();
          if (!frameAfter.ok) {
            _this35.showToast("Sorry — please reselect your size to continue.");
            return;
          }
          if (!frameBefore.ok) {
            _this35.stampFrameCorrected(frameBefore.posted, frameAfter.expected.id);
          }
          if (_this35.submitting) return;
          _this35.submitting = true;
          _this35.refreshBikeBuildId();
          var bikeVariant = frameAfter.expected;
          (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.emitBikeAddedToCart)({
            itemId: _this35.dataset.bikeProductId || (bikeVariant ? bikeVariant.id : _this35.product && _this35.product.id),
            itemName: _this35.dataset.bikeProductTitle || _this35.product && _this35.product.title,
            itemVariant: bikeVariant && bikeVariant.title
          });
          if (_this35.editParentId && !addAsNewBike) {
            _this35.updateBasket();
            return;
          }
          var form = _this35.bikeBuilderForm;
          window.setTimeout(function () {
            return form.submit();
          }, 200);
        });
      }
    }

    /**
     * Edit from basket: add the new build, then remove the old one, then show
     * the basket. Adding first means a failure never costs the customer the
     * bike they had. The parent id was re-minted before this ran, so the new
     * build's lines never match the old id.
     *
     * The old build's lines are remembered for the basket's Undo, and the
     * basket opens as the drawer over this page (Kenny's V3 "Basket drawer after
     * update"), with the bike page left holding the updated build.
     */
  }, {
    key: "updateBasket",
    value: (function () {
      var _updateBasket = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _document$querySelect;
        var root, newParentId, response, oldLines, _t3, _t4, _t5;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              root = window.Shopify.routes.root; // Minted by refreshBikeBuildId() just before this ran.
              newParentId = (_document$querySelect = document.querySelector("#primaryParentLineItem")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
              _context4.p = 1;
              _context4.n = 2;
              return fetch("".concat(root, "cart/add.js"), {
                method: "POST",
                body: new FormData(this.bikeBuilderForm),
                headers: {
                  Accept: "application/json"
                },
                credentials: "same-origin"
              });
            case 2:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 3;
                break;
              }
              throw new Error("cart/add ".concat(response.status));
            case 3:
              _context4.n = 9;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              _context4.p = 5;
              if (!newParentId) {
                _context4.n = 6;
                break;
              }
              _context4.n = 6;
              return (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_7__.removeBuild)(newParentId);
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t4 = _context4.v;
            case 8:
              this.submitting = false;
              this.showToast(this.editStrings.updateFailed);
              return _context4.a(2);
            case 9:
              oldLines = null;
              _context4.p = 10;
              _context4.n = 11;
              return (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_7__.removeBuild)(this.editParentId);
            case 11:
              oldLines = _context4.v;
              _context4.n = 13;
              break;
            case 12:
              _context4.p = 12;
              _t5 = _context4.v;
            case 13:
              if (oldLines && oldLines.parent && newParentId) {
                (0,_bike_build_basket__WEBPACK_IMPORTED_MODULE_7__.rememberUpdatedBuild)({
                  parentId: newParentId,
                  oldParentId: this.editParentId,
                  oldLines: oldLines
                });
              }
              if (document.querySelector("#shopify-section-mini-cart")) {
                _context4.n = 14;
                break;
              }
              window.location.href = "".concat(root, "cart");
              return _context4.a(2);
            case 14:
              this.finishEditMode();
              this.submitting = false;
              document.dispatchEvent(new Event("renderCart"));
            case 15:
              return _context4.a(2);
          }
        }, _callee4, this, [[10, 12], [5, 7], [1, 4]]);
      }));
      function updateBasket() {
        return _updateBasket.apply(this, arguments);
      }
      return updateBasket;
    }()
    /**
     * Stamps the build with a fresh, unique parent line-item id on every submit.
     *
     * Each build groups its component line items to its frame via a parent id:
     * the frame carries `_primaryParentLineItem` and every component carries
     * `_parentLineItem` = `<GROUP>___<id>`. That id is seeded server-side from
     * `{{ "now" | date: "%s" }}` (#primaryParentLineItem).
     *
     * The builder adds via a native form submit (no AJAX), so the customer
     * usually returns to it via the browser back/forward cache or a CDN-cached
     * render. In that case the seed is frozen and a second bike submits with the
     * SAME id as the first — the two builds then share a parent id, their
     * components become indistinguishable, and the cart's bundle grouping /
     * removal logic cross-links them, stripping the first bike's options.
     *
     * Re-minting the id here, client-side at submit time, guarantees each added
     * bike gets a distinct parent id regardless of how the page was cached. (The
     * legacy `checkBikeBuilder()` increment in cart.js only runs on the AJAX add
     * path, which the bike builder never uses.)
     */
    )
  }, {
    key: "refreshBikeBuildId",
    value: function refreshBikeBuildId() {
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");
      if (!primaryParentLineItem) return;
      var uniqueId = "".concat(Date.now()).concat(Math.floor(Math.random() * 1000));

      // Re-point every component line at the new id (value is "<GROUP>___<id>").
      document.querySelectorAll('input[name$="[_parentLineItem]"]').forEach(function (input) {
        var group = input.value.split("___")[0];
        input.value = "".concat(group, "___").concat(uniqueId);
      });
      primaryParentLineItem.value = uniqueId;
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      var _this36 = this;
      this.dedupeOptionCards(this);
      this.syncOptionCards(this);
      this.initScrollBar();
      var delta = 6;
      var startX;
      var startY;
      document.body.addEventListener("mousedown", function (event) {
        startX = event.pageX;
        startY = event.pageY;
      });
      document.body.addEventListener("mouseup", function (event) {
        var diffX = Math.abs(event.pageX - startX);
        var diffY = Math.abs(event.pageY - startY);
        if (diffX < delta && diffY < delta) {
          _this36.mouseIsDragging = false;
        } else {
          _this36.mouseIsDragging = true;
        }
      });
    }

    /**
     * One card per product per row. A group's default tag renders its product
     * first, and where the group's upgrade collection carries the same product
     * the collection's copy is dropped. Then, as before cards existed, any other
     * block repeating a standard variant is dropped too, so the standard choice
     * is never also on offer as an upgrade.
     */
  }, {
    key: "dedupeOptionCards",
    value: function dedupeOptionCards(scope) {
      var _this37 = this;
      scope.querySelectorAll(this.selectors.bikeBuilderGroups).forEach(function (group) {
        var cards = Array.from(group.querySelectorAll(_this37.selectors.optionCards));
        (0,_bike_builder_option_card_mjs__WEBPACK_IMPORTED_MODULE_3__.duplicateCardIndexes)(cards.map(function (card) {
          return card.dataset.productHandle;
        })).forEach(function (index) {
          cards[index].remove();
        });
      });
      scope.querySelectorAll("".concat(this.selectors.bikeBuilderBlocks, ".default")).forEach(function (standard) {
        scope.querySelectorAll("".concat(_this37.selectors.bikeBuilderBlocks, "[data-attr-id=\"").concat(standard.dataset.attrId, "\"]:not(.default)")).forEach(function (duplicate) {
          return _this37.removeVariantBlock(duplicate);
        });
      });
    }

    /**
     * Takes one variant out of its card, with its size button, and the card with
     * it if that was its last variant. A card left with one size keeps its one
     * button, as a single-size card renders.
     */
  }, {
    key: "removeVariantBlock",
    value: function removeVariantBlock(block) {
      var card = block.closest(this.selectors.optionCards);
      block.remove();
      if (!card) return;
      var button = card.querySelector("".concat(this.selectors.variantSizes, "[data-variant-id=\"").concat(block.dataset.attrId, "\"]"));
      if (button) button.remove();
      if (!card.querySelector(this.selectors.bikeBuilderBlocks)) {
        card.remove();
        return;
      }
      this.syncOptionCard(card);
    }
  }, {
    key: "syncOptionCards",
    value: function syncOptionCards(scope) {
      var _this38 = this;
      scope.querySelectorAll(this.selectors.optionCards).forEach(function (card) {
        return _this38.syncOptionCard(card);
      });
    }

    /**
     * Shows the one block a card should (see shownVariantIndex) and brings its
     * size buttons and selected styling into line with it. A size reads as
     * pressed only on the chosen card: an unchosen card's showing size is where
     * it was left, not something the customer has picked.
     */
  }, {
    key: "syncOptionCard",
    value: function syncOptionCard(card) {
      var blocks = Array.from(card.querySelectorAll(this.selectors.bikeBuilderBlocks));
      var shown = (0,_bike_builder_option_card_mjs__WEBPACK_IMPORTED_MODULE_3__.shownVariantIndex)(blocks.map(function (block) {
        return {
          active: block.classList.contains("active"),
          standard: block.classList.contains("default"),
          shown: !block.hidden
        };
      }));
      if (shown === -1) return;
      blocks.forEach(function (block, index) {
        block.hidden = index !== shown;
      });
      var active = blocks[shown].classList.contains("active");
      card.classList.toggle("bike-builder-block-wrapper--active", active);
      card.querySelectorAll(this.selectors.variantSizes).forEach(function (button) {
        var pressed = active && button.dataset.variantId === blocks[shown].dataset.attrId;
        button.setAttribute("aria-pressed", String(pressed));
      });
    }

    /**
     * Picking a size is a choice in itself, so it selects the card at that size
     * whether or not the card was already selected. The buttons sit outside the
     * blocks, so a size click never also reaches a block's own click handler.
     *
     * In Step 2 the shown block is display: contents (see _bike-builder.scss), so
     * the card's padding and its photo (pointer-events: none) are hit as the card
     * itself. Those clicks go on to the block the card is showing.
     */
  }, {
    key: "bindOptionCards",
    value: function bindOptionCards(scope) {
      var _this39 = this;
      scope.querySelectorAll(this.selectors.optionCards).forEach(function (card) {
        card.addEventListener("click", function (event) {
          if (event.target !== card) return;
          var shown = card.querySelector("".concat(_this39.selectors.bikeBuilderBlocks, ":not([hidden])"));
          if (shown) shown.click();
        });
      });
      scope.querySelectorAll(this.selectors.variantSizes).forEach(function (button) {
        button.addEventListener("click", function () {
          var card = button.closest(_this39.selectors.optionCards);
          var block = card ? card.querySelector("".concat(_this39.selectors.bikeBuilderBlocks, "[data-attr-id=\"").concat(button.dataset.variantId, "\"]")) : null;
          if (!block || _this39.isSelectingDefaults) return;

          // Re-picking the size the chosen card already shows changes nothing.
          if (block.classList.contains("active")) return;
          _this39.changeBikeBuilderProduct(block);
          _this39.syncOptionCard(card);
        });
      });
    }

    /**
     * Keeps every card on its active block. `.active` is set from more places
     * than one function: a click, the Step 2/3 defaults, reset and undo, the
     * fork colour match and checkURLForVariant all toggle it directly. So watch
     * the class itself rather than chase each path. The observer only writes
     * `hidden` on blocks and a class on cards, neither of which it reacts to, so
     * it cannot retrigger itself. Watching the element covers the Step 3
     * fragment, which is injected inside it.
     */
  }, {
    key: "observeOptionCards",
    value: function observeOptionCards() {
      var _this40 = this;
      if (!("MutationObserver" in window)) return;
      var observer = new MutationObserver(function (records) {
        var cards = new Set();
        records.forEach(function (record) {
          if (!record.target.matches || !record.target.matches(_this40.selectors.bikeBuilderBlocks)) return;
          var card = record.target.closest(_this40.selectors.optionCards);
          if (card) cards.add(card);
        });
        cards.forEach(function (card) {
          return _this40.syncOptionCard(card);
        });
      });
      observer.observe(this, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true
      });
    }
  }, {
    key: "initScrollBar",
    value: function initScrollBar() {
      this.bikeBuilderGroups.forEach(function (group) {
        var uniqueId = group.dataset.attrGroup;
        var $content = $(group).parents(".bike-builder-row");
        var $slides = $(group).children();
        var $scrollbar = $("[data-attr-scrollbar-group=\"".concat(uniqueId, "\"]"));
        var $thumb = $("[data-attr-scrollbar-thumb-group=\"".concat(uniqueId, "\"]"));
        var $prevBtn = $("[data-attr-prev-btn=\"".concat(uniqueId, "\"]"));
        var $nextBtn = $("[data-attr-next-btn=\"".concat(uniqueId, "\"]"));
        var totalSlides = $slides.length;
        // Both of these were fixed at init: slideWidth captured once (so it was
        // stale after any viewport change, and zero whenever the row was still
        // hidden) and slidesToShow hard-coded to the desktop three. Below tablet
        // only one or two options fit, and overstating the count retired the next
        // arrow several slides early. measure() re-takes them, and the resize
        // handler at the bottom re-runs it.
        var slideWidth = $($slides[0]).outerWidth(true);
        var slidesToShow = 3;
        var isDragging = false;
        var currentSlide = 0;
        var isGoToSlide = false;
        function measure() {
          slideWidth = $($slides[0]).outerWidth(true) || slideWidth;
          var fits = slideWidth > 0 ? Math.floor($content.width() / slideWidth) : 1;
          slidesToShow = Math.max(1, Math.min(fits, totalSlides));
        }

        // The thumb is the visible share of the row, so its length says how much
        // more there is to see. Measured once the track is showing.
        function checkOverflow() {
          var _$content$ = $content[0],
            scrollWidth = _$content$.scrollWidth,
            clientWidth = _$content$.clientWidth;
          // Rows that scroll get Previous and Next under the cards (buy column).
          var $item = $content.closest(".bike-builder-content__step-item");
          if (scrollWidth <= clientWidth) {
            $scrollbar.hide();
            $item.removeClass("bike-builder-step-item--scrolls");
            return;
          }
          $scrollbar.show();
          $item.addClass("bike-builder-step-item--scrolls");
          $thumb.css("width", Math.max(32, Math.round($scrollbar.width() * clientWidth / scrollWidth)));
        }

        // Previously gated on a >= 768px viewport, which is why the arrows worked
        // on desktop and were absent below tablet. Position in the row is the only
        // thing that should decide whether an arrow is useful.
        function updateButtons() {
          currentSlide <= 0 ? $prevBtn.hide() : $prevBtn.show();
          currentSlide >= totalSlides - slidesToShow ? $nextBtn.hide() : $nextBtn.show();
        }
        function updateSlideVisibility() {
          $slides.each(function (index, slide) {
            var slideLeft = $(slide).position().left;
            var visibleWidth = Math.min(slideWidth, $content.width() - slideLeft, slideLeft + slideWidth);
            $(slide).css("opacity", visibleWidth >= 0.7 * slideWidth ? 1 : 0.5);
          });
        }
        function updateThumbPosition() {
          var scrollRatio = $content.scrollLeft() / ($content[0].scrollWidth - $content[0].clientWidth);
          $thumb.css("left", scrollRatio * ($scrollbar.width() - $thumb.width()));
        }
        function updateCurrentSlide() {
          var viewportCenter = $content.scrollLeft() + $content.width() / 2;
          var closestDistance = Infinity;
          var mostCenterLeftSlideIndex = 0;
          for (var i = 0; i < totalSlides; i++) {
            var slideCenter = i * slideWidth + slideWidth / 2;
            if (slideCenter <= viewportCenter && viewportCenter - slideCenter < closestDistance) {
              closestDistance = viewportCenter - slideCenter;
              mostCenterLeftSlideIndex = i;
            }
          }
          currentSlide = mostCenterLeftSlideIndex === 1 && $content.scrollLeft() <= slideWidth ? 0 : Math.min(mostCenterLeftSlideIndex, totalSlides - slidesToShow);
        }
        function goToSlide(slideIndex) {
          slideIndex = Math.max(0, Math.min(slideIndex, totalSlides - slidesToShow));
          $content.scrollLeft(slideIndex * slideWidth);
          currentSlide = slideIndex;
          isGoToSlide = true;
        }
        function startDrag(e) {
          isDragging = true;
          var startX = e.type === "touchstart" ? e.originalEvent.touches[0].pageX : e.pageX;
          var thumbStartX = $thumb.position().left;
          var moveFn = function moveFn(moveEvent) {
            var currentPageX = moveEvent.type === "touchmove" ? moveEvent.originalEvent.touches[0].pageX : moveEvent.pageX;
            var dragAmount = currentPageX - startX;
            var thumbNewX = thumbStartX + dragAmount;
            var maxThumbX = $scrollbar.width() - $thumb.width();
            thumbNewX = Math.max(0, Math.min(thumbNewX, maxThumbX));
            var scrollRatio = thumbNewX / maxThumbX;
            $content.scrollLeft(scrollRatio * ($content[0].scrollWidth - $content[0].clientWidth));
            $thumb.css("left", thumbNewX);
          };
          $(document).on("mousemove touchmove", moveFn).one("mouseup touchend", function () {
            $(document).off("mousemove touchmove", moveFn);
            isDragging = false;
          });
        }
        $thumb.off("mousedown touchstart").on("mousedown touchstart", startDrag);
        $content.off("scroll").on("scroll", function () {
          if (!isDragging) updateThumbPosition();
          if (!isGoToSlide) updateCurrentSlide();else isGoToSlide = false;
          updateButtons();
          updateSlideVisibility();
        });
        $prevBtn.off("click").on("click", function () {
          return goToSlide(currentSlide - 1);
        });
        $nextBtn.off("click").on("click", function () {
          return goToSlide(currentSlide + 1);
        });

        // initScrollBar re-runs (entering customise mode, and again once Step 3 is
        // injected), so namespace per group and rebind rather than stacking a
        // handler per group per call. The title can carry spaces; a namespace
        // cannot.
        var resizeNamespace = "resize.bbScrollBar-".concat(String(uniqueId).replace(/[^a-zA-Z0-9]/g, ""));
        var resizeTimer;
        $(window).off(resizeNamespace).on(resizeNamespace, function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            measure();
            checkOverflow();
            updateCurrentSlide();
            updateThumbPosition();
            updateButtons();
            updateSlideVisibility();
          }, 150);
        });
        measure();
        checkOverflow();
        updateThumbPosition();
        updateButtons();
        updateSlideVisibility();
      });
    }
  }, {
    key: "handleAvailTriggers",
    value: function handleAvailTriggers() {
      var _this41 = this;
      this.availTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          // The summary sheet sits above everything on mobile: close it so the
          // modal is not opened underneath it.
          if (_this41.summarySheet) _this41.summarySheet.close({
            restoreFocus: false
          });
          if (_this41.availModal) {
            _this41.availModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
        });
      });
    }
  }, {
    key: "handleInfoTriggers",
    value: function handleInfoTriggers() {
      var _this42 = this;
      this.infoTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var _this42$infoModalCont, _this42$infoModalCont2, _this42$infoModalCont3;
          var img = (_this42$infoModalCont = _this42.infoModalContent) === null || _this42$infoModalCont === void 0 ? void 0 : _this42$infoModalCont.querySelector(".js-bike-builder-product-info-modal__image");
          var title = (_this42$infoModalCont2 = _this42.infoModalContent) === null || _this42$infoModalCont2 === void 0 ? void 0 : _this42$infoModalCont2.querySelector(".js-bike-builder-product-info-modal__title");
          var text = (_this42$infoModalCont3 = _this42.infoModalContent) === null || _this42$infoModalCont3 === void 0 ? void 0 : _this42$infoModalCont3.querySelector(".js-bike-builder-product-info-modal__text");
          if (img) img.src = "";
          if (_this42.infoModal) {
            _this42.infoModal.classList.toggle("is-active");
            document.body.classList.toggle("overflow-hidden");
          }
          if (!trigger.hasAttribute("data-product-info-featured-image")) return;
          if (img) img.src = trigger.dataset.productInfoFeaturedImage;
          if (title) title.innerHTML = trigger.dataset.productInfoTitle.replace("[OEM]", "").replace("[BB]", "");
          if (text) text.innerHTML = trigger.dataset.productInfoText;
        });
      });
    }
  }, {
    key: "populateWheelbaseInput",
    value: function populateWheelbaseInput() {
      var wheelGroup = document.querySelector('.bike-builder-group[data-attr-group="Wheels"]');
      if (wheelGroup) {
        var activeBlock = wheelGroup.querySelector(".bike-builder-block.active");
        if (activeBlock) {
          var wheelbaseSkus = activeBlock.getAttribute("data-wheelbase-skus");
          if (wheelbaseSkus) {
            var _wheelGroup$closest;
            var wheelSplit = wheelbaseSkus.split(", ");
            var productProperties = (_wheelGroup$closest = wheelGroup.closest("[data-product-option-list]")) === null || _wheelGroup$closest === void 0 ? void 0 : _wheelGroup$closest.querySelector(".product-properties");
            if (productProperties) {
              var productIdToBundleFront = "\n            <input\n              id=\"bundleProduct_".concat(wheelSplit[0], "\"\n              type=\"text\"\n              name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[0], "]\"\n              value=\"1\"\n            />\n            ");
              var productIdToBundleBack = "\n            <input\n              id=\"bundleProduct_".concat(wheelSplit[1], "\"\n              type=\"text\"\n              name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[1], "]\"\n              value=\"1\"\n            />\n            ");
              productProperties.innerHTML = productIdToBundleFront + productIdToBundleBack;
            }
          }
        }
      }
    }
  }, {
    key: "hideEmptyStepItems",
    value: function hideEmptyStepItems() {
      var emptyStepItems = document.querySelectorAll("[data-product-option-list-empty]");
      emptyStepItems.forEach(function (item) {
        return item.parentElement.style.display = "none";
      });
    }
  }, {
    key: "handleContentScroll",
    value: function handleContentScroll() {
      if (this.submit) {
        var stickyElement = this.submit.parentElement;
        var sentinel = stickyElement === null || stickyElement === void 0 ? void 0 : stickyElement.previousElementSibling;
        if (sentinel) {
          var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
              stickyElement.classList.remove("sticky");
            } else {
              stickyElement.classList.add("sticky");
            }
          }, {
            threshold: [1]
          });
          observer.observe(sentinel);
        }
      }
    }
  }, {
    key: "handleNinjaDiscount",
    value: function handleNinjaDiscount() {
      var _this43 = this;
      document.addEventListener("limoniapps:discountninja:product:discountapplied", function (event) {
        var discountedProductInfo = event.detail.data[0];
        _this43.bikeBuilderBlocks = document.querySelectorAll(_this43.selectors.bikeBuilderBlocks);
        var discountedBlocks = document.querySelectorAll("".concat(_this43.selectors.bikeBuilderBlocks, "[data-product-handle=\"").concat(discountedProductInfo.ProductHandle, "\"]"));
        discountedBlocks.forEach(function (discountedBlock) {
          var variantPrice = parseInt(discountedBlock.getAttribute("data-attr-price"));
          var variantCompareAtPrice = parseInt(discountedBlock.getAttribute("data-attr-compare-at-price"));
          var discountPercentage = discountedProductInfo.Percentage / 100;
          var discountedVariantPrice = Math.round(variantPrice * (1 - discountPercentage));
          var formattedVariantCompareAtPrice = window.Shopify.formatMoney(variantCompareAtPrice, "".concat(window.Shopify.currency.symbol, "{{amount}}"));
          var formattedDiscountedVariantPrice = window.Shopify.formatMoney(discountedVariantPrice, "".concat(window.Shopify.currency.symbol, "{{amount}}"));
          var $price = discountedBlock.querySelector(".bike-builder-product_price");
          var updatedHTML;
          if (variantPrice == variantCompareAtPrice || variantPrice == 0) {
            updatedHTML = "<span class=\"bike-builder-product_price__current\">+".concat(formattedVariantCompareAtPrice, "</span>");
          } else {
            discountedBlock.setAttribute("data-attr-price", discountedVariantPrice);
            updatedHTML = "<span class=\"bike-builder-product_price__current\"><s>+".concat(formattedVariantCompareAtPrice, "</s> +").concat(formattedDiscountedVariantPrice, "</span>");
          }
          var $newPrice = document.createElement("p");
          $newPrice.className = "bike-builder-product_price";
          $newPrice.innerHTML = updatedHTML;
          if ($price) {
            $price.replaceWith($newPrice);
          }
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-bike-builder.js":
/*!*****************************************************!*\
  !*** ./src/scripts/modules/product-bike-builder.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductBikeBuilder)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./bike-builder-ga4 */ "./src/scripts/modules/bike-builder-ga4.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }



var ProductBikeBuilder = /*#__PURE__*/function (_HTMLElement) {
  function ProductBikeBuilder() {
    var _this;
    _classCallCheck(this, ProductBikeBuilder);
    _this = _callSuper(this, ProductBikeBuilder);

    // General
    _this.product = JSON.parse(document.querySelector("[data-frame-product-json]").textContent);
    _this.observeConfig = {
      attributes: true,
      subtree: true
    };

    // Selectors
    _this.selectors = {
      bikeBuilderForm: ".js-bike-builder-form",
      bikeBuilderGroups: ".bike-builder-group",
      bikeBuilderBlocks: ".bike-builder-block",
      bikeBuilderRow: ".bike-builder-row",
      frameOptions: "[data-product-option]",
      frameDefaults: ".default",
      availModal: ".js-bike-builder-product-avail-modal",
      availTriggers: ".js-bike-builder-product-avail-trigger",
      infoModal: ".js-bike-builder-product-info-modal",
      infoModalContent: ".js-bike-builder-product-info-modal-content",
      infoTriggers: ".js-bike-builder-product-info-trigger",
      propVariantId: "[data-bike-builder-variant-id]",
      propVariantTitle: "[data-bike-builder-variant-title]",
      sizeGuide: "product-size-guide",
      stepsStates: ".js-bike-builder-state",
      steps: ".js-bike-builder-step",
      stepsContents: ".js-bike-builder-step-content",
      stepsSelections: ".js-bike-builder-step-selection",
      edits: ".js-bike-builder-edit",
      resets: ".js-bike-builder-reset",
      extra: ".js-bike-builder-extra",
      extrasArea: ".js-bike-builder-extras-area",
      extrasTotal: ".js-bike-builder-extras-total",
      priceFrameTitle: ".js-bike-builder-frame-title",
      total: ".js-bike-builder-total",
      additionalTotals: ".js-bike-builder-additional-total",
      productCount: ".js-bike-builder-product-count",
      submit: ".js-bike-builder-submit",
      preorderVariant: "[data-preorder-variant]"
    };
    _this.preorderVariant = document.querySelector(_this.selectors.preorderVariant);

    // Elements
    _this.bikeBuilderForm = document.querySelector(_this.selectors.bikeBuilderForm);
    _this.bikeBuilderGroups = document.querySelectorAll(_this.selectors.bikeBuilderGroups);
    _this.bikeBuilderBlocks = document.querySelectorAll(_this.selectors.bikeBuilderBlocks);
    _this.bikeBuilderRow = document.querySelectorAll(_this.selectors.bikeBuilderRow);
    _this.frameOptions = document.querySelectorAll(_this.selectors.frameOptions);
    _this.availModal = document.querySelector(_this.selectors.availModal);
    _this.infoModal = document.querySelector(_this.selectors.infoModal);
    _this.infoModalContent = document.querySelector(_this.selectors.infoModalContent);
    _this.availTriggers = document.querySelectorAll(_this.selectors.availTriggers);
    _this.infoTriggers = document.querySelectorAll(_this.selectors.infoTriggers);
    _this.edits = document.querySelectorAll(_this.selectors.edits);
    _this.resets = document.querySelectorAll(_this.selectors.resets);
    _this.extrasArea = document.querySelector(_this.selectors.extrasArea);
    _this.extrasTotal = document.querySelector(_this.selectors.extrasTotal);
    _this.priceFrameTitle = document.querySelector(_this.selectors.priceFrameTitle);
    _this.total = document.querySelector(_this.selectors.total);
    _this.additionalTotals = document.querySelectorAll(_this.selectors.additionalTotals);
    _this.productCount = document.querySelector(_this.selectors.productCount);
    _this.submit = document.querySelector(_this.selectors.submit);
    _this.properties = {
      variantId: document.querySelector("[data-bike-builder-variant-id]"),
      variantTitle: document.querySelector("[data-bike-builder-variant-title]")
    };
    _this.wheelbaseInputFront = document.querySelector("#wheelbase-id-front");
    _this.wheelbaseInputBack = document.querySelector("#wheelbase-id-back");

    // General
    // - Prevent the mutation observer from firing if a user is sliding the slider.
    _this.mouseIsDragging = false;

    // - Prevents the Step 2/3 defaults being set after their initial completion.
    _this.step2DefaultsSet = false;
    _this.step3DefaultsSet = false;

    // - Prevents progress to the next step if the step is being edited.
    _this.stepIsBeingEdited = false;

    // Steps
    _this.steps = document.querySelectorAll(_this.selectors.steps);
    _this.stepsStates = document.querySelectorAll(_this.selectors.stepsStates);
    _this.stepsContents = document.querySelectorAll(_this.selectors.stepsContents);
    _this.stepsSelections = document.querySelectorAll(_this.selectors.stepsSelections);
    _this.step = {
      1: {
        step: _this.steps[0],
        state: _this.stepsStates[0],
        content: _this.stepsContents[0],
        selection: _this.stepsSelections[0]
      },
      2: {
        step: _this.steps[1],
        state: _this.stepsStates[1],
        content: _this.stepsContents[1],
        selection: _this.stepsSelections[1]
      },
      3: {
        step: _this.steps[2],
        state: _this.stepsStates[2],
        content: _this.stepsContents[2],
        selection: _this.stepsSelections[2]
      }
    };
    _this.state = {
      active: {
        1: true,
        2: false,
        3: false
      },
      observers: {}
    };

    // Classes

    _this.classes = {
      stepsStates: {
        active: "bike-builder-content__state--active",
        complete: "bike-builder-content__state--complete"
      },
      steps: {
        active: "bike-builder-content__step--active",
        complete: "bike-builder-content__step--complete"
      },
      submit: {
        disabled: "bike-builder-button--disabled"
      }
    };
    _this.currencySymbol = window.Shopify.currency.symbol;
    _this.init();
    return _this;
  }

  /**
   * Initialises the Bike Builder..
   */
  _inherits(ProductBikeBuilder, _HTMLElement);
  return _createClass(ProductBikeBuilder, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.initSliders();
      this.initialiseStep1();
      this.observeSteps();
      this.handleEdits();
      this.handleResets();
      this.handleAvailTriggers();
      this.handleInfoTriggers();
      this.scrollToActiveStep();
      this.initFormSubmission();
      this.hideEmptyStepItems();
      this.checkURLForVariant();
      this.bikeBuilderBlocks.forEach(function (el) {
        el.addEventListener("click", function () {
          return _this2.changeBikeBuilderProduct(el);
        });
      });
      this.frameOptions.forEach(function (el) {
        el.addEventListener("click", function () {
          _this2.updateVariantAvailability(el);
          _this2.changeFrameOption(el);
          console.log("here", _this2.properties.variantId.value);
        });
      });
      this.handleContentScroll();
      if (this.wheelbaseInputFront && this.wheelbaseInputBack) {
        this.populateWheelbaseInput();
      }
    }
  }, {
    key: "checkURLForVariant",
    value: function checkURLForVariant() {
      if (window.location.search.includes("variant=")) {
        var allDefaults = document.querySelectorAll(".default");
        allDefaults.forEach(function (block) {
          block.classList.add("active");
        });
      } else {
        // If there is no variant we want to see if there is nothing in the customise step and then just add active class to all defaults
        var step2Element = document.querySelector('.bike-builder-content__step[data-bike-builder-step="2"]');
        if (step2Element) {
          var stepItems = step2Element.querySelectorAll(".bike-builder-content__step-item");
          var emptyCount = 0;
          stepItems.forEach(function (stepItem) {
            if (stepItem.innerHTML.trim() === "") {
              emptyCount++;
            }
          });
          if (emptyCount === stepItems.length) {
            var _allDefaults = document.querySelectorAll(".default");
            _allDefaults.forEach(function (block) {
              block.classList.add("active");
            });
          } else {
            console.log("Not all step items are empty.");
          }
        }
      }
    }

    /**
     * Checks whether or not all steps have been completed, if they have
     * then the submit button is enabled.
     */
  }, {
    key: "isReadyToSubmit",
    value: function isReadyToSubmit() {
      var completedSteps = 0;
      this.steps.forEach(function (step) {
        step = parseInt(step.dataset.bikeBuilderStep);
        var productOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(step, "\"] [data-product-option-list]"));
        var checkedOptions;
        if (step === 1) {
          checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(step, "\"] input[data-product-option]:checked"));
        } else {
          checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(step, "\"] .bike-builder-block.active"));
        }
        if (checkedOptions.length === productOptions.length) ++completedSteps;
      });
      if (completedSteps === 3) {
        this.submit.disabled = false;
        this.submit.classList.remove(this.classes.submit.disabled);
        this.submit.value = window.bikeBuilderStrings.submit.add;
      } else {
        this.submit.disabled = true;
        this.submit.classList.add(this.classes.submit.disabled);
        this.submit.value = window.bikeBuilderStrings.submit.select;
      }
    }

    /**
     * Clones a chosen element and removes all height restrictions
     * from the clone to get the elements actual height - used when a step
     * is closed and we need to re-open it, the result of this method is what's
     * applied to the content of a step to make it appear as thought it's opening.
     *
     * @param {*} el
     * @returns
     */
  }, {
    key: "getHiddenHeight",
    value: function getHiddenHeight(el) {
      if (!(el !== null && el !== void 0 && el.cloneNode)) {
        return null;
      }
      var clone = el.cloneNode(true);
      Object.assign(clone.style, {
        overflow: "visible",
        height: "auto",
        maxHeight: "none",
        opacity: "0",
        visibility: "hidden",
        display: "block"
      });

      // Prevents inputs being registered inside the form.
      var inputs = clone.querySelectorAll("input");
      inputs.forEach(function (input) {
        input.name = "null";
        input.id = "null";
      });
      el.after(clone);
      var height = clone.offsetHeight + 10;
      clone.remove();
      return height;
    }

    /**
     * Takes in two parameters, the first stepsToReset, resets each step
     * to it's initial state - closed and inactive. This should be an
     * array so you can reset multiple steps if you want to. The last
     * parameter, setActiveStep, takes a single interger value - which
     * should correspond to a step, that step value will be set as the active
     * step.
     *
     * @param {*} stepsToReset
     * @param {*} setActiveStep
     */
  }, {
    key: "resetSteps",
    value: function resetSteps(stepsToReset, setActiveStep) {
      var _this3 = this;
      // Reset chosen steps
      stepsToReset.forEach(function (step) {
        step = parseInt(step);
        if (step === 1) {
          var options = document.querySelectorAll("[data-bike-builder-step=\"".concat(step, "\"] input[data-product-option]"));
          options.forEach(function (option) {
            // Clear checked inputs...
            if (option.checked) option.checked = false;
          });

          // Resets Variant/Frame title in price area...
          _this3.priceFrameTitle.textContent = window.bikeBuilderStrings.price.framePrompt;
        } else {
          var activeOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(step, "\"] .bike-builder-block.active"));
          activeOptions.forEach(function (option) {
            return option.classList.remove("active");
          });
        }

        // Reset Styles
        _this3.step[step].state.classList.remove(_this3.classes.stepsStates.complete);
        _this3.step[step].step.classList.remove(_this3.classes.steps.complete);
        _this3.step[step].state.classList.remove(_this3.classes.stepsStates.active);
        _this3.step[step].step.classList.remove(_this3.classes.steps.active);

        // Reset Selections (2/3 Only)
        if (step === 2) _this3.step[2].selection.innerHTML = "";
        if (step === 3) _this3.step[3].selection.innerHTML = "";

        // Hide the content
        _this3.step[step].content.style.maxHeight = null;

        // Update global state object
        _this3.state.active[step] = false;

        // Price Area Changes
        // Update the total price of the extras area...
        var extrasTotal = 0;
        var extraProducts = document.querySelectorAll(_this3.selectors.extra);
        extraProducts.forEach(function (product) {
          var extraAssociatedStep = parseInt(product.dataset.attrStep);
          if (extraAssociatedStep === step) {
            product.remove();
          } else {
            extrasTotal = extrasTotal + parseInt(product.dataset.attrPrice);
          }
        });

        // Set the price of the extras area.
        _this3.extrasTotal.textContent = Shopify.formatMoney(extrasTotal, "".concat(_this3.currencySymbol, "{{ amount}}"));

        // Calulate total by adding the extras total and the frame total together...
        var originalTotal = _this3.total.dataset.attrPrice;
        var newTotal = parseInt(extrasTotal) + parseInt(originalTotal);
        _this3.total.textContent = Shopify.formatMoney(newTotal, "".concat(_this3.currencySymbol, "{{ amount}}"));
        if (document.querySelectorAll(".monthly") !== null) {
          var monthly = (newTotal * 0.9 * 1.149 / 2400).toFixed(0) * 100;
          console.log(monthly);
          var all_monthly_el = document.querySelectorAll(".monthly");
          all_monthly_el.forEach(function (monthly_el) {
            monthly_el.textContent = Shopify.formatMoney(monthly, "".concat(_this3.currencySymbol, "{{ amount}}"));
          });
        }
        _this3.additionalTotals.forEach(function (additionalTotal) {
          additionalTotal.textContent = Shopify.formatMoney(newTotal, "".concat(_this3.currencySymbol, "{{ amount}}"));
        });

        // Remove the editing status.
        _this3.stepIsBeingEdited = false;

        // Remove the defaults set status.
        _this3.step2DefaultsSet = false;
        _this3.step3DefaultsSet = false;

        // Check if the customiser is in a fully completed state.
        _this3.isReadyToSubmit();
      });

      // Provide active functionality to the active step
      //
      // Reset Step to Initial Load
      this.state.active[setActiveStep] = true;

      // Reset Step to Initial Load
      this.step[setActiveStep].state.classList.remove(this.classes.stepsStates.complete);
      this.step[setActiveStep].step.classList.remove(this.classes.steps.complete);
      this.step[setActiveStep].state.classList.add(this.classes.stepsStates.active);
      this.step[setActiveStep].step.classList.add(this.classes.steps.active);
      this.step[setActiveStep].content.style.maxHeight = "".concat(this.getHiddenHeight(this.step[setActiveStep].content), "px");

      // Observe Step
      this.state.observers[setActiveStep].observe(this.step[setActiveStep].step, this.observeConfig);
    }

    /**
     * Attatches click events to each edit tool, each edit tool
     * has its associated step number on it as a data attribute. This is utilised
     * to determine which steps to reset and make active.
     */
  }, {
    key: "handleEdits",
    value: function handleEdits() {
      var _this4 = this;
      this.edits.forEach(function (edit) {
        edit.addEventListener("click", function () {
          // Target references the edit tools target, so if this edit tool was in Step 1, it'd return 1
          var step = parseInt(edit.dataset.bikeBuilderEditStep);

          // Set the step's state to active.
          _this4.state.active[step] = true;

          // Set the active styling
          _this4.step[step].state.classList.remove(_this4.classes.stepsStates.complete);
          _this4.step[step].step.classList.remove(_this4.classes.steps.complete);
          _this4.step[step].state.classList.add(_this4.classes.stepsStates.active);
          _this4.step[step].step.classList.add(_this4.classes.steps.active);

          // Open the steps content
          _this4.step[step].content.style.maxHeight = "".concat(_this4.getHiddenHeight(_this4.step[step].content), "px");

          // Observe Step
          _this4.state.observers[step].observe(_this4.step[step].step, _this4.observeConfig);
          _this4.stepIsBeingEdited = true;
        });
      });
    }

    /**
     * Attatches click events to reset tools, this will
     * reset all steps and move the user back to the first step.
     */
  }, {
    key: "handleResets",
    value: function handleResets() {
      var _this5 = this;
      this.resets.forEach(function (reset) {
        reset.addEventListener("click", function () {
          _this5.resetSteps([1, 2, 3], 1);
        });
      });
    }

    /**
     * Goes either forward or backwards to the next
     * chosen step, currentStep will of course require
     * information about the users current step - while
     * direction will tell the method which method to run
     * to either go 'backward' or 'forward' in the chain
     * of steps.
     *
     * @param {*} currentStep
     * @param {*} direction
     */
  }, {
    key: "changeStep",
    value: function changeStep(currentStep, direction) {
      var nextStep = direction === "backward" ? currentStep - 1 : currentStep + 1;
      if (direction === "backward") this.moveBackward(currentStep, nextStep);
      if (direction === "forward") this.moveForward(currentStep, nextStep);

      // Check if the customiser is in a fully completed state.
      this.isReadyToSubmit();
    }

    /**
     * This advance the user forward a step, but only
     * if the amount of selected options in their current step
     * is equal to the amount of options that can be selected.
     *
     * @param {*} currentStep
     * @param {*} nextStep
     */
  }, {
    key: "moveForward",
    value: function moveForward(currentStep, nextStep) {
      /**
       * If the amount of checked inputs is equal to the amount
       * of product options for that step, progress to the previous step.
       *
       * checkedOptions changes depending on currentStep because of how Step 1 is built, Step 1 uses inputs
       * instead of div elements with class definitions, so we switch between them depending on the currentStep.
       */

      var productOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(currentStep, "\"] [data-product-option-list]"));
      var checkedOptions;
      if (currentStep === 1) {
        checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(currentStep, "\"] input[data-product-option]:checked"));
      } else {
        checkedOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(currentStep, "\"] .bike-builder-block.active"));
      }
      if (checkedOptions.length === productOptions.length) {
        // Stop observing the current step.
        this.state.observers[currentStep].disconnect();

        // Reconfigure Current Step Styling
        if (currentStep != 3) this.step[currentStep].state.classList.remove(this.classes.stepsStates.active);
        if (currentStep != 3) this.step[currentStep].state.classList.add(this.classes.stepsStates.complete);
        if (currentStep != 3) this.step[currentStep].step.classList.remove(this.classes.steps.active);
        if (currentStep != 3) this.step[currentStep].step.classList.add(this.classes.steps.complete);
        if (nextStep <= 3 && this.stepIsBeingEdited === false) {
          // Reconfigure Next Step Styling
          this.step[nextStep].state.classList.add(this.classes.stepsStates.active);
          this.step[nextStep].step.classList.add(this.classes.steps.active);
        }

        // Update global state object
        this.state.active[currentStep] = false;
        if (nextStep <= 3 && this.stepIsBeingEdited === false) this.state.active[nextStep] = true;

        // Hide the previous content, reveal the next content
        if (currentStep != 3) this.step[currentStep].content.style.maxHeight = null;
        if (nextStep <= 3 && this.stepIsBeingEdited === false) this.step[nextStep].content.style.maxHeight = "".concat(this.getHiddenHeight(this.step[nextStep].content), "px");

        // Start observing the next step.
        if (nextStep <= 3 && this.stepIsBeingEdited === false) this.state.observers[nextStep].observe(this.step[nextStep].step, this.observeConfig);

        // For Step 2 we preselect all defaults and populate the step immediately.
        if (currentStep === 1 && this.step2DefaultsSet === false) {
          var step2Groups = document.querySelectorAll("[data-bike-builder-step=\"2\"] [data-product-option-list]");
          var step2Defaults = document.querySelectorAll("[data-bike-builder-step=\"2\"] ".concat(this.selectors.frameDefaults));
          if (step2Defaults.length === step2Groups.length) {
            step2Defaults.forEach(function (step2Default) {
              step2Default.click();
            });
            this.step2DefaultsSet = true;
          }
        }

        // For Step 3 we preselect all defaults and populate the step immediately,
        // however, we prevent it from automatically closing
        if (currentStep === 2 && this.step3DefaultsSet === false) {
          var step3Groups = document.querySelectorAll("[data-bike-builder-step=\"3\"] [data-product-option-list]");
          var step3Defaults = document.querySelectorAll("[data-bike-builder-step=\"3\"] ".concat(this.selectors.frameDefaults));
          if (step3Defaults.length === step3Groups.length) {
            step3Defaults.forEach(function (step3Default) {
              step3Default.click();
            });
            this.step3DefaultsSet = true;
          }
        }
      }
    }

    /**
     * This will move the user back a step, regardless
     * of the currentStep's chosen options, which will be
     * cleared in the progress of moving backwards.
     *
     * @param {*} currentStep
     * @param {*} prevStep
     */
  }, {
    key: "moveBackward",
    value: function moveBackward(currentStep, prevStep) {
      // Stop observing the current step.
      this.state.observers[currentStep].disconnect();

      // Reset the choices made in the currentStep
      var activeOptions = document.querySelectorAll("[data-bike-builder-step=\"".concat(currentStep, "\"] .bike-builder-block.active"));
      activeOptions.forEach(function (option) {
        return option.classList.remove("active");
      });

      // Reconfigure Current Step Styling
      if (currentStep != 3) this.step[currentStep].state.classList.remove(this.classes.stepsStates.active);
      if (currentStep != 3) this.step[currentStep].step.classList.remove(this.classes.steps.active);

      // Reconfigure Next Step Styling
      if (prevStep <= 3) {
        this.step[prevStep].state.classList.add(this.classes.stepsStates.active);
        this.step[prevStep].state.classList.remove(this.classes.stepsStates.complete);
        this.step[prevStep].step.classList.add(this.classes.steps.active);
        this.step[prevStep].step.classList.remove(this.classes.steps.complete);
      }

      // Update global state object
      this.state.active[currentStep] = false;
      if (prevStep >= 1) this.state.active[prevStep] = true;

      // Hide the previous content, reveal the previous content
      if (currentStep != 3) this.step[currentStep].content.style.maxHeight = null;
      if (prevStep >= 1) this.step[prevStep].content.style.maxHeight = "".concat(this.getHiddenHeight(this.step[prevStep].content), "px");

      // Start observing the previous step.
      if (prevStep >= 1) this.state.observers[prevStep].observe(this.step[prevStep].step, this.observeConfig);
    }

    /**
     * This attatches a MutationObserver to each available step,
     * the MutationObserver is only observer when the user moves to it
     * by way of other methods. These MutationObservers are stored
     * inside of this.state.observers for later access and manipulation.
     *
     * The callback function fires when the currentStep undergoes a change,
     * changeStep will complete its functionality if that currentStep has
     * all of its available options checked.
     */
  }, {
    key: "observeSteps",
    value: function observeSteps() {
      var _this6 = this;
      // Callback function to execute when mutations are observed
      var callback = function callback(mutationList) {
        var _iterator = _createForOfIteratorHelper(mutationList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _mutation$target, _mutation$target2;
            var mutation = _step.value;
            if ((mutation.attributeName == "class" || mutation.attributeName == "name") && mutation.target != _this6.sizeGuide && !((_mutation$target = mutation.target) !== null && _mutation$target !== void 0 && _mutation$target.className.includes("slick-slide")) && !((_mutation$target2 = mutation.target) !== null && _mutation$target2 !== void 0 && (_mutation$target2 = _mutation$target2.parentElement) !== null && _mutation$target2 !== void 0 && _mutation$target2.className.includes("slick-dots")) && _this6.mouseIsDragging === false) {
              var step = mutation.target.closest("[data-bike-builder-step]");
              var currentStep = parseInt(step.dataset.bikeBuilderStep);
              console.warn("Step ".concat(currentStep, " has undergone a change..."));

              // If this change occured in the currently active
              // step, then progress.
              if (_this6.state.active[currentStep] === true) {
                _this6.changeStep(currentStep, "forward");
                break;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      // Create a mutation observer for each step.
      this.steps.forEach(function (step, index) {
        // Create an observer instance linked to the callback function
        // for every section there is.
        Object.assign(_this6.state.observers, _defineProperty({}, "".concat(index + 1), new MutationObserver(callback)));

        // Start observing the target node for configured mutations
      });

      // Begin observering the first step.
      this.state.observers[1].observe(this.step[1].step, this.observeConfig);
    }

    /**
     * This automatically reveals Step 1 on page load,
     * and disables all available options that are not
     * option1 options. These options are renabled as soon
     * as a choice is made on each option level.
     */
  }, {
    key: "initialiseStep1",
    value: function initialiseStep1() {
      var content = this.step[1].content;
      content.style.maxHeight = "".concat(this.getHiddenHeight(content), "px");

      // Disable all options except inputs representing option 1
      for (var i = 0; i < this.frameOptions.length; i++) {
        var input = this.frameOptions[i];
        var optionPosition = input.dataset.productOption;
        if (optionPosition === "1") continue;
        /**
         * If the colour is completely sold out in every possible size,
         * then hide the swatch from view.
         */
        if (input.hasAttribute("data-product-option-colour")) {
          var colour = input.value;
          var colourIsAvailable = false;
          for (var _i = 0; _i < this.product.variants.length; _i++) {
            var variant = this.product.variants[_i];
            if (variant["option".concat(optionPosition)] === colour) {
              if (variant.available) {
                colourIsAvailable = true;
              }
            }
          }
          if (!colourIsAvailable) {
            var item = input.closest("li");
            item.style.display = "none";
          }
        }
      }
    }

    /**
     * Each swatch needs to update its variant availability as the
     * user clicks and chooses different swatches, because we need to apply
     * out of stock/in stock styles to each swatch depending on its combinations
     * availability.
     *
     * @param {*} event
     */
  }, {
    key: "updateVariantAvailability",
    value: function updateVariantAvailability(chosenSwatch) {
      var chosenPosition = chosenSwatch.dataset.productOption;
      var relevantVariants = [];

      /**
       * Gets variants that are associated with the current
       * selection - so if the user just selected a coat in
       * 'Fern', it'll find all variants that share that
       * colour as an option.
       */

      for (var i = 0; i < this.product.variants.length; i++) {
        var variant = this.product.variants[i];

        /**
         * What we're doing here is: getting the option.position value
         * from the variant we just selected. That option.position value
         * is then used to find variants in product.variants that also
         * have the value of the swatch that was just selected. So if
         * we clicked size 12 which was associated with variant.option1
         * - then we find all variants that have variant.option1 set
         * to 12.
         */
        var variantMatchedOptions = variant["option".concat(chosenPosition)];
        if (variantMatchedOptions == chosenSwatch.value) {
          relevantVariants.push(variant);
        }
      }

      /* Loop over the relevant variants... */
      for (var _i2 = 0; _i2 < relevantVariants.length; _i2++) {
        var _variant = relevantVariants[_i2];

        /**
         * Loop over that relevant variants available options,
         * there can only be 3 of these, so we loop three times.
         */
        for (var _i3 = 1; _i3 < 4; _i3++) {
          /* Find those options as swatches. */
          var optionName = _variant["option".concat(_i3)];

          // If option2 or option 3 are empty, skip - there won't be a swatch to find.
          if (optionName === null || optionName == chosenSwatch.value) continue;
          var optionPosition = _i3;
          var handleizedName = optionName.toLowerCase().replace(/ /g, "-");
          var input = document.querySelector("#Option-".concat(handleizedName, "-").concat(optionPosition));
          if (input !== null) {
            var swatch = input.parentElement;
            if (_variant.available) {
              swatch.classList.remove("is-sold-out");
              input.disabled = false;
            } else {
              swatch.classList.add("is-sold-out");
              input.disabled = true;
            }
          }
        }
      }
    }

    /**
     * Updates the relevant inputs properties to
     * set the main bike frame variant
     */
  }, {
    key: "changeFrameOption",
    value: function changeFrameOption(el) {
      var step = el.closest("[data-bike-builder-step]");
      var option1 = step.querySelector('input[data-product-option="1"]:checked');
      var option2 = step.querySelector('input[data-product-option="2"]:checked');
      var option3 = step.querySelector('input[data-product-option="3"]:checked');

      // Update Step Selection Area
      if (option1) this.step[1].selection.querySelector('[data-attr-option-position="1"] .js-bike-builder-step-selection-choice').textContent = option1.value;
      if (option2) this.step[1].selection.querySelector('[data-attr-option-position="2"] .js-bike-builder-step-selection-choice').textContent = option2.value;
      if (option3) this.step[1].selection.querySelector('[data-attr-option-position="3"] .js-bike-builder-step-selection-choice').textContent = option3.value;
      var options = [option1, option2, option3].filter(function (n) {
        return n;
      });
      var title = "";
      options.forEach(function (option, index) {
        var optionsIndex = options.length - 1;
        if (option) title = title.concat(option.value);
        if (index !== optionsIndex) title = title.concat(" / ");
      });
      var variant = this.product.variants.filter(function (variant) {
        return variant.title === title;
      });
      if (variant.length > 0) {
        // Updates properties...
        this.properties.variantId.name = "items[0]properties[_bundleProduct_".concat(variant[0].id, "]");
        this.properties.variantTitle.value = variant[0].title;
        this.updatePreorderStatus(variant[0]);
        console.warn("Frame Chosen: ".concat(variant[0].title), variant);

        // Updates Variant/Frame title in price area...
        this.priceFrameTitle.textContent = " / ".concat(variant[0].title);

        // SOMETIMES THERE ARE ITEMS LIKE SINGLE FRAMES THAT DON'T HAVE CUSTOMISE OPTIONS
        // WHAT WE'RE GOING TO DO IS CHECK IF THERE ARE ANY OPTIONS TO CUSTOMISE, IF NOT
        // THEN WE'LL JUST PROGRESS TO THE NEXT STEP.

        // WE NEED TO CHECK IF THERE ARE HIDDEN FRAMES
        // IF THERE ARE WE NEED TO TRY AND SELECT A MATCHING COLOUR
        if (document.querySelector('.bike-builder-group[data-attr-group="Fork"]') !== null) {
          var fork_group = document.querySelector('.bike-builder-group[data-attr-group="Fork"]');
          var fork_colour = fork_group.querySelector('.bike-builder-block[data-variant-title="' + variant[0].option2 + '"]');
          console.log('.bike-builder-block[data-variant-title="' + variant[0].option2 + '"]');
          console.log(fork_colour);
          if (fork_colour !== null) {
            console.log("Fork Colour Found");
            fork_colour.click();
            setTimeout(function () {
              fork_colour.click();
            }, 300);
          }
          console.log(variant[0].option2);
        }
      } else {
        console.warn("Variant not found, or selection incomplete...");
      }

      // Prevents options from overflowing...
      var stepIndex = step.dataset.bikeBuilderStep;
      var content = this.step[stepIndex].content;
      content.style.maxHeight = "6000px";
    }
  }, {
    key: "updatePreorderStatus",
    value: function updatePreorderStatus(variant) {
      this.preorderVariant.value = variant.id;
      this.preorderVariant.setAttribute("data-selected-variant", JSON.stringify(variant));
      var event = new Event("change");
      this.preorderVariant.dispatchEvent(event);
    }
  }, {
    key: "changeBikeBuilderProduct",
    value: function changeBikeBuilderProduct(el) {
      var _this7 = this;
      var productRow = el.closest("[data-product-option-list]");
      var productProperties = productRow.querySelector(".product-properties");
      var productBlocks = productRow.querySelectorAll(this.selectors.bikeBuilderBlocks);

      // Toggle active state on the selected block
      productBlocks.forEach(function (block) {
        block.classList.toggle("active", block === el);
      });
      var productId = el.dataset.attrId;
      var productTitle = el.dataset.attrTitle;
      var productPrice = el.getAttribute("data-attr-price");
      var productGroup = el.closest(".bike-builder-group").dataset.attrGroup;
      var associatedStep = parseInt(el.closest(".js-bike-builder-step").dataset.bikeBuilderStep);
      var classList = el.classList;
      var isDefault = el.classList.contains("default");
      var rowIndex = isDefault ? 0 : el.closest(".bike-builder-content__step-item").dataset.rowIndex;
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");

      // Remove pre-existing extras if a extra inside a active group is changed.
      var currentExtra = this.extrasArea.querySelector("div[data-attr-group=\"".concat(productGroup, "\"]"));
      if (currentExtra) currentExtra.remove();

      // Add Selections
      var currentSelectionPrexists = this.step[associatedStep].selection.querySelector("[data-selection-attr-group=\"".concat(productGroup, "\"]"));
      if (currentSelectionPrexists) {
        currentSelectionPrexists.innerHTML = "\n        <p class=\"bike-builder-content__step-selection-group\">\n          ".concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n        </p>\n      ");
      } else {
        this.step[associatedStep].selection.insertAdjacentHTML("beforeend", "\n          <li\n            class=\"bike-builder-content__step-selection-item\"\n            data-selection-attr-group=\"".concat(productGroup, "\"\n          >\n            <p class=\"bike-builder-content__step-selection-group\">\n              ").concat(productGroup, ": <span class=\"bike-builder-content__step-selection-choice js-bike-builder-step-selection-choice\">").concat(productTitle, "</span>\n            </p>\n          </li>\n        "));
      }

      // IF THE CLASSLIST DOESN'T CONTAIN DEFAULT THEN WE SHOW IT AT THE BOTTOM AS AN EXTRA
      if (!isDefault) {
        // Add Extras
        this.extrasArea.insertAdjacentHTML("beforeend", "\n        <div\n          class=\"price-row js-bike-builder-extra\"\n          data-attr-row=\"".concat(rowIndex, "\"\n          data-attr-price=\"").concat(productPrice, "\"\n          data-attr-group=\"").concat(productGroup, "\"\n          data-attr-step=\"").concat(associatedStep, "\"\n          style=\"order: ").concat(rowIndex, "\"\n        >\n          <div class=\"desc\">\n            ").concat(productTitle, "\n          </div>\n          <div class=\"price\">\n            +").concat(Shopify.formatMoney(productPrice, "".concat(this.currencySymbol, "{{ amount}}")), "\n          </div>\n        </div>\n      "));
      }

      // Update the total price of the extras area...
      var extrasTotal = 0;
      var extraProducts = document.querySelectorAll(this.selectors.extra);
      extraProducts.forEach(function (product) {
        extrasTotal = extrasTotal + parseInt(product.dataset.attrPrice);
      });

      // Set the price of the extras area.
      this.extrasTotal.textContent = Shopify.formatMoney(extrasTotal, "".concat(this.currencySymbol, "{{ amount}}"));

      // Calulate total by adding the extras total and the frame total together...
      var originalTotal = this.total.dataset.attrPrice;
      var newTotal = parseInt(extrasTotal) + parseInt(originalTotal);
      this.total.textContent = Shopify.formatMoney(newTotal, "".concat(this.currencySymbol, "{{ amount}}"));
      this.additionalTotals.forEach(function (additionalTotal) {
        additionalTotal.textContent = Shopify.formatMoney(newTotal, "".concat(_this7.currencySymbol, "{{ amount}}"));
      });
      if (document.querySelectorAll(".monthly") !== null) {
        var monthly = (newTotal * 0.9 * 1.149 / 2400).toFixed(0) * 100;
        var all_monthly_el = document.querySelectorAll(".monthly");
        all_monthly_el.forEach(function (monthly_el) {
          monthly_el.textContent = Shopify.formatMoney(monthly, "".concat(_this7.currencySymbol, "{{ amount_no_decimals }}"));
        });
      }

      // Generate properties HTML
      var inputs = [];
      var defaultInputs = ["<input id=\"bundleProduct_".concat(productId, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(productId, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
      var extraInputs = ["<input type=\"hidden\" name=\"items[".concat(rowIndex, "]id\" value=\"").concat(productId, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_parentLineItem]\" value=\"").concat(productGroup, "___").concat(primaryParentLineItem.value, "\" />"), "<input type=\"hidden\" name=\"items[".concat(rowIndex, "]properties[_bikeComponent]\" value=\"true\" />")];
      if (isDefault) {
        inputs.push.apply(inputs, defaultInputs);
      } else {
        inputs.push.apply(inputs, extraInputs);

        // Set Product Count
        this.productCount = document.querySelector(this.selectors.productCount);
        var newProductCountValue = 0;
        this.bikeBuilderGroups.forEach(function (group) {
          var activeChoice = group.querySelector(".active");
          if (activeChoice) ++newProductCountValue;
        });
        this.productCount.value = newProductCountValue;
      }
      // Special handling for Wheelsets (adds multiple bundle inputs)
      var isWheelset = productGroup === "Wheels";
      if (isWheelset) {
        var wheelbaseSkus = el.getAttribute("data-wheelbase-skus");
        if (wheelbaseSkus) {
          var wheelSplit = wheelbaseSkus.split(", ");
          var _wheelSplit = _slicedToArray(wheelSplit, 2),
            frontSku = _wheelSplit[0],
            backSku = _wheelSplit[1];
          var baseWheelInputs = ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[0]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />"), "<input id=\"defaultComponent_".concat(productGroup, "\" type=\"text\" name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\" value=\"").concat(productTitle, "\" />"), "<input type=\"hidden\" name=\"items[0]properties[_bikeComponent]\" value=\"true\" />"];
          inputs.length = 0; // Reset to override completely
          if (isDefault) {
            inputs.push.apply(inputs, baseWheelInputs);
          }
          if (!isDefault) {
            var wheelExtras = [].concat(extraInputs, ["<input id=\"bundleProduct_".concat(frontSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(frontSku, "]\" value=\"1\" />"), "<input id=\"bundleProduct_".concat(backSku, "\" type=\"text\" name=\"items[").concat(rowIndex, "]properties[_bundleProduct_").concat(backSku, "]\" value=\"1\" />")]);
            inputs.push.apply(inputs, _toConsumableArray(wheelExtras));
          }
        }
      }
      productProperties.innerHTML = inputs.join("\n");
    }

    /**
     * Stamps the build with a fresh, unique parent line-item id before the form
     * submits (the builder adds via a native submit, not AJAX).
     */
  }, {
    key: "initFormSubmission",
    value: function initFormSubmission() {
      var _this8 = this;
      this.bikeBuilderForm.addEventListener("submit", function (e) {
        e.preventDefault();
        if (_this8.submitting) return;
        _this8.submitting = true;
        _this8.refreshBikeBuildId();
        var bikeVariant = (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.getSelectedFrameVariant)(_this8.product);
        (0,_bike_builder_ga4__WEBPACK_IMPORTED_MODULE_1__.emitBikeAddedToCart)({
          itemId: _this8.dataset.bikeProductId || (bikeVariant ? bikeVariant.id : _this8.product && _this8.product.id),
          itemName: _this8.dataset.bikeProductTitle || _this8.product && _this8.product.title,
          itemVariant: bikeVariant && bikeVariant.title
        });
        var form = _this8.bikeBuilderForm;
        window.setTimeout(function () {
          return form.submit();
        }, 200);
      });
    }

    /**
     * Stamps the build with a fresh, unique parent line-item id on every submit.
     *
     * Each build groups its component line items to its frame via a parent id:
     * the frame carries `_primaryParentLineItem` and every component carries
     * `_parentLineItem` = `<GROUP>___<id>`. That id is seeded server-side from
     * `{{ "now" | date: "%s" }}` (#primaryParentLineItem).
     *
     * The builder adds via a native form submit (no AJAX), so the customer
     * usually returns to it via the browser back/forward cache or a CDN-cached
     * render. In that case the seed is frozen and a second bike submits with the
     * SAME id as the first — the two builds then share a parent id, their
     * components become indistinguishable, and the cart's bundle grouping /
     * removal logic cross-links them, stripping the first bike's options.
     *
     * Re-minting the id here, client-side at submit time, guarantees each added
     * bike gets a distinct parent id regardless of how the page was cached. (The
     * legacy `checkBikeBuilder()` increment in cart.js only runs on the AJAX add
     * path, which the bike builder never uses.)
     */
  }, {
    key: "refreshBikeBuildId",
    value: function refreshBikeBuildId() {
      var primaryParentLineItem = document.querySelector("#primaryParentLineItem");
      if (!primaryParentLineItem) return;
      var uniqueId = "".concat(Date.now()).concat(Math.floor(Math.random() * 1000));

      // Re-point every component line at the new id (value is "<GROUP>___<id>").
      document.querySelectorAll('input[name$="[_parentLineItem]"]').forEach(function (input) {
        var group = input.value.split("___")[0];
        input.value = "".concat(group, "___").concat(uniqueId);
      });
      primaryParentLineItem.value = uniqueId;
    }

    /**
     * Generates a slick slider for each product row in steps 2 and 3.
     */
  }, {
    key: "initSliders",
    value: function initSliders() {
      var _this9 = this;
      // CHECK FOR DUPLICATES
      var all_defaults = document.querySelectorAll(".bike-builder-block.default");
      all_defaults.forEach(function (default_item) {
        var get_id = default_item.dataset.attrId;
        var find_duplicates = document.querySelectorAll(".bike-builder-block[data-attr-id=\"".concat(get_id, "\"]:not(.default)"));
        if (find_duplicates.length > 0) {
          find_duplicates.forEach(function (duplicate) {
            duplicate.closest(".bike-builder-block-wrapper").remove();
          });
        }
      });
      this.initScrollBar();
      var delta = 6;
      var startX;
      var startY;
      document.body.addEventListener("mousedown", function (event) {
        startX = event.pageX;
        startY = event.pageY;
      });
      document.body.addEventListener("mouseup", function (event) {
        var diffX = Math.abs(event.pageX - startX);
        var diffY = Math.abs(event.pageY - startY);
        if (diffX < delta && diffY < delta) {
          _this9.mouseIsDragging = false;
        } else {
          _this9.mouseIsDragging = true;
        }
      });
    }
  }, {
    key: "initScrollBar",
    value: function initScrollBar() {
      this.bikeBuilderGroups.forEach(function (group) {
        var uniqueId = group.dataset.attrGroup;

        // Get elements
        var $content = $(group).parents(".bike-builder-row");
        var $slides = $(group).children();
        var $scrollbar = $("[data-attr-scrollbar-group=\"".concat(uniqueId, "\"]"));
        var $thumb = $("[data-attr-scrollbar-thumb-group=\"".concat(uniqueId, "\"]"));
        var $prevBtn = $("[data-attr-prev-btn=\"".concat(uniqueId, "\"]"));
        var $nextBtn = $("[data-attr-next-btn=\"".concat(uniqueId, "\"]"));

        // Define initial constants and variables
        var slideWidth = $($slides[0]).outerWidth(true);
        var slidesToShow = 3;
        var totalSlides = $slides.length;
        var isDragging = false;
        var currentSlide = 0;
        var isGoToSlide = false;
        function checkOverflow() {
          $content[0].scrollWidth > $content[0].clientWidth ? $scrollbar.show() : $scrollbar.hide();
        }
        function updateButtons() {
          if ($(window).width() >= 768) {
            currentSlide <= 0 ? $prevBtn.hide() : $prevBtn.show();
            currentSlide >= totalSlides - slidesToShow ? $nextBtn.hide() : $nextBtn.show();
          }
        }
        function updateSlideVisibility() {
          $slides.each(function (index, slide) {
            var slideLeft = $(slide).position().left;
            var visibleWidth = Math.min(slideWidth, $content.width() - slideLeft, slideLeft + slideWidth);
            $(slide).css("opacity", visibleWidth >= 0.7 * slideWidth ? 1 : 0.5);
          });
        }
        function updateThumbPosition() {
          var scrollRatio = $content.scrollLeft() / ($content[0].scrollWidth - $content[0].clientWidth);
          $thumb.css("left", scrollRatio * ($scrollbar.width() - $thumb.width()));
        }
        function updateCurrentSlide() {
          var viewportCenter = $content.scrollLeft() + $content.width() / 2;
          var closestDistance = Infinity;
          var mostCenterLeftSlideIndex = 0;
          for (var i = 0; i < totalSlides; i++) {
            var slideCenter = i * slideWidth + slideWidth / 2;
            if (slideCenter <= viewportCenter && viewportCenter - slideCenter < closestDistance) {
              closestDistance = viewportCenter - slideCenter;
              mostCenterLeftSlideIndex = i;
            }
          }
          currentSlide = mostCenterLeftSlideIndex === 1 && $content.scrollLeft() <= slideWidth ? 0 : Math.min(mostCenterLeftSlideIndex, totalSlides - slidesToShow);
        }
        function goToSlide(slideIndex) {
          slideIndex = Math.max(0, Math.min(slideIndex, totalSlides - slidesToShow));
          $content.scrollLeft(slideIndex * slideWidth);
          currentSlide = slideIndex;
          isGoToSlide = true;
        }
        function startDrag(e) {
          isDragging = true;
          var startX = e.type === "touchstart" ? e.originalEvent.touches[0].pageX : e.pageX;
          var thumbStartX = $thumb.position().left;
          var moveFn = function moveFn(moveEvent) {
            var currentPageX = moveEvent.type === "touchmove" ? moveEvent.originalEvent.touches[0].pageX : moveEvent.pageX;
            var dragAmount = currentPageX - startX;
            var thumbNewX = thumbStartX + dragAmount;
            var maxThumbX = $scrollbar.width() - $thumb.width();
            thumbNewX = Math.max(0, Math.min(thumbNewX, maxThumbX));
            var scrollRatio = thumbNewX / maxThumbX;
            $content.scrollLeft(scrollRatio * ($content[0].scrollWidth - $content[0].clientWidth));
            $thumb.css("left", thumbNewX);
          };
          $(document).on("mousemove touchmove", moveFn).one("mouseup touchend", function () {
            $(document).off("mousemove touchmove", moveFn);
            isDragging = false;
          });
        }
        $thumb.on("mousedown touchstart", startDrag);
        $content.on("scroll", function () {
          if (!isDragging) updateThumbPosition();
          if (!isGoToSlide) updateCurrentSlide();else isGoToSlide = false;
          updateButtons();
          updateSlideVisibility();
        });
        $prevBtn.on("click", function () {
          return goToSlide(currentSlide - 1);
        });
        $nextBtn.on("click", function () {
          return goToSlide(currentSlide + 1);
        });

        // Initialize the initial state
        checkOverflow();
        updateThumbPosition();
        updateButtons();
        updateSlideVisibility();
      });
    }
    /**
     * Handles the opening and closing of the availability modals
     */
  }, {
    key: "handleAvailTriggers",
    value: function handleAvailTriggers() {
      var _this0 = this;
      this.availTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          _this0.availModal.classList.toggle("is-active");
          document.body.classList.toggle("overflow-hidden");
        });
      });
    }

    /**
     * Handles the opening and closing of the info modals
     */
  }, {
    key: "handleInfoTriggers",
    value: function handleInfoTriggers() {
      var _this1 = this;
      this.infoTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var img = _this1.infoModalContent.querySelector(".js-bike-builder-product-info-modal__image");
          var title = _this1.infoModalContent.querySelector(".js-bike-builder-product-info-modal__title");
          var text = _this1.infoModalContent.querySelector(".js-bike-builder-product-info-modal__text");
          img.src = "";
          _this1.infoModal.classList.toggle("is-active");
          document.body.classList.toggle("overflow-hidden");
          if (!trigger.hasAttribute("data-product-info-featured-image")) return;
          img.src = trigger.dataset.productInfoFeaturedImage;
          title.innerHTML = trigger.dataset.productInfoTitle.replace("[OEM]", "").replace("[BB]", "");
          text.innerHTML = trigger.dataset.productInfoText;
        });
      });
    }

    /**
     * Scrolls to the first available active step when the submit area
     * fires a click event.
     */
  }, {
    key: "scrollToActiveStep",
    value: function scrollToActiveStep() {
      var _this10 = this;
      var submitArea = this.submit.parentElement;
      submitArea.addEventListener("click", function () {
        if (_this10.submit.disabled === true) {
          var firstActiveStep = document.querySelector(".bike-builder-content__step.bike-builder-content__step--active");
          firstActiveStep.scrollIntoView({
            behavior: "smooth"
          });
        }
      });
    }

    /**
     * Scrolls to the first available active step when the submit area
     * fires a click event.
     */
  }, {
    key: "populateWheelbaseInput",
    value: function populateWheelbaseInput() {
      var wheelGroup = document.querySelector('.bike-builder-group[data-attr-group="Wheels"]');
      if (wheelGroup) {
        var activeBlock = wheelGroup.querySelector(".bike-builder-block.active");
        if (activeBlock) {
          var wheelbaseSkus = activeBlock.getAttribute("data-wheelbase-skus");
          if (wheelbaseSkus) {
            var wheelSplit = wheelbaseSkus.split(", ");
            var productIdToBundleFront = "\n          <input\n            id=\"bundleProduct_".concat(wheelSplit[0], "\"\n            type=\"text\"\n            name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[0], "]\"\n            value=\"1\"\n          />\n          ");
            var productIdToBundleBack = "\n          <input\n            id=\"bundleProduct_".concat(wheelSplit[1], "\"\n            type=\"text\"\n            name=\"items[0]properties[_bundleProduct_").concat(wheelSplit[1], "]\"\n            value=\"1\"\n          />\n          ");
            var productTitleToBundle = "\n          <input\n            id=\"defaultComponent_".concat(productGroup, "\"\n            type=\"text\"\n            name=\"items[0]properties[_defaultComponent_").concat(productGroup, "]\"\n            value=\"").concat(productTitle, "\"\n          />\n        ");
            productProperties.innerHTML = productIdToBundleFront + productIdToBundleBack + productTitleToBundle;
          }
        }
      }
    }

    /**
     * Hides any step items with no available content or options
     */
  }, {
    key: "hideEmptyStepItems",
    value: function hideEmptyStepItems() {
      var emptyStepItems = document.querySelectorAll("[data-product-option-list-empty]");
      emptyStepItems.forEach(function (item) {
        return item.parentElement.style.display = "none";
      });
    }
  }, {
    key: "handleContentScroll",
    value: function handleContentScroll() {
      var stickyElement = this.submit.parentElement;
      var sentinel = stickyElement.previousElementSibling;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          stickyElement.classList.remove("sticky");
        } else {
          stickyElement.classList.add("sticky");
        }
      }, {
        threshold: [1]
      });
      observer.observe(sentinel);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-bundle.js":
/*!***********************************************!*\
  !*** ./src/scripts/modules/product-bundle.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductBundle)
/* harmony export */ });
/* harmony import */ var _bundle_payload_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bundle-payload.mjs */ "./src/scripts/modules/bundle-payload.mjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ProductBundle = /*#__PURE__*/function () {
  function ProductBundle() {
    _classCallCheck(this, ProductBundle);
    this.DOM = {
      bundle: '.bundle',
      bundleForm: 'AddToCartForm',
      bundleSubmit: 'addBundle',
      bundleSaving: '.js-bundle-saving',
      bundleItem: '.bundle__item',
      bundleItemProduct: '[data-bundle-item-product]',
      bundleItemVariant: '[data-bundle-item-variant]',
      bundleItemOption: '.bundle__item__option',
      bundleItemOptionSelected: '.bundle__item__option--selected',
      bundleItemOptions: '.bundle__item__options',
      bundleItemOptionValue: '.bundle__item__option-value',
      bundleItemImage: '.bundle__item__image',
      bundleItemPriceOriginal: 'js-bundle-item-price-original',
      bundleItemPriceCurrent: 'js-bundle-item-price-current'
    };
    this.bundle = document.querySelector(this.DOM.bundle);
    if (this.bundle && this.bundle.getAttribute('data-bundle-total-price')) this.totalPrice = parseFloat(this.bundle.getAttribute('data-bundle-total-price'));
    this.bundleForm = document.getElementById(this.DOM.bundleForm);
    this.bundleSubmit = document.getElementById(this.DOM.bundleSubmit);
    this.bundleItems = document.querySelectorAll(this.DOM.bundleItem);
    this.bundleItemOptions = document.querySelectorAll(this.DOM.bundleItemOption);
    this.bundleItemOptionsWrapper = document.querySelectorAll(this.DOM.bundleItemOptions);
    this.optionDrawerIsOpen = false;
    this.bundleError = this.bundle ? this.bundle.querySelector('.js-bundle-error') : null;
    this.cartQuantities = new Map();
  }
  return _createClass(ProductBundle, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (!this.bundle) {
        return false;
      }
      this.productHandle = this.bundle.getAttribute('data-product-handle');
      this.expectedItemCount = parseInt(this.bundle.getAttribute('data-bundle-expected-items'), 10);
      this.$bundleSaving = this.bundle.querySelector(this.DOM.bundleSaving);
      document.addEventListener('click', function (event) {
        var hasMatchingClass = _toConsumableArray(event.target.classList).some(function (className) {
          return className.includes('bundle__item__');
        });
        // Check if the clicked item's classes contain the string 'bundle__item__'
        if (hasMatchingClass) {
          var parentBundleItemOption = event.target.closest('.bundle__item__option');
          if (event.target === parentBundleItemOption) {
            parentBundleItemOption = event.target;
          }
          if (parentBundleItemOption) {
            // Handle the parent option click
            this.selectBundleItemOption(parentBundleItemOption);
            this.toggleBundleItemOptions(parentBundleItemOption);
            this.optionDrawerIsOpen = document.querySelectorAll('.bundle__item__options.is-opened').length > 0;
          }
          return;
        }

        // Handle other clicks, if necessary
        if (this.optionDrawerIsOpen) {
          this.toggleBundleItemOptions(event.target);
          this.optionDrawerIsOpen = false;
        }
      }.bind(this));
      this.bundleSubmit.addEventListener('click', function (e) {
        e.preventDefault();
        _this.clearBundleError();
        var formData = new FormData(_this.bundleForm);
        var data = Object.fromEntries(formData);
        _this.addBundleToCart(data);
      });
      document.addEventListener('renderCart', function () {
        _this.refreshBundleAvailabilityFromCart();
      });
      document.addEventListener('cart:updated', function () {
        _this.refreshBundleAvailabilityFromCart();
      });
      this.refreshBundleAvailabilityFromCart();
    }
  }, {
    key: "normalizeOptionValue",
    value: function normalizeOptionValue(value) {
      if (typeof value === 'string') {
        return value.trim();
      }
      return value;
    }
  }, {
    key: "findVariantBySelectedValues",
    value: function findVariantBySelectedValues(product, selectedValues) {
      var _this2 = this;
      if (!product || !Array.isArray(product.variants)) {
        return null;
      }
      var optionCount = Array.isArray(product.options) ? product.options.length : 3;
      return product.variants.find(function (variant) {
        for (var index = 1; index <= optionCount; index += 1) {
          var selectedValue = _this2.normalizeOptionValue(selectedValues["option".concat(index)]);
          var variantValue = _this2.normalizeOptionValue(variant["option".concat(index)]);
          if (selectedValue == null || selectedValue !== variantValue) {
            return false;
          }
        }
        return true;
      });
    }
  }, {
    key: "getSelectedValuesFromItem",
    value: function getSelectedValuesFromItem(bundleItem) {
      var selectedOptions = bundleItem.querySelectorAll(this.DOM.bundleItemOptionSelected);
      if (!selectedOptions.length) {
        return null;
      }
      var selectedValues = {
        option1: null,
        option2: null,
        option3: null
      };
      selectedOptions.forEach(function (option) {
        var position = option.getAttribute('data-option-position');
        if (!position) {
          return;
        }
        selectedValues["option".concat(position)] = option.getAttribute('data-option-value');
      });
      return selectedValues;
    }
  }, {
    key: "getVariantInventoryOverrides",
    value: function getVariantInventoryOverrides(bundleItem) {
      var inventoryNode = bundleItem.querySelector('[data-bundle-variant-inventory]');
      if (!inventoryNode) {
        return null;
      }
      try {
        var inventoryData = JSON.parse(inventoryNode.innerHTML);
        if (!Array.isArray(inventoryData)) {
          return null;
        }
        var map = new Map();
        inventoryData.forEach(function (entry) {
          if (!entry || !entry.id) {
            return;
          }
          map.set(String(entry.id), entry);
        });
        return map;
      } catch (error) {
        console.warn('ProductBundle: unable to parse inventory overrides', error);
        return null;
      }
    }
  }, {
    key: "applyInventoryOverrides",
    value: function applyInventoryOverrides(product, inventoryOverrides) {
      if (!product || !Array.isArray(product.variants) || !inventoryOverrides) {
        return;
      }
      product.variants.forEach(function (variant) {
        var override = inventoryOverrides.get(String(variant.id));
        if (!override) {
          return;
        }
        if (typeof override.inventory_quantity === 'number') {
          variant.inventory_quantity = override.inventory_quantity;
        }
        if (override.inventory_policy !== undefined) {
          variant.inventory_policy = override.inventory_policy;
        }
        if (override.inventory_management !== undefined) {
          variant.inventory_management = override.inventory_management;
        }
      });
    }
  }, {
    key: "selectBundleItemOption",
    value: function selectBundleItemOption($option) {
      var $thisOption = $option;
      var $thisBundleItem = $thisOption.closest(this.DOM.bundleItem);
      var $thisOptions = $thisBundleItem.querySelectorAll(this.DOM.bundleItemOption);
      var thisValue = $thisOption.getAttribute('data-option-value');
      var thisOption = $thisOption.getAttribute('data-option-name');
      var thisPosition = $thisOption.getAttribute('data-option-position');
      var $thisSelectedOption = $thisBundleItem.querySelector(this.DOM.bundleItemOptionSelected + '[data-option-name="' + thisOption + '"]');
      var $thisSelectedVariant = $thisBundleItem.querySelector(this.DOM.bundleItemVariant);
      var thisProduct = JSON.parse($thisBundleItem.querySelector(this.DOM.bundleItemProduct).innerHTML);
      this.applyInventoryOverrides(thisProduct, this.getVariantInventoryOverrides($thisBundleItem));
      var $otherSelectedOptions = $thisBundleItem.querySelectorAll(this.DOM.bundleItemOptionSelected + ':not([data-option-name="' + thisOption + '"])');
      var selectedOptionValues = {
        option1: null,
        option2: null,
        option3: null
      };
      selectedOptionValues["option".concat(thisPosition)] = thisValue;
      $otherSelectedOptions.forEach(function (item) {
        var value = item.getAttribute('data-option-value');
        var position = item.getAttribute('data-option-position');
        selectedOptionValues["option".concat(position)] = value;
      });
      var thisSelectedVariant = this.findVariantBySelectedValues(thisProduct, selectedOptionValues);

      // NEW: handle no variant
      if (!thisSelectedVariant) {
        console.warn('ProductBundle: no matching variant for selection', {
          productHandle: thisProduct.handle,
          selectedOptionValues: selectedOptionValues
        });
        return;
      }
      $thisSelectedOption.innerHTML = $thisOption.innerHTML;
      $thisSelectedOption.setAttribute('data-option-value', thisValue);
      $thisSelectedVariant.value = thisSelectedVariant.id;
      $thisSelectedVariant.setAttribute('data-selected-variant', JSON.stringify(thisSelectedVariant));
      $thisSelectedVariant.setAttribute('data-selected-variant-last-selected-option', "option".concat(thisPosition));
      thisSelectedVariant.options.forEach(function (option, index) {
        $thisSelectedVariant.setAttribute("data-selected-variant-option".concat(index + 1), option);
      });
      this.updateBundleItemStockLevel($thisOptions, thisProduct, thisSelectedVariant);
      var event = new Event('change');
      $thisSelectedVariant.dispatchEvent(event);
    }
  }, {
    key: "toggleBundleItemOptions",
    value: function toggleBundleItemOptions($option) {
      var _this3 = this;
      document.querySelectorAll(this.DOM.bundleItemOptionSelected).forEach(function (item) {
        if (item.classList.contains('is-opened')) {
          item.classList.remove('is-opened');
        }
      });
      var bundleItemOption = $option;
      var bundleItemOptionName = bundleItemOption.getAttribute('data-option-name') || null;
      var bundleItem = bundleItemOption.closest(this.DOM.bundleItem);
      this.bundleItemOptionsWrapper.forEach(function (item) {
        if (bundleItemOptionName != null && item.getAttribute('data-option-name') === bundleItemOptionName && !item.classList.contains('is-opened') && item.closest(_this3.DOM.bundleItem) === bundleItem) {
          item.classList.add('is-opened');
        } else {
          if (item.classList.contains('is-opened')) {
            item.classList.remove('is-opened');
          }
        }
      });
      if (bundleItem) {
        var $selectedOption = bundleItem.querySelector(this.DOM.bundleItemOptionSelected + '[data-option-name="' + bundleItemOptionName + '"]');
        if ($selectedOption !== null) {
          var siblingsOptions = $selectedOption.nextElementSibling;
          if (siblingsOptions && siblingsOptions.classList.contains('is-opened')) {
            $selectedOption.classList.add('is-opened');
          } else {
            $selectedOption.classList.remove('is-opened');
          }
        }
      }
    }
  }, {
    key: "updateBundleItemStockLevel",
    value: function updateBundleItemStockLevel($options, product, selectedVariant) {
      var _this4 = this;
      if (!product || !Array.isArray(product.variants)) {
        return;
      }
      var fallbackVariant = selectedVariant || product.variants[0];
      if (!fallbackVariant) {
        return;
      }
      $options.forEach(function (option) {
        var selectedValues = {
          option1: fallbackVariant.option1,
          option2: fallbackVariant.option2,
          option3: fallbackVariant.option3
        };
        var optionPosition = option.getAttribute('data-option-position');
        var optionValue = option.getAttribute('data-option-value');
        selectedValues["option".concat(optionPosition)] = optionValue;
        var variant = _this4.findVariantBySelectedValues(product, selectedValues);

        // NEW: guard when variant doesn't exist
        if (!variant) {
          var hasAvailableAlternative = product.variants.some(function (candidateVariant) {
            if (_this4.normalizeOptionValue(candidateVariant["option".concat(optionPosition)]) !== _this4.normalizeOptionValue(optionValue)) {
              return false;
            }
            return _this4.isVariantAvailable(candidateVariant);
          });
          if (hasAvailableAlternative) {
            option.classList.remove('is-unavailable');
          } else {
            option.classList.add('is-unavailable');
          }
          return;
        }
        if (_this4.isVariantAvailable(variant)) {
          option.classList.remove('is-unavailable');
        } else {
          option.classList.add('is-unavailable');
        }
      });
    }
  }, {
    key: "addBundleToCart",
    value: function addBundleToCart(data) {
      var _this5 = this;
      var bundleInstanceId = "bundle_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 8));
      var _buildBundleItems = (0,_bundle_payload_mjs__WEBPACK_IMPORTED_MODULE_0__.buildBundleItems)(data, bundleInstanceId),
        items = _buildBundleItems.items,
        parentCount = _buildBundleItems.parentCount,
        childCount = _buildBundleItems.childCount,
        emptyKeys = _buildBundleItems.emptyKeys;

      // Re-read the rows rather than trusting the NodeList captured at construction.
      var renderedItemCount = this.bundle.querySelectorAll(this.DOM.bundleItem).length;
      var configMismatch = (0,_bundle_payload_mjs__WEBPACK_IMPORTED_MODULE_0__.describeBundleConfigMismatch)({
        renderedItemCount: renderedItemCount,
        expectedItemCount: this.expectedItemCount
      });
      if (configMismatch) {
        console.error(configMismatch, {
          productHandle: this.productHandle
        });
      }

      // Every component row on the page has to contribute exactly one item,
      // alongside exactly one parent. Without this the bundle added whatever it
      // could and charged the full parent price, so a component that never made
      // it into the payload only showed up when the parcel arrived short.
      var incompleteBundleError = (0,_bundle_payload_mjs__WEBPACK_IMPORTED_MODULE_0__.validateBundlePayload)({
        parentCount: parentCount,
        childCount: childCount,
        renderedItemCount: renderedItemCount
      });
      if (incompleteBundleError) {
        console.error('ProductBundle: refusing to add an incomplete bundle', {
          productHandle: this.productHandle,
          parentCount: parentCount,
          childCount: childCount,
          renderedItemCount: renderedItemCount,
          expectedItemCount: this.expectedItemCount,
          emptyKeys: emptyKeys,
          items: items
        });
        this.showBundleError(incompleteBundleError);
        return;
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      }).then(function (response) {
        return response.json();
      }).then(function (payload) {
        if (payload && payload.status === 422) {
          // Use Shopify's actual error description so the message reflects the
          // real cause (e.g. bundle product at max qty, item out of stock, etc.)
          // rather than always blaming every component in the bundle.
          var errorMsg = payload.description || payload.message || 'Some bundle items are unavailable or have reached their maximum cart quantity.';
          _this5.showBundleError(errorMsg);
          return;
        }
        // Only render/open the cart on a successful add
        var renderCartEvent = new CustomEvent('renderCart');
        document.dispatchEvent(renderCartEvent);
        _this5.clearBundleError();
        _this5.refreshBundleAvailabilityFromCart();
      })["catch"](function (error) {
        console.error('Error:', error);
        _this5.showBundleError('Unable to add this bundle to the cart.');
      });
    }
  }, {
    key: "isVariantAvailable",
    value: function isVariantAvailable(variant) {
      if (!variant) {
        return false;
      }
      if (!variant.available) {
        return false;
      }
      var cartEntry = this.cartQuantities.get(String(variant.id));
      if (cartEntry && typeof cartEntry.max === 'number') {
        if (cartEntry.max > 0 && cartEntry.quantity >= cartEntry.max) {
          return false;
        }
      }
      if (variant.inventory_management && variant.inventory_policy === 'deny' && typeof variant.inventory_quantity === 'number') {
        var currentQty = cartEntry ? cartEntry.quantity : 0;
        if (currentQty >= variant.inventory_quantity) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "refreshBundleAvailabilityFromCart",
    value: function refreshBundleAvailabilityFromCart() {
      var _this6 = this;
      fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        var quantities = new Map();
        cart.items.forEach(function (item) {
          var key = String(item.variant_id);
          var existing = quantities.get(key);
          var nextQuantity = (existing ? existing.quantity : 0) + item.quantity;
          var nextMax = item.quantity_rule && typeof item.quantity_rule.max === 'number' ? item.quantity_rule.max : null;
          var max = nextMax;
          if (existing && typeof existing.max === 'number') {
            if (typeof nextMax === 'number') {
              max = Math.min(existing.max, nextMax);
            } else {
              max = existing.max;
            }
          }
          quantities.set(key, {
            quantity: nextQuantity,
            max: max
          });
        });
        _this6.cartQuantities = quantities;
        _this6.applyBundleAvailability();
      })["catch"](function (error) {
        console.warn('ProductBundle: unable to refresh cart quantities', error);
      });
    }
  }, {
    key: "applyBundleAvailability",
    value: function applyBundleAvailability() {
      var _this7 = this;
      this.bundleItems.forEach(function (item) {
        var productDataNode = item.querySelector(_this7.DOM.bundleItemProduct);
        var selectedVariantInput = item.querySelector(_this7.DOM.bundleItemVariant);
        if (!productDataNode || !selectedVariantInput) {
          return;
        }
        var product = JSON.parse(productDataNode.innerHTML);
        _this7.applyInventoryOverrides(product, _this7.getVariantInventoryOverrides(item));
        var selectedValues = _this7.getSelectedValuesFromItem(item);
        var selectedVariant = null;
        if (selectedValues) {
          selectedVariant = _this7.findVariantBySelectedValues(product, selectedValues);
        }
        if (!selectedVariant) {
          var selectedVariantData = selectedVariantInput.getAttribute('data-selected-variant');
          if (selectedVariantData) {
            selectedVariant = JSON.parse(selectedVariantData);
          }
        }
        if (!selectedVariant) {
          console.warn('ProductBundle: unable to determine selected variant', {
            productHandle: product.handle,
            selectedValues: selectedValues
          });
          return;
        }
        var $options = item.querySelectorAll(_this7.DOM.bundleItemOption);
        _this7.updateBundleItemStockLevel($options, product, selectedVariant);
      });
    }
  }, {
    key: "clearBundleError",
    value: function clearBundleError() {
      if (!this.bundleError) {
        return;
      }
      this.bundleError.textContent = '';
      this.bundleError.classList.add('hide');
    }
  }, {
    key: "showBundleError",
    value: function showBundleError(message) {
      if (!this.bundleError) {
        return;
      }
      this.bundleError.textContent = message;
      this.bundleError.classList.remove('hide');
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/product-card.js":
/*!*********************************************!*\
  !*** ./src/scripts/modules/product-card.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductCard)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var ProductCard = /*#__PURE__*/function () {
  function ProductCard() {
    var cardElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    _classCallCheck(this, ProductCard);
    this.DOM = {
      product_card: ".product-card",
      variant_swatch: ".product-card__variants-colour",
      product_card_images: ".product-card__image",
      second_images: "picture[data-second-image]",
      swatch_images: ".product-card__variants-colour[data-attr-product-image]"
    };
    if (cardElement) {
      this.productCard = cardElement;
    }
    this.productCard = document.querySelectorAll(this.DOM.product_card);
    this.variantSwatch = document.querySelectorAll(this.DOM.variant_swatch);
    this.productCardImages = document.querySelectorAll(this.DOM.product_card_images);
    this.secondImages = document.querySelectorAll(this.DOM.second_images);
    this.swatchImages = document.querySelectorAll(this.DOM.swatch_images);
  }
  return _createClass(ProductCard, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (!this.productCard) {
        return false;
      }
      var hasMouseClass = this.hasMouse() ? 'has-mouse' : 'no-mouse';
      document.documentElement.classList.add(hasMouseClass);
      var eventListenerType = this.hasMouse() ? 'mouseover' : 'click';
      this.swatchImages.forEach(function (swatchImage) {
        var swatchImageURL = swatchImage.getAttribute('data-attr-product-image');
        _this.preloadImage(swatchImageURL);
      });
      this.secondImages.forEach(function (picture) {
        var secondImageURL = picture.getAttribute('data-second-image');
        _this.preloadImage(secondImageURL);
      });
      Array.from(this.variantSwatch).forEach(function (el) {
        if (_this.hasMouse()) {
          el.addEventListener('mouseover', function (e) {
            return _this.variantHover(e);
          });
          el.addEventListener('mouseout', function (e) {
            return _this.resetSwatches(e);
          });
        } else {
          el.addEventListener('click', function (e) {
            return _this.variantHover(e);
          });
        }
      });
      Array.from(this.productCard).forEach(function (el) {
        if (!el.querySelector('.product-card__image').classList.contains("no_image")) {
          if (_this.hasMouse()) {
            var screenWidth = _this.getScreenWidth();
            el.addEventListener('mouseover', function (e) {
              return _this.imageSwitch(e, screenWidth);
            });
            el.addEventListener('mouseout', function (e) {
              return _this.resetImage(e, screenWidth);
            });
          }
        }
      });
    }
  }, {
    key: "variantHover",
    value: function variantHover(e) {
      var screenWidth = this.getScreenWidth();
      if (e.target.classList.contains('active')) {
        return;
      }
      e.target.parentElement.querySelector('div.product-card__variants-colour.active').classList.remove('active');
      var image = e.target.getAttribute('data-attr-product-image');
      var pictureElement = e.target.closest('.product-card').querySelector('.product-card__image picture');
      pictureElement.querySelector("source:nth-child(".concat(screenWidth, ")")).setAttribute('srcset', image);
      pictureElement.querySelector('source').setAttribute('srcset', image);
      pictureElement.style.width = '356px';
      pictureElement.style.height = '428px';
      pictureElement.style.objectFit = 'cover';
      e.target.classList.add('active');
    }
  }, {
    key: "resetSwatches",
    value: function resetSwatches(e) {
      var currentProductCard = e.target.closest('.product-card');
      var firstSwatch = currentProductCard.querySelector('.product-card__variants-colour');
      if (!firstSwatch.classList.contains('active')) {
        firstSwatch.classList.add('active');
      }
      var pictureElement = currentProductCard.querySelector('.product-card__image picture');
      var image = firstSwatch.getAttribute('data-attr-product-image');
      var screenWidth = this.getScreenWidth();
      pictureElement.querySelector("source:nth-child(".concat(screenWidth, ")")).setAttribute('srcset', image);
      pictureElement.querySelector('source').setAttribute('srcset', image);
      pictureElement.querySelector('img').setAttribute('src', image);
      Array.from(currentProductCard.querySelectorAll('.product-card__variants-colour')).forEach(function (swatch) {
        if (swatch !== firstSwatch && swatch.classList.contains('active')) {
          swatch.classList.remove('active');
        }
      });
    }
  }, {
    key: "imageSwitch",
    value: function imageSwitch(e, screenWidth) {
      if (!e.target.classList.contains('product-card__variants-colour') && screenWidth == 2) {
        var pictureElement = e.target.closest('.product-card').querySelector('picture');
        var image = pictureElement.getAttribute('data-second-image');
        pictureElement.querySelector("source:nth-child(".concat(screenWidth, ")")).setAttribute('srcset', image);
        pictureElement.querySelector('source').setAttribute('srcset', image);
        pictureElement.style.width = '356px';
        pictureElement.style.height = '428px';
        pictureElement.style.objectFit = 'contain';
      }
    }
  }, {
    key: "resetImage",
    value: function resetImage(e, screenWidth) {
      var pictureElement = e.target.closest('.product-card').querySelector('picture');
      var image = pictureElement.getAttribute('data-first-image');
      pictureElement.querySelector("source:nth-child(".concat(screenWidth, ")")).setAttribute('srcset', image);
      pictureElement.querySelector('source').setAttribute('srcset', image);
      pictureElement.querySelector('img').setAttribute('src', image);
    }
  }, {
    key: "getScreenWidth",
    value: function getScreenWidth() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        return 1;
      } else if (window.matchMedia('(min-width: 769px)').matches) {
        return 2;
      }
    }
  }, {
    key: "hasMouse",
    value: function hasMouse() {
      return matchMedia('(pointer:fine)').matches || matchMedia('(hover:hover)').matches;
    }
  }, {
    key: "preloadImage",
    value: function preloadImage(src) {
      var img = new Image();
      img.src = src;
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/product-event.gallery.js":
/*!******************************************************!*\
  !*** ./src/scripts/modules/product-event.gallery.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductEventGallery)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ProductEventGallery = /*#__PURE__*/function () {
  function ProductEventGallery() {
    _classCallCheck(this, ProductEventGallery);
    this.DOM = {
      container: ".product-media-event__gallery-grid"
    };
    this.container = document.querySelector(this.DOM.container);
  }
  return _createClass(ProductEventGallery, [{
    key: "init",
    value: function init() {
      console.log('image & text init');
      if (this.container) {
        $('.product-media-event__gallery-grid').slick({
          responsive: [{
            breakpoint: 980,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
              nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
              dots: false,
              infinite: true
            }
          }]
        });
      }
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/product-form.js":
/*!*********************************************!*\
  !*** ./src/scripts/modules/product-form.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductForm)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProductForm = /*#__PURE__*/function (_HTMLElement) {
  function ProductForm() {
    var _this;
    _classCallCheck(this, ProductForm);
    _this = _callSuper(this, ProductForm);
    // onChangeProductOption = (event) => {
    //   const productOptionEl = event.target;
    //   const productOptionValue = productOptionEl.value;
    //   const productOptionPosition = productOptionEl.dataset.productOption;
    //   const otherProductOptions = this.productOptions.filter((productOption) => {
    //     return productOption.dataset.productOption !== productOptionPosition;
    //   });
    //
    //   this.productOptions.forEach((productOption) => {
    //     productOption.closest("li").classList.remove("product-option--disabled");
    //   });
    //
    //   const validProductOptions = [];
    //   this.productJson.variants
    //     .filter((v) => {
    //       return v[`option${productOptionPosition}`] === productOptionValue;
    //     })
    //     .map((v) => {
    //       v.options.map((o) => {
    //         if (o !== productOptionValue) {
    //           const validProductOption = otherProductOptions.find((productOption) => {
    //             return productOption.value === o;
    //           });
    //           validProductOption && validProductOptions.push(validProductOption);
    //         }
    //       });
    //     });
    //   const invalidProductOptions = otherProductOptions.filter((productOption) => {
    //     return !validProductOptions.includes(productOption);
    //   });
    //   validProductOptions.forEach((productOption) => {
    //     productOption.closest("li").classList.remove("product-option--disabled");
    //   });
    //
    //   invalidProductOptions.forEach((productOption) => {
    //     productOption.closest("li").classList.add("product-option--disabled");
    //     productOption.checked = false;
    //   });
    //
    //   // If checked option is not in selectedOptions, add it
    //   if (productOptionEl.checked) {
    //     this.selectedOptions[`option${productOptionPosition}`] = productOptionValue;
    //   } else {
    //     delete this.selectedOptions[`option${productOptionPosition}`];
    //   }
    //
    //   this.setSelectedVariant();
    // };
    _defineProperty(_this, "setSelectedVariant", function () {
      var selectedOptions = Object.values(_this.selectedOptions).sort().join(" / ");
      var selectedVariant = _this.productJson.variants.find(function (variant) {
        return variant.title === selectedOptions;
      }) || {
        id: ""
      };
      _this.selectedVariant = selectedVariant;
      _this.productForm.setAttribute("data-current-variant", selectedVariant.id);
    });
    _this.DOM = {
      productOption: ".js-product-option",
      productJson: ".js-product-json",
      productForm: "#AddToCartForm"
    };
    return _this;
  }
  _inherits(ProductForm, _HTMLElement);
  return _createClass(ProductForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      console.log("ProductForm connected");
      this.selectedOptions = {};
      this.productOptions = Array.from(this.querySelectorAll(this.DOM.productOption));
      // this.productOptions.forEach((productOption) => {
      //   productOption.addEventListener("change", this.onChangeProductOption);
      // });

      this.productJson = JSON.parse(this.querySelector(this.DOM.productJson).textContent);
      this.productForm = this.querySelector(this.DOM.productForm);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // this.productOptions.forEach((productOption) => {
      //   productOption.removeEventListener("change", this.onChangeProductOption);
      // });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-gallery.js":
/*!************************************************!*\
  !*** ./src/scripts/modules/product-gallery.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductGallery)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var ProductGallery = /*#__PURE__*/function (_HTMLElement) {
  function ProductGallery() {
    var _this;
    _classCallCheck(this, ProductGallery);
    _this = _callSuper(this, ProductGallery);
    _this.element = _this;
    _this.images = _this.element.querySelectorAll("[data-product-gallery-item]");
    if (_this.images.length < 2) return _possibleConstructorReturn(_this);
    _this.init();
    return _this;
  }
  _inherits(ProductGallery, _HTMLElement);
  return _createClass(ProductGallery, [{
    key: "init",
    value: function init() {
      $(".".concat(this.element.className, " .slick-slider")).slick({
        dots: true,
        infinite: false,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
        appendDots: '.product-gallery__navigation',
        appendArrows: '.product-gallery__navigation'
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-lightbox.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/product-lightbox.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductLightbox)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var ProductLightbox = /*#__PURE__*/function (_HTMLElement) {
  function ProductLightbox() {
    var _this$element;
    var _this;
    _classCallCheck(this, ProductLightbox);
    _this = _callSuper(this, ProductLightbox);
    _this.element = _this;
    _this.productLightboxContent = (_this$element = _this.element) === null || _this$element === void 0 ? void 0 : _this$element.querySelectorAll("[data-product-lightbox-content]");
    var productRoot = _this.closest("main-product, product-bike-builder-simple, product-bike-builder-v3, product-bike-builder");
    _this.productLightboxTriggers = productRoot === null || productRoot === void 0 ? void 0 : productRoot.querySelectorAll("[data-product-lightbox-trigger]");
    _this.productLightboxOverlay = productRoot === null || productRoot === void 0 ? void 0 : productRoot.querySelector("[data-product-lightbox-overlay]");
    _this.slickInitialised = false;
    _this.mediaReady = false;
    _this.remainingLoaded = false;
    _this.bindEvents();

    // Move to document.body so position:fixed is always relative to the
    // viewport, regardless of any ancestor transforms or stacking contexts
    // (e.g. position:sticky on the bike-builder column).
    document.body.appendChild(_this);
    return _this;
  }

  /**
   * Binds primary events to the DOM elements initial load.
   */
  _inherits(ProductLightbox, _HTMLElement);
  return _createClass(ProductLightbox, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.triggerEvents();
    }

    /**
     * Handles lightbox triggers which are placed on the product-media
     * slides and on the close button, clicking the former will open the
     * lightbox, and then swipe automatically to the matching product-lightbox slide,
     * while the latter closes the lightbox.
     *
     */
  }, {
    key: "triggerEvents",
    value: function triggerEvents() {
      var _this2 = this;
      this.productLightboxTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var staticTrigger = trigger.dataset.productLightboxTrigger;
          var slide = trigger.closest(".slick-slide");
          var triggerIndex = null;
          if (staticTrigger !== undefined && staticTrigger !== "") {
            triggerIndex = parseInt(staticTrigger);
          } else if (slide) {
            triggerIndex = parseInt(slide.dataset.slickIndex);
          }
          _this2.ensureMediaReady(triggerIndex);
          _this2.element.classList.toggle("is-active");
          document.body.classList.toggle("overflow-hidden");
          if (!_this2.slickInitialised || triggerIndex === null) return;
          $("[data-id=\"".concat(_this2.element.dataset.id, "\"] [data-product-lightbox-carousel]")).slick("slickGoTo", triggerIndex);
        });
      });
    }

    /**
     * Lightbox images carry no src, only data-lazy, so nothing downloads on
     * page load. Runs on the first open: with two or more slides slick is
     * initialised with lazyLoad 'ondemand', which fetches the tapped slide
     * first; once that image has loaded the rest are fetched together so
     * swiping is instant. With a single slide there is no slick, so the
     * source is swapped in by hand.
     */
  }, {
    key: "ensureMediaReady",
    value: function ensureMediaReady(initialSlide) {
      if (this.mediaReady) return;
      this.mediaReady = true;
      if (this.productLightboxContent.length < 2) {
        this.loadRemainingImages();
        return;
      }
      this.initSlick(initialSlide);
    }

    /**
     * Swaps every still-lazy image source in, so all slides are fetched in
     * parallel. Idempotent, and a no-op for images slick has already loaded.
     */
  }, {
    key: "loadRemainingImages",
    value: function loadRemainingImages() {
      if (this.remainingLoaded) return;
      this.remainingLoaded = true;
      this.element.querySelectorAll("img[data-lazy]").forEach(function (img) {
        img.src = img.dataset.lazy;
        delete img.dataset.lazy;
      });
    }

    /**
     * Initialises Slick slider for product media. Starting on the slide that
     * was tapped means only that image is fetched, not slide 0 as well.
     */
  }, {
    key: "initSlick",
    value: function initSlick(initialSlide) {
      var _this3 = this;
      var $carousel = $("[data-id=\"".concat(this.element.dataset.id, "\"] [data-product-lightbox-carousel]"));

      // slick fires lazyLoaded once the tapped slide's image is in; fetch the
      // rest then. lazyLoadError and the timer cover a failed or very slow
      // first image, and afterChange covers a swipe before either fires.
      $carousel.on("lazyLoaded lazyLoadError afterChange", function () {
        return _this3.loadRemainingImages();
      });
      setTimeout(function () {
        return _this3.loadRemainingImages();
      }, 3000);
      $carousel.slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        initialSlide: initialSlide || 0,
        lazyLoad: "ondemand",
        prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
        appendArrows: ".product-lightbox__inner"
      });
      this.slickInitialised = true;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-list.js":
/*!*********************************************!*\
  !*** ./src/scripts/modules/product-list.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductList)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var ProductList = /*#__PURE__*/function () {
  function ProductList() {
    var _this$container$;
    _classCallCheck(this, ProductList);
    this.DOM = {
      container: ".js-product-list"
    };
    this.container = $(this.DOM.container);
    this.dots = ((_this$container$ = this.container[0]) === null || _this$container$ === void 0 || (_this$container$ = _this$container$.dataset) === null || _this$container$ === void 0 ? void 0 : _this$container$.dots) === "true";
  }
  return _createClass(ProductList, [{
    key: "init",
    value: function init() {
      if (!this.container) {
        return false;
      }
      this.container.slick({
        infinite: false,
        slidesToShow: 4,
        lazyLoad: 'anticipated',
        prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
        responsive: [{
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].mega,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 800,
          settings: {
            slidesToShow: 2.3,
            dots: true,
            arrows: false
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.25,
            dots: this.dots,
            arrows: false,
            variableWidth: false,
            outerEdgeLimit: true
          }
        }]
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/product-media.js":
/*!**********************************************!*\
  !*** ./src/scripts/modules/product-media.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductMedia)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }


var ProductMedia = /*#__PURE__*/function (_HTMLElement) {
  function ProductMedia() {
    var _this;
    _classCallCheck(this, ProductMedia);
    _this = _callSuper(this, ProductMedia);
    _this.element = _this;
    _this.template = document.body.dataset.template;
    _this.viewportWidth = window.innerWidth;
    _this.slickBreakpointTrigger = _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].large;
    _this.slickInitialised = false;
    _this.slickConfig = {};
    _this.carouselNavigation = _this.element.querySelector("[data-product-media-carousel-navigation]");
    _this.productMediaContent = _this.element.querySelectorAll("[data-product-media-content]");
    _this.productMediaOptions = document.querySelectorAll("[data-product-media-option]");
    _this.productMediaImagesWithVariants = _this.element.querySelectorAll("[data-product-media-variant-image]");
    _this.thumbnailNavigation = _this.element.querySelector(".product-media__thumbnails");
    _this.productFormColourOptions = document.querySelectorAll("[data-product-option-colour]");
    _this.youtubeMedia = _this.element.querySelector(".product-media__media--youtubevideo");
    _this.youtubeOriginalNextSibling = _this.youtubeMedia ? _this.youtubeMedia.nextElementSibling : null;
    _this.templateCheck = "standard";
    _this.windowSize = "desktop";

    // The bike builder V3 gallery (buy column): dots under the photo at every
    // width, and one whole photo at a time on mobile with no peek of the next.
    // Every other product page, the older builders included, keeps the config
    // below unchanged.
    _this.isBikeBuilder = !!_this.closest("product-bike-builder-v3");
    _this.bindEvents();
    return _this;
  }

  /**
   * Binds primary events to the DOM elements initial load.
   */
  _inherits(ProductMedia, _HTMLElement);
  return _createClass(ProductMedia, [{
    key: "bindEvents",
    value: function bindEvents() {
      // If the template is not a product page, do not run the script.
      if (this.template === "product" || this.template === "product-custom-2024" || this.template === "product-activity-template" || this.template === "product-bundle" || this.template === "product-complementary-items") {
        this.templateCheck = "grid";
      }
      this.findSetMediaQuery();
      this.slick_run();
      this.handleAttatchedToVariantImages();
    }
  }, {
    key: "findSetMediaQuery",
    value: function findSetMediaQuery() {
      if (this.viewportWidth <= _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].large) {
        this.windowSize = "mobile";
      } else {
        this.windowSize = "desktop";
      }
    }
  }, {
    key: "reorderYoutubeForMobile",
    value: function reorderYoutubeForMobile() {
      var _this2 = this;
      if (!this.youtubeMedia) return;
      var carousel = this.element.querySelector("[data-product-media-carousel]");
      if (!carousel) return;
      var items = Array.from(carousel.children).filter(function (li) {
        return li !== _this2.youtubeMedia;
      });
      if (items.length >= 4) {
        items[3].after(this.youtubeMedia);
      }
    }
  }, {
    key: "restoreYoutubeOrder",
    value: function restoreYoutubeOrder() {
      if (!this.youtubeMedia) return;
      var carousel = this.element.querySelector("[data-product-media-carousel]");
      if (!carousel) return;
      if (this.youtubeOriginalNextSibling && this.youtubeOriginalNextSibling.parentNode === carousel) {
        carousel.insertBefore(this.youtubeMedia, this.youtubeOriginalNextSibling);
      } else {
        carousel.appendChild(this.youtubeMedia);
      }
    }

    /**
     * Handles Slick-related events on the product media snippets
     * initial load.
     */
  }, {
    key: "slick_run",
    value: function slick_run() {
      var _this3 = this;
      // IF THE TEMPLATECHECK IS GRID THEN WE'RE WORKING WITH PRODUCT PAGES AND EVENTS
      // THINGS LIKE THE BIKE BUILDER WORK DIFFERENTLY

      // IF SLICK IS ALREADY SETUP THEN RETURN
      if (this.slickInitialised === true) {
        return;
      }

      // WHEN THE TEMPLATE IS GRID
      if (this.templateCheck === "grid") {
        // LISTEN FOR RESIZES
        window.addEventListener("resize", debounce(function () {
          _this3.viewportWidth = window.innerWidth;

          // IF THE WIDTH IS WITHIN THE BREAKPOINT RANGE
          // AND MATCHES WHAT WE EXPECT THEN WE DON'T WANT TO DO ANYTHING
          if (_this3.viewportWidth <= _this3.slickBreakpointTrigger && _this3.windowSize === "mobile") {
            return;
          }
          if (_this3.viewportWidth > _this3.slickBreakpointTrigger && _this3.windowSize === "desktop") {
            return;
          }

          // IF IT GETS TO THIS POINT THEN IT'S CHANGE FROM DESKTOP -> MOBILE OR VICE VERSA
          if (_this3.viewportWidth <= _this3.slickBreakpointTrigger) {
            _this3.windowSize = "mobile";
          } else {
            _this3.windowSize = "desktop";
          }

          // IF SLICK IS NOT INITIALISED YET AND WE ARE ON MOBILE
          if (_this3.windowSize === "mobile" && _this3.slickInitialised === false) {
            _this3.reorderYoutubeForMobile();
            _this3.initSlick();
          }

          // IF SLICK IS INITIALISED AND WE ARE ON DESKTOP
          if (_this3.windowSize === "desktop" && _this3.slickInitialised === true) {
            $(".".concat(_this3.element.className, " [data-product-media-carousel]")).slick("unslick");
            _this3.slickInitialised = false;
            _this3.restoreYoutubeOrder();
          }
        }, 200));

        // IF IT'S LESS THAN 2 WE DON'T CARE ABOUT SLIDERS OR ANYTHING
        if (this.productMediaContent.length < 2) return;
        this.setSlickConfig();

        // WE ONLY SHOW WHEN IT'S MOBILE
        if (this.windowSize === "mobile" && this.slickInitialised === false) {
          this.reorderYoutubeForMobile();
          this.initSlick();
        }

        // WE WANT TO MAKE SURE IF IT'S GRID
        // WE DON'T LOOK AT ANY FUTURE EVENTS
        return;
      }
      this.setSlickConfig();
      this.initSlick();
    }

    /**
     * Sets the configuration for slick depending on
     * the template being viewed.
     */
  }, {
    key: "setSlickConfig",
    value: function setSlickConfig() {
      this.slickConfig = {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        appendArrows: ".product-media__navigation",
        prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
        nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
        responsive: [{
          breakpoint: 980,
          settings: {
            dots: true,
            slidesToShow: 1.05
          }
        }]
      };
      if (this.isBikeBuilder) {
        this.slickConfig.dots = true;
        this.slickConfig.responsive = [{
          breakpoint: 980,
          settings: {
            dots: true,
            slidesToShow: 1
          }
        }];
      }
    }

    /**
     * Initialises Slick slider for product media.
     */
  }, {
    key: "initSlick",
    value: function initSlick() {
      var _this4 = this;
      $("[data-id=\"".concat(this.element.dataset.id, "\"] [data-product-media-carousel]")).slick(this.slickConfig);
      if (this.thumbnailNavigation) {
        $(this.thumbnailNavigation).slick({
          slidesToShow: 7,
          slidesToScroll: 4,
          focusOnSelect: true,
          arrows: false,
          asNavFor: "[data-id=\"".concat(this.element.dataset.id, "\"] [data-product-media-carousel]"),
          infinite: false
        });
      }
      $(".".concat(this.element.dataset.id, " [data-product-media-carousel]")).on("init", function () {
        if (_this4.carouselNavigation) _this4.initSlickNavigation();
      });
      var index = 0;
      document.querySelectorAll("[data-id=\"".concat(this.element.dataset.id, "\"] .product-swatches__input")).forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          // GET THE COLOR
          var color = swatch.getAttribute("data-product-identifier");

          // FIND THE PRODUCT IMAGE WITH THIS COLOR
          document.querySelectorAll("[data-id=\"".concat(_this4.element.dataset.id, "\"] .product-media__media")).forEach(function (media) {
            var img = media.querySelector("img");
            if (img.getAttribute("data-src").includes(color)) {
              index = media.closest(".slick-slide").getAttribute("data-slick-index");
            }
            if (img.getAttribute("alt").includes(color)) {
              index = media.closest(".slick-slide").getAttribute("data-slick-index");
            }
          });
          $("[data-id=\"".concat(_this4.element.dataset.id, "\"] [data-product-media-carousel]")).slick("slickGoTo", index);
        });
      });
      this.slickInitialised = true;
      var currentlySelectedOption = this.element.querySelector("[data-product-media-option]:checked");
      if (!this.querySelector(".product-media__media--custom-image")) this.selectCurrentVariantImage(currentlySelectedOption);
    }
  }, {
    key: "initSlickNavigation",
    value: function initSlickNavigation() {
      $(".product-media [data-product-media-carousel]").on("beforeChange", function () {
        var slickDots = document.querySelector(".product-media [data-product-media-carousel]").querySelector(".slick-dots");
        var relevantDot = slickDots.querySelector(".slick-active");
        var relevantDotOffset = relevantDot.offsetLeft;
        slickDots.scrollLeft = relevantDotOffset - 24;
      });
    }

    /**
     * Sets slick to the relevant variant image if that variant
     * has an associated image.
     *
     * @returns
     */
  }, {
    key: "selectCurrentVariantImage",
    value: function selectCurrentVariantImage(option) {
      var _this5 = this;
      if (this.productMediaOptions.length === 0 || !option) return;
      this.productMediaImagesWithVariants.forEach(function (image) {
        var variantImageOptions = image.dataset.productMediaVariantImage.split(",");
        if (variantImageOptions.includes(option.value.toLowerCase())) {
          var imageSlide = image.closest(".slick-slide");
          var imageIndex = parseInt(imageSlide.dataset.slickIndex);
          $("[data-id=\"".concat(_this5.element.dataset.id, "\"] [data-product-media-carousel]")).slick("slickGoTo", imageIndex);
        }
      });
    }

    /**
     * Implements the selectCurrentVariantImage method functionality on the
     * product media snippet's initial load.
     *
     * @returns
     */
  }, {
    key: "handleAttatchedToVariantImages",
    value: function handleAttatchedToVariantImages() {
      var _this6 = this;
      if (this.productMediaOptions.length === 0) return;
      this.syncCurrentVariantColourSelection();
      if (this.slickInitialised) {
        var initialSelectedOption = document.querySelector("#".concat(this.element.dataset.id, " [data-product-option][data-product-media-option]:checked"));
        if (initialSelectedOption && this.querySelector(".product-media__media--custom-image") == undefined) this.selectCurrentVariantImage(initialSelectedOption);
      }
      this.productMediaOptions.forEach(function (option) {
        var item = option.closest("li");
        item.addEventListener("click", function () {
          if (item.dataset.productId != undefined) {
            // No <main-product> wrapper on some templates (e.g. the bike builder),
            // so guard closest() — it used to throw null.dataset on every colour
            // click there. With no wrapper there's nothing to match against, so
            // skip (mirrors the previous behaviour, where the throw aborted here).
            var mainProduct = _this6.closest("main-product");
            if (!mainProduct || item.dataset.productId != mainProduct.dataset.productId) return;
          }
          if (_this6.slickInitialised) {
            _this6.selectCurrentVariantImage(option);
          }
        });
      });
    }

    /**
     * Syncs the product media option swatches with the
     * colour swatches inside the main product form.
     */
  }, {
    key: "syncCurrentVariantColourSelection",
    value: function syncCurrentVariantColourSelection() {
      var _this7 = this;
      this.productFormColourOptions.forEach(function (colourOption) {
        colourOption.parentElement.addEventListener("click", function () {
          var relevantProductMediaSwatch = document.querySelector("[data-product-media-option=\"".concat(colourOption.value.toLowerCase(), "\"]"));
          if (relevantProductMediaSwatch && _this7.querySelector(".product-media__media--custom-image") == undefined) {
            relevantProductMediaSwatch.checked = true;
          }
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-preorder.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/product-preorder.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductPreorder)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProductPreorder = /*#__PURE__*/function () {
  function ProductPreorder() {
    var _this = this;
    _classCallCheck(this, ProductPreorder);
    this.DOM = {
      variant: '[data-selected-variant]',
      product: '[data-product]',
      preorderMessage: '.js-preorder-variant-message',
      preorderProduct: '[data-product-preorder]',
      earliestDate: '[data-preorder-earliest-date]',
      date: '[data-preorder-date]',
      dispatch: '.js-preorder-dispatch',
      // The availability message is ONE field, replaced in place rather than
      // shown alongside a second one.
      //
      // The bike_availability note is a SINGLE-line metafield, so it renders as
      // .metafield-single_line_text_field and the original multi-line-only
      // selector never matched it. That is why this note used to be hidden
      // instead of updated — and hiding it collided with the builder's own
      // frame-gating, which keeps the dispatch line hidden until a frame is
      // chosen, leaving a bike with no default size showing no date at all.
      //
      // Targeting the note's text element instead means the copy is swapped for
      // the resolved dispatch message and reverted when nothing resolves. The
      // info-modal trigger is a SIBLING of this span, not a child, so it
      // survives the swap and stays clickable.
      //
      // :not(.js-bb-summary-dispatch) is load-bearing: the customise-mode build
      // summary reuses the note class for its own dispatch line, and that is not
      // ours to touch — product-bike-builder-simple.js excludes it the same way.
      metafieldMultiLineTextField: '.metafield-multi_line_text_field, .bike-builder-content__emboldened-text-note:not(.js-bb-summary-dispatch) .metafield-single_line_text_field',
      dispatchHumanInput: '[data-preorder-dispatch-human]',
      dispatchUtcInput: '[data-preorder-dispatch-utc]',
      framesetLabel: '[data-frameset-label]'
    };

    // this.preorderProducts = document.querySelectorAll(this.DOM.preorderProduct);
    this.$variants = document.querySelectorAll(this.DOM.variant);
    this.preorderProducts = [];
    this.$earliestDate = document.querySelector(this.DOM.earliestDate);
    this.$dispatch = document.querySelector(this.DOM.dispatch);
    this.$dispatchHumanInput = document.querySelector(this.DOM.dispatchHumanInput);
    this.$dispatchUtcInput = document.querySelector(this.DOM.dispatchUtcInput);
    this.$framesetLabels = document.querySelectorAll(this.DOM.framesetLabel);
    this.$metafieldMultiLineTextField = document.querySelectorAll(this.DOM.metafieldMultiLineTextField);
    Array.from(document.querySelectorAll(this.DOM.preorderProduct)).map(function (product) {
      var id = product.getAttribute('data-product-preorder');
      _this.preorderProducts[id] = JSON.parse(product.innerHTML);
    });
  }
  return _createClass(ProductPreorder, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      if (!this.preorderProducts) {
        return false;
      }
      this.$variants.forEach(function (variant) {
        variant.addEventListener('change', function () {
          _this2.updatePreorderMessage(variant);
          _this2.updatePreorderEarliestDispatch();
        });
      });

      // Nothing to reconcile at load. The availability field carries the product's
      // own copy until the customer picks a frame, and the swap happens on change.
      //
      // Deliberately NOT updatePreorderEarliestDispatch() here: it also runs
      // replaceMetafieldContent() across the document and overrides the dispatch
      // line's server-rendered visibility. .js-preorder-dispatch is rendered by
      // snippets/bundle.liquid as well as the two bike-builder sections, so
      // calling it at load would change bundle PDPs, which are outside this work.
      //
      // The property inputs need no work at load: they are server-rendered from the
      // same frame variant as the dispatch line, so they already agree with it.
    }
  }, {
    key: "updatePreorderMessage",
    value: function updatePreorderMessage(variant) {
      var variantData = JSON.parse(variant.getAttribute('data-selected-variant'));
      var productID = variant.getAttribute('data-selected-variant-product-id');
      var $thisMessages = document.querySelectorAll("".concat(this.DOM.preorderMessage, "[data-preorder-product-id=\"").concat(productID, "\"]"));
      var preorderProductData = this.preorderProducts[productID];
      var variantPreorderData = preorderProductData.find(function (item) {
        return item.variant_title === variantData.title;
      });
      if (variantPreorderData && variantPreorderData.preorder_date && variantPreorderData.preorder_date.UTC !== 'null') {
        variant.setAttribute('data-preorder-date', variantPreorderData.preorder_date.UTC);
      } else {
        variant.setAttribute('data-preorder-date', '');
      }
      $thisMessages.forEach(function (item) {
        var $thisOption = item.closest('.bundle__item__option');
        var values = {
          option1: variantData.option1,
          option2: variantData.option2,
          option3: variantData.option3
        };
        var itemPosition = item.getAttribute('data-preorder-option-position');
        var itemValue = item.getAttribute('data-preorder-option-value');
        values["option".concat(itemPosition)] = itemValue;
        var alternativeValues = Object.values(values).filter(function (item) {
          return item != null;
        }).join(' / ');
        item.setAttribute('data-preorder-selected-values', alternativeValues);
        var preorderData = preorderProductData.find(function (item) {
          return item.variant_title === alternativeValues;
        });
        if (!preorderData) {
          item.innerHTML = '';
          item.classList.remove('is-active');
          $thisOption && $thisOption.classList.remove('is-preorder');
        } else {
          var message = preorderData.message;
          if (message.includes('{{ DATE }}')) {
            message = message.replace(/{{ DATE }}/g, preorderData.preorder_date.human);
          }
          item.innerHTML = message;
          item.classList.add('is-active');
          $thisOption && $thisOption.classList.add('is-preorder');
        }
      });
    }
  }, {
    key: "updatePreorderEarliestDispatch",
    value: function updatePreorderEarliestDispatch() {
      // Instantiated on every page of the site; bail on pages with no dispatch line.
      if (!this.$dispatch) {
        return;
      }
      var dates = Array.from(document.querySelectorAll(this.DOM.date)).map(function (item) {
        return item.getAttribute('data-preorder-date') !== '' ? {
          "int": parseInt(item.getAttribute('data-preorder-date')),
          el: item
        } : null;
      })
      // A corrupt value (e.g. a spreadsheet export artefact like '#REF!' or
      // '#N/A' reaching the storefront) parses to NaN. Without this second
      // check, NaN survives into the reduce/Math.max below and propagates
      // into durable order data via setDispatchProperties instead of falling
      // back to a perfectly good bike SKU date.
      .filter(function (item) {
        return item !== null && !Number.isNaN(item["int"]);
      });
      var floorUtc = this.bikePreorderFloorUtc();
      if (dates.length === 0 && floorUtc === null) {
        this.$dispatch.classList.add('is-hidden');
        this.revertMetafieldContent();
        this.setDispatchProperties('', '');
        this.setFramesetLabel(false);
        return;
      }

      // The displayed date is the LATER of the frame's date and the bike SKU's
      // own — the bike ships no earlier than its slowest constraint. See
      // docs/superpowers/specs/2026-08-05-bike-preorder-date-precedence-design.md
      //
      // The reduce below stays a MINIMUM deliberately: on a bundle PDP
      // snippets/bundle.liquid renders one [data-preorder-date] per line and the
      // earliest is the right answer there. On a bike builder exactly one such
      // element exists, so the reduce is a no-op and the floor does the work.
      var resolvedInt = floorUtc;
      if (dates.length > 0) {
        var earliestDate = dates.reduce(function (prev, current) {
          return prev["int"] < current["int"] ? prev : current;
        });
        earliestDate.el.setAttribute('data-preorder-date', earliestDate["int"]);
        resolvedInt = floorUtc === null ? earliestDate["int"] : Math.max(earliestDate["int"], floorUtc);
      }

      // timeZone is pinned to UTC because this string is carried into durable
      // order data by setDispatchProperties: without it a customer west of UTC
      // bakes in a day-earlier date than the one the metafield states.
      var resolvedString = new Date(resolvedInt * 1000).toLocaleDateString("".concat(window.Shopify.locale, "-").concat(window.Shopify.country), {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      this.$earliestDate.innerHTML = resolvedString;
      this.$earliestDate.setAttribute('data-preorder-earliest-date', resolvedInt);
      this.$dispatch.classList.remove('is-hidden');
      this.replaceMetafieldContent(this.$dispatch.innerHTML);
      this.setDispatchProperties(resolvedString, resolvedInt);
      this.setFramesetLabel(true);
    }

    // A frameset's badge follows its frame, never its header SKU. On a frameset
    // the bike-only floor is always empty, so a dispatch date resolves exactly
    // when the chosen frame variant is on pre-order, and the badge shows the
    // matching state. snippets/bike-builder-label.liquid renders both states; a
    // complete bike, a bundle and every other page render neither, so this is a
    // no-op there.
  }, {
    key: "setFramesetLabel",
    value: function setFramesetLabel(isPreorder) {
      this.$framesetLabels.forEach(function (label) {
        var state = label.getAttribute('data-frameset-label');
        label.hidden = state === 'preorder' !== isPreorder;
      });
    }

    // The bike SKU's own date, carried as an attribute by
    // snippets/product-variants-bike-builder.liquid. Its presence is also what
    // scopes the floor logic to bike builders: a bundle PDP has a
    // .js-preorder-dispatch but no such attribute, so this returns null there.
  }, {
    key: "bikePreorderFloorUtc",
    value: function bikePreorderFloorUtc() {
      if (!this.$dispatchUtcInput) {
        return null;
      }
      var raw = this.$dispatchUtcInput.getAttribute('data-bike-preorder-floor-utc');
      if (!raw) {
        return null;
      }
      var parsed = parseInt(raw, 10);
      return Number.isNaN(parsed) ? null : parsed;
    }
  }, {
    key: "setDispatchProperties",
    value: function setDispatchProperties(humanDate, utcInt) {
      if (this.$dispatchHumanInput) {
        this.$dispatchHumanInput.value = humanDate || '';
      }
      if (this.$dispatchUtcInput) {
        this.$dispatchUtcInput.value = utcInt === '' || utcInt == null ? '' : utcInt;
      }
    }
  }, {
    key: "revertMetafieldContent",
    value: function revertMetafieldContent() {
      this.$metafieldMultiLineTextField.forEach(function (field) {
        // Revert to original content
        var originalContent = field.getAttribute('data-original-content');
        if (originalContent) {
          field.innerHTML = originalContent;
        }
      });
    }
  }, {
    key: "replaceMetafieldContent",
    value: function replaceMetafieldContent(newContent) {
      this.$metafieldMultiLineTextField.forEach(function (field) {
        var originalContent = field.getAttribute('data-original-content');

        // Set the attribute only if it's not already set
        if (!originalContent) {
          field.setAttribute('data-original-content', field.innerHTML);
        }

        // Replace content with new content
        field.innerHTML = newContent;
      });
    }
  }, {
    key: "initDataForTesting",
    value: function initDataForTesting() {}
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/product-recommendations.js":
/*!********************************************************!*\
  !*** ./src/scripts/modules/product-recommendations.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductRecommendations)
/* harmony export */ });
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* harmony import */ var _product_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./product-card */ "./src/scripts/modules/product-card.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var ProductRecommendations = /*#__PURE__*/function (_HTMLElement) {
  function ProductRecommendations() {
    var _this;
    _classCallCheck(this, ProductRecommendations);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductRecommendations, [].concat(args));
    _defineProperty(_this, "loaded", false);
    return _this;
  }
  _inherits(ProductRecommendations, _HTMLElement);
  return _createClass(ProductRecommendations, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      if (this.loaded) return;
      this.loaded = true;
      fetch(this.dataset.url).then(function (response) {
        return response.text();
      }).then(function (text) {
        var html = new DOMParser().parseFromString(text, "text/html");
        var recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          _this2.innerHTML = recommendations.innerHTML;
        }
        $('[data-product-recommendations-carousel]').slick({
          infinite: false,
          slidesToShow: 2.2,
          lazyLoad: 'anticipated',
          prevArrow: '<button type="button" class="arrows slick-prev"><svg class="icon icon--arrow-left"><use href="#sprite-icon-arrow-left"></use></svg></button>',
          nextArrow: '<button type="button" class="arrows slick-next"><svg class="icon icon--arrow-right"><use href="#sprite-icon-arrow-right"></use></svg></button>',
          responsive: [{
            breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_0__["default"].medium,
            settings: {
              slidesToShow: 1.5
            }
          }]
        });
      })["finally"](function () {
        new _product_card__WEBPACK_IMPORTED_MODULE_1__["default"]().init();
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product-size-guide.js":
/*!***************************************************!*\
  !*** ./src/scripts/modules/product-size-guide.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductSizeGuide)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var ProductSizeGuide = /*#__PURE__*/function (_HTMLElement) {
  function ProductSizeGuide() {
    var _this;
    _classCallCheck(this, ProductSizeGuide);
    _this = _callSuper(this, ProductSizeGuide);
    _this.element = _this;
    _this.productSizeGuideTriggers = _this.parentElement.querySelectorAll("[data-product-size-guide-trigger]");
    _this.bindEvents();
    return _this;
  }

  /**
   * Binds primary events to the DOM elements initial load.
   */
  _inherits(ProductSizeGuide, _HTMLElement);
  return _createClass(ProductSizeGuide, [{
    key: "bindEvents",
    value: function bindEvents() {
      this.triggerEvents();
    }

    /**
     * Handles the size guide modal triggers which are placed on the size guide
     * trigger alongside any product option that's named 'size', and on the close
     * button, clicking the former will open the lightbox, while the latter closes
     * the lightbox.
     *
     */
  }, {
    key: "triggerEvents",
    value: function triggerEvents() {
      var _this2 = this;
      this.productSizeGuideTriggers.forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          _this2.element.classList.toggle("is-active");
          document.body.classList.toggle("overflow-hidden");
        });
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/product.js":
/*!****************************************!*\
  !*** ./src/scripts/modules/product.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Product)
/* harmony export */ });
/* harmony import */ var _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-product-form */ "./node_modules/@shopify/theme-product-form/theme-product-form.js");
/* harmony import */ var _globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/formatPrice */ "./src/scripts/modules/globals/formatPrice.js");
/* harmony import */ var _product_event_gallery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./product-event.gallery */ "./src/scripts/modules/product-event.gallery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




// Bottom padding of the pinned add to basket bar, before the safe-area inset.
// Keep in step with .product-form__actions--stickied in _product-form.scss.
var STICKY_BAR_PADDING = 12;
var Product = /*#__PURE__*/function (_HTMLElement) {
  function Product() {
    var _this$querySelectorAl, _this$addToBasketButt;
    var _this;
    _classCallCheck(this, Product);
    _this = _callSuper(this, Product);

    /* Data */
    _defineProperty(_this, "setSelectedVariant", function () {
      var _selectedVariant$id, _selectedVariant, _selectedVariant$id2, _selectedVariant2;
      // Handle products with no options (Default Title only).
      // Use the hidden select's current value to find the variant, as Liquid already selected the right one.
      // This handles cases where the product JSON has additional hidden (e.g. [BB]) variants.
      if (_this.totalProductOptions === 0) {
        var selectedVariantId = parseInt(_this.variantSelect.value, 10);
        var defaultVariant = _this.product.variants.find(function (v) {
          return v.id === selectedVariantId;
        }) || _this.product.variants.find(function (v) {
          return v.title === "Default Title";
        }) || _this.product.variants[0];
        _this.selectedVariant = defaultVariant;
        _this.productFormElement.dataset.currentVariant = defaultVariant.id;
        _this.productFormElement.dataset.productOptions = JSON.stringify(_this.selectedOptions);
        _this.variantSelect.value = defaultVariant.id;
        _this.variantSelect.dispatchEvent(new Event("change"));
        return;
      }
      var selectedVariant = _this.product.variants.find(
      // Changed to 'let'
      function (variant) {
        return variant.options.length == Object.keys(_this.selectedOptions).length && Object.keys(_this.selectedOptions).every(function (key) {
          return variant[key] === _this.selectedOptions[key];
        });
      });

      // Check if there's only one variant, and it's the default one then select it
      if (!selectedVariant && _this.product.variants.length == 1 && _this.product.variants[0].title == "Default Title") {
        selectedVariant = _this.product.variants[0]; // Now this works!
      }

      // Auto-select if exactly one non-BB available variant exists and nothing has been selected yet.
      // Handles products where the only purchasable variant is "Default Title" alongside hidden BB
      // variants — the option UI is rendered (totalProductOptions > 0) but there's nothing meaningful
      // for the customer to choose, so we select the variant on their behalf.
      if (!selectedVariant) {
        var allOptionsNull = Object.values(_this.selectedOptions).every(function (v) {
          return v === null;
        });
        if (allOptionsNull) {
          var availableNonBBVariants = _this.product.variants.filter(function (v) {
            return v.available && !(v.sku && v.sku.endsWith("-BB"));
          });
          if (availableNonBBVariants.length === 1) {
            selectedVariant = availableNonBBVariants[0];
            // Populate selectedOptions and check the matching DOM input so the
            // CSS :checked styles (dark-grey for sizes, green border for swatches) apply.
            var _loop = function _loop(i) {
              var key = "option".concat(i);
              if (selectedVariant[key]) {
                _this.selectedOptions[key] = selectedVariant[key];
                var matchingInput = Array.from(_this.productOptions).find(function (input) {
                  return input.dataset.productOption == i && input.value === selectedVariant[key];
                });
                if (matchingInput) matchingInput.checked = true;
              }
            };
            for (var i = 1; i <= _this.totalProductOptions; i++) {
              _loop(i);
            }
          }
        }
      }

      // Set selected variant or null
      _this.selectedVariant = selectedVariant !== null && selectedVariant !== void 0 ? selectedVariant : null;

      // Update form dataset and select input
      _this.productFormElement.dataset.currentVariant = (_selectedVariant$id = (_selectedVariant = selectedVariant) === null || _selectedVariant === void 0 ? void 0 : _selectedVariant.id) !== null && _selectedVariant$id !== void 0 ? _selectedVariant$id : null;
      _this.productFormElement.dataset.productOptions = JSON.stringify(_this.selectedOptions);
      _this.variantSelect.value = (_selectedVariant$id2 = (_selectedVariant2 = selectedVariant) === null || _selectedVariant2 === void 0 ? void 0 : _selectedVariant2.id) !== null && _selectedVariant$id2 !== void 0 ? _selectedVariant$id2 : null;
      _this.variantSelect.dispatchEvent(new Event("change"));
    });
    _this.variantInventoryJSON = JSON.parse(document.querySelector("[data-product-variant-inventory-json]").textContent);

    /* Form Functionality */
    _this.productFormElement = _this.querySelector("[data-product-form]");
    _this.productFormErrorElements = _this.querySelectorAll(".js-product-form-error");
    _this.variantSelect = _this.querySelector("[data-variant-select]");
    _this.productOptions = _this.querySelectorAll("[data-product-option]");
    _this.initialSelectedProductOptions = _this.querySelectorAll("[data-product-option]:checked");
    _this.quickBuyButtonContainer = _this.querySelector("[data-quick-buy-button-container]");
    _this.totalProductOptions = (_this$querySelectorAl = _this.querySelectorAll(".product-variants__option")) === null || _this$querySelectorAl === void 0 ? void 0 : _this$querySelectorAl.length;
    _this.selectedOptions = {};
    _this.productFormActions = _this.querySelector(".product-form__actions");
    _this.preorderMessage = _this.querySelector("[data-preorder-message]");
    for (var i = 1; i <= _this.totalProductOptions; i++) {
      _this.selectedOptions["option".concat(i)] = null;
    }
    _this.productFormElement.dataset.productOptions = JSON.stringify(_this.selectedOptions);

    /* Quantity Selector */
    _this.quantitySelectorInput = _this.querySelector("[data-quantity-selector-input]");

    /* Price */
    _this.priceElement = _this.querySelector("[data-price-wrapper]");
    _this.currentPrice = _this.querySelector("[data-current-price]");
    _this.previousPrice = _this.querySelector("[data-previous-price]");
    _this.klarnaInstallment = _this.querySelector("[data-klarna-installment]");
    _this.paypalInstallment = _this.querySelector("[data-paypal-installment]");
    _this.klarnaModal = document.querySelector("[data-klarna-modal]");
    _this.klarnaModalOpenButtons = document.querySelectorAll("[data-klarna-modal-open]");
    _this.klarnaModalCloseButtons = document.querySelectorAll("[data-klarna-modal-close]");
    _this.klarnaModalInstalmentEls = document.querySelectorAll("[data-klarna-modal-installment]");
    _this.klarnaModalFullPriceEls = document.querySelectorAll("[data-klarna-modal-full-price]");
    _this.paypalModal = document.querySelector("[data-paypal-modal]");
    _this.paypalModalOpenButtons = document.querySelectorAll("[data-paypal-modal-open]");
    _this.paypalModalCloseButtons = document.querySelectorAll("[data-paypal-modal-close]");
    _this.paypalModalInstalmentEls = document.querySelectorAll("[data-paypal-modal-installment]");
    _this.paypalModalFullPriceEls = document.querySelectorAll("[data-paypal-modal-full-price]");
    if (_this.paypalModal) {
      _this.paypalModalOpenButtons.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          _this.openPaypalModal();
        });
      });
      _this.paypalModalCloseButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          return _this.closePaypalModal();
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !_this.paypalModal.hidden) _this.closePaypalModal();
      });
    }
    if (_this.klarnaModal) {
      _this.klarnaModalOpenButtons.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          _this.openKlarnaModal();
        });
      });
      _this.klarnaModalCloseButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          return _this.closeKlarnaModal();
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !_this.klarnaModal.hidden) _this.closeKlarnaModal();
      });
    }

    /* Store Availability */

    /* Scarcity Messages */
    _this.scarcityMessages = _this.querySelector("[data-product-scarcity-messages]");

    /* USP Modal */
    _this.uspsDiv = document.querySelector(".product-form__usps");
    _this.modalOuter = document.querySelector(".product-form__usps-modal-outer");
    _this.modalCloseButton = document.querySelector(".featherlight-close");
    _this.submit = _this.querySelector("[data-product-submit]");

    /* Hidden Wheelbase Line Item Property Input */
    _this.wheelbaseInputFront = document.querySelector("#wheelbase-id-front");
    _this.wheelbaseInputBack = document.querySelector("#wheelbase-id-back");

    /* Classes */
    _this.classes = {
      outOfStockSwatchClass: "is-sold-out",
      invalidSwatchClass: "is-invalid",
      productFormErrors: "is-error"
    };
    _this.addToBasketButton = document.querySelector(".product-form__actions");
    _this.addToBasketButtonButton = document.querySelector(".product-form__actions button.product-form__button");
    _this.hasUpsell = (_this$addToBasketButt = _this.addToBasketButtonButton) === null || _this$addToBasketButt === void 0 ? void 0 : _this$addToBasketButt.classList.contains("js-upsell");

    // HANDLE DESKTOP SCROLLING
    _this.lastKnownScrollPosition = 0;
    _this.ticking = false;
    _this.scrollingDirection = "down";
    _this.productGrid = document.querySelector(".product__grid.row");
    _this.productGridHeight = 0;
    _this.rightColumn = document.querySelector(".product-information");
    _this.rightColumnHeight = 0;
    _this.windowHeight = 0;
    _this.windowWidth = 0;
    _this.navigation = document.getElementById("shopify-section-header") || document.getElementById("shopify-section-header-sonder");
    _this.navigationHeight = 0;
    _this.visibleHeight = 0;
    _this.difference = 0;
    _this.differenceWithHeader = 0;
    _this.distanceFromTop = 0;
    _this.marginBlock = document.querySelector(".margin-block");
    _this.marginAllowence = 0;
    _this.marginHeight = 0;
    _this.setMargin = false;

    // THE NUMBER ASSOCIATED WITH THE DOWN SCROLL
    _this.downNumber = 0;
    // THE NUMBER ASSOCIATED WITH THE UP SCROLL
    _this.upNumber = 0;
    _this.scrollingLocation = "top";
    _this.handleDesktopPageScrollSetup();
    window.addEventListener("scroll", function (e) {
      _this.handleDesktopPageScroll(e);
      _this.handleStickyAddToCart(e);
    });
    window.addEventListener("resize", function (e) {
      _this.checkWindowWidth(e);
      _this.handleStickyAddToCart(e);
    });

    // A restored scroll position can put the button past its pin point before any scroll event.
    _this.handleStickyAddToCart();
    _this.bindEvents();
    _this.bindModalEvents();
    return _this;
  }
  _inherits(Product, _HTMLElement);
  return _createClass(Product, [{
    key: "handleVariantSelect",
    value: function handleVariantSelect() {
      this.setProductOptions();
      this.setSelectedVariant();
      this.updateProductPrice(this.selectedVariant);
      this.updateQuantitySelectorMax(this.selectedVariant);
      if (this.scarcityMessages) this.handleScarcityMessages(this.selectedVariant);
      this.updateProductFormErrors();
      this.updateBrowserHistory(this.selectedVariant);
      this.updatePreorderStatus();
      if (this.submit) {
        this.renderSubmitButtonText(this.selectedVariant);
      }
    }
  }, {
    key: "bindEvents",
    value: function () {
      var _bindEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(!this.productFormElement || !this.productFormElement.dataset.productHandle)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.getProductJson(this.productFormElement.dataset.productHandle);
            case 2:
              this.product = _context.v;
              this.productForm = new _shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__.ProductForm(this.productFormElement, this.product, {
                onOptionChange: this.onFormOptionChange.bind(this)
              });
              document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

              document.body.scrollTop = 0; // For Safari

              if (this.submit) this.initFormSubmission();

              /* Variant In/No Stock Stylings */

              /* Store Availability */
              if (this.storeAvailabilityTrigger) this.initStoreAvailability();
              /* Update Form Quick Buy Button */
              this.updateFormQuickBuyButton();
              this.handleVariantSelect();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function bindEvents() {
        return _bindEvents.apply(this, arguments);
      }
      return bindEvents;
    }()
  }, {
    key: "handleDesktopPageScrollSetup",
    value: function handleDesktopPageScrollSetup() {
      // Desktop sticky sidebar removed — right column is normal document flow
      this.rightColumn.style.top = "";
      this.rightColumn.style.bottom = "";
      this.windowWidth = window.innerWidth;
    }
  }, {
    key: "checkWindowWidth",
    value: function checkWindowWidth() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 980) {
        this.addToBasketButton.classList.remove("product-form__actions--stickied");
      }
    }
  }, {
    key: "handleDesktopPageScroll",
    value: function handleDesktopPageScroll(e) {
      // Desktop sticky sidebar removed — right column is normal document flow
    }

    /**
     * Displays messages set by variants that indicate if
     * a variant is close to selling out.
     *
     * @param {*} variant
     */
  }, {
    key: "handleScarcityMessages",
    value: function handleScarcityMessages(variant) {
      var scarcityMessages = JSON.parse(this.scarcityMessages.dataset.productScarcityMessages);
      this.scarcityMessages.innerHTML = "";
      var inventoryInformation = this.variantInventoryJSON.filter(function (productVariant) {
        return productVariant.id === variant.id;
      });
      var quantity = inventoryInformation[0] ? inventoryInformation[0].quantity : 0;
      var inventory_management = variant.inventory_management;
      for (var i = 0; i < scarcityMessages.length; i++) {
        var info = scarcityMessages[i];
        var min = info.min;
        var max = info.max;
        var message = info.message;
        if (quantity > min && quantity <= max && inventory_management == "shopify") {
          this.scarcityMessages.innerHTML = message;
        }
      }
    }

    /**
     * Toggles the store availability snippet inside product-variants.liquid,
     * the content here is generated by the app Stocky.
     */
  }, {
    key: "initStoreAvailability",
    value: function initStoreAvailability() {
      var _this2 = this;
      this.storeAvailabilityTrigger.addEventListener("click", function () {
        _this2.storeAvailabilityList.classList.toggle("is-active");
      });
      document.addEventListener("click", function (e) {
        if (e.target != _this2.storeAvailabilityTrigger && !_this2.storeAvailabilityTrigger.contains(e.target) && e.target != _this2.storeAvailabilityList && !_this2.storeAvailabilityList.contains(e.target) && _this2.storeAvailabilityList.classList.contains("is-active")) {
          _this2.storeAvailabilityList.classList.remove("is-active");
        }
      });
    }

    /**
     * Fetches product data, for use in JS
     *
     * @param {String} handle - The product handle
     * @return {Object} - Returns Shopify Product Object
     */
  }, {
    key: "getProductJson",
    value: function getProductJson(handle) {
      return fetch("/products/".concat(handle, ".js")).then(function (response) {
        return response.json();
      });
    }

    /**
     * Handles the variant change - triggers the related functions.
     *
     * @param {Object} event
     */
  }, {
    key: "onFormOptionChange",
    value: function onFormOptionChange(event) {
      // this.setProductOptionsStates();

      if (this.wheelbaseInputFront) {
        this.updateWheelbaseSKUs(event.target);
      }
      this.handleVariantSelect();
    }
  }, {
    key: "updateProductFormErrors",
    value: function updateProductFormErrors() {
      var _this3 = this;
      var submit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.productFormErrors = [];
      Object.entries(this.selectedOptions).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (!value) {
          _this3.productFormErrors.push("unselected-product-".concat(key));
        }
      });
      if (this.selectedVariant && !this.selectedVariant.available) {
        this.productFormErrors.push("unavailable-product-variant-".concat(this.selectedVariant.id));
      } else if (!this.selectedVariant) {
        this.productFormErrors.push("invalid-product-variant");
      }
      this.productFormElement.dataset.errors = JSON.stringify(this.productFormErrors);
      var productFormActions = Array.from(this.productFormElement.querySelector(".product-form__actions").children).filter(function (child) {
        return child !== _this3.submit;
      });
      if (this.productFormErrors.length > 0) {
        productFormActions.forEach(function (child) {
          child.classList.add("hide");
        });
      } else {
        productFormActions.forEach(function (child) {
          child.classList.remove("hide");
        });
      }
      Array.from(this.productFormErrorElements).forEach(function (errorEl) {
        var error = errorEl.dataset.error;
        errorEl.classList.add("hide");
        if (submit && _this3.productFormErrors.includes(error)) {
          errorEl.classList.remove("hide");
        }
      });
      var firstErrorElement = this.productFormElement.querySelector(".js-product-form-error:not(.hide)");
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        this.addToBasketButtonButton.classList.add("disabled");
      } else {
        if (this.hasUpsell) {
          this.addToBasketButtonButton.classList.remove("disabled");
        }
      }
    }
  }, {
    key: "setProductOptions",
    value: function setProductOptions() {
      var _this4 = this;
      var selectedProductOptions = this.productFormElement.querySelectorAll("[data-product-option]:checked");

      // Reset state
      this.selectedOptions = {};
      for (var i = 1; i <= this.totalProductOptions; i++) {
        this.selectedOptions["option".concat(i)] = null;
      }
      this.unavailableProductOptions = new Set();
      this.availableProductOptions = new Set();
      this.invalidProductOptions = new Set();

      // Convert all product option inputs to a real array once
      var productOptionsArray = Array.from(this.productOptions);
      function generateCombinationsWithFixedOption(arrays, selectedItem, fixedIndex) {
        function combine(index, currentCombo) {
          // Base case: all arrays processed
          if (index === arrays.length) {
            results.push(currentCombo.join(" / "));
            return;
          }

          // If this is the fixed array, just use the selectedItem
          if (index === fixedIndex) {
            combine(index + 1, [].concat(_toConsumableArray(currentCombo), [selectedItem]));
          } else {
            // For all other arrays, iterate through each element
            var _iterator = _createForOfIteratorHelper(arrays[index]),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;
                combine(index + 1, [].concat(_toConsumableArray(currentCombo), [item]));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
        var results = [];
        combine(0, []);
        return results;
      }
      productOptionsArray.forEach(function (optionEl) {
        var groupedOptions = [];
        var value = optionEl.value;
        var position = parseInt(optionEl.dataset.productOption) - 1;
        var otherSelectedOptions = [];
        selectedProductOptions.forEach(function (el) {
          if (parseInt(el.dataset.productOption) !== parseInt(optionEl.dataset.productOption)) {
            otherSelectedOptions.push(el);
          }
        });
        productOptionsArray.forEach(function (el) {
          var value = el.value;
          var position = parseInt(el.dataset.productOption) - 1;
          if (!groupedOptions[position]) {
            groupedOptions[position] = [];
          }
          groupedOptions[position].push(value);
          if (otherSelectedOptions.length > 0) {
            otherSelectedOptions.forEach(function (input) {
              groupedOptions[parseInt(input.dataset.productOption) - 1] = [input.value];
            });
          }
        });
        var matchingVariantTitles = generateCombinationsWithFixedOption(groupedOptions, value, position);
        var matchingVariants = _this4.product.variants.filter(function (variant) {
          return matchingVariantTitles.includes(variant.title);
        });
        var isUnavailable = matchingVariants.every(function (variant) {
          return !variant.available;
        });
        var isInvalid = matchingVariants.length === 0;
        if (isInvalid) {
          _this4.invalidProductOptions.add(optionEl);
        } else {
          if (isUnavailable) {
            _this4.unavailableProductOptions.add(optionEl);
          } else {
            _this4.availableProductOptions.add(optionEl);
          }
        }
      });
      selectedProductOptions.forEach(function (input) {
        _this4.selectedOptions["option".concat(input.dataset.productOption)] = input.value;
      });

      // UI updates
      productOptionsArray.forEach(function (optionEl) {
        var classList = optionEl.parentElement.classList;
        classList.remove(_this4.classes.invalidSwatchClass, _this4.classes.outOfStockSwatchClass);
        if (_this4.unavailableProductOptions.has(optionEl)) {
          classList.add(_this4.classes.outOfStockSwatchClass);
        }
        if (_this4.invalidProductOptions.has(optionEl)) {
          classList.add(_this4.classes.invalidSwatchClass);
        }
      });
    }
  }, {
    key: "updateProductPrice",
    value:
    /**
     * Changes the prices displayed to the user on variant change.
     *
     * @param {Object} variant
     */
    function updateProductPrice(variant) {
      if (!this.priceElement || !variant) return;

      // Skip BB (bike builder) variants - their prices shouldn't be displayed
      if (variant.sku && variant.sku.endsWith('-BB')) return;
      if (variant.compare_at_price > variant.price) {
        this.priceElement.classList.add("is-sale");
        this.currentPrice.textContent = (0,_globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(variant.price);
        this.previousPrice.textContent = (0,_globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(variant.compare_at_price);
        this.previousPrice.style.display = "block";
      } else {
        this.priceElement.classList.remove("is-sale");
        this.currentPrice.innerHTML = (0,_globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(variant.price);
        this.previousPrice.textContent = "";
        this.previousPrice.style.display = "none";
      }
      if (typeof variant.price === "number") {
        var instalmentMarkup = (0,_globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(Math.ceil(variant.price / 3));
        var fullMarkup = (0,_globals_formatPrice__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(variant.price);
        if (this.klarnaInstallment) {
          this.klarnaInstallment.innerHTML = instalmentMarkup;
        }
        // PayPal Pay in 3 instalment is price / 3, same as Klarna.
        if (this.paypalInstallment) {
          this.paypalInstallment.innerHTML = instalmentMarkup;
        }
        this.paypalModalInstalmentEls.forEach(function (el) {
          el.innerHTML = instalmentMarkup;
        });
        this.paypalModalFullPriceEls.forEach(function (el) {
          el.innerHTML = fullMarkup;
        });
        this.klarnaModalInstalmentEls.forEach(function (el) {
          el.innerHTML = instalmentMarkup;
        });
        this.klarnaModalFullPriceEls.forEach(function (el) {
          el.innerHTML = fullMarkup;
        });
      }
    }
  }, {
    key: "openKlarnaModal",
    value: function openKlarnaModal() {
      if (!this.klarnaModal) return;
      this.klarnaModal.hidden = false;
      document.body.classList.add("klarna-modal-open");
    }
  }, {
    key: "closeKlarnaModal",
    value: function closeKlarnaModal() {
      if (!this.klarnaModal) return;
      this.klarnaModal.hidden = true;
      document.body.classList.remove("klarna-modal-open");
    }
  }, {
    key: "openPaypalModal",
    value: function openPaypalModal() {
      if (!this.paypalModal) return;
      this.paypalModal.hidden = false;
      document.body.classList.add("paypal-modal-open");
    }
  }, {
    key: "closePaypalModal",
    value: function closePaypalModal() {
      if (!this.paypalModal) return;
      this.paypalModal.hidden = true;
      document.body.classList.remove("paypal-modal-open");
    }

    /**
     * Changes hidden input sku content.
     *
     * @param {*} event
     */
  }, {
    key: "updateWheelbaseSKUs",
    value: function updateWheelbaseSKUs(chosenSwatch) {
      var wheelbaseSkus = chosenSwatch.dataset.productWheelbaseSkus;
      var wheelSplit = wheelbaseSkus.split(", ");
      this.wheelbaseInputFront.setAttribute("name", "properties[bundleProduct_".concat(wheelSplit[0], "]"));
      this.wheelbaseInputBack.setAttribute("name", "properties[bundleProduct_".concat(wheelSplit[1], "]"));
    }

    /**
     * Changes the button text displayed to the user on variant change.
     *
     * @param {Object} variant
     */
  }, {
    key: "renderSubmitButtonText",
    value: function renderSubmitButtonText(variant) {
      var _this$quickBuyButtonC,
        _this5 = this;
      var iconBell = "<svg width=\"17\" height=\"21\" viewBox=\"0 0 17 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon--bell\">\n<path d=\"M8.2505 20.7339C7.70049 20.7339 7.22982 20.5382 6.83849 20.147C6.44649 19.7549 6.25049 19.2839 6.25049 18.734H10.2505C10.2505 19.2839 10.0548 19.7549 9.6635 20.147C9.27149 20.5382 8.80049 20.7339 8.2505 20.7339Z\" fill=\"#181818\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.25049 17.7339C0.967158 17.7339 0.729498 17.6379 0.537498 17.4459C0.346158 17.2545 0.250488 17.0172 0.250488 16.7339C0.250488 16.4505 0.346158 16.2132 0.537498 16.022C0.729498 15.83 0.967158 15.734 1.25049 15.734H2.2505V8.7339C2.2505 7.31722 2.67549 6.07956 3.5255 5.02089C4.37549 3.96289 5.45049 3.26722 6.7505 2.93389V2.23389C6.7505 1.81722 6.89649 1.46322 7.1885 1.17189C7.47983 0.879896 7.83383 0.733887 8.2505 0.733887C8.66717 0.733887 9.02117 0.879896 9.3125 1.17189C9.6045 1.46322 9.7505 1.81722 9.7505 2.23389V2.93389C11.0505 3.26722 12.1255 3.96289 12.9755 5.02089C13.8255 6.07956 14.2505 7.31722 14.2505 8.7339L14.2505 15.734H15.2505C15.5339 15.734 15.7712 15.83 15.9626 16.022C16.1546 16.2132 16.2506 16.4505 16.2506 16.7339C16.2506 17.0172 16.1546 17.2545 15.9626 17.4459C15.7712 17.6379 15.5339 17.7339 15.2505 17.7339H1.25049ZM5.42549 5.90889C6.20882 5.12556 7.15049 4.73389 8.2505 4.73389C9.35051 4.73389 10.2922 5.12556 11.0755 5.90889C11.8588 6.69222 12.2505 7.63389 12.2505 8.7339V15.734H4.25049V8.7339C4.25049 7.63389 4.64216 6.69222 5.42549 5.90889Z\" fill=\"#181818\"/>\n<path d=\"M8.2505 4.73389C7.15049 4.73389 6.20882 5.12556 5.42549 5.90889C4.64216 6.69222 4.25049 7.63389 4.25049 8.7339V15.734H12.2505V8.7339C12.2505 7.63389 11.8588 6.69222 11.0755 5.90889C10.2922 5.12556 9.35051 4.73389 8.2505 4.73389Z\" fill=\"#181818\"/>\n</svg>";
      var selectedOptionValues = Object.values(this.selectedOptions);
      var hasAllSelections = this.totalProductOptions === 0 ? true : selectedOptionValues.every(function (value) {
        return value !== null;
      });
      var submit = this.submit;
      var actionsContainer = (_this$quickBuyButtonC = this.quickBuyButtonContainer) === null || _this$quickBuyButtonC === void 0 || (_this$quickBuyButtonC = _this$quickBuyButtonC.parentElement) === null || _this$quickBuyButtonC === void 0 ? void 0 : _this$quickBuyButtonC.parentElement;

      // The sold-out button only opens AMP while the store takes back in stock
      // requests (settings.back_in_stock_app). Otherwise it is a disabled
      // "Sold Out" with an id AMP's script does not listen for.
      var renderSoldOut = function renderSoldOut() {
        var _this5$productFormEle;
        if (((_this5$productFormEle = _this5.productFormElement) === null || _this5$productFormEle === void 0 ? void 0 : _this5$productFormEle.dataset.backInStock) === "amp") {
          submit.type = "input";
          submit.id = "BIS_trigger";
          submit.innerHTML = iconBell + "<span>".concat(window.variantStrings.soldOut, "</span>");
        } else {
          submit.type = "button";
          submit.id = "SoldOut";
          submit.disabled = true;
          submit.innerHTML = "<span>".concat(window.variantStrings.soldOut, "</span>");
        }
        submit.classList.add("variant--unavailable");
      };

      // Reset submit button state
      submit.disabled = false;
      submit.classList.remove("variant--unavailable", "variant--invalid");

      // CASE 1: No variant yet, but no selections at all (e.g. page just loaded)
      if (!variant && (!hasAllSelections || this.totalProductOptions === 0)) {
        var _this$product, _this$quickBuyButtonC2;
        // Check if there are any available non-BB variants
        var hasAvailableNonBBVariant = (_this$product = this.product) === null || _this$product === void 0 || (_this$product = _this$product.variants) === null || _this$product === void 0 ? void 0 : _this$product.some(function (v) {
          return v.available && !(v.sku && v.sku.endsWith('-BB'));
        });
        if (hasAvailableNonBBVariant) {
          submit.id = "AddToCart";
          submit.innerHTML = window.variantStrings.addToCart;
          submit.classList.add("primary_green");
          submit.classList.remove("secondary");
          submit.type = "submit";
        } else {
          // All non-BB variants are sold out
          renderSoldOut();
        }
        (_this$quickBuyButtonC2 = this.quickBuyButtonContainer) === null || _this$quickBuyButtonC2 === void 0 || _this$quickBuyButtonC2.classList.add("is-hidden");
        actionsContainer === null || actionsContainer === void 0 || actionsContainer.classList.remove("product-form__actions-container--double-buttons");
        return;
      }

      // CASE 2: Variant not found, but user selected some options (invalid combo)
      if (!variant && hasAllSelections) {
        var _this$quickBuyButtonC3;
        submit.id = "InvalidVariant";
        submit.innerHTML = window.variantStrings.unavailable;
        submit.classList.add("variant--invalid");
        (_this$quickBuyButtonC3 = this.quickBuyButtonContainer) === null || _this$quickBuyButtonC3 === void 0 || _this$quickBuyButtonC3.classList.add("is-hidden");
        actionsContainer === null || actionsContainer === void 0 || actionsContainer.classList.remove("product-form__actions-container--double-buttons");
        return;
      }

      // CASE 3: Variant found – check availability
      if (variant) {
        submit.dataset.variantId = variant.id;

        // BB variants should not be purchasable on PDP - treat as unavailable
        var isBBVariant = variant.sku && variant.sku.endsWith('-BB');
        if (variant.available && !isBBVariant) {
          var _this$quickBuyButtonC4;
          submit.type = "submit";
          submit.id = "AddToCart";
          submit.innerHTML = this.isPreorderVariant(variant) ? window.variantStrings.preorder : window.variantStrings.addToCart;
          submit.classList.add("primary_green");
          submit.classList.remove("secondary");
          (_this$quickBuyButtonC4 = this.quickBuyButtonContainer) === null || _this$quickBuyButtonC4 === void 0 || _this$quickBuyButtonC4.classList.remove("is-hidden");
          actionsContainer === null || actionsContainer === void 0 || actionsContainer.classList.add("product-form__actions-container--double-buttons");
        } else {
          var _this$quickBuyButtonC5;
          renderSoldOut();
          (_this$quickBuyButtonC5 = this.quickBuyButtonContainer) === null || _this$quickBuyButtonC5 === void 0 || _this$quickBuyButtonC5.classList.add("is-hidden");
          actionsContainer === null || actionsContainer === void 0 || actionsContainer.classList.remove("product-form__actions-container--double-buttons");
        }
      }
    }

    /**
     * Prevents the default form submission, adds a event listener to the submit
     * button, and performs a fetch to accomplish an add to cart function without
     * a page refresh.
     *
     * @param {Object} variant
     */
  }, {
    key: "initFormSubmission",
    value: function initFormSubmission() {
      var _this6 = this;
      this.productFormElement.addEventListener("error", function (e) {
        _this6.updateProductFormErrors(true);
      });
      this.productFormElement.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!_this6.selectedVariant) {
          _this6.updateProductFormErrors(true);
          return;
        }
        var formData = new FormData(e.target);
        fetch("/cart/add.js", {
          body: formData,
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        }).then(function (response) {
          return response.json();
        })["catch"](function (error) {
          console.error("Error:", error);
        });
      });
    }

    /**
     * Pushes variant to the URL, on change.
     * - e.g ?variant=42757667225843
     *
     * @param {Object} variant
     */
  }, {
    key: "updateBrowserHistory",
    value: function updateBrowserHistory(variant) {
      var enableHistoryState = this.productFormElement.dataset.enableHistoryState;
      if (!variant || enableHistoryState !== "true" || variant.id == "") {
        var _url = new URL(window.location.href);
        _url.searchParams["delete"]("variant");
        window.history.replaceState(null, "", _url.toString());
        return;
      }
      var url = (0,_shopify_theme_product_form__WEBPACK_IMPORTED_MODULE_0__.getUrlWithVariant)(window.location.href, variant.id);
      window.history.replaceState({
        path: url
      }, "", url);
    }

    /**
     * The ids of every variant flagged as a preorder, as emitted by
     * snippets/product-form.liquid into [data-preorder-message]. This is the only
     * source of that list — do not re-derive it from product JSON.
     */
  }, {
    key: "preorderVariantIds",
    value: function preorderVariantIds() {
      if (!this.preorderMessage) return [];
      return (this.preorderMessage.dataset.preorderVariants || "").split(", ").map(function (id) {
        return parseInt(id, 10);
      }).filter(function (id) {
        return Number.isFinite(id);
      });
    }
  }, {
    key: "isPreorderVariant",
    value: function isPreorderVariant(variant) {
      if (!variant) return false;
      return this.preorderVariantIds().includes(variant.id);
    }
  }, {
    key: "updatePreorderStatus",
    value: function updatePreorderStatus() {
      if (!this.preorderMessage) return;
      this.preorderMessage.style.display = this.isPreorderVariant(this.selectedVariant) ? "block" : "none";
    }

    /**
     * This changes the liquid generated button's 'BUY IT NOW text
     * to 'BUY NOW'
     */
  }, {
    key: "updateFormQuickBuyButton",
    value: function updateFormQuickBuyButton() {
      var findButton;
      var quickBuyButton;
      function getElementByXpath(path) {
        return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
      }
      findButton = setInterval(function () {
        quickBuyButton = getElementByXpath("//button[text()='Buy it now']");
        if (quickBuyButton) {
          quickBuyButton.textContent = "Buy Now";
          clearInterval(findButton);
        }
      }, 250);
    }

    /**
     * Updates the max attribute on the quantity selector
     * to sync itself with the currently chosen variants
     * available quantity.
     */
  }, {
    key: "updateQuantitySelectorMax",
    value: function updateQuantitySelectorMax(variant) {
      if (!variant || !this.quantitySelectorInput) return;
      var quantitySelectorMinus = this.quantitySelectorInput.previousElementSibling;
      var quantitySelectorPlus = this.quantitySelectorInput.nextElementSibling;
      var inventoryInformation = this.variantInventoryJSON.filter(function (productVariant) {
        return productVariant.id === variant.id;
      });
      var quantity = inventoryInformation[0] ? inventoryInformation[0].quantity : 99999;
      this.quantitySelectorInput.max = quantity;
      if (variant.available) {
        this.quantitySelectorInput.value = 1;
        if (quantity > 1) {
          quantitySelectorPlus.classList.remove("is-disabled");
        } else {
          quantitySelectorPlus.classList.add("is-disabled");
        }
      } else {
        this.quantitySelectorInput.value = 0;
        quantitySelectorPlus.classList.add("is-disabled");
      }
      if (this.quantitySelectorInput.value <= 1) {
        quantitySelectorMinus.classList.add("is-disabled");
      } else {
        quantitySelectorMinus.classList.remove("is-disabled");
      }
    }

    /**
     * Pins the add to basket button to the bottom of the screen once scrolling
     * brings it up to the spot the pinned bar holds it in, so it changes from
     * inline to pinned, and back, without moving.
     *
     * Measured from the top of the button's slot, which stays put while the
     * sticky arm's CSS closes up the empty slot, so pinning cannot change the
     * answer and the bar cannot flicker.
     */
  }, {
    key: "handleStickyAddToCart",
    value: function handleStickyAddToCart() {
      var _this$addToBasketButt2;
      var isMobile = window.innerWidth <= 980;
      var slot = (_this$addToBasketButt2 = this.addToBasketButton) === null || _this$addToBasketButt2 === void 0 ? void 0 : _this$addToBasketButt2.closest(".product-form__actions-container");
      if (!isMobile || !slot || !this.addToBasketButtonButton) {
        var _this$addToBasketButt3;
        (_this$addToBasketButt3 = this.addToBasketButton) === null || _this$addToBasketButt3 === void 0 || _this$addToBasketButt3.classList.remove("product-form__actions--stickied");
        return;
      }
      var pinnedButtonBottom = window.innerHeight - STICKY_BAR_PADDING - this.safeAreaInsetBottom();
      var inlineButtonBottom = slot.getBoundingClientRect().top + this.addToBasketButtonButton.offsetHeight;
      var shouldStick = inlineButtonBottom <= pinnedButtonBottom;
      this.addToBasketButton.classList.toggle("product-form__actions--stickied", shouldStick);
    }

    /**
     * The bottom safe-area inset in px (the iPhone home indicator), which the
     * pinned bar adds to its padding. JS can't read env() directly, so this
     * measures a hidden probe sized by it.
     */
  }, {
    key: "safeAreaInsetBottom",
    value: function safeAreaInsetBottom() {
      if (!this.safeAreaProbe) {
        this.safeAreaProbe = document.createElement("div");
        this.safeAreaProbe.setAttribute("aria-hidden", "true");
        this.safeAreaProbe.style.cssText = "position:fixed;bottom:0;left:0;width:0;height:env(safe-area-inset-bottom, 0px);visibility:hidden;pointer-events:none;";
        document.body.appendChild(this.safeAreaProbe);
      }
      return this.safeAreaProbe.offsetHeight;
    }
  }, {
    key: "bindModalEvents",
    value: function bindModalEvents() {
      var _this7 = this;
      var uspListItems = document.querySelectorAll(".product-form__usp");
      uspListItems.forEach(function (listItem, index) {
        listItem.addEventListener("click", function () {
          _this7.openUspModal(index + 1);
        });
      });
      var modalCloseButtons = document.querySelectorAll(".featherlight-close-icon");
      modalCloseButtons.forEach(function (closeButton) {
        closeButton.addEventListener("click", function () {
          _this7.closeUspModal();
        });
      });
      var modalOuter = document.querySelectorAll(".product-form__usps-modal-outer");
      modalOuter.forEach(function (modal) {
        modal.addEventListener("click", function () {
          _this7.closeUspModal();
        });
      });
    }
  }, {
    key: "openUspModal",
    value: function openUspModal(index) {
      var modal = document.querySelector("#modal-".concat(index));
      if (modal) {
        modal.style.display = "block";
      }
    }
  }, {
    key: "closeUspModal",
    value: function closeUspModal() {
      var openModals = document.querySelectorAll(".product-form__usps-modal-outer");
      openModals.forEach(function (modal) {
        modal.style.display = "none";
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
/**
 * Check if document is ready cross-browser
 * @param callback
 */

var ready = function ready(callback) {
  if (document.readyState !== "loading") {
    /**
     * Document is already ready, call the callback directly
     */
    callback();
  } else if (document.addEventListener) {
    /**
     * All modern browsers to register DOMContentLoaded
     */
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    /**
     * Old IE browsers
     */
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        callback();
      }
    });
  }
};
ready(function () {
  // Section: image-text

  var eventGallery = new _product_event_gallery__WEBPACK_IMPORTED_MODULE_2__["default"]();
  eventGallery.init();
});

/***/ }),

/***/ "./src/scripts/modules/quantity-selector.js":
/*!**************************************************!*\
  !*** ./src/scripts/modules/quantity-selector.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ QuantitySelector)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var QuantitySelector = /*#__PURE__*/function (_HTMLElement) {
  function QuantitySelector() {
    var _this;
    _classCallCheck(this, QuantitySelector);
    _this = _callSuper(this, QuantitySelector);
    _defineProperty(_this, "onButtonClick", function (event) {
      var previousValue = _this.input.value;
      event.currentTarget.name === "plus" ? _this.input.stepUp() : _this.input.stepDown();
      if (_this.input.value === _this.input.min) {
        _this.buttons[0].classList.add("is-disabled");
      } else {
        _this.buttons[0].classList.remove("is-disabled");
      }
      if (_this.input.max && _this.input.value === _this.input.max) {
        _this.buttons[1].classList.add("is-disabled");
      } else {
        _this.buttons[1].classList.remove("is-disabled");
      }
      if (previousValue !== _this.input.value) {
        document.body.dispatchEvent(new CustomEvent("Quantity:changed", {
          bubbles: true,
          detail: {
            value: _this.input.value
          }
        }));
      }
    });
    _this.input = _this.querySelector("[data-quantity-selector-input]");
    _this.buttons = _this.querySelectorAll("button");
    var _iterator = _createForOfIteratorHelper(_this.buttons),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var elButton = _step.value;
        elButton.type = "button";
        elButton.addEventListener("click", _this.onButtonClick);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return _this;
  }
  _inherits(QuantitySelector, _HTMLElement);
  return _createClass(QuantitySelector);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/quick-add-form.js":
/*!***********************************************!*\
  !*** ./src/scripts/modules/quick-add-form.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ QuickAddForm)
/* harmony export */ });
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-currency */ "./node_modules/@shopify/theme-currency/currency.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }

var QuickAddForm = /*#__PURE__*/function (_HTMLElement) {
  function QuickAddForm() {
    var _this;
    _classCallCheck(this, QuickAddForm);
    _this = _callSuper(this, QuickAddForm);
    _this.handleOptionChange = _this.handleOptionChange.bind(_this);
    return _this;
  }
  _inherits(QuickAddForm, _HTMLElement);
  return _createClass(QuickAddForm, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var variantsScript = this.querySelector("[data-quick-add-variants-json]");
      if (!variantsScript) return;
      try {
        this.variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        console.error("[quick-add-form] failed to parse variants JSON", err);
        return;
      }

      // Closed variants must never be matched even if their option combo is
      // technically selectable in the picker. PDP product-sizes.liquid hides
      // the radio for closed variants, but PDP product-swatches.liquid may
      // still render colour swatches that include closed variants, so we
      // need to filter on the JS side too.
      this.closedVariantIds = new Set();
      var closedScript = this.querySelector("[data-quick-add-closed-ids]");
      if (closedScript) {
        try {
          var parsed = JSON.parse(closedScript.textContent);
          if (Array.isArray(parsed)) {
            parsed.forEach(function (id) {
              return _this2.closedVariantIds.add(id);
            });
          }
        } catch (err) {
          console.warn("[quick-add-form] failed to parse closed-variant IDs", err);
        }
      }

      // Preorder variants are purchasable, so they are NOT filtered like closed
      // ones — this set only changes the button label.
      this.preorderVariantIds = new Set();
      var preorderScript = this.querySelector("[data-quick-add-preorder-ids]");
      if (preorderScript) {
        try {
          var _parsed = JSON.parse(preorderScript.textContent);
          if (Array.isArray(_parsed)) {
            _parsed.forEach(function (id) {
              return _this2.preorderVariantIds.add(id);
            });
          }
        } catch (err) {
          console.warn("[quick-add-form] failed to parse preorder-variant IDs", err);
        }
      }
      this.moneyFormat = this.dataset.moneyFormat || "{{ amount }}";
      this.variantInput = this.querySelector("[data-quick-add-variant-id]");
      this.submitButton = this.querySelector("[data-quick-add-submit]");
      this.submitText = this.querySelector("[data-quick-add-submit-text]");
      this.priceContainer = this.querySelector("[data-quick-add-price]");
      this.heroImage = this.querySelector("[data-quick-add-hero]");

      // PDP variant picker (rendered via {% render 'product-variants' %}) uses
      // data-product-option on every radio (size + colour). The class names
      // differ between picker types — product-sizes uses .js-product-option,
      // product-swatches uses .product-swatches__input — so match on the
      // shared data attribute instead.
      this.optionInputs = Array.from(this.querySelectorAll('input[type="radio"][data-product-option]'));
      this.optionInputs.forEach(function (input) {
        input.addEventListener("change", _this2.handleOptionChange);
      });

      // When only one variant is actually pickable (in-stock + non-closed),
      // there's nothing for the user to choose — preselect it so the modal
      // opens ready to add. Multi-pickable products still open unselected
      // to match the PDP behaviour.
      var pickableVariants = this.variants.filter(function (v) {
        return v.available && !_this2.closedVariantIds.has(v.id);
      });
      if (pickableVariants.length === 1) {
        this.preselectVariant(pickableVariants[0]);
      }
    }
  }, {
    key: "preselectVariant",
    value: function preselectVariant(variant) {
      var _this3 = this;
      variant.options.forEach(function (value, idx) {
        var pos = idx + 1;
        var radio = _this3.optionInputs.find(function (r) {
          return parseInt(r.dataset.productOption, 10) === pos && r.value === value;
        });
        if (radio && !radio.checked) {
          radio.checked = true;
        }
      });
      var firstChecked = this.optionInputs.find(function (r) {
        return r.checked;
      });
      if (firstChecked) {
        firstChecked.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
    }
  }, {
    key: "handleOptionChange",
    value: function handleOptionChange(event) {
      var _event$target,
        _this4 = this;
      var selected = this.getSelectedOptions();
      var allSelected = selected.every(function (value) {
        return value !== null;
      });

      // Match PDP behaviour: require every option to be explicitly picked
      // before the form is submittable. Until then, the button stays
      // disabled with the "Select options" label and the hidden id is
      // empty so a stray submit can't fall back to the first variant.
      if (!allSelected) {
        this.variantInput.value = "";
        this.submitButton.disabled = true;
        this.submitText.textContent = this.submitText.dataset.selectLabel || "Select options";
        this.refreshOptionAvailability();
        return;
      }
      var variant = this.findVariant(selected);

      // Snap to a usable variant when either no match exists or the
      // match is unavailable (sold-out). Keeps the picker in an actionable
      // state — the snap target must be both available AND non-closed.
      var needsSnap = !variant || !variant.available;
      if (needsSnap && event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target = _event$target.dataset) !== null && _event$target !== void 0 && _event$target.productOption) {
        var changedPos = parseInt(event.target.dataset.productOption, 10);
        var changedValue = event.target.value;
        var fallback = this.variants.find(function (v) {
          if (_this4.closedVariantIds.has(v.id)) return false;
          if (!v.available) return false;
          return v.options[changedPos - 1] === changedValue;
        });
        if (fallback) {
          fallback.options.forEach(function (value, idx) {
            var pos = idx + 1;
            if (pos === changedPos) return;
            var radio = _this4.optionInputs.find(function (r) {
              return parseInt(r.dataset.productOption, 10) === pos && r.value === value;
            });
            if (radio && !radio.checked) radio.checked = true;
          });
          variant = fallback;
        }
      }
      if (!variant) {
        this.setUnavailable();
        this.refreshOptionAvailability();
        return;
      }
      this.variantInput.value = variant.id;
      this.submitButton.disabled = !variant.available;
      if (!variant.available) {
        this.submitText.textContent = this.submitText.dataset.soldOutLabel;
      } else if (this.preorderVariantIds.has(variant.id)) {
        this.submitText.textContent = this.submitText.dataset.preorderLabel || this.submitText.dataset.availableLabel;
      } else {
        this.submitText.textContent = this.submitText.dataset.availableLabel;
      }
      if (this.priceContainer && typeof variant.price === "number") {
        this.priceContainer.innerHTML = this.renderPrice(variant);
      }
      if (variant.featured_image && this.heroImage) {
        this.heroImage.src = variant.featured_image.src;
        this.heroImage.removeAttribute("srcset");
        this.heroImage.alt = variant.featured_image.alt || this.heroImage.alt;
      }
      this.refreshOptionAvailability();
    }

    // Grey out option values that have no in-stock, non-closed variant given
    // the current selection of the OTHER options. On the PDP this is driven by
    // <main-product>, whose handlers we suppress in the modal — so without this
    // every colour looks buyable even when the picked size only exists in one.
  }, {
    key: "refreshOptionAvailability",
    value: function refreshOptionAvailability() {
      var _this5 = this;
      var selected = this.getSelectedOptions();
      this.optionInputs.forEach(function (input) {
        var pos = parseInt(input.dataset.productOption, 10);
        var usable = _this5.variants.some(function (variant) {
          if (_this5.closedVariantIds.has(variant.id)) return false;
          if (!variant.available) return false;
          if (variant.options[pos - 1] !== input.value) return false;
          // Must also match every OTHER option the user has already picked.
          return selected.every(function (value, idx) {
            if (idx === pos - 1) return true;
            if (value === null) return true;
            return variant.options[idx] === value;
          });
        });
        var swatch = input.closest(".product-swatches__swatch, .product-sizes__swatch");
        (swatch || input).classList.toggle("quick-add-unavailable", !usable);
      });
    }
  }, {
    key: "getSelectedOptions",
    value: function getSelectedOptions() {
      var _this6 = this;
      var positions = _toConsumableArray(new Set(this.optionInputs.map(function (r) {
        return parseInt(r.dataset.productOption, 10);
      }))).sort(function (a, b) {
        return a - b;
      });
      return positions.map(function (pos) {
        var checked = _this6.optionInputs.find(function (r) {
          return parseInt(r.dataset.productOption, 10) === pos && r.checked;
        });
        return checked ? checked.value : null;
      });
    }
  }, {
    key: "findVariant",
    value: function findVariant(selectedOptions) {
      var _this7 = this;
      return this.variants.find(function (variant) {
        if (_this7.closedVariantIds.has(variant.id)) return false;
        return variant.options.every(function (value, index) {
          return value === selectedOptions[index];
        });
      });
    }
  }, {
    key: "setUnavailable",
    value: function setUnavailable() {
      this.submitButton.disabled = true;
      this.submitText.textContent = this.submitText.dataset.unavailableLabel || "Unavailable";
    }
  }, {
    key: "renderPrice",
    value: function renderPrice(variant) {
      var price = this.money(variant.price);
      var compareAt = variant.compare_at_price;
      if (compareAt && compareAt > variant.price) {
        var compare = this.money(compareAt);
        return "\n        <div class=\"product-card__price\">\n          <span class=\"product-card__price--sale\">".concat(price, "</span>\n          <span class=\"product-card__price--regular is-on-sale\">").concat(compare, "</span>\n        </div>\n      ");
      }
      return "\n      <div class=\"product-card__price\">\n        <span class=\"product-card__price--regular\">".concat(price, "</span>\n      </div>\n    ");
    }
  }, {
    key: "money",
    value: function money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }
      return (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(cents, this.moneyFormat);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/quick-add-modal.js":
/*!************************************************!*\
  !*** ./src/scripts/modules/quick-add-modal.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ QuickAddModal)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var QuickAddModal = /*#__PURE__*/function (_HTMLElement) {
  function QuickAddModal() {
    var _this;
    _classCallCheck(this, QuickAddModal);
    _this = _callSuper(this, QuickAddModal);
    _this.openerButton = null;
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleCartUpdated = _this.handleCartUpdated.bind(_this);
    return _this;
  }
  _inherits(QuickAddModal, _HTMLElement);
  return _createClass(QuickAddModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.modalContent = this.querySelector(".quick-add-modal__content-info");
      this.toggleButton = this.querySelector(".quick-add-modal__toggle");
      if (this.toggleButton) {
        this.toggleButton.addEventListener("click", function () {
          return _this2.hide();
        });
      }
      this.addEventListener("click", this.handleBackdropClick);
      document.addEventListener("renderCart", this.handleCartUpdated);

      // Escape the card's stacking context / any transformed ancestor so
      // position: fixed renders above the grid. Mirrors product-lightbox.js.
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener("renderCart", this.handleCartUpdated);
      document.removeEventListener("keydown", this.handleKeydown);
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.classList.contains("quick-add-modal--open");
    }
  }, {
    key: "handleCartUpdated",
    value: function handleCartUpdated() {
      if (this.isOpen()) this.hide();
    }
  }, {
    key: "handleBackdropClick",
    value: function handleBackdropClick(event) {
      if (event.target === this) this.hide();
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.key === "Escape" && this.isOpen()) this.hide();
    }
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(opener) {
        var _this$toggleButton, _opener$dataset;
        var productUrl, fetchUrl, response, html, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.openerButton = opener || null;
              if (!this.modalContent) {
                this.modalContent = this.querySelector(".quick-add-modal__content-info");
              }
              this.modalContent.innerHTML = this.renderSpinner();
              this.classList.add("quick-add-modal--open");
              document.body.classList.add("quick-add-modal--locked");
              document.addEventListener("keydown", this.handleKeydown);
              (_this$toggleButton = this.toggleButton) === null || _this$toggleButton === void 0 || _this$toggleButton.focus({
                preventScroll: true
              });
              productUrl = opener === null || opener === void 0 || (_opener$dataset = opener.dataset) === null || _opener$dataset === void 0 ? void 0 : _opener$dataset.productUrl;
              if (productUrl) {
                _context.n = 1;
                break;
              }
              this.modalContent.innerHTML = this.renderError("Missing product URL");
              return _context.a(2);
            case 1:
              // product.url on filtered/sorted collections carries tracking params
              // (?_pos=&_fid=&_ss=), so string-appending "?view=quick-add" yields a
              // double-"?" URL — Shopify ignores the view param and returns the full
              // product page instead of the quick-add fragment. Build the URL properly
              // so the view param is honoured whether or not params already exist.
              fetchUrl = new URL(productUrl, window.location.origin);
              fetchUrl.searchParams.set("view", "quick-add");
              _context.p = 2;
              _context.n = 3;
              return fetch(fetchUrl, {
                credentials: "same-origin"
              });
            case 3:
              response = _context.v;
              if (response.ok) {
                _context.n = 4;
                break;
              }
              throw new Error("HTTP ".concat(response.status));
            case 4:
              _context.n = 5;
              return response.text();
            case 5:
              html = _context.v;
              this.injectContent(html);
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error("[quick-add-modal] fetch failed", _t);
              this.modalContent.innerHTML = this.renderError("Couldn't load product");
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 6]]);
      }));
      function show(_x) {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "injectContent",
    value: function injectContent(html) {
      var _this3 = this,
        _customElements;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var source = doc.querySelector(".quick-add-modal__content-info-source") || doc.querySelector(".shopify-section") || doc.body;

      // Use outerHTML so the wrapper element (and its class) is preserved —
      // the grid layout selector .quick-add-modal__content-info-source has
      // to live on a real element in the modal, not just on the template
      // response.
      this.modalContent.innerHTML = source.outerHTML;
      var form = this.modalContent.querySelector("form[action*='/cart/add']");
      if (form) {
        form.addEventListener("submit", function (event) {
          return _this3.handleAddToCart(event, form);
        });
      }
      if (typeof ((_customElements = customElements) === null || _customElements === void 0 ? void 0 : _customElements.upgrade) === "function") {
        customElements.upgrade(this.modalContent);
      }
      var firstFocusable = this.modalContent.querySelector("input:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex='-1'])");
      firstFocusable === null || firstFocusable === void 0 || firstFocusable.focus({
        preventScroll: true
      });
    }
  }, {
    key: "handleAddToCart",
    value: function () {
      var _handleAddToCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event, form) {
        var submitButton, response, _t2, _t3, _t4;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              event.preventDefault();
              submitButton = form.querySelector("[type='submit']");
              if (submitButton) {
                submitButton.disabled = true;
                submitButton.classList.add("is-loading");
              }
              _context2.p = 1;
              _context2.n = 2;
              return window.fetch(window.Shopify.routes.root + "cart/add.js", {
                credentials: "same-origin",
                method: "POST",
                body: new FormData(form)
              });
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 4;
                break;
              }
              _t2 = Error;
              _context2.n = 3;
              return response.text();
            case 3:
              _t3 = _context2.v;
              throw new _t2(_t3);
            case 4:
              document.dispatchEvent(new CustomEvent("renderCart"));
              this.hide();
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t4 = _context2.v;
              console.error("[quick-add-modal] add failed", _t4);
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove("is-loading");
              }
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5]]);
      }));
      function handleAddToCart(_x2, _x3) {
        return _handleAddToCart.apply(this, arguments);
      }
      return handleAddToCart;
    }()
  }, {
    key: "hide",
    value: function hide() {
      this.classList.remove("quick-add-modal--open");
      document.body.classList.remove("quick-add-modal--locked");
      document.removeEventListener("keydown", this.handleKeydown);
      if (this.modalContent) this.modalContent.innerHTML = "";
      if (this.openerButton) {
        this.openerButton.setAttribute("aria-expanded", "false");
        this.openerButton.focus({
          preventScroll: true
        });
        this.openerButton = null;
      }
    }
  }, {
    key: "renderSpinner",
    value: function renderSpinner() {
      return "\n      <div class=\"quick-add-modal__loading\" role=\"status\" aria-live=\"polite\">\n        <div class=\"loading-overlay__spinner\">\n          <svg aria-hidden=\"true\" focusable=\"false\" role=\"presentation\" class=\"spinner\" viewBox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\">\n            <circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle>\n          </svg>\n        </div>\n      </div>\n    ";
    }
  }, {
    key: "renderError",
    value: function renderError(message) {
      return "<p class=\"quick-add-modal__error\" role=\"alert\">".concat(message, "</p>");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./src/scripts/modules/review-carousel.js":
/*!************************************************!*\
  !*** ./src/scripts/modules/review-carousel.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ReviewSlider)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var ReviewSlider = /*#__PURE__*/function () {
  function ReviewSlider() {
    _classCallCheck(this, ReviewSlider);
    this.DOM = {
      container: ".review__container--flex"
    };
  }
  return _createClass(ReviewSlider, [{
    key: "init",
    value: function init() {
      $(this.DOM.container).slick({
        slidesToShow: 4,
        infinite: false,
        autoplay: false,
        slidesToScroll: 1,
        prevArrow: '<div class="arrow-prev-container"><button type="button" class="review__arrows-prev arrows  slick-prev prev_button"><svg class="icon icon--arrow-left carousels"><use class="icon_prev"href="#sprite-icon-arrow-left"></use></svg></button></div>',
        nextArrow: '<div class="arrow-next-container"><button type="button" class="review__arrows-next arrows arrows-next slick-next next_button"><svg class="icon icon--arrow-right carousels"><use class="icon_next" href="#sprite-icon-arrow-right"></use></svg></button></div>',
        responsive: [{
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].mega,
          settings: {
            slidesToShow: 4,
            variableWidth: false
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].huge,
          settings: {
            slidesToShow: 4,
            variableWidth: false
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].medium,
          settings: {
            slidesToShow: 2.25,
            dots: true,
            arrows: false,
            variableWidth: false
          }
        }, {
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].small,
          settings: {
            slidesToShow: 1.25,
            dots: true,
            arrows: false,
            variableWidth: false,
            swipeToSlide: true,
            outerEdgeLimit: true
          }
        }]
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/select-item-ga4.js":
/*!************************************************!*\
  !*** ./src/scripts/modules/select-item-ga4.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildSelectItemPayload: () => (/* binding */ buildSelectItemPayload),
/* harmony export */   "default": () => (/* binding */ initSelectItem),
/* harmony export */   getCardIndex: () => (/* binding */ getCardIndex),
/* harmony export */   publishPendingSelectItem: () => (/* binding */ publishPendingSelectItem)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * GA4 `select_item` for product cards.
 *
 * Shopify has no standard customer event for a product clicked inside a list,
 * so the Google & YouTube tag cannot send `select_item` and GA4 has never
 * recorded one. We publish our own custom event and a custom pixel forwards it
 * to GA4, the same bridge PR #132 uses for the bike builders.
 *
 * The click is recorded, not published. A card click is a navigation, and
 * nothing guarantees a publish survives the page unloading, so the selection
 * is stored and published from the product page it leads to. The pixel sends
 * the click time as the GA4 timestamp, so `select_item` still sorts before the
 * managed tag's `view_item` in funnels. Stored per handle, so opening several
 * cards into new tabs keeps every one of them.
 *
 * Card data comes from the data-ga-* attributes rendered by product-card.liquid.
 * Nothing here throws.
 */

var EVENT_NAME = "alpkit:select_item";
var STORAGE_KEY = "alpkit:select_item";
var MAX_AGE_MS = 30 * 60 * 1000;
var CARD_SELECTOR = "product-card[data-ga-item-id]";
var PRODUCT_PATH = /\/products\/([^/?#]+)/;
function readStore() {
  try {
    var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
    return stored && _typeof(stored) === "object" ? stored : {};
  } catch (err) {
    return {};
  }
}
function writeStore(stored) {
  try {
    if (Object.keys(stored).length) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (err) {
    // Storage blocked (private mode, full quota). Lose the event, not the click.
  }
}
function pruneExpired(stored, now) {
  Object.keys(stored).forEach(function (handle) {
    if (!stored[handle] || now - stored[handle].clicked_at > MAX_AGE_MS) delete stored[handle];
  });
  return stored;
}
function handleFromPath(path) {
  var match = PRODUCT_PATH.exec(path || "");
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]).toLowerCase();
  } catch (err) {
    return match[1].toLowerCase();
  }
}

/**
 * Zero-based position of the card in its list, matching the managed tag's
 * view_item_list index. Slick clones are skipped so carousels count once.
 *
 * @param {HTMLElement} card
 * @returns {number}
 */
function getCardIndex(card) {
  var listId = card.dataset.gaListId;
  var peers = Array.from(document.querySelectorAll(CARD_SELECTOR)).filter(function (el) {
    return el.dataset.gaListId === listId && !el.closest(".slick-cloned");
  });
  var position = peers.indexOf(card);
  var offset = parseInt(card.dataset.gaIndexOffset, 10) || 0;
  return offset + Math.max(position, 0);
}

/**
 * Build the GA4 payload for a card.
 *
 * @param {HTMLElement} card
 * @returns {Object|null}
 */
function buildSelectItemPayload(card) {
  var d = card && card.dataset;
  if (!d || !d.gaItemId || !d.gaItemName) return null;
  var item = {
    item_id: d.gaItemId,
    item_name: d.gaItemName,
    index: getCardIndex(card),
    item_list_id: d.gaListId,
    item_list_name: d.gaListName
  };
  if (d.gaItemBrand) item.item_brand = d.gaItemBrand;
  if (d.gaItemCategory) item.item_category = d.gaItemCategory;
  if (d.gaItemVariant && d.gaItemVariant !== "Default Title") item.item_variant = d.gaItemVariant;
  var price = parseFloat(d.gaPrice);
  if (!Number.isNaN(price)) item.price = price;
  return {
    item_list_id: d.gaListId,
    item_list_name: d.gaListName,
    currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "GBP",
    items: [item]
  };
}
function onCardClick(e) {
  try {
    // Left click and middle click only. Right click opens a menu, not a page.
    if (e.type === "auxclick" && e.button !== 1) return;
    if (e.type === "click" && e.button !== 0) return;
    var link = e.target.closest && e.target.closest("a[href]");
    if (!link) return;
    var card = link.closest(CARD_SELECTOR);
    if (!card || link.closest(".quick-add")) return;
    var handle = handleFromPath(link.pathname);
    var payload = buildSelectItemPayload(card);
    if (!handle || !payload) return;
    var now = Date.now();
    var stored = pruneExpired(readStore(), now);
    stored[handle] = {
      clicked_at: now,
      payload: payload
    };
    writeStore(stored);
  } catch (err) {
    console.error("select_item record failed:", err);
  }
}

/**
 * On a product page, publish the selection that led here, if there is one.
 *
 * @returns {boolean} true if an event was published
 */
function publishPendingSelectItem() {
  try {
    var handle = handleFromPath(window.location.pathname);
    var now = Date.now();
    var stored = pruneExpired(readStore(), now);
    var pending = handle && stored[handle];
    if (pending) delete stored[handle];
    writeStore(stored);
    if (!pending) return false;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish(EVENT_NAME, Object.assign({}, pending.payload, {
        clicked_at: pending.clicked_at
      }));
      return true;
    }
  } catch (err) {
    console.error("select_item publish failed:", err);
  }
  return false;
}

/**
 * Delegated on the document, so cards added later by load-more, filtering or
 * the recommendations fetch are covered without re-binding.
 */
function initSelectItem() {
  document.addEventListener("click", onCardClick, true);
  document.addEventListener("auxclick", onCardClick, true);
  publishPendingSelectItem();
}

/***/ }),

/***/ "./src/scripts/modules/slideshow-slider.js":
/*!*************************************************!*\
  !*** ./src/scripts/modules/slideshow-slider.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SlideshowSlider)
/* harmony export */ });
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-carousel */ "./node_modules/slick-carousel/slick/slick.js");
/* harmony import */ var slick_carousel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_carousel__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./globals/breakpoints */ "./src/scripts/modules/globals/breakpoints.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var SlideshowSlider = /*#__PURE__*/function () {
  function SlideshowSlider() {
    _classCallCheck(this, SlideshowSlider);
    this.DOM = {
      container: ".slideshow-slider"
    };
    this.container = document.querySelector(this.DOM.container);
    console.log('slideshow slider');
  }
  return _createClass(SlideshowSlider, [{
    key: "init",
    value: function init() {
      console.log('slideshow slider init');
      var slider = $('.slideshow-slider.slick-slider').slick({
        infinite: false,
        slidesToShow: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        appendDots: $(".custom-dots-wrapper .wrapper"),
        customPaging: function customPaging(slider, i) {
          return '<a class="custom-dot"><span>' + $(slider.$slides[i]).find(".item").data('title') + '</span></a>';
        },
        arrows: false,
        responsive: [{
          breakpoint: _globals_breakpoints__WEBPACK_IMPORTED_MODULE_1__["default"].medium,
          settings: {
            slidesToShow: 1,
            dots: false,
            arrows: false
          }
        }]
      });
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/top-bar.js":
/*!****************************************!*\
  !*** ./src/scripts/modules/top-bar.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ TopBar)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TopBar = /*#__PURE__*/function () {
  function TopBar() {
    _classCallCheck(this, TopBar);
    this.DOM = {
      current: ".top-bar__store-current",
      list: ".top-bar__store-list"
    };
    this.current = document.querySelector(this.DOM.current);
    this.list = document.querySelector(this.DOM.list);
    this.root = document.documentElement;
  }
  return _createClass(TopBar, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.current.addEventListener('click', function (c) {
        if (_this.current.classList.contains('active')) {
          _this.current.classList.remove('active');
          _this.list.classList.remove('active');
        } else {
          _this.current.classList.add('active');
          _this.list.classList.add('active');
        }
      });
      var marqueeContent = document.querySelector(".usp-bar__inner");
    }
  }]);
}();


/***/ }),

/***/ "./src/scripts/modules/upsell-popup.js":
/*!*********************************************!*\
  !*** ./src/scripts/modules/upsell-popup.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ UpsellPopup)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Button labels come from the language file through window.variantStrings
// (layout/theme.liquid), the keys the product form's own button uses.
var label = function label(key, fallback) {
  return window.variantStrings && window.variantStrings[key] || fallback;
};
var UpsellPopup = /*#__PURE__*/function () {
  function UpsellPopup() {
    _classCallCheck(this, UpsellPopup);
    this.DOM = {
      upsellTrigger: '.js-upsell',
      upsellModal: '.js-upsell-modal-inner',
      upsellModalWrapper: '.js-upsell-modal',
      upsellPopupClose: '.js-upsell-modal-close',
      variantSelector: '.js-AddToCart-variant',
      addToCart: '.js-AddToCart',
      upsellFooterSelected: '.js-upsell-modal-item-selected',
      upsellFooterUnselected: '.js-upsell-modal-item-unselected'
    };
    this.upsellModal = document.querySelector(this.DOM.upsellModal);
    if (!this.upsellModal) {
      return;
    }
    this.upsellTrigger = document.querySelectorAll(this.DOM.upsellTrigger);
    this.upsellModal = document.querySelector(this.DOM.upsellModal);
    this.upsellModalWrapper = document.querySelector(this.DOM.upsellModalWrapper);
    // Deferred: another component (the bike builder) opens the popup and adds
    // its own product once the popup closes, so closing hands back instead of
    // opening the mini cart.
    this.deferred = this.upsellModalWrapper.hasAttribute('data-upsell-deferred');
    this.upsellPopupClose = document.querySelectorAll(this.DOM.upsellPopupClose);
    if (typeof this.upsellModal != 'undefined' && this.upsellModal != null) {
      this.variantSelector = this.upsellModal.querySelectorAll(this.DOM.variantSelector);
      this.addToCart = this.upsellModal.querySelectorAll(this.DOM.addToCart);
      this.upsellFooterSelected = this.upsellModal.querySelectorAll(this.DOM.upsellFooterSelected);
      this.upsellFooterUnselected = this.upsellModal.querySelectorAll(this.DOM.upsellFooterUnselected);
    }
  }
  return _createClass(UpsellPopup, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (!this.upsellModal) {
        return;
      }
      if (typeof this.upsellModal != 'undefined' && this.upsellModal != null) {
        Array.from(this.variantSelector).forEach(function (el) {
          var options = el.querySelectorAll('option');
          options.length <= 1 ? el.classList.add('is-hidden') : null;
        });
        Array.from(this.upsellTrigger).forEach(function (el) {
          el.addEventListener('click', function (e) {
            if (!el.classList.contains('disabled') && !el.classList.contains('upsell-shown')) {
              e.preventDefault();
              _this.openUpsellPopup();
            }
          });
        });
        this.upsellModalWrapper.addEventListener('upsell:open', function () {
          _this.openUpsellPopup();
        });
        Array.from(this.upsellPopupClose).forEach(function (el) {
          el.addEventListener('click', function (e) {
            _this.openCart = e.target.classList.contains('js-upsell-render-cart');
            _this.closeUpsellPopup();
            if (!_this.deferred) _this.renderCart();
          });
        });
      }
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('js-upsell-modal-close') || e.target.classList.contains('js-upsell-modal')) {
          _this.closeUpsellPopup();
        }
      });
      Array.from(this.addToCart).forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          // currentTarget, not target: a click on the label lands on its <span>,
          // which then got the disabled attribute instead of the button.
          var button = e.currentTarget;
          button.innerText = label('addingToCart', 'Adding...');
          _this.addUpsellToCart(button);
        });
      });
    }
  }, {
    key: "openUpsellPopup",
    value: function openUpsellPopup() {
      this.upsellModalWrapper.classList.add('is-active');
      this.openCart = false;
    }
  }, {
    key: "closeUpsellPopup",
    value: function closeUpsellPopup() {
      var _this2 = this;
      // A close button runs this twice (its own listener and the document one),
      // so only announce a close that actually hid the popup.
      var wasActive = this.upsellModalWrapper.classList.contains('is-active');
      this.upsellModalWrapper.classList.remove('is-active');
      Array.from(this.addToCart).forEach(function (el) {
        el.innerText = label('addToCart', 'Add to basket');
        el.classList.remove('is-added');
        el.removeAttribute('disabled');
      });
      Array.from(this.upsellFooterSelected).map(function (el) {
        return el.classList.add('is-hidden');
      });
      Array.from(this.upsellFooterUnselected).map(function (el) {
        return el.classList.remove('is-hidden');
      });
      if (wasActive) {
        // Let an add still in flight land first: a deferred host navigates away
        // as soon as it hears this, which could cut the add off.
        Promise.resolve(this.pendingAdd).then(function () {
          _this2.upsellModalWrapper.dispatchEvent(new CustomEvent('upsell:closed'));
        });
      }
    }
  }, {
    key: "addUpsellToCart",
    value: function addUpsellToCart(button) {
      var _this3 = this;
      var form = button.closest('form.js-AddToCartForm');
      var formData = new FormData(form);
      this.pendingAdd = fetch('/cart/add.js', {
        body: formData,
        method: 'POST',
        credentials: 'same-origin'
      }).then(function (response) {
        // The Cart API answers a sold-out add with a 422 JSON body, which
        // used to fall through to "Added".
        if (!response.ok) throw new Error("cart/add.js ".concat(response.status));
        return response.json();
      }).then(function (cart) {
        button.innerText = label('addedToCart', 'Added to basket');
        button.classList.add('is-added');
        button.setAttribute('disabled', true);
        Array.from(_this3.upsellFooterSelected).map(function (el) {
          return el.classList.remove('is-hidden');
        });
        Array.from(_this3.upsellFooterUnselected).map(function (el) {
          return el.classList.add('is-hidden');
        });
        _this3.renderCart();
      })["catch"](function (err) {
        button.innerText = label('unavailable', 'Unavailable');
        console.error(err.message, err);
      });
      return this.pendingAdd;
    }
  }, {
    key: "openCartDrawer",
    value: function openCartDrawer() {
      document.querySelector('.cart__trigger').click();
    }
  }, {
    key: "updateCartCount",
    value: function updateCartCount() {
      var isEmpty = this.currentCart.item_count === 0;
      Array.from(document.querySelectorAll('.cart__trigger')).forEach(function (el) {
        isEmpty ? el.classList.remove('cart__trigger--has-items') : el.classList.add('cart__trigger--has-items');
      });
    }
  }, {
    key: "fetchCart",
    value: function fetchCart() {
      var _this4 = this;
      return window.fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        // this.renderCart(cart);
        _this4.currentCart = cart;
        _this4.updateCartCount();
      })["catch"](function (error) {
        throw new Error(error);
      });
    }
  }, {
    key: "renderCart",
    value: function renderCart() {
      var _this5 = this;
      return fetch(window.Shopify.routes.root + '?sections=mini-cart').then(function (response) {
        return response.json();
      }).then(function (cart) {
        document.querySelector('#shopify-section-mini-cart').innerHTML = cart['mini-cart'];
        _this5.fetchCart();
        if (_this5.openCart) _this5.openCartDrawer();
      })["catch"](function (err) {
        return console.error(err.message, err);
      });
    }
  }]);
}();


/***/ }),

/***/ "./node_modules/form-serialize/index.js":
/*!**********************************************!*\
  !*** ./node_modules/form-serialize/index.js ***!
  \**********************************************/
/***/ ((module) => {

// get successful control from form and assemble into object
// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

// types which indicate a submit action and are not successful controls
// these will be ignored
var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

// node names which could be successful controls
var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

// Matches bracket notation.
var brackets = /(\[[^\[\]]*\])/g;

// serializes form fields
// @param form MUST be an HTMLForm element
// @param options is an optional argument to configure the serialization. Default output
// with no options specified is a url encoded string
//    - hash: [true | false] Configure the output type. If true, the output will
//    be a js object.
//    - serializer: [function] Optional serializer function to override the default one.
//    The function takes 3 arguments (result, key, value) and should return new result
//    hash and url encoded str serializers are provided with this module
//    - disabled: [true | false]. If true serialize disabled fields.
//    - empty: [true | false]. If true serialize empty fields
function serialize(form, options) {
    if (typeof options != 'object') {
        options = { hash: !!options };
    }
    else if (options.hash === undefined) {
        options.hash = true;
    }

    var result = (options.hash) ? {} : '';
    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

    var elements = form && form.elements ? form.elements : [];

    //Object store each radio and set if it's empty or not
    var radio_store = Object.create(null);

    for (var i=0 ; i<elements.length ; ++i) {
        var element = elements[i];

        // ingore disabled fields
        if ((!options.disabled && element.disabled) || !element.name) {
            continue;
        }
        // ignore anyhting that is not considered a success field
        if (!k_r_success_contrls.test(element.nodeName) ||
            k_r_submitter.test(element.type)) {
            continue;
        }

        var key = element.name;
        var val = element.value;

        // we can't just use element.value for checkboxes cause some browsers lie to us
        // they say "on" for value when the box isn't checked
        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
            val = undefined;
        }

        // If we want empty elements
        if (options.empty) {
            // for checkbox
            if (element.type === 'checkbox' && !element.checked) {
                val = '';
            }

            // for radio
            if (element.type === 'radio') {
                if (!radio_store[element.name] && !element.checked) {
                    radio_store[element.name] = false;
                }
                else if (element.checked) {
                    radio_store[element.name] = true;
                }
            }

            // if options empty is true, continue only if its radio
            if (val == undefined && element.type == 'radio') {
                continue;
            }
        }
        else {
            // value-less fields are ignored unless options.empty is true
            if (!val) {
                continue;
            }
        }

        // multi select boxes
        if (element.type === 'select-multiple') {
            val = [];

            var selectOptions = element.options;
            var isSelectedOptions = false;
            for (var j=0 ; j<selectOptions.length ; ++j) {
                var option = selectOptions[j];
                var allowedEmpty = options.empty && !option.value;
                var hasValue = (option.value || allowedEmpty);
                if (option.selected && hasValue) {
                    isSelectedOptions = true;

                    // If using a hash serializer be sure to add the
                    // correct notation for an array in the multi-select
                    // context. Here the name attribute on the select element
                    // might be missing the trailing bracket pair. Both names
                    // "foo" and "foo[]" should be arrays.
                    if (options.hash && key.slice(key.length - 2) !== '[]') {
                        result = serializer(result, key + '[]', option.value);
                    }
                    else {
                        result = serializer(result, key, option.value);
                    }
                }
            }

            // Serialize if no selected options and options.empty is true
            if (!isSelectedOptions && options.empty) {
                result = serializer(result, key, '');
            }

            continue;
        }

        result = serializer(result, key, val);
    }

    // Check for all empty radio buttons and serialize them with key=""
    if (options.empty) {
        for (var key in radio_store) {
            if (!radio_store[key]) {
                result = serializer(result, key, '');
            }
        }
    }

    return result;
}

function parse_keys(string) {
    var keys = [];
    var prefix = /^([^\[\]]*)/;
    var children = new RegExp(brackets);
    var match = prefix.exec(string);

    if (match[1]) {
        keys.push(match[1]);
    }

    while ((match = children.exec(string)) !== null) {
        keys.push(match[1]);
    }

    return keys;
}

function hash_assign(result, keys, value) {
    if (keys.length === 0) {
        result = value;
        return result;
    }

    var key = keys.shift();
    var between = key.match(/^\[(.+?)\]$/);

    if (key === '[]') {
        result = result || [];

        if (Array.isArray(result)) {
            result.push(hash_assign(null, keys, value));
        }
        else {
            // This might be the result of bad name attributes like "[][foo]",
            // in this case the original `result` object will already be
            // assigned to an object literal. Rather than coerce the object to
            // an array, or cause an exception the attribute "_values" is
            // assigned as an array.
            result._values = result._values || [];
            result._values.push(hash_assign(null, keys, value));
        }

        return result;
    }

    // Key is an attribute name and can be assigned directly.
    if (!between) {
        result[key] = hash_assign(result[key], keys, value);
    }
    else {
        var string = between[1];
        // +var converts the variable into a number
        // better than parseInt because it doesn't truncate away trailing
        // letters and actually fails if whole thing is not a number
        var index = +string;

        // If the characters between the brackets is not a number it is an
        // attribute name and can be assigned directly.
        if (isNaN(index)) {
            result = result || {};
            result[string] = hash_assign(result[string], keys, value);
        }
        else {
            result = result || [];
            result[index] = hash_assign(result[index], keys, value);
        }
    }

    return result;
}

// Object/hash encoding serializer.
function hash_serializer(result, key, value) {
    var matches = key.match(brackets);

    // Has brackets? Use the recursive assignment function to walk the keys,
    // construct any missing objects in the result tree and make the assignment
    // at the end of the chain.
    if (matches) {
        var keys = parse_keys(key);
        hash_assign(result, keys, value);
    }
    else {
        // Non bracket notation can make assignments directly.
        var existing = result[key];

        // If the value has been assigned already (for instance when a radio and
        // a checkbox have the same name attribute) convert the previous value
        // into an array before pushing into it.
        //
        // NOTE: If this requirement were removed all hash creation and
        // assignment could go through `hash_assign`.
        if (existing) {
            if (!Array.isArray(existing)) {
                result[key] = [ existing ];
            }

            result[key].push(value);
        }
        else {
            result[key] = value;
        }
    }

    return result;
}

// urlform encoding serializer
function str_serialize(result, key, value) {
    // encode newlines as \r\n cause the html spec says so
    value = value.replace(/(\r)?\n/g, '\r\n');
    value = encodeURIComponent(value);

    // spaces should be '+' rather than '%20'.
    value = value.replace(/%20/g, '+');
    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
}

module.exports = serialize;


/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "./node_modules/lazysizes/lazysizes.js":
/*!*********************************************!*\
  !*** ./node_modules/lazysizes/lazysizes.js ***!
  \*********************************************/
/***/ ((module) => {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ "./src/css/components/_breadcrumbs.scss":
/*!**********************************************!*\
  !*** ./src/css/components/_breadcrumbs.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_bundle.scss":
/*!*****************************************!*\
  !*** ./src/css/components/_bundle.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-events.scss":
/*!****************************************************!*\
  !*** ./src/css/components/_collection-events.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-hero.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_collection-hero.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-list.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_collection-list.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-signposting.scss":
/*!*********************************************************!*\
  !*** ./src/css/components/_collection-signposting.scss ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-slider.scss":
/*!****************************************************!*\
  !*** ./src/css/components/_collection-slider.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_collection-text.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_collection-text.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_event-filters.scss":
/*!************************************************!*\
  !*** ./src/css/components/_event-filters.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_featured-blog.scss":
/*!************************************************!*\
  !*** ./src/css/components/_featured-blog.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_featured-events.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_featured-events.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_gift-card-form.scss":
/*!*************************************************!*\
  !*** ./src/css/components/_gift-card-form.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_gift-card.scss":
/*!********************************************!*\
  !*** ./src/css/components/_gift-card.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_hero-button-group.scss":
/*!****************************************************!*\
  !*** ./src/css/components/_hero-button-group.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_hero-cta.scss":
/*!*******************************************!*\
  !*** ./src/css/components/_hero-cta.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_image-text.scss":
/*!*********************************************!*\
  !*** ./src/css/components/_image-text.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_login-modal.scss":
/*!**********************************************!*\
  !*** ./src/css/components/_login-modal.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_members-price.scss":
/*!************************************************!*\
  !*** ./src/css/components/_members-price.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_newsletter-section.scss":
/*!*****************************************************!*\
  !*** ./src/css/components/_newsletter-section.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_old_theme_overwrites.scss":
/*!*******************************************************!*\
  !*** ./src/css/components/_old_theme_overwrites.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-bundle.scss":
/*!*************************************************!*\
  !*** ./src/css/components/_product-bundle.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-card.scss":
/*!***********************************************!*\
  !*** ./src/css/components/_product-card.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-custom.scss":
/*!*************************************************!*\
  !*** ./src/css/components/_product-custom.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-ecard.scss":
/*!************************************************!*\
  !*** ./src/css/components/_product-ecard.scss ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-events.scss":
/*!*************************************************!*\
  !*** ./src/css/components/_product-events.scss ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-list.scss":
/*!***********************************************!*\
  !*** ./src/css/components/_product-list.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_product-preorder.scss":
/*!***************************************************!*\
  !*** ./src/css/components/_product-preorder.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_quick-add.scss":
/*!********************************************!*\
  !*** ./src/css/components/_quick-add.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_review-carousel.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_review-carousel.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_section-heading.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_section-heading.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_split-shipments.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_split-shipments.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_usps.scss":
/*!***************************************!*\
  !*** ./src/css/components/_usps.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/spotlight-blocks.scss":
/*!**************************************************!*\
  !*** ./src/css/components/spotlight-blocks.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/legacy/checkout.scss":
/*!**************************************!*\
  !*** ./src/css/legacy/checkout.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/legacy/collection.scss":
/*!****************************************!*\
  !*** ./src/css/legacy/collection.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/legacy/main.scss":
/*!**********************************!*\
  !*** ./src/css/legacy/main.scss ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/legacy/other.scss":
/*!***********************************!*\
  !*** ./src/css/legacy/other.scss ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/legacy/product.scss":
/*!*************************************!*\
  !*** ./src/css/legacy/product.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/style.scss":
/*!****************************!*\
  !*** ./src/css/style.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/first-paint.scss":
/*!**********************************!*\
  !*** ./src/css/first-paint.scss ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_bike-builder-v3.scss":
/*!**************************************************!*\
  !*** ./src/css/components/_bike-builder-v3.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_bike-builder.scss":
/*!***********************************************!*\
  !*** ./src/css/components/_bike-builder.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/css/components/_bis-popup.scss":
/*!********************************************!*\
  !*** ./src/css/components/_bis-popup.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/slick-carousel/slick/slick.js":
/*!****************************************************!*\
  !*** ./node_modules/slick-carousel/slick/slick.js ***!
  \****************************************************/
/***/ ((module, exports, __webpack_require__) => {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));


/***/ }),

/***/ "./src/icons/sprite-icon-4-season.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-4-season.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-4-season-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-4-season",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-add.svg":
/*!***************************************!*\
  !*** ./src/icons/sprite-icon-add.svg ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-add-usage",
      viewBox: "0 0 16 16",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-add",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-age.svg":
/*!***************************************!*\
  !*** ./src/icons/sprite-icon-age.svg ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-age-usage",
      viewBox: "0 0 10 16",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-age",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-aircool-back-system.svg":
/*!*******************************************************!*\
  !*** ./src/icons/sprite-icon-aircool-back-system.svg ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-aircool-back-system-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-aircool-back-system",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-anti-microbrial.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-anti-microbrial.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-anti-microbrial-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-anti-microbrial",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-apline-bond.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-apline-bond.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-apline-bond-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-apline-bond",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-arrow-left.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-arrow-left.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-arrow-left-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-arrow-left",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-arrow-right.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-arrow-right.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-arrow-right-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-arrow-right",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-arrow.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-arrow.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-arrow-usage",
      viewBox: "0 0 7.7 11",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-arrow",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-backpacking.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-backpacking.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-backpacking-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-backpacking",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-battery-life.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-battery-life.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-battery-life-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-battery-life",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-beginner.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-beginner.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-beginner-usage",
      viewBox: "0 0 11 12",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-beginner",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-big-pockets.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-big-pockets.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-big-pockets-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-big-pockets",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-bike.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-bike.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-bike-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-bike",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-bikepacking.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-bikepacking.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-bikepacking-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-bikepacking",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-biodegradable.svg":
/*!*************************************************!*\
  !*** ./src/icons/sprite-icon-biodegradable.svg ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-biodegradable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-biodegradable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-bouldering.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-bouldering.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-bouldering-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-bouldering",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-breathable.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-breathable.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-breathable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-breathable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-calendar.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-calendar.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-calendar-usage",
      viewBox: "0 0 18 20",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-calendar",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-camp.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-camp.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-camp-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-camp",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-cart.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-cart.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-cart-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-cart",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-check.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-check.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-check-usage",
      viewBox: "0 0 16 16",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-check",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-chevron.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-chevron.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-chevron-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-chevron",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-climb.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-climb.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-climb-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-climb",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-cold-protection.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-cold-protection.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-cold-protection-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-cold-protection",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-cross.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-cross.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-cross-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-cross",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-delete.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-delete.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-delete-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-delete",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-delivery.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-delivery.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-delivery-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-delivery",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-disabled.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-disabled.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-disabled-usage",
      viewBox: "0 0 13 14",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-disabled",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-down.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-down.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-down-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-down",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-durable.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-durable.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-durable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-durable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-ethically-sourced.svg":
/*!*****************************************************!*\
  !*** ./src/icons/sprite-icon-ethically-sourced.svg ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-ethically-sourced-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-ethically-sourced",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-facebook.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-facebook.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-facebook-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-facebook",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-filter-hide.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-filter-hide.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-filter-hide-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-filter-hide",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-filter.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-filter.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-filter-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-filter",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-fivestars.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-fivestars.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-fivestars-usage",
      viewBox: "0 0 136 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-fivestars",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-go-further.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-go-further.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-go-further-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-go-further",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-hamburger.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-hamburger.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-hamburger-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-hamburger",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-heat-protection.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-heat-protection.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-heat-protection-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-heat-protection",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-high-wicking.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-high-wicking.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-high-wicking-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-high-wicking",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-hike.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-hike.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-hike-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-hike",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-hydrophobic-down.svg":
/*!****************************************************!*\
  !*** ./src/icons/sprite-icon-hydrophobic-down.svg ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-hydrophobic-down-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-hydrophobic-down",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-improved-balance.svg":
/*!****************************************************!*\
  !*** ./src/icons/sprite-icon-improved-balance.svg ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-improved-balance-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-improved-balance",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-instagram.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-instagram.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-instagram-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-instagram",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-kayak.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-kayak.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-kayak-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-kayak",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-leg-lengths.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-leg-lengths.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-leg-lengths-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-leg-lengths",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-lightweight.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-lightweight.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-lightweight-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-lightweight",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-location.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-location.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-location-usage",
      viewBox: "0 0 12 15",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-location",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-long-lasting.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-long-lasting.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-long-lasting-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-long-lasting",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-lower-impact.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-lower-impact.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-lower-impact-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-lower-impact",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-lumens.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-lumens.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-lumens-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-lumens",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-membrane.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-membrane.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-membrane-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-membrane",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-mens-and-womens.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-mens-and-womens.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-mens-and-womens-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-mens-and-womens",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-mens.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-mens.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-mens-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-mens",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-merino-wool.svg":
/*!***********************************************!*\
  !*** ./src/icons/sprite-icon-merino-wool.svg ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-merino-wool-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-merino-wool",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-minus.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-minus.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-minus-usage",
      viewBox: "0 0 16 16",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-minus",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-mountaineering.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-mountaineering.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-mountaineering-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-mountaineering",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-multi-activity.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-multi-activity.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-multi-activity-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-multi-activity",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-natural-fibres.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-natural-fibres.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-natural-fibres-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-natural-fibres",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-non-polluting.svg":
/*!*************************************************!*\
  !*** ./src/icons/sprite-icon-non-polluting.svg ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-non-polluting-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-non-polluting",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-odour-resistant.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-odour-resistant.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-odour-resistant-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-odour-resistant",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-odourless.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-odourless.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-odourless-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-odourless",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-organic.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-organic.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-organic-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-organic",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-outdoor-specific.svg":
/*!****************************************************!*\
  !*** ./src/icons/sprite-icon-outdoor-specific.svg ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-outdoor-specific-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-outdoor-specific",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-packable.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-packable.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-packable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-packable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-performance-swimwear.svg":
/*!********************************************************!*\
  !*** ./src/icons/sprite-icon-performance-swimwear.svg ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-performance-swimwear-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-performance-swimwear",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-pfc-free.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-pfc-free.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-pfc-free-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-pfc-free",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-pitch-time.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-pitch-time.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-pitch-time-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-pitch-time",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-profile.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-profile.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-profile-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-profile",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-purposeful.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-purposeful.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-purposeful-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-purposeful",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-quick-drying.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-quick-drying.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-quick-drying-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-quick-drying",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-rds.svg":
/*!***************************************!*\
  !*** ./src/icons/sprite-icon-rds.svg ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-rds-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-rds",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-rechargeable.svg":
/*!************************************************!*\
  !*** ./src/icons/sprite-icon-rechargeable.svg ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-rechargeable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-rechargeable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-recycled.svg":
/*!********************************************!*\
  !*** ./src/icons/sprite-icon-recycled.svg ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-recycled-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-recycled",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-reduce-fatigue.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-reduce-fatigue.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-reduce-fatigue-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-reduce-fatigue",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-repairable.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-repairable.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-repairable-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-repairable",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-rugged-robust.svg":
/*!*************************************************!*\
  !*** ./src/icons/sprite-icon-rugged-robust.svg ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-rugged-robust-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-rugged-robust",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-run.svg":
/*!***************************************!*\
  !*** ./src/icons/sprite-icon-run.svg ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-run-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-run",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-rws.svg":
/*!***************************************!*\
  !*** ./src/icons/sprite-icon-rws.svg ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-rws-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-rws",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-search.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-search.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-search-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-search",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-softshell.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-softshell.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-softshell-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-softshell",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-strava.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-strava.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-strava-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-strava",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-stretch.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-stretch.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-stretch-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-stretch",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-strong.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-strong.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-strong-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-strong",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-sub-zero-cold-tested.svg":
/*!********************************************************!*\
  !*** ./src/icons/sprite-icon-sub-zero-cold-tested.svg ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-sub-zero-cold-tested-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-sub-zero-cold-tested",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-sun-protection.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-sun-protection.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-sun-protection-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-sun-protection",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-swim.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-swim.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-swim-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-swim",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-synthetic-insulation.svg":
/*!********************************************************!*\
  !*** ./src/icons/sprite-icon-synthetic-insulation.svg ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-synthetic-insulation-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-synthetic-insulation",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-tasteless.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-tasteless.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-tasteless-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-tasteless",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-thermo-regulating.svg":
/*!*****************************************************!*\
  !*** ./src/icons/sprite-icon-thermo-regulating.svg ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-thermo-regulating-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-thermo-regulating",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-tiktok.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-tiktok.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-tiktok-usage",
      viewBox: "0 0 448 512",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-tiktok",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-time.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-time.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-time-usage",
      viewBox: "0 0 14 15",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-time",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-twitter.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-twitter.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-twitter-usage",
      viewBox: "0 0 512 512",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-twitter",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-ultra-fine-comfort.svg":
/*!******************************************************!*\
  !*** ./src/icons/sprite-icon-ultra-fine-comfort.svg ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-ultra-fine-comfort-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-ultra-fine-comfort",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-vimeo.svg":
/*!*****************************************!*\
  !*** ./src/icons/sprite-icon-vimeo.svg ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-vimeo-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-vimeo",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-warm.svg":
/*!****************************************!*\
  !*** ./src/icons/sprite-icon-warm.svg ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-warm-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-warm",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-water-resistant.svg":
/*!***************************************************!*\
  !*** ./src/icons/sprite-icon-water-resistant.svg ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-water-resistant-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-water-resistant",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-waterproof.svg":
/*!**********************************************!*\
  !*** ./src/icons/sprite-icon-waterproof.svg ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-waterproof-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-waterproof",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-weight.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-weight.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-weight-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-weight",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-wind-resistant.svg":
/*!**************************************************!*\
  !*** ./src/icons/sprite-icon-wind-resistant.svg ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-wind-resistant-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-wind-resistant",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-windproof.svg":
/*!*********************************************!*\
  !*** ./src/icons/sprite-icon-windproof.svg ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-windproof-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-windproof",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-womens.svg":
/*!******************************************!*\
  !*** ./src/icons/sprite-icon-womens.svg ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-womens-usage",
      viewBox: "0 0 141.73 141.73",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-womens",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./src/icons/sprite-icon-youtube.svg":
/*!*******************************************!*\
  !*** ./src/icons/sprite-icon-youtube.svg ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
      id: "sprite-icon-youtube-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "snippets/sprite.liquid#sprite-icon-youtube",
      toString: function () {
        return this.url;
      }
    });

/***/ }),

/***/ "./node_modules/whatwg-fetch/fetch.js":
/*!********************************************!*\
  !*** ./node_modules/whatwg-fetch/fetch.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DOMException: () => (/* binding */ DOMException),
/* harmony export */   Headers: () => (/* binding */ Headers),
/* harmony export */   Request: () => (/* binding */ Request),
/* harmony export */   Response: () => (/* binding */ Response),
/* harmony export */   fetch: () => (/* binding */ fetch)
/* harmony export */ });
/* eslint-disable no-prototype-builtins */
var g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g) ||
  {}

var support = {
  searchParams: 'URLSearchParams' in g,
  iterable: 'Symbol' in g && 'iterator' in Symbol,
  blob:
    'FileReader' in g &&
    'Blob' in g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in g,
  arrayBuffer: 'ArrayBuffer' in g
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 200, statusText: ''})
  response.ok = false
  response.status = 0
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = g.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && g.location.href ? g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name))
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!g.fetch) {
  g.fetch = fetch
  g.Headers = Headers
  g.Request = Request
  g.Response = Response
}


/***/ }),

/***/ "./src/scripts/modules/bike-build-c2w.mjs":
/*!************************************************!*\
  !*** ./src/scripts/modules/bike-build-c2w.mjs ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C2W_MONTHS: () => (/* binding */ C2W_MONTHS),
/* harmony export */   c2wFigures: () => (/* binding */ c2wFigures)
/* harmony export */ });
/**
 * Cycle to Work calculator figures (Builder refinements package 2, Kenny's
 * "Builder/Cycle to Work calculator"). Illustrative: the saving is the build
 * total times the tax band's rate, the shopper pays the rest, spread over 12
 * months of salary. The rates live in the modal snippet, kept in step with
 * /pages/cycle-to-work by hand.
 */

var C2W_MONTHS = 12;

/**
 * @param {number} totalCents the build total in pence
 * @param {number} rate the band's saving as a fraction (0.25 for 25%)
 * @returns {{ savingCents: number, costCents: number, monthlyCents: number }}
 */
function c2wFigures(totalCents, rate) {
  var total = Number.isFinite(totalCents) && totalCents > 0 ? Math.round(totalCents) : 0;
  var share = Number.isFinite(rate) && rate > 0 && rate < 1 ? rate : 0;
  var savingCents = Math.round(total * share);
  var costCents = total - savingCents;
  return {
    savingCents: savingCents,
    costCents: costCents,
    monthlyCents: Math.round(costCents / C2W_MONTHS)
  };
}

/***/ }),

/***/ "./src/scripts/modules/bike-build-changes.mjs":
/*!****************************************************!*\
  !*** ./src/scripts/modules/bike-build-changes.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   basketTotalCents: () => (/* binding */ basketTotalCents),
/* harmony export */   buildChanges: () => (/* binding */ buildChanges),
/* harmony export */   savingsCents: () => (/* binding */ savingsCents),
/* harmony export */   undoItems: () => (/* binding */ undoItems)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Pure helpers for edit mode: how a build being edited differs from the one in
 * the basket (Phase 3 brief 4.2, Kenny's V3 design).
 *
 * The builder records the basket's choice for every group when it restores a
 * build (the baseline), then compares the current selection with it on every
 * change. Prices are in cents. A part that could not be restored because it is
 * no longer offered is "removed": the builder fell back to the standard part,
 * which is reported as the part coming off, not as a change the customer made.
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bike-build-changes.test.mjs.
 */

/**
 * The build saving: compare-at price less price paid, across the chosen
 * upgrades. A free part that carries a compare-at price claims nothing.
 *
 * @param {{price: number, compareAt: number}[]} rows
 * @returns {number}
 */
function savingsCents(rows) {
  return rows.reduce(function (total, _ref) {
    var price = _ref.price,
      compareAt = _ref.compareAt;
    if (!Number.isFinite(price) || !Number.isFinite(compareAt)) return total;
    if (price <= 0 || compareAt <= price) return total;
    return total + (compareAt - price);
  }, 0);
}

/**
 * The changes between the basket's build and the current selection, frame
 * first, then each group in page order, then removed parts whose group is no
 * longer on the page.
 *
 * @param {object} args
 * @param {string[]} args.groups group names in page order
 * @param {Object<string, {variantId: string, title: string, price: number}>} args.baseline the basket's choice per group
 * @param {Object<string, {variantId: string, title: string, price: number, isDefault: boolean}>} args.current
 * @param {string[]} args.removed groups whose basket part is no longer offered
 * @param {{from: string, to: string}} [args.frame] frame variant titles
 * @returns {{group: string, from: string, to: string|null, delta: number|null, removed: boolean}[]}
 */
function buildChanges(_ref2) {
  var groups = _ref2.groups,
    baseline = _ref2.baseline,
    current = _ref2.current,
    removed = _ref2.removed,
    frame = _ref2.frame;
  var rows = [];
  var gone = new Set(removed);
  if (frame && frame.from && frame.to && frame.from !== frame.to) {
    rows.push({
      group: 'Frame',
      from: frame.from,
      to: frame.to,
      delta: null,
      removed: false
    });
  }
  var compare = function compare(group) {
    var before = baseline[group];
    var now = current[group];
    if (!before) return;
    if (gone.has(group)) {
      if (!now || now.isDefault) {
        rows.push({
          group: group,
          from: before.title,
          to: null,
          delta: -before.price,
          removed: true
        });
      } else {
        rows.push({
          group: group,
          from: before.title,
          to: now.title,
          delta: now.price - before.price,
          removed: false
        });
      }
      return;
    }
    if (now && now.variantId !== before.variantId) {
      rows.push({
        group: group,
        from: before.title,
        to: now.title,
        delta: now.price - before.price,
        removed: false
      });
    }
  };
  groups.forEach(compare);
  removed.filter(function (group) {
    return !groups.includes(group);
  }).forEach(compare);
  return rows;
}

/**
 * What the build costs in the basket today, as charged.
 *
 * @returns {number}
 */
function basketTotalCents(parent, components) {
  return [parent].concat(_toConsumableArray(components)).filter(Boolean).reduce(function (total, line) {
    return total + (Number(line.final_line_price) || 0);
  }, 0);
}

/**
 * The Cart API items that put a build back as it was, for Undo: the bike line
 * first, as the builder's form posts it, then its parts.
 *
 * @returns {{id: number, quantity: number, properties: object}[]}
 */
function undoItems(parent, components) {
  return [parent].concat(_toConsumableArray(components)).filter(Boolean).map(function (line) {
    var properties = {};
    Object.entries(line.properties || {}).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      if (value !== null && value !== undefined) properties[key] = value;
    });
    return {
      id: line.variant_id,
      quantity: line.quantity,
      properties: properties
    };
  });
}

/***/ }),

/***/ "./src/scripts/modules/bike-build-lines.mjs":
/*!**************************************************!*\
  !*** ./src/scripts/modules/bike-build-lines.mjs ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildLines: () => (/* binding */ buildLines),
/* harmony export */   frameVariantId: () => (/* binding */ frameVariantId),
/* harmony export */   isComponentOf: () => (/* binding */ isComponentOf),
/* harmony export */   upgradeSelections: () => (/* binding */ upgradeSelections)
/* harmony export */ });
/**
 * Pure helpers for reading a bike build back out of the basket.
 *
 * The bike builder posts one form that becomes several basket lines. The bike
 * line carries `_primaryParentLineItem: <id>`, plus its frame and standard
 * parts as `_bundleProduct_<variant id>` keys. Each upgrade is its own line
 * carrying `_parentLineItem: <Group>___<id>`. The cart's cascade delete and the
 * builder's edit mode both find a build's lines through these helpers, so they
 * agree on what a build is.
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bike-build-lines.test.mjs.
 */

var PARENT_KEY = "_primaryParentLineItem";
var COMPONENT_KEY_PREFIX = "_parentLineItem";
var BUNDLE_KEY_PREFIX = "_bundleProduct_";
var SEPARATOR = "___";
var hasId = function hasId(parentId) {
  return parentId !== null && parentId !== undefined && String(parentId) !== "";
};
var componentValue = function componentValue(properties) {
  var key = Object.keys(properties || {}).find(function (k) {
    return k.startsWith(COMPONENT_KEY_PREFIX);
  });
  return key ? String(properties[key]) : null;
};
var tidyTitle = function tidyTitle(title) {
  return String(title || "").replace(/\[BB\]|\[OEM\]/g, "").replace(/\s+/g, " ").trim();
};

/**
 * @returns {boolean} true when any `_parentLineItem*` property ends in `___<parentId>`
 */
function isComponentOf(properties, parentId) {
  if (!hasId(parentId)) return false;
  return Object.keys(properties || {}).some(function (key) {
    return key.startsWith(COMPONENT_KEY_PREFIX) && String(properties[key]).split(SEPARATOR).pop() === String(parentId);
  });
}

/**
 * @returns {{parent: object|null, components: object[]}} one build's lines
 */
function buildLines(items, parentId) {
  if (!hasId(parentId)) return {
    parent: null,
    components: []
  };
  var id = String(parentId);
  var parent = items.find(function (item) {
    return String((item.properties || {})[PARENT_KEY]) === id;
  }) || null;
  var components = parent ? items.filter(function (item) {
    return isComponentOf(item.properties, id);
  }) : [];
  return {
    parent: parent,
    components: components
  };
}

/**
 * @returns {{group: string, variantId: string, title: string}[]} one entry per upgrade line
 */
function upgradeSelections(components) {
  return components.map(function (item) {
    var value = componentValue(item.properties);
    if (value === null) return null;
    var at = value.lastIndexOf(SEPARATOR);
    return {
      group: at === -1 ? value : value.slice(0, at),
      variantId: String(item.variant_id),
      title: tidyTitle(item.title)
    };
  }).filter(Boolean);
}

/**
 * The frame's variant id, from the bike line's `_bundleProduct_<id>` keys.
 * Only the frame's key is one of the frame product's own variants.
 *
 * @returns {string|null}
 */
function frameVariantId(parentLine, frameVariantIds) {
  if (!parentLine) return null;
  var known = new Set(frameVariantIds.map(String));
  var key = Object.keys(parentLine.properties || {}).find(function (k) {
    return k.startsWith(BUNDLE_KEY_PREFIX) && known.has(k.slice(BUNDLE_KEY_PREFIX.length));
  });
  return key ? key.slice(BUNDLE_KEY_PREFIX.length) : null;
}

/***/ }),

/***/ "./src/scripts/modules/bike-build-summary.mjs":
/*!****************************************************!*\
  !*** ./src/scripts/modules/bike-build-summary.mjs ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deliveryDateText: () => (/* binding */ deliveryDateText),
/* harmony export */   extrasLabel: () => (/* binding */ extrasLabel),
/* harmony export */   largestUpgradeSaving: () => (/* binding */ largestUpgradeSaving),
/* harmony export */   sizeLabel: () => (/* binding */ sizeLabel),
/* harmony export */   summaryFigures: () => (/* binding */ summaryFigures)
/* harmony export */ });
/* harmony import */ var _bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bike-build-changes.mjs */ "./src/scripts/modules/bike-build-changes.mjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Builder refinements, package 1: the build summary's figures (Kenny's
 * "Builder/Build summary v2"), worked out from the selections on the page.
 * See docs/superpowers/specs/2026-10-06-bike-builder-refinements-customise-screen-design.md
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bike-build-summary.test.mjs.
 */


/**
 * @param {{basePrice: number, upgrades: {group: string, variantId: string, title: string, price: number, compareAt: number}[]}} build
 *   upgrades: each group's chosen part that is not its standard one, in page order
 * @returns {{extras: object[], count: number, extrasTotal: number, saving: number, total: number}} pence
 */
function summaryFigures(_ref) {
  var basePrice = _ref.basePrice,
    upgrades = _ref.upgrades;
  var extras = upgrades.map(function (upgrade) {
    return _objectSpread(_objectSpread({}, upgrade), {}, {
      price: Number.isFinite(upgrade.price) ? upgrade.price : 0
    });
  });
  var extrasTotal = extras.reduce(function (sum, extra) {
    return sum + extra.price;
  }, 0);
  var base = Number.isFinite(basePrice) ? basePrice : 0;
  return {
    extras: extras,
    count: extras.length,
    extrasTotal: extrasTotal,
    // The same rule as the cards' "less than buying it separately": paid
    // upgrades only, compare-at price minus price.
    saving: (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_0__.savingsCents)(extras),
    total: base + extrasTotal
  };
}

/** "4 extras · View build", "1 extra · View build", or "View build" with none. */
function extrasLabel(count, _ref2) {
  var none = _ref2.none,
    one = _ref2.one,
    other = _ref2.other;
  if (count === 0) return none;
  if (count === 1) return one;
  return other.replace("[count]", String(count));
}

/**
 * The delivery block's date line: the frame's dispatch date when it has one,
 * otherwise the bike's availability note, as the summary showed before.
 */
function deliveryDateText(_ref3) {
  var dispatchDate = _ref3.dispatchDate,
    note = _ref3.note,
    template = _ref3.template;
  var date = String(dispatchDate || "").trim();
  if (date) return template.replace("[date]", date);
  return String(note || "").trim();
}

/** "Size: Medium", or nothing when the frame has no size. */
function sizeLabel(size, template) {
  return size ? template.replace("[size]", size) : "";
}

/**
 * The non-standard option with the largest saving (compare-at minus price,
 * the rule savingsCents uses), for the Step 2 heading's example. Ties go to
 * the first in page order. Null when nothing saves anything.
 *
 * @param {Array<{ group: string, price: number, compareAt: number, isDefault: boolean }>} options
 * @returns {{ group: string, saving: number } | null}
 */
function largestUpgradeSaving(options) {
  var best = null;
  var _iterator = _createForOfIteratorHelper(options),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        group = _step$value.group,
        price = _step$value.price,
        compareAt = _step$value.compareAt,
        isDefault = _step$value.isDefault;
      if (isDefault) continue;
      var saving = (0,_bike_build_changes_mjs__WEBPACK_IMPORTED_MODULE_0__.savingsCents)([{
        price: price,
        compareAt: compareAt
      }]);
      if (saving > 0 && (!best || saving > best.saving)) best = {
        group: group,
        saving: saving
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return best;
}

/***/ }),

/***/ "./src/scripts/modules/bike-builder-finance.mjs":
/*!******************************************************!*\
  !*** ./src/scripts/modules/bike-builder-finance.mjs ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   monthlyPaymentCents: () => (/* binding */ monthlyPaymentCents)
/* harmony export */ });
/**
 * The PayItMonthly "From £X / month" figure.
 *
 * One formula for every place the figure appears. The builder calls this
 * from product-bike-builder-v3.js; snippets/product-card-finance.liquid
 * does the same arithmetic in Liquid for collection cards, so change both
 * together. The terms come from the theme settings (PayItMonthly finance),
 * which must hold PayItMonthly's approved representative example.
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bike-builder-finance.test.mjs.
 */

/**
 * @param {number} totalCents price being financed, in pence
 * @param {{apr: number, term: number, depositPct: number}} terms
 *   apr as a percentage, term in months, deposit as a percentage of the price
 * @returns {number|null} the monthly payment in pence, rounded to the nearest
 *   whole pound, or null when there is no valid term or APR to show a figure for
 */
function monthlyPaymentCents(totalCents, _ref) {
  var apr = _ref.apr,
    term = _ref.term,
    depositPct = _ref.depositPct;
  if (!term || term <= 0 || Number.isNaN(term) || Number.isNaN(apr)) return null;
  var deposit = Number.isNaN(depositPct) ? 0 : depositPct || 0;
  var financed = totalCents * (1 - deposit / 100);
  var totalRepayable = financed * (1 + apr / 100 * (term / 12));
  var monthly = totalRepayable / term;
  return Math.round(monthly / 100) * 100;
}

/***/ }),

/***/ "./src/scripts/modules/bike-builder-option-card.mjs":
/*!**********************************************************!*\
  !*** ./src/scripts/modules/bike-builder-option-card.mjs ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   duplicateCardIndexes: () => (/* binding */ duplicateCardIndexes),
/* harmony export */   shownVariantIndex: () => (/* binding */ shownVariantIndex)
/* harmony export */ });
/**
 * Pure helpers for the bike builder's grouped option cards (Package C).
 *
 * snippets/bike-builder-product-block.liquid renders one card per component
 * product, holding one .bike-builder-block per bike-builder variant (sizes,
 * widths, colours). Only one block per card is on show; the blocks stay the
 * unit of selection, so the posted cart payload for any given choice is the
 * same as when every variant was its own card.
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bike-builder-option-card.test.mjs.
 */

/**
 * Which of a card's variants to show: the selected one, else the bike's
 * standard one, else whichever the card was already showing, else the first.
 *
 * Standard ranks above "already showing" so a deselected standard card goes
 * back to its standard size, rather than staying on the size the customer
 * tried and moved away from. An upgrade card has no standard, so it keeps the
 * size it was left on.
 *
 * @param {{active: boolean, standard: boolean, shown: boolean}[]} variants
 * @returns {number} index into variants, or -1 when there are none
 */
function shownVariantIndex(variants) {
  if (!variants.length) return -1;
  var active = variants.findIndex(function (variant) {
    return variant.active;
  });
  if (active !== -1) return active;
  var standard = variants.findIndex(function (variant) {
    return variant.standard;
  });
  if (standard !== -1) return standard;
  var shown = variants.findIndex(function (variant) {
    return variant.shown;
  });
  if (shown !== -1) return shown;
  return 0;
}

/**
 * Cards in one row that repeat a product already carded earlier in it. A
 * group's default tag renders first, so where its upgrade collection carries
 * the same product the collection's copy is the one dropped.
 *
 * @param {string[]} handles product handle of each card, in row order
 * @returns {number[]} indexes of the cards to remove
 */
function duplicateCardIndexes(handles) {
  var seen = new Set();
  var duplicates = [];
  handles.forEach(function (handle, index) {
    if (!handle) return;
    if (seen.has(handle)) duplicates.push(index);else seen.add(handle);
  });
  return duplicates;
}

/***/ }),

/***/ "./src/scripts/modules/bike-buy-column.mjs":
/*!*************************************************!*\
  !*** ./src/scripts/modules/bike-buy-column.mjs ***!
  \*************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildToggleLabel: () => (/* binding */ buildToggleLabel),
/* harmony export */   buyButtonState: () => (/* binding */ buyButtonState),
/* harmony export */   closedCount: () => (/* binding */ closedCount),
/* harmony export */   optionLabel: () => (/* binding */ optionLabel),
/* harmony export */   sectionsLocked: () => (/* binding */ sectionsLocked),
/* harmony export */   unlockCopy: () => (/* binding */ unlockCopy)
/* harmony export */ });
/* harmony import */ var _bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bike-build-summary.mjs */ "./src/scripts/modules/bike-build-summary.mjs");
/**
 * Bike builder buy column (Kenny's "Builder direction: buy column"): the
 * states and labels the page shows, worked out from the build. Kept as .mjs
 * with no DOM access so node --test loads it directly. See
 * tests/bike-buy-column.test.mjs and
 * docs/superpowers/specs/2026-10-13-bike-builder-buy-column-design.md
 */


/** Customise your bike and Select Accessories stay locked until an available size and colour are chosen. */
function sectionsLocked(_ref) {
  var chosen = _ref.chosen,
    available = _ref.available;
  return !(chosen && available);
}

/** "2 added" or "2 changed" on a closed heading; nothing while open or at zero. */
function closedCount(_ref2) {
  var count = _ref2.count,
    open = _ref2.open,
    template = _ref2.template;
  if (open || !(count > 0) || !template) return "";
  return String(template).replace("[count]", String(count));
}

/** The Your build toggle: "Hide your build" while the drawer is open, otherwise the extras label. */
function buildToggleLabel(_ref3, _ref4) {
  var count = _ref3.count,
    open = _ref3.open;
  var none = _ref4.none,
    one = _ref4.one,
    other = _ref4.other,
    hide = _ref4.hide;
  return open ? hide : (0,_bike_build_summary_mjs__WEBPACK_IMPORTED_MODULE_0__.extrasLabel)(count, {
    none: none,
    one: one,
    other: other
  });
}

/**
 * Every Add to basket (the desktop bar's, the mobile bar's and the sheet's)
 * from one state. With no size or colour yet it reads "Select options" (Kenny,
 * 22 Oct 2026) and stays live: the submit handler prompts instead of posting.
 *
 * @returns {{ label: string, disabled: boolean }}
 */
function buyButtonState(_ref5, labels) {
  var ready = _ref5.ready,
    failed = _ref5.failed,
    chosen = _ref5.chosen,
    available = _ref5.available,
    editing = _ref5.editing;
  if (failed) return {
    label: labels.failed,
    disabled: true
  };
  if (!ready) return {
    label: labels.loading,
    disabled: true
  };
  if (chosen && !available) return {
    label: labels.outOfStock,
    disabled: true
  };
  if (!chosen) return {
    label: labels.select || labels.add,
    disabled: false
  };
  return {
    label: editing ? labels.update : labels.add,
    disabled: false
  };
}

/**
 * The Step 2 heading (Kenny's progression, 22 Oct 2026): the locked words
 * until an available size and colour are chosen, then "Make it your own" and
 * the biggest saving on the page, its group in lower case ("on wheels").
 *
 * @returns {{ title: string, body: string }}
 */
function unlockCopy(_ref6, _ref7) {
  var locked = _ref6.locked,
    group = _ref6.group,
    amount = _ref6.amount;
  var titleLocked = _ref7.titleLocked,
    bodyLocked = _ref7.bodyLocked,
    title = _ref7.title,
    body = _ref7.body,
    example = _ref7.example;
  if (locked) return {
    title: titleLocked,
    body: bodyLocked
  };
  var sentence = group && amount && example ? " ".concat(String(example).replace("[amount]", amount).replace("[group]", String(group).toLowerCase())) : "";
  return {
    title: title,
    body: "".concat(body).concat(sentence)
  };
}

/** "Colour: Raw Titanium", or nothing without a value. */
function optionLabel(value, template, token) {
  return value ? String(template || "").replace(token, value) : "";
}

/***/ }),

/***/ "./src/scripts/modules/bundle-payload.mjs":
/*!************************************************!*\
  !*** ./src/scripts/modules/bundle-payload.mjs ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   INCOMPLETE_BUNDLE_MESSAGE: () => (/* binding */ INCOMPLETE_BUNDLE_MESSAGE),
/* harmony export */   buildBundleItems: () => (/* binding */ buildBundleItems),
/* harmony export */   describeBundleConfigMismatch: () => (/* binding */ describeBundleConfigMismatch),
/* harmony export */   parseBundleKey: () => (/* binding */ parseBundleKey),
/* harmony export */   validateBundlePayload: () => (/* binding */ validateBundlePayload)
/* harmony export */ });
/**
 * Pure helpers for turning the bundle form's hidden inputs into a /cart/add.js
 * payload, plus the completeness check that stops a partial bundle reaching the
 * cart.
 *
 * Kept as .mjs with no DOM access so node --test can load it directly. See
 * tests/bundle-payload.test.mjs.
 *
 * Background: snippets/bundle.liquid renders one hidden input per component,
 *   name="_bundle_id-<component product id>-<parent variant id>"   (child)
 *   name="_bundle_id-<parent variant id>"                          (parent)
 * and the child input only renders when a variant title matches the selected
 * options. Every way that can fail used to be a console.warn and a bare return,
 * so a bundle could be added with some of its components missing, charged at the
 * full parent price, with nothing shown to the customer. Order #1679273
 * (2026-09-01) shipped a Nefyn Swimwear Set with no Nefyn Bottom that way.
 */

var BUNDLE_KEY_ROOT = '_bundle_id';

// A component can ask for more than one unit, from a 'bundle_<handle>_qty:<n>'
// tag on the parent. bundle.liquid renders the count alongside the variant
// input as '_bundle_qty-<product id>-<parent variant id>'.
var QUANTITY_KEY_ROOT = '_bundle_qty';
function parseBundleQuantity(value) {
  var quantity = parseInt(value, 10);
  if (!Number.isFinite(quantity) || quantity < 1) {
    return 1;
  }
  return quantity;
}
var INCOMPLETE_BUNDLE_MESSAGE = 'We could not add every item in this bundle. Please refresh the page and try again.';

/**
 * Identify a bundle hidden input by name.
 *
 * @param {string} key form field name
 * @returns {{isParent: boolean, bundleId: string}|null} null when the field is
 *   not one of the bundle inputs.
 */
function parseBundleKey(key) {
  if (typeof key !== 'string') {
    return null;
  }
  var parts = key.split('-');
  if (parts[0] !== BUNDLE_KEY_ROOT) {
    return null;
  }
  if (parts.length === 2) {
    return {
      isParent: true,
      bundleId: parts[1]
    };
  }
  if (parts.length === 3) {
    return {
      isParent: false,
      bundleId: parts[2]
    };
  }
  return null;
}

/**
 * Build the /cart/add.js items array from the bundle form's fields.
 *
 * @param {Object<string, string>} formEntries form names to values
 * @param {string} bundleInstanceId groups the parent and its children in the cart
 * @returns {{items: Array, parentCount: number, childCount: number, emptyKeys: string[]}}
 */
function buildBundleItems(formEntries, bundleInstanceId) {
  var items = [];
  var emptyKeys = [];
  var parentCount = 0;
  var childCount = 0;
  Object.keys(formEntries || {}).forEach(function (key) {
    var parsed = parseBundleKey(key);
    if (!parsed) {
      return;
    }
    var variantId = formEntries[key];
    if (!variantId) {
      emptyKeys.push(key);
      return;
    }
    var properties = parsed.isParent ? {
      _bundle_parent: true
    } : {
      _bundle_free: true
    };
    properties._bundle_id = parsed.bundleId;
    properties._bundle_instance_id = bundleInstanceId;

    // One bundle per add, so only components carry a quantity.
    var quantity = parsed.isParent ? 1 : parseBundleQuantity(formEntries[key.replace(BUNDLE_KEY_ROOT, QUANTITY_KEY_ROOT)]);
    items.push({
      id: variantId,
      quantity: quantity,
      properties: properties
    });
    if (parsed.isParent) {
      parentCount += 1;
    } else {
      childCount += 1;
    }
  });
  return {
    items: items,
    parentCount: parentCount,
    childCount: childCount,
    emptyKeys: emptyKeys
  };
}

/**
 * Check the payload covers the whole bundle before it is posted.
 *
 * The invariant is that every component row drawn on the page contributes
 * exactly one child item, alongside exactly one parent. Counting rendered rows
 * rather than bundle_ tags keeps a malformed tag from blocking the sale while
 * still catching the case that matters: a row the customer chose from that did
 * not make it into the cart.
 *
 * @returns {string|null} customer-facing message, or null when the payload is whole
 */
function validateBundlePayload(_ref) {
  var parentCount = _ref.parentCount,
    childCount = _ref.childCount,
    renderedItemCount = _ref.renderedItemCount;
  if (parentCount !== 1) {
    return INCOMPLETE_BUNDLE_MESSAGE;
  }
  if (childCount !== renderedItemCount) {
    return INCOMPLETE_BUNDLE_MESSAGE;
  }
  return null;
}

/**
 * Compare the rows drawn on the page against the bundle_ tags the parent
 * product carries. A shortfall means a tag never resolved to a product, which
 * is a data fault on the product rather than anything the customer did, so this
 * only produces a log line. Blocking here would take a whole bundle off sale
 * over a tag typo.
 *
 * @returns {string|null} diagnostic for the console, or null when they agree
 */
function describeBundleConfigMismatch(_ref2) {
  var renderedItemCount = _ref2.renderedItemCount,
    expectedItemCount = _ref2.expectedItemCount;
  if (typeof expectedItemCount !== 'number' || !Number.isFinite(expectedItemCount)) {
    return null;
  }
  if (renderedItemCount === expectedItemCount) {
    return null;
  }
  return "ProductBundle: rendered ".concat(renderedItemCount, " component row(s) but the product carries ").concat(expectedItemCount, " bundle_ tag(s). Check the bundle_ tags resolve to product handles.");
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/common": 0,
/******/ 			"assets/_bis-popup": 0,
/******/ 			"assets/_bike-builder": 0,
/******/ 			"assets/_bike-builder-v3": 0,
/******/ 			"assets/first-paint": 0,
/******/ 			"assets/style": 0,
/******/ 			"assets/product": 0,
/******/ 			"assets/other": 0,
/******/ 			"assets/main": 0,
/******/ 			"assets/collection": 0,
/******/ 			"assets/checkout": 0,
/******/ 			"assets/spotlight-blocks": 0,
/******/ 			"assets/_usps": 0,
/******/ 			"assets/_split-shipments": 0,
/******/ 			"assets/_section-heading": 0,
/******/ 			"assets/_review-carousel": 0,
/******/ 			"assets/_quick-add": 0,
/******/ 			"assets/_product-preorder": 0,
/******/ 			"assets/_product-list": 0,
/******/ 			"assets/_product-events": 0,
/******/ 			"assets/_product-ecard": 0,
/******/ 			"assets/_product-custom": 0,
/******/ 			"assets/_product-card": 0,
/******/ 			"assets/_product-bundle": 0,
/******/ 			"assets/_old_theme_overwrites": 0,
/******/ 			"assets/_newsletter-section": 0,
/******/ 			"assets/_members-price": 0,
/******/ 			"assets/_login-modal": 0,
/******/ 			"assets/_image-text": 0,
/******/ 			"assets/_hero-cta": 0,
/******/ 			"assets/_hero-button-group": 0,
/******/ 			"assets/_gift-card": 0,
/******/ 			"assets/_gift-card-form": 0,
/******/ 			"assets/_featured-events": 0,
/******/ 			"assets/_featured-blog": 0,
/******/ 			"assets/_event-filters": 0,
/******/ 			"assets/_collection-text": 0,
/******/ 			"assets/_collection-slider": 0,
/******/ 			"assets/_collection-signposting": 0,
/******/ 			"assets/_collection-list": 0,
/******/ 			"assets/_collection-hero": 0,
/******/ 			"assets/_collection-events": 0,
/******/ 			"assets/_bundle": 0,
/******/ 			"assets/_breadcrumbs": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkwiro_frontend_foundation"] = self["webpackChunkwiro_frontend_foundation"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/scripts/common.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/style.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/first-paint.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_bike-builder-v3.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_bike-builder.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_bis-popup.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_breadcrumbs.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_bundle.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-events.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-hero.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-list.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-signposting.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-slider.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_collection-text.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_event-filters.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_featured-blog.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_featured-events.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_gift-card-form.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_gift-card.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_hero-button-group.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_hero-cta.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_image-text.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_login-modal.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_members-price.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_newsletter-section.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_old_theme_overwrites.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-bundle.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-card.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-custom.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-ecard.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-events.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-list.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_product-preorder.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_quick-add.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_review-carousel.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_section-heading.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_split-shipments.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/_usps.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/components/spotlight-blocks.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/legacy/checkout.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/legacy/collection.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/legacy/main.scss")))
/******/ 	__webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/legacy/other.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/_bis-popup","assets/_bike-builder","assets/_bike-builder-v3","assets/first-paint","assets/style","assets/product","assets/other","assets/main","assets/collection","assets/checkout","assets/spotlight-blocks","assets/_usps","assets/_split-shipments","assets/_section-heading","assets/_review-carousel","assets/_quick-add","assets/_product-preorder","assets/_product-list","assets/_product-events","assets/_product-ecard","assets/_product-custom","assets/_product-card","assets/_product-bundle","assets/_old_theme_overwrites","assets/_newsletter-section","assets/_members-price","assets/_login-modal","assets/_image-text","assets/_hero-cta","assets/_hero-button-group","assets/_gift-card","assets/_gift-card-form","assets/_featured-events","assets/_featured-blog","assets/_event-filters","assets/_collection-text","assets/_collection-slider","assets/_collection-signposting","assets/_collection-list","assets/_collection-hero","assets/_collection-events","assets/_bundle","assets/_breadcrumbs"], () => (__webpack_require__("./src/css/legacy/product.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;